webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth_js__ = __webpack_require__(1160);




var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json'
  }
});

service.interceptors.request.use(function (config) {
  var token = __WEBPACK_IMPORTED_MODULE_2__services_auth_js__["a" /* default */].getToken();
  var info = JSON.parse(atob(token));

  if (token) {
    config.headers['Token'] = info.token;
  }
  return config;
});

service.interceptors.response.use(function (response) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
}, function (error) {
  var res = error.response;
  if (res.status === 403 || res.status === 401) {
    __WEBPACK_IMPORTED_MODULE_2__services_auth_js__["a" /* default */].deleteToken();
    window.location.href = '/';
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5168b938_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(1110);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5168b938_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Switch.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5168b938", Component.options)
  } else {
    hotAPI.reload("data-v-5168b938", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectDropdown_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffe1eea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectDropdown_vue__ = __webpack_require__(1142);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffe1eea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Partials/SelectDropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6ffe1eea", Component.options)
  } else {
    hotAPI.reload("data-v-6ffe1eea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateCode;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["f"] = getMasterMaterialList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/create',
    method: 'post',
    data: data
  });
}

function generateCode(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/generate-code',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/update',
    method: 'put',
    data: data
  });
}

function getMasterMaterialList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material/common-list',
    method: 'get'
  });
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterUomList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/update',
    method: 'put',
    data: data
  });
}

function getMasterUomList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/common-list',
    method: 'get'
  });
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = history;
/* harmony export (immutable) */ __webpack_exports__["e"] = store;
/* harmony export (immutable) */ __webpack_exports__["a"] = best_sale;
/* harmony export (immutable) */ __webpack_exports__["b"] = config;
/* harmony export (immutable) */ __webpack_exports__["d"] = order_processing_time;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function history(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/report/v1/report" + '/history',
    method: 'get',
    params: data
  });
}

function store() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/report/v1/report" + '/store',
    method: 'get'
  });
}

function best_sale(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/report/v1/report" + '/best_sale',
    method: 'get',
    params: data
  });
}

function config() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/report/v1/report" + '/system/config',
    method: 'get'
  });
}

function order_processing_time(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/report/v1/report" + '/order-processing-time',
    method: 'get',
    params: data
  });
}

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterGroupList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-group/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-group/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-group/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-group/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-group/update',
    method: 'put',
    data: data
  });
}

function getMasterGroupList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-group/common-list',
    method: 'get'
  });
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterAccountList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-account/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-account/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-account/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-account/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-account/update',
    method: 'put',
    data: data
  });
}

function getMasterAccountList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-account/common-list',
    method: 'get'
  });
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterSupplierList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-supplier/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-supplier/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-supplier/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-supplier/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-supplier/update',
    method: 'put',
    data: data
  });
}

function getMasterSupplierList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-supplier/common-list',
    method: 'get'
  });
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SquareLoader_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2aa05b1f_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_SquareLoader_vue__ = __webpack_require__(1279);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1277)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SquareLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2aa05b1f_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_SquareLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-spinner/src/SquareLoader.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2aa05b1f", Component.options)
  } else {
    hotAPI.reload("data-v-2aa05b1f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* unused harmony export getRole */
/* harmony export (immutable) */ __webpack_exports__["e"] = getRolePermission;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/update_status',
    method: 'post',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/detail',
    method: 'get',
    params: data
  });
}

function getRole() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/list',
    method: 'get'
  });
}

function getRolePermission() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/roles_permissions',
    method: 'get'
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/role/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPermissionList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/permission/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/permission/update_status',
    method: 'post',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/permission/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/permission/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/permission/update',
    method: 'put',
    data: data
  });
}

function getPermissionList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/common/permission/list',
    method: 'get'
  });
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterTypeList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-type/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-type/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-type/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-type/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-type/update',
    method: 'put',
    data: data
  });
}

function getMasterTypeList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-type/common-list',
    method: 'get'
  });
}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterGenstoreList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-genstore/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-genstore/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-genstore/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-genstore/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-genstore/update',
    method: 'put',
    data: data
  });
}

function getMasterGenstoreList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-genstore/common-list',
    method: 'get'
  });
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["e"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateCode;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["f"] = getMasterMaterialDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/create',
    method: 'post',
    data: data
  });
}

function generateCode(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/generate-code',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/update',
    method: 'put',
    data: data
  });
}

function getMasterMaterialDetail() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail/common-list',
    method: 'get'
  });
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getMasterUomList;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["g"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterUomDetailList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function getMasterUomList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom/common-list',
    method: 'get'
  });
}

function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom-detail/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom-detail/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom-detail/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom-detail/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom-detail/update',
    method: 'put',
    data: data
  });
}

function getMasterUomDetailList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-uom-detail/common-list',
    method: 'get'
  });
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getMasterRecipeList;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function getMasterRecipeList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe/common-list',
    method: 'get'
  });
}

function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/charts/Bar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bbf5175a", Component.options)
  } else {
    hotAPI.reload("data-v-bbf5175a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/charts/Pie.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8e77568", Component.options)
  } else {
    hotAPI.reload("data-v-d8e77568", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lang_js__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_progressbar__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_timezone__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_lodash__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notification__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_numeral_filter__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);


















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_progressbar___default.a, {
  autoFinish: false
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_moment___default.a, {
  moment: __WEBPACK_IMPORTED_MODULE_11_moment_timezone___default.a
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].router = router;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__(1360), {
  auth: {
    request: function request(req, token) {
      var info = JSON.parse(atob(token));
      this.options.http._setHeaders.call(this, req, { Token: info.token });
    },
    response: function response(res) {
      if (res.data.data == null || res.data.data.length == 0 || res.data.data.key == null) {
        return null;
      }
      var token = res.data.data.token;
      var key = res.data.data.key;
      var info = {
        token: token.trim(),
        key: JSON.parse(atob(key.trim()))
      };
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.headers.common['Market'] = info.key.client_id;
      return btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
    }
  },
  http: __webpack_require__(1364),
  router: __webpack_require__(1365),
  loginData: {
    url: "https://betapich.phsmk.id/user/v1/user" + '/ch_login',
    method: 'POST',
    redirect: '/',
    fetchUser: false
  },
  logoutData: {
    url: "https://betapich.phsmk.id/user/v1/user" + '/ch_logout',
    method: 'POST'
  },
  refreshData: {
    enabled: false
  },
  fetchData: {
    enabled: false,
    success: function success(res) {
      var info = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].auth.token();
      info = JSON.parse(atob(info));
      info.key.group = info.key.roles;
      info.key.roles = info.key.permissions;
      info.key.store_code = info.key.info.outlets.length > 0 ? info.key.info.outlets[0] : '';
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.headers.common['Market'] = info.key.info.client_id;
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].auth.user(info.key);
    }
  },
  notFoundRedirect: {
    path: '/pages/404'
  },
  forbiddenRedirect: {
    path: '/pages/404'
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('json', function (value) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value, null, 2);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_notification___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_numeral_filter__["a" /* default */]);

var main = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  i18n: __WEBPACK_IMPORTED_MODULE_8__lang_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  }
});
window.Vue = __WEBPACK_IMPORTED_MODULE_1_vue__["default"];
main.$i18n.locale = main.$session.get('lang') || 'en';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.defaults.headers.common['Lang'] = main.$session.get('lang') || 'en';

/* harmony default export */ __webpack_exports__["default"] = (main);

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/Simple-Line-Icons.f33df36.eot";

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(1107);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components___["c" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__components___["d" /* Sidebar */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_0__components___["b" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: [{
        role: 'report',
        title: true,
        name: 'report',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }, {
        name: 'dashboard',
        url: '/dashboard',
        icon: 'icon-speedometer'
      }, {
        name: 'sales_history',
        url: '/sales-history',
        icon: 'icon-speedometer'
      }, {
        name: 'product_mix',
        url: '/product-mix',
        icon: 'icon-speedometer'
      }, {
        name: 'order_processing_time',
        url: '/order-processing-time',
        icon: 'icon-speedometer'
      }, {
        name: 'report',
        url: '/report',
        icon: 'fa fa-bar-chart'
      }, {
        title: true,
        name: 'system',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }, {
        name: 'user',
        url: '/user',
        icon: 'fa fa-user-o'
      }, {
        name: 'role',
        url: '/role',
        icon: 'fa fa-users'
      }, {
        name: 'permission',
        url: '/permission',
        icon: 'fa fa-balance-scale'
      }, {
        name: 'client',
        url: '/client',
        icon: 'fa fa-globe'
      }, {
        title: true,
        name: 'inventory',
        class: '',
        wrapper: {
          element: '',
          attributes: {}
        }
      }, {
        name: 'master_data',
        url: '/inventory',
        icon: 'fa fa-tasks',
        children: [{
          name: 'group',
          url: '/inventory/master-group',
          icon: 'icon-puzzle'
        }, {
          name: 'type',
          url: '/inventory/master-type',
          icon: 'fa fa-tag'
        }, {
          name: 'account',
          url: '/inventory/master-account',
          icon: 'fa fa-user'
        }, {
          name: 'supplier',
          url: '/inventory/master-supplier',
          icon: 'fa fa-user-secret'
        }, {
          name: 'genstore',
          url: '/inventory/master-genstore',
          icon: 'fa fa-tag'
        }, {
          name: 'uom',
          url: '/inventory/master-uom',
          icon: 'fa fa-tag'
        }, {
          name: 'uom_detail',
          url: '/inventory/master-uom-detail',
          icon: 'fa fa-tag'
        }, {
          name: 'material',
          url: '/inventory/master-material',
          icon: 'fa fa-user-secret'
        }, {
          name: 'material_detail',
          url: '/inventory/master-material-detail',
          icon: 'fa fa-user-secret'
        }, {
          name: 'material_detail_supplier',
          url: '/inventory/master-material-detail-supplier',
          icon: 'fa fa-user-secret'
        }, {
          name: 'master_material_recipe_mapping',
          url: '/inventory/master-material-recipe-mapping',
          icon: 'fa fa-user-secret'
        }, {
          name: 'recipe',
          url: '/inventory/master-recipe',
          icon: 'fa fa-user-secret'
        }]
      }, {
        name: 'sync_data',
        url: '/inventory',
        icon: 'fa fa-tasks',
        children: [{
          name: 'sync_master',
          url: '/inventory/sync-master',
          icon: 'icon-puzzle'
        }, {
          name: 'sync_master_detail',
          url: '/inventory/sync-master-detail',
          icon: 'fa fa-tag'
        }]
      }]
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  },
  created: function created() {
    var main_page = 'master_material';
    if (this.$route.name == 'home') {
      if (this.$auth.user().group) {
        this.$auth.user().group.forEach(function (item) {
          if (item == "phd") {
            main_page = 'master_group';
          }
        });
      } else {
        main_page = 'login';
      }
      this.$router.push({ name: main_page });
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_0__Callout__["a" /* default */],
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch__["a" /* default */]
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff56ba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(1109);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ff56ba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Callout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ff56ba0", Component.options)
  } else {
    hotAPI.reload("data-v-4ff56ba0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return this.$t(item);
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdownAccnt_vue__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_ChangeLangues_vue__ = __webpack_require__(192);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-header',
  components: {
    HeaderDropdownAccnt: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdownAccnt_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown-accnt',
  data: function data() {
    return {};
  },
  methods: {
    logout: function logout() {
      this.$Progress.start();
      this.$auth.logout({
        makeRequest: true,
        success: function success(response) {
          this.$Progress.finish();
          console.log(response);
        },
        error: function error(_error) {
          this.$Progress.fail();
          console.log(_error);
        },
        redirect: '/login'
      });
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeLangues_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f737190_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeLangues_vue__ = __webpack_require__(1121);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangeLangues_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f737190_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangeLangues_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Partials/ChangeLangues.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f737190", Component.options)
  } else {
    hotAPI.reload("data-v-1f737190", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lang',
  data: function data() {
    return {
      current_lang: 'en'
    };
  },
  methods: {
    setLang: function setLang(lang) {
      this.$store.dispatch('setLang', lang);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang = lang;
      __WEBPACK_IMPORTED_MODULE_1_js_cookie__["set"]('locale', lang);
      this.$session.set('lang', lang);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.headers.common['Lang'] = lang;
    }
  },
  created: function created() {
    this.current_lang = this.$session.get('lang') || 'en';
    this.setLang(this.current_lang);
  },

  watch: {
    current_lang: function current_lang(val) {
      this.setLang(val);
    }
  }
});

/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMinimizer__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavDivider__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavDropdown__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarNavLink__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavTitle__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavItem__ = __webpack_require__(1137);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_0__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_1__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_2__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_3__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_4__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_5__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_user__ = __webpack_require__(204);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      model: 'user',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'username',
          search: true,
          sort: true
        }, {
          name: 'email',
          search: true,
          sort: true
        }, {
          name: 'roles',
          search: false,
          sort: false,
          render: function render(data, row) {
            var html = [];
            for (var i in data) {
              html.push(_this.$t(data[i].code));
            }
            return html.join('<br/>');
          }
        }, {
          name: 'active',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 1) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(uuid, status) {
      var _this2 = this;

      this.$Progress.start();
      var data = {
        active: status,
        uuid: uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_user__["a" /* changeStatusItem */])(data).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.refreshData();
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_user__["c" /* fetchAll */])(params).then(function (response) {
        _this3.dataTable.body = response.data.data.items;
        _this3.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelectDropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: false
    },
    position: {
      type: String,
      required: false
    },
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    all: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      value: this.selected,
      values: this.options
    };
  },
  methods: {
    setSelected: function setSelected(val) {
      this.value = val;
      if (this.value == 'all') {
        this.$emit('input', null);
      } else {
        this.$emit('input', this.value);
      }
    }
  },
  created: function created() {
    if (this.all) {
      var newOptions = ['all'];
      for (var i in this.options) {
        newOptions.push(this.options[i]);
      }
      this.values = newOptions;
    }
    if (this.selected == null && this.values.length > 0) {
      this.value = this.values[0];
    }
    if (this.position == null) {
      this.position = 'prepend';
    }
    if (this.value == 'all') {
      this.$emit('input', null);
    } else {
      this.$emit('input', this.value);
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["e"] = getListOutlet;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/update_status',
    method: 'post',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/detail',
    method: 'get',
    params: data
  });
}

function getListOutlet() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/report/v1/report" + '/store',
    method: 'get'
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/update',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_user__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_role__ = __webpack_require__(98);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'user',
      roles: [],
      permissions: [],
      item: {
        uuid: null,
        avatar: '',
        username: '',
        email: '',
        name: '',
        password: '',
        password_confirmation: '',
        store_code: '',
        active: 0,
        roles: [],
        roleIds: [],
        permissions: [],
        permissionIds: [],
        permissionIdsInRoles: []
      },
      avatarData: 'https://bodiezpro.com/wp-content/uploads/2015/09/medium-default-avatar.png',
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    checkPermission: function checkPermission(id) {
      if (_.indexOf(this.item.permissionIds, id) >= 0) {
        return true;
      }
      return false;
    },
    checkPermissionInRole: function checkPermissionInRole(id) {
      if (_.indexOf(this.item.permissionIdsInRoles, id) >= 0) {
        return true;
      }
      return false;
    },
    previewImage: function previewImage(event) {
      var _this = this;

      var input = event.target;

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this[input.id] = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
        this.item.avatar = input.files[0];
      }
    },
    updatePermission: function updatePermission(val) {
      var _this2 = this;

      if (!val.target.checked) {
        for (var i in this.item.roles) {
          if (this.item.roles[i].id == val.target.value) {
            (function () {
              var permissionIds = [];
              for (var j in _this2.item.roles[i].permissions) {
                permissionIds.push(_this2.item.roles[i].permissions[j].id);
              }

              var permissions = [];
              _this2.item.permissions.forEach(function (item, k) {
                if (_.indexOf(permissionIds, item.id) < 0) {
                  permissions.push(item);
                }
              });
              _this2.item.permissions = permissions;
              _this2.item.roles.splice(i, 1);
            })();
          }
        }
      } else {
        for (var _i in this.roles) {
          if (this.roles[_i].id == val.target.value) {
            if (_.indexOf(this.item.roleIds, val.target.value) < 0) {
              this.item.roles.push(this.roles[_i]);
            }
            break;
          }
        }
      }
      this.updateUserRolePermission();
    },
    updateRole: function updateRole(val) {
      if (!val.target.checked) {
        for (var i in this.item.permissions) {
          if (this.item.permissions[i].id == val.target.value) {
            this.item.permissions.splice(i, 1);
          }
        }

        for (var _i2 in this.item.permissionIds) {
          if (this.item.permissionIds[_i2] == val.target.value) {
            this.item.permissionIds.splice(_i2, 1);
          }
        }

        var roles = [];
        for (var _i3 in this.item.roles) {
          var role = this.item.roles[_i3];
          var permissions = [];

          for (var j in role.permissions) {
            if (_.indexOf(this.item.permissionIds, role.permissions[j].id) >= 0) {
              permissions.push(role.permissions[j]);
            }
          }

          if (role.permissions.length == permissions.length) {
            roles.push(role);
          } else {
            for (var _i4 in permissions) {
              this.item.permissions.push(permissions[_i4]);
            }
          }
        }

        this.item.roles = roles;
      } else {
        for (var _i5 in this.permissions) {
          if (this.permissions[_i5].id == val.target.value && _.indexOf(this.item.permissionIds, val.target.value) < 0) {
            this.item.permissions.push(this.permissions[_i5]);
            this.item.permissionIds.push(parseInt(val.target.value));
          }
        }

        for (var _i6 in this.roles) {
          var _role = this.roles[_i6];

          var permissionIds = [];
          for (var _j in _role.permissions) {
            if (_.indexOf(this.item.permissionIds, _role.permissions[_j].id) >= 0) {
              permissionIds.push(_role.permissions[_j].id);
            }
          }

          if (_role.permissions.length == permissionIds.length && _.indexOf(this.item.roleIds, _role.id) < 0) {
            this.item.roles.push(_role);
          }
        }
      }

      this.updateUserRolePermission();
    },
    updateUserRolePermission: function updateUserRolePermission() {
      var permissionIds = [];
      var permissions = [];
      for (var i in this.item.permissions) {
        if (_.indexOf(permissionIds, this.item.permissions[i].id) < 0) {
          permissionIds.push(this.item.permissions[i].id);
          permissions.push(this.item.permissions[i]);
        }
      }

      var roleIds = [];
      var permissionIdsInRoles = [];
      for (var _i7 in this.item.roles) {
        if (_.indexOf(roleIds, this.item.roles[_i7].id) < 0) {
          roleIds.push(this.item.roles[_i7].id);
          for (var j in this.item.roles[_i7].permissions) {
            if (_.indexOf(permissionIds, this.item.roles[_i7].permissions[j].id) < 0) {
              permissionIds.push(this.item.roles[_i7].permissions[j].id);
              permissions.push(this.item.roles[_i7].permissions[j]);
            }
            if (_.indexOf(permissionIdsInRoles, this.item.roles[_i7].permissions[j].id) < 0) {
              permissionIdsInRoles.push(this.item.roles[_i7].permissions[j].id);
            }
          }
        }
      }

      this.item = {
        uuid: this.item.uuid,
        avatar: this.item.avatar,
        username: this.item.username,
        email: this.item.email,
        name: this.item.name,
        password: this.item.password,
        password_confirmation: this.item.password_confirmation,
        active: this.item.active,
        roles: this.item.roles,
        roleIds: roleIds,
        permissions: permissions,
        permissionIds: permissionIds,
        permissionIdsInRoles: permissionIdsInRoles
      };

      return this.item;
    },
    getDetails: function getDetails() {
      var _this3 = this;

      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["d" /* get */])(data).then(function (response) {
        _this3.item = response.data.data;
        _this3.avatarData = _this3.item.avatar;
        _this3.updateUserRolePermission();
        _this3.item.store_code = response.data.data.user_outlets[0] != null ? response.data.data.user_outlets[0].outlet_code : '';
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getRolePermissions: function getRolePermissions(cb) {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_role__["e" /* getRolePermission */])().then(function (response) {
        _this4.roles = response.data.data.roles;
        _this4.permissions = response.data.data.permissions;
        cb();
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this5 = this;

      this.$Progress.start();
      var formData = new FormData();

      for (var i in this.item.permissionIds) {
        if (_.indexOf(this.item.permissionIdsInRoles, this.item.permissionIds[i]) < 0) {
          formData.append('permissionIds[]', this.item.permissionIds[i]);
        }
      }
      for (var _i8 in this.item.roleIds) {
        formData.append('roleIds[]', this.item.roleIds[_i8]);
      }

      for (var _i9 in this.item) {
        if (_i9 != 'permissionIds' && _i9 != 'roleIds' && _i9 != 'permissions' && _i9 != 'roles' && _i9 != 'permissionIdsInRoles') {
          if (this.item[_i9] == null) {
            this.item[_i9] = '';
          }
          formData.append(_i9, this.item[_i9]);
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["f" /* update */])(formData).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this6 = this;

      this.$Progress.start();
      var formData = new FormData();

      for (var i in this.item.permissionIds) {
        if (_.indexOf(this.item.permissionIdsInRoles, this.item.permissionIds[i]) < 0) {
          formData.append('permissionIds[]', this.item.permissionIds[i]);
        }
      }
      for (var _i10 in this.item.roleIds) {
        formData.append('roleIds[]', this.item.roleIds[_i10]);
      }

      for (var _i11 in this.item) {
        if (_i11 != 'permissionIds' && _i11 != 'roleIds' && _i11 != 'permissions' && _i11 != 'roles' && _i11 != 'permissionIdsInRoles') {
          formData.append(_i11, this.item[_i11]);
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["b" /* create */])(formData).then(function (response) {
        _this6.$notify({
          title: _this6.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this6.$router.push({ name: _this6.model });
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    getListOutlets: function getListOutlets() {
      var _this7 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_user__["e" /* getListOutlet */])().then(function (response) {
        _this7.outlets = {};
        var langs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this7.$i18n.messages);
        for (var l in langs) {
          _this7.outlets[langs[l]] = [];
          for (var i in response.data.data) {
            _this7.outlets[langs[l]].push({
              text: response.data.data[i].name,
              value: response.data.data[i].store_code
            });
          }
        }
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    }
  },
  created: function created() {
    var _this8 = this;

    var langs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages);
    this.outlets = {};
    for (var l in langs) {
      this.outlets[langs[l]] = [];
    }
    this.getListOutlets();
    this.getRolePermissions(function () {
      if (_this8.uuid != null) {
        _this8.getDetails();
      } else {
        _this8.item.uuid = '';
      }
    });
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_role__ = __webpack_require__(98);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RoleList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'role',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'active',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 1) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(uuid, status) {
      var _this = this;

      this.$Progress.start();
      var data = {
        active: status,
        uuid: uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_role__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_role__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_role__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_permission__ = __webpack_require__(99);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RoleForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'role',
      permissionsData: [],
      item: {
        uuid: null,
        name: '',
        description: '',
        code: '',
        active: 0,
        permissionIds: []
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    checkPermission: function checkPermission(id) {
      if (_.indexOf(this.item.permissionIds, id) >= 0) {
        return true;
      }
      return false;
    },
    getDetails: function getDetails() {
      var _this = this;

      var self = this;
      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_role__["d" /* get */])(data).then(function (response) {
        _this.$Progress.finish();
        _this.item.uuid = response.data.data.uuid;
        _this.item.name = response.data.data.name;
        _this.item.description = response.data.data.description;
        _this.item.code = response.data.data.code;
        _this.item.active = response.data.data.active;
        response.data.data.permissions.forEach(function (item) {
          self.item.permissionIds.push(item.id);
        });
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getPermission: function getPermission() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_permission__["e" /* getPermissionList */])().then(function (response) {
        _this2.$Progress.finish();
        _this2.permissionsData = response.data.data;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    checkAll: function checkAll(val) {
      this.item.permissionIds = [];
      if (val.target.checked) {
        for (var i in this.permissionsData) {
          this.item.permissionIds.push(this.permissionsData[i].id);
        }
      }
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_role__["f" /* update */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_role__["b" /* create */])(this.item).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getDetails();
    this.getPermission();
  },
  watch: {
    'item.name': function itemName() {
      this.item.code = this.item.name.trim().toLowerCase().replace(/ /g, '.');
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_permission__ = __webpack_require__(99);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PermissionList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'permission',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'active',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 1) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(uuid, status) {
      var _this = this;

      this.$Progress.start();
      var data = {
        active: status,
        uuid: uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_permission__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_permission__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_permission__ = __webpack_require__(99);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PermissionForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'permission',
      item: {
        uuid: null,
        name: '',
        description: '',
        code: '',
        active: 0
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetails: function getDetails() {
      var _this = this;

      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_permission__["d" /* get */])(data).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_permission__["f" /* update */])(this.item).then(function (response) {
        _this2.$Progress.finish();
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$Progress.fail();
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_permission__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.uuid != null) {
      this.getDetails();
    } else {
      this.item.uuid = '';
    }
  },
  watch: {
    'item.name': function itemName() {
      if (this.item.uuid == '') {
        this.item.code = this.item.name.trim().toLowerCase().replace(/ /g, '.');
      }
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(215);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ClientList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'client',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["b" /* fetchAll */])(params).then(function (response) {
        _this.dataTable.body = response.data.data.items;
        _this.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["c"] = get;
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["d"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/client/list',
    method: 'get',
    params: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/client/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/client/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/user/v1/user" + '/client/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_client__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_text_mask__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_text_mask__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PermissionForm',
  props: {
    uuid: {
      type: String,
      default: null
    }
  },
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_3_vue_text_mask___default.a,
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'client',
      item: {
        uuid: null,
        name: '',
        description: '',
        code: '',
        configs: [],
        customizes: []
      },
      configStatus: 0,
      customizeStatus: 0,
      groups: [{ text: 'Customer', value: 'customer' }, { text: 'Product', value: 'product' }, { text: 'Store', value: 'store' }],
      tags: [{ text: 'Text Box', value: 'text_box' }, { text: 'Check Box', value: 'check_box' }, { text: 'Radio Group', value: 'radio_group' }, { text: 'Select', value: 'select' }, { text: 'Switch', value: 'switch' }, { text: 'Text Area', value: 'text_area' }, { text: 'Date Box', value: 'date_box' }],
      types: [{ text: 'Text', value: 'text' }, { text: 'Number', value: 'number' }],
      option: {
        text: '',
        check_value: '',
        uncheck_value: ''
      },
      attributes: {
        text_box: {
          type: 'text',
          class: '',
          default: '',
          place_holder: ''
        },
        check_box: {
          class: '',
          options: [],
          default: ''
        },
        radio_group: {
          class: '',
          options: [],
          default: ''
        },
        select: {
          class: '',
          multiple: false,
          options: [],
          default: ''
        },
        switch: {
          class: '',
          check_value: '',
          uncheck_value: '',
          default: ''
        },
        text_area: {
          class: '',
          rows: 5,
          uncheck_value: '',
          default: '',
          place_holder: ''
        },
        date_box: {
          class: '',
          default: this.$moment().format('DD/MM/YYYY')
        }
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    updateTag: function updateTag(group, field) {
      var _this = this;

      var tag = this.item.customizes[group].fields[field].tag;
      var c = setInterval(function () {
        if (tag != _this.item.customizes[group].fields[field].tag) {
          _this.item.customizes[group].fields[field].attribute = _this._.cloneDeep(_this.attributes[_this.item.customizes[group].fields[field].tag]);
          clearInterval(c);
        }
      }, 100);
    },
    removeOption: function removeOption(group, field, option) {
      var options = [];
      for (var i in this.item.customizes[group].fields[field].attribute.options) {
        if (i != option) {
          options.push(this.item.customizes[group].fields[field].attribute.options[i]);
        }
      }
      this.item.customizes[group].fields[field].attribute.options = options;
    },
    addOption: function addOption(group, field) {
      console.log(this.item.customizes[group].fields[field].attribute);
      this.item.customizes[group].fields[field].attribute.options.push({
        text: '',
        value: ''
      });
    },
    removeField: function removeField(group, field) {
      var fields = [];
      for (var i in this.item.customizes[group].fields) {
        if (i != field) {
          fields.push(this.item.customizes[group].fields[i]);
        }
      }
      this.item.customizes[group].fields = fields;
    },
    addField: function addField(group) {
      this.item.customizes[group].fields.push({
        tag: 'text_box',
        name: '',
        attribute: this._.cloneDeep(this.attributes.text_box)
      });
    },
    removeGroup: function removeGroup(index) {
      var customizes = [];
      for (var i in this.item.customizes) {
        if (i != index) {
          customizes.push(this.item.customizes[i]);
        }
      }
      this.item.customizes = customizes;
    },
    addGroup: function addGroup() {
      this.item.customizes.push({
        group: '',
        fields: []
      });
    },
    removeConfig: function removeConfig(index) {
      var configs = [];
      for (var i in this.item.configs) {
        if (i != index) {
          configs.push(this.item.configs[i]);
        }
      }
      this.item.configs = configs;
    },
    addConfig: function addConfig() {
      this.item.configs.push({
        group: '',
        key: '',
        value: ''
      });
    },
    updateConfigStatus: function updateConfigStatus() {
      if (this.configStatus == 0) {
        this.configStatus = 1;
      } else {
        this.configStatus = 0;
      }
    },
    updateCustomizeStatus: function updateCustomizeStatus() {
      if (this.customizeStatus == 0) {
        this.customizeStatus = 1;
      } else {
        this.customizeStatus = 0;
      }
    },
    getDetails: function getDetails() {
      var _this2 = this;

      this.$Progress.start();
      var data = {
        uuid: this.uuid
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["c" /* get */])(data).then(function (response) {
        response.data.data.customizes = [];
        _this2.item = response.data.data;
        var customizes = [];
        _this2.item.customizes = [];

        for (var i in response.data.data.customize_fields) {
          var customize = response.data.data.customize_fields[i];
          if (customizes[customize.group] == null) {
            customizes[customize.group] = {
              group: customize.group,
              fields: []
            };
          }
          customizes[customize.group].fields.push({
            tag: customize.tag,
            name: customize.name,
            attribute: customize.attribute
          });
        }

        for (var _i in customizes) {
          _this2.item.customizes.push(customizes[_i]);
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["d" /* update */])(this.item).then(function (response) {
        _this3.$Progress.finish();
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_1__api_client__["a" /* create */])(this.item).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.uuid != null) {
      this.getDetails();
    } else {
      this.item.uuid = '';
    }
  },
  watch: {}
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_group__ = __webpack_require__(66);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGroupList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_group',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_group__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_group__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_group__ = __webpack_require__(66);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGroupForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_group',
      item: {
        id: null,
        code: '',
        name: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_group__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_group__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_group__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_type__ = __webpack_require__(100);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterTypeList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_type',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_type__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_type__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_type__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_group__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_account__ = __webpack_require__(67);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterTypeForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_type',
      item: {
        id: null,
        group_id: '',
        account_id: '',
        code: '',
        name: '',
        description: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      groups: [],
      accounts: []
    };
  },
  methods: {
    getListGroup: function getListGroup() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_group__["e" /* getMasterGroupList */])().then(function (response) {
        for (var i in response.data.data) {
          _this.groups.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListAccount: function getListAccount() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_account__["e" /* getMasterAccountList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.accounts.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_type__["d" /* get */])(params).then(function (response) {
        _this3.item = response.data.data;
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.account_id = this.item.account_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_type__["f" /* update */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this5 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.account_id = this.item.account_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_type__["b" /* create */])(param).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListGroup();
    this.getListAccount();
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_account__ = __webpack_require__(67);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterAccountList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_account',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_account__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_account__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset(val) {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate(val) {
      this.refreshData();
    },
    'filter.actived': function filterActived(val) {
      this.refreshData();
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_account__ = __webpack_require__(67);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterAccountForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_account',
      item: {
        id: null,
        code: '',
        name: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_account__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_account__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_account__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material__ = __webpack_require__(49);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'group_name',
          search: false,
          sort: false
        }, {
          name: 'type_name',
          search: false,
          sort: false
        }, {
          name: 'account_code',
          search: false,
          sort: false
        }, {
          name: 'genstore_code',
          search: false,
          sort: false
        }, {
          name: 'recipe_rate',
          search: false,
          sort: false
        }, {
          name: 'uom_name',
          search: false,
          sort: false
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_group__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_type__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_master_account__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_master_genstore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_master_uom__ = __webpack_require__(50);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material',
      item: {
        id: null,
        group_id: '',
        type_id: '',
        account_id: '',
        genstore_id: '',
        code: '',
        name: '',
        recipe_rate: '',
        recipe_rate_uom_id: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      groups: [],
      types: [],
      accounts: [],
      genstores: [],
      uoms: []
    };
  },
  methods: {
    getListUom: function getListUom() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_8__api_master_uom__["e" /* getMasterUomList */])().then(function (response) {
        for (var i in response.data.data) {
          _this.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListGroup: function getListGroup() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_group__["e" /* getMasterGroupList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.groups.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getListType: function getListType() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_type__["e" /* getMasterTypeList */])().then(function (response) {
        for (var i in response.data.data) {
          _this3.types.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getListAccount: function getListAccount() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_6__api_master_account__["e" /* getMasterAccountList */])().then(function (response) {
        for (var i in response.data.data) {
          _this4.accounts.push({
            label: response.data.data[i].code,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    getListGenstore: function getListGenstore() {
      var _this5 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_7__api_master_genstore__["e" /* getMasterGenstoreList */])().then(function (response) {
        for (var i in response.data.data) {
          _this5.genstores.push({
            label: response.data.data[i].code,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this6 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["e" /* get */])(params).then(function (response) {
        _this6.item = response.data.data;
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this7 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.type_id = this.item.type_id.value;
      param.account_id = this.item.account_id.value;
      param.genstore_id = this.item.genstore_id.value;
      param.recipe_rate_uom_id = this.item.recipe_rate_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["g" /* update */])(param).then(function (response) {
        _this7.$notify({
          title: _this7.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this7.$router.push({ name: _this7.model });
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this8 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.group_id = this.item.group_id.value;
      param.type_id = this.item.type_id.value;
      param.account_id = this.item.account_id.value;
      param.genstore_id = this.item.genstore_id.value;
      param.recipe_rate_uom_id = this.item.recipe_rate_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["b" /* create */])(param).then(function (response) {
        _this8.$notify({
          title: _this8.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this8.$router.push({ name: _this8.model });
      }).catch(function (error) {
        _this8.$notify({
          title: _this8.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this8.$Progress.finish();
      });
    },
    generateMaterialCode: function generateMaterialCode() {
      var _this9 = this;

      if (this.item.group_id.value && this.item.type_id.value) {
        var params = {
          group_id: this.item.group_id.value,
          group_code: this.getGroupCode(),
          type_id: this.item.type_id.value,
          type_code: this.getTypeCode()
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["d" /* generateCode */])(params).then(function (response) {
          _this9.item.code = response.data.data.material_code;
        }).catch(function (error) {});
      }
    },
    getGroupCode: function getGroupCode() {
      for (var i in this.groups) {
        var group = this.groups[i];
        if (group.value == this.item.group_id.value) {
          return group.code;
        }
      }
    },
    getTypeCode: function getTypeCode() {
      for (var i in this.types) {
        var type = this.types[i];
        if (type.value == this.item.type_id.value) {
          return type.code;
        }
      }
    }
  },
  created: function created() {
    this.getListGroup();
    this.getListType();
    this.getListAccount();
    this.getListGenstore();
    this.getListUom();
    if (this.id != null) {
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {
    'item.group_id': function itemGroup_id() {
      if (this.id == null) {
        this.generateMaterialCode();
      }
    },
    'item.type_id': function itemType_id() {
      if (this.id == null) {
        this.generateMaterialCode();
      }
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material_detail__ = __webpack_require__(102);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialDetailList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material_detail',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'material_name',
          search: false,
          sort: false
        }, {
          name: 'supplier_unit_name',
          search: false,
          sort: false
        }, {
          name: 'smaller_uom_name',
          search: false,
          sort: false
        }, {
          name: 'smaller_uom_detail_name',
          search: false,
          sort: false
        }, {
          name: 'outlet_uom_name',
          search: false,
          sort: false
        }, {
          name: 'outlet_uom_detail_name',
          search: false,
          sort: false
        }, {
          name: 'recipe_uom_name',
          search: false,
          sort: false
        }, {
          name: 'recipe_uom_detail_name',
          search: false,
          sort: false
        }, {
          name: 'report_uom_name',
          search: false,
          sort: false
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_material__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_supplier__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_master_uom__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_master_uom_detail__ = __webpack_require__(103);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material_detail',
      edit: 0,
      item: {
        id: null,
        material_id: '',
        supplier_id: '',
        supplier_uom_id: '',
        outlet_uom_id: '',
        outlet_uom_detail_id: '',
        recipe_uom_id: '',
        recipe_uom_detail_id: '',
        smaller_uom_id: '',
        smaller_uom_detail_id: '',
        report_uom_id: '',
        code: '',
        name: '',
        fixed_unit_id: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      materials: [],
      suppliers: [],
      uoms: [],
      uom_details: [],
      smaller_uom_details: [],
      outlet_uom_details: [],
      recipe_uom_details: []
    };
  },
  methods: {
    getListSmallerUomDetail: function getListSmallerUomDetail(from_uom_id, to_uom_id) {
      this.$Progress.start();
      this.smaller_uom_details = [];
      for (var i in this.uom_details) {
        if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
          this.smaller_uom_details.push({
            label: this.uom_details[i].name,
            value: this.uom_details[i].id
          });
        }
      }
      this.$Progress.finish();
    },
    getListOutletUomDetail: function getListOutletUomDetail(from_uom_id, to_uom_id) {
      this.$Progress.start();
      this.outlet_uom_details = [];
      for (var i in this.uom_details) {
        if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
          this.outlet_uom_details.push({
            label: this.uom_details[i].name,
            value: this.uom_details[i].id
          });
        }
      }
      this.$Progress.finish();
    },
    getListRecipeUomDetail: function getListRecipeUomDetail(from_uom_id, to_uom_id) {
      this.$Progress.start();
      this.recipe_uom_details = [];
      for (var i in this.uom_details) {
        if (parseInt(this.uom_details[i].from_uom_id) == parseInt(from_uom_id) && parseInt(this.uom_details[i].to_uom_id) == parseInt(to_uom_id)) {
          this.recipe_uom_details.push({
            label: this.uom_details[i].name,
            value: this.uom_details[i].id
          });
        }
      }
      this.$Progress.finish();
    },
    getListMaterial: function getListMaterial() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
        for (var i in response.data.data) {
          _this.materials.push({
            label: response.data.data[i].code + ' - ' + response.data.data[i].name,
            value: response.data.data[i].id,
            code: response.data.data[i].code
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListSupplier: function getListSupplier() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_supplier__["e" /* getMasterSupplierList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.suppliers.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getListUom: function getListUom() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_6__api_master_uom__["e" /* getMasterUomList */])().then(function (response) {
        for (var i in response.data.data) {
          _this3.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getListUomDetail: function getListUomDetail() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_7__api_master_uom_detail__["e" /* getMasterUomDetailList */])().then(function (response) {
        for (var i in response.data.data) {
          _this4.uom_details.push(response.data.data[i]);
        }
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this5 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["e" /* get */])(params).then(function (response) {
        _this5.item = response.data.data;
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this6 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.material_id = this.item.material_id.value;
      param.supplier_uom_id = this.item.supplier_uom_id.value;
      param.smaller_uom_id = this.item.smaller_uom_id.value;
      param.smaller_uom_detail_id = this.item.smaller_uom_detail_id.value;
      param.outlet_uom_id = this.item.outlet_uom_id.value;
      param.outlet_uom_detail_id = this.item.outlet_uom_detail_id.value;
      param.recipe_uom_id = this.item.recipe_uom_id.value;
      param.recipe_uom_detail_id = this.item.recipe_uom_detail_id.value;
      param.report_uom_id = this.item.report_uom_id.value;
      param.fixed_unit_id = this.item.fixed_unit_id ? this.item.fixed_unit_id.value : '';
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["g" /* update */])(param).then(function (response) {
        _this6.$notify({
          title: _this6.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this6.$router.push({ name: _this6.model });
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this7 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.material_id = this.item.material_id.value;
      param.supplier_uom_id = this.item.supplier_uom_id.value;
      param.smaller_uom_id = this.item.smaller_uom_id.value;
      param.smaller_uom_detail_id = this.item.smaller_uom_detail_id.value;
      param.outlet_uom_id = this.item.outlet_uom_id.value;
      param.outlet_uom_detail_id = this.item.outlet_uom_detail_id.value;
      param.recipe_uom_id = this.item.recipe_uom_id.value;
      param.recipe_uom_detail_id = this.item.recipe_uom_detail_id.value;
      param.report_uom_id = this.item.report_uom_id.value;
      param.fixed_unit_id = this.item.fixed_unit_id ? this.item.fixed_unit_id.value : '';

      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["b" /* create */])(param).then(function (response) {
        _this7.$notify({
          title: _this7.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this7.$router.push({ name: _this7.model });
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    },
    generateMaterialDetailCode: function generateMaterialDetailCode() {
      var _this8 = this;

      if (this.item.material_id) {
        var params = {
          material_id: this.item.material_id.value,
          material_code: this.getMaterialCode()
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["d" /* generateCode */])(params).then(function (response) {
          _this8.item.code = response.data.data.code;
        }).catch(function (error) {});
      }
    },
    getMaterialCode: function getMaterialCode() {
      for (var i in this.materials) {
        var material = this.materials[i];
        if (material.value == this.item.material_id.value) {
          return material.code;
        }
      }
    }
  },
  created: function created() {
    this.getListMaterial();
    this.getListSupplier();
    this.getListUom();
    this.getListUomDetail();
    if (this.id != null) {
      this.edit = 1;
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {
    'item.material_id': function itemMaterial_id() {
      if (this.edit == 0) {
        this.generateMaterialDetailCode();
      }
    },
    'item.supplier_uom_id': function itemSupplier_uom_id() {
      if (this.edit == 0) {
        this.item.smaller_uom_detail_id = '';
      }
      if (this.item.supplier_uom_id && this.item.smaller_uom_id) {
        this.getListSmallerUomDetail(this.item.supplier_uom_id.value, this.item.smaller_uom_id.value);
      }
    },
    'item.smaller_uom_id': function itemSmaller_uom_id() {
      if (this.edit == 0) {
        this.item.smaller_uom_detail_id = '';
        this.item.outlet_uom_detail_id = '';
      }
      if (this.item.supplier_uom_id && this.item.smaller_uom_id) {
        this.getListSmallerUomDetail(this.item.supplier_uom_id.value, this.item.smaller_uom_id.value);
      }
      if (this.item.smaller_uom_id && this.item.outlet_uom_id) {
        this.getListOutletUomDetail(this.item.smaller_uom_id.value, this.item.outlet_uom_id.value);
      }
    },
    'item.outlet_uom_id': function itemOutlet_uom_id() {
      if (this.edit == 0) {
        this.item.outlet_uom_detail_id = '';
        this.item.recipe_uom_detail_id = '';
      }
      if (this.item.smaller_uom_id && this.item.outlet_uom_id) {
        this.getListOutletUomDetail(this.item.smaller_uom_id.value, this.item.outlet_uom_id.value);
      }
      if (this.item.outlet_uom_id && this.item.recipe_uom_id) {
        this.getListRecipeUomDetail(this.item.outlet_uom_id.value, this.item.recipe_uom_id.value);
      }
    },
    'item.recipe_uom_id': function itemRecipe_uom_id() {
      if (this.edit == 0) {
        this.item.recipe_uom_detail_id = '';
      } else {
        this.edit = 0;
      }
      if (this.item.outlet_uom_id && this.item.recipe_uom_id) {
        this.getListRecipeUomDetail(this.item.outlet_uom_id.value, this.item.recipe_uom_id.value);
      }
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_supplier__ = __webpack_require__(68);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterSupplierList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_supplier',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'address',
          search: true,
          sort: true
        }, {
          name: 'phone',
          search: true,
          sort: true
        }, {
          name: 'fax',
          search: true,
          sort: true
        }, {
          name: 'terms_of_payment',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active, is_import_do) {
      var _this = this;

      this.$Progress.start();
      var data = {
        id: id
      };
      if (is_active === "") {
        data.is_import_do = is_import_do;
      } else {
        data.is_active = is_active;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_supplier__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_supplier__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_supplier__ = __webpack_require__(68);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterSupplierForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_supplier',
      item: {
        id: null,
        code: '',
        name: '',
        address: '',
        phone: '',
        fax: '',
        terms_of_payment: '',
        is_active: 1,
        is_import_do: 1,
        is_tax: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      materials: []
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_supplier__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_supplier__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_supplier__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_uom__ = __webpack_require__(50);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_uom',
      item: {
        id: null,
        name: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetails: function getDetails() {
      var _this = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_uom__["d" /* get */])(params).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_uom__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_uom__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_uom__ = __webpack_require__(50);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_uom',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__ = __webpack_require__(103);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomDetailForm',
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_uom_detail',
      item: {
        id: '',
        from_uom_id: '',
        to_uom_id: '',
        from_uom_qty: '',
        to_uom_qty: '',
        conversion_rate: '',
        name: '',
        is_active: 1
      },
      uoms: [],
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getListUoms: function getListUoms() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["f" /* getMasterUomList */])().then(function (response) {
        _this.uoms = [];
        for (var i in response.data.data) {
          _this.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["d" /* get */])(params).then(function (response) {
        _this2.item = response.data.data;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.from_uom_id = this.item.from_uom_id.value;
      param.to_uom_id = this.item.to_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["g" /* update */])(param).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      param.from_uom_id = this.item.from_uom_id.value;
      param.to_uom_id = this.item.to_uom_id.value;
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_uom_detail__["b" /* create */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListUoms();
    if (this.id != null) {
      this.getDetails();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_uom_detail__ = __webpack_require__(103);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterUomDetailList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_uom_detail',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'from_uom_name',
          search: false,
          sort: true
        }, {
          name: 'from_uom_qty',
          search: true,
          sort: true
        }, {
          name: 'to_uom_name',
          search: false,
          sort: true
        }, {
          name: 'to_uom_qty',
          search: true,
          sort: true
        }, {
          name: 'conversion_rate',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom_detail__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_uom_detail__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_genstore__ = __webpack_require__(101);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGenstoreForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_genstore',
      item: {
        id: null,
        code: '',
        name: '',
        description: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;

      this.$Progress.start();
      var data = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_genstore__["d" /* get */])(data).then(function (response) {
        _this.item = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_genstore__["f" /* update */])(this.item).then(function (response) {
        _this2.$notify({
          title: _this2.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this2.$router.push({ name: _this2.model });
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_genstore__["b" /* create */])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_genstore__ = __webpack_require__(101);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterGenstoreList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_genstore',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'id',
          search: false,
          sort: true
        }, {
          name: 'code',
          search: true,
          sort: true
        }, {
          name: 'name',
          search: true,
          sort: true
        }, {
          name: 'description',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        id: id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_genstore__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_genstore__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_recipe__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_material__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_master_recipe_detail__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_master_uom__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MasterRecipeForm",
  props: {
    id: {
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_2__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: "master_recipe",
      formatted: ["action"],
      item: {
        id: null,
        uom_id: "",
        code: "",
        plucode: "",
        sku: "",
        name: "",
        usage: "",
        expired_in: "",
        price: 0,
        is_active: 1,
        is_daily_batch: 1
      },
      material: {},
      popup: {
        material: "",
        recipe: "",
        recipe_detail_usage: "",
        recipe_detail_status: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      uoms: [],
      materials: [],
      list_materials: [],
      recipes: [],
      recipe_details: [],
      recipe_list: [],
      recipe_details_by_recipe: [],
      columns_table: [{
        key: "recipe_or_material_code",
        label: "Recipe / Material Code"
      }, {
        key: "recipe_or_material_name",
        label: "Recipe / Material Name"
      }, {
        key: "usage_detail",
        label: "Usage Detail"
      }, {
        key: "uom"
      }, {
        key: "status",
        formatter: function formatter(value) {
          return parseInt(value) == 0 ? "Not active" : "Active";
        }
      }, {
        key: "detail_price",
        label: "Price"
      }, {
        key: "action"
      }],
      data_table: [],
      selected: 1,
      isHidden: true,
      index: 0,
      is_edit: false,
      index_edit: ""
    };
  },
  methods: {
    showModal: function showModal() {
      this.$refs["my-modal"].show();
    },
    switchTab: function switchTab(data) {
      if (data) {
        this.selected = true;
      } else {
        this.selected = false;
      }
      this.isHidden = data;
    },
    addNew: function addNew() {
      this.showModal();
      this.clearForm();
      this.setRecipes();
    },
    removeRecipeDeTail: function removeRecipeDeTail(index) {
      this.item.price = parseInt(this.item.price) - parseInt(this.data_table[index].detail_price);
      this.data_table.splice(index, 1);
      this.recipe_details.splice(index, 1);
    },
    editRecipeDeTail: function editRecipeDeTail(index, row) {
      var _this = this;

      this.is_edit = true;
      this.index_edit = index;
      this.recipe_details.forEach(function (item, key) {
        if (key === index) {
          if (!item.other_recipe_id) {
            _this.selected = true;
            _this.popup.material = {
              value: item.material_id,
              label: row.recipe_or_material_code + "-" + row.recipe_or_material_name
            };
          } else {
            _this.selected = false;
            _this.popup.recipe = {
              value: item.other_recipe_id,
              label: row.recipe_or_material_code + "-" + row.recipe_or_material_name
            };
          }
          _this.popup.recipe_detail_usage = item.usage;
          _this.isHidden = _this.selected;
          return;
        }
      });
      this.showModal();
    },
    clearForm: function clearForm() {
      this.selected = true;
      this.popup.material = "";
      this.popup.recipe_detail_usage = "";
      this.popup.recipe_detail_status = 1;
      this.popup.recipe = "";
    },
    handleAdd: function handleAdd() {
      var _this2 = this;

      if (isNaN(this.popup.recipe_detail_usage)) {
        this.$notify({
          title: this.$t("error"),
          text: "Usage must be numeric!",
          type: "error"
        });
        return;
      }
      if (this.selected) {
        if (!this.popup.material) {
          this.$notify({
            title: this.$t("error"),
            text: "Please choose Material",
            type: "error"
          });
          return;
        }
        var data_display = {
          recipe_or_material_code: this.material.code,
          recipe_or_material_name: this.material.name,
          weight: this.material.recipe_rate,
          uom: this.material.uom_name,
          usage_detail: this.popup.recipe_detail_usage,
          status: this.popup.recipe_detail_status,
          detail_price: this.material.price
        };
        var data_save = {
          recipe_id: this.item.id,
          material_id: this.popup.material.value,
          other_recipe_id: "",
          weight: this.material.recipe_rate,
          price: this.material.price,
          usage: this.popup.recipe_detail_usage,
          is_active: this.popup.recipe_detail_status
        };
        if (this.is_edit) {
          var data_table = this.data_table;
          var recipe_details = this.recipe_details;
          data_table.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              _this2.item.price = parseInt(_this2.item.price) + parseInt(_this2.material.price) - parseInt(item.detail_price);
              Vue.set(_this2.data_table, key, data_display);
              return;
            }
          });
          recipe_details.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              Vue.set(_this2.recipe_details, key, data_save);
              return;
            }
          });
          this.is_edit = false;
          this.index_edit = "";
        } else {
          this.data_table.push(data_display);
          this.recipe_details.push(data_save);
          this.item.price = parseInt(this.item.price) + parseInt(this.material.price);
        }
        this.hideModal();
      } else {
        if (!this.popup.recipe) {
          this.$notify({
            title: this.$t("error"),
            text: "Please choose recipe",
            type: "error"
          });
          return;
        }

        var recipe_display = [];
        for (var i in this.recipe_list) {
          if (this.recipe_list[i].id == this.popup.recipe.value) {
            recipe_display = this.recipe_list[i];
          }
        }
        var _data_display = {
          recipe_or_material_code: recipe_display.code,
          recipe_or_material_name: recipe_display.name,
          weight: recipe_display.usage,
          uom: recipe_display.uom_name,
          usage_detail: this.popup.recipe_detail_usage,
          status: this.popup.recipe_detail_status,
          detail_price: recipe_display.price,

          _rowVariant: "success"
        };
        var _data_save = {
          recipe_id: this.item.id,
          material_id: "",
          other_recipe_id: this.popup.recipe.value,
          weight: recipe_display.usage,
          price: recipe_display.price,
          usage: this.popup.recipe_detail_usage,
          is_active: this.popup.recipe_detail_status
        };
        if (this.is_edit) {
          var _data_table = this.data_table;
          var _recipe_details = this.recipe_details;
          _data_table.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              _this2.item.price = parseInt(_this2.item.price) + parseInt(recipe_display.price) - parseInt(item.detail_price);
              Vue.set(_this2.data_table, key, _data_display);
              return;
            }
          });
          _recipe_details.forEach(function (item, key) {
            if (key === _this2.index_edit) {
              Vue.set(_this2.recipe_details, key, _data_save);
              return;
            }
          });
          this.is_edit = false;
          this.index_edit = "";
        } else {
          this.data_table.push(_data_display);
          this.recipe_details.push(_data_save);
          this.item.price = parseInt(this.item.price) + parseInt(recipe_display.price);
        }
        this.hideModal();
      }
      this.clearForm();
    },
    hideModal: function hideModal() {
      this.$refs["my-modal"].hide();
    },
    getListUom: function getListUom() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_6__api_master_uom__["e" /* getMasterUomList */])().then(function (response) {
        for (var i in response.data.data) {
          _this3.uoms.push({
            label: response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    getListRecipe: function getListRecipe() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["e" /* getMasterRecipeList */])().then(function (response) {
        for (var i in response.data.data) {
          if (parseInt(response.data.data[i].id) !== parseInt(_this4.id)) {
            _this4.recipes.push({
              label: response.data.data[i].code + "-" + response.data.data[i].name,
              value: response.data.data[i].id
            });
            _this4.recipe_list.push(response.data.data[i]);
          }
        }
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    getListRecipeDetailDefault: function getListRecipeDetailDefault() {
      var _this5 = this;

      this.$Progress.start();
      var param = {
        recipe_id: parseInt(this.id)
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__api_master_recipe_detail__["a" /* getMasterRecipeDetailByRecipe */])(param).then(function (response) {
        for (var i in response.data.data) {
          _this5.recipe_details.push(response.data.data[i]);
          var bg_color = "";
          if (typeof response.data.data[i].other_recipe_id != "undefined" && response.data.data[i].other_recipe_id) {
            bg_color = "success";
          }
          _this5.index = parseInt(i);
          _this5.data_table.push({
            recipe_or_material_code: response.data.data[i].code,
            recipe_or_material_name: response.data.data[i].name,
            weight: response.data.data[i].weight,
            uom: response.data.data[i].uom,
            usage_detail: response.data.data[i].usage,
            status: response.data.data[i].is_active,
            detail_price: response.data.data[i].price,

            _rowVariant: bg_color
          });
        }
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    },
    getMaterial: function getMaterial() {
      for (var i in this.list_materials) {
        if (this.list_materials[i].id == this.popup.material.value) {
          this.material = this.list_materials[i];
        }
      }
    },
    getListMaterials: function getListMaterials() {
      var _this6 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
        for (var i in response.data.data) {
          _this6.materials.push({
            label: response.data.data[i].code + "-" + response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
        _this6.list_materials = response.data.data;
      }).catch(function (error) {
        _this6.$notify({
          title: _this6.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this6.$Progress.finish();
      });
    },
    getDetails: function getDetails() {
      var _this7 = this;

      this.$Progress.start();
      var params = {
        id: parseInt(this.id)
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["d" /* get */])(params).then(function (response) {
        _this7.item = response.data.data;
      }).catch(function (error) {
        _this7.$notify({
          title: _this7.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this7.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this8 = this;

      this.$Progress.start();
      var recipe = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      recipe.uom_id = this.item.uom_id.value;
      var data = {
        recipe: recipe,
        recipe_details: this.recipe_details
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["f" /* update */])(data).then(function (response) {
        _this8.$notify({
          title: _this8.$t("success"),
          text: response.data.message,
          type: "success"
        });
        _this8.$router.push({ name: _this8.model });
      }).catch(function (error) {
        _this8.$notify({
          title: _this8.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this8.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this9 = this;

      this.$Progress.start();
      var recipe = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.item);
      if (recipe.uom_id != false) {
        recipe.uom_id = this.item.uom_id.value;
      }
      var data = {
        recipe: recipe,
        recipe_details: this.recipe_details
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_recipe__["b" /* create */])(data).then(function (response) {
        _this9.$notify({
          title: _this9.$t("success"),
          text: response.data.message,
          type: "success"
        });
        _this9.$router.push({ name: _this9.model });
      }).catch(function (error) {
        _this9.$notify({
          title: _this9.$t("error"),
          text: error.data.message,
          type: "error"
        });
      }).then(function () {
        _this9.$Progress.finish();
      });
    },
    setRecipes: function setRecipes() {
      var _this10 = this;

      this.$set(this, 'recipes', Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["filter"])(this.recipes, function (o) {
        return o.label.split('-')[0] !== _this10.item.code;
      }));
    }
  },
  created: function created() {
    this.getListUom();
    this.getListRecipe();
    this.getListMaterials();
    if (this.id != null) {
      this.getDetails();
      this.getListRecipeDetailDefault();
    } else {
      this.item.id = "";
    }
  },
  watch: {
    "popup.material": function popupMaterial() {
      this.getMaterial();
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_recipe__ = __webpack_require__(104);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterRecipeList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_recipe',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'code',
          search: true,
          sort: false
        }, {
          name: 'name',
          search: true,
          sort: false
        }, {
          name: 'plucode',
          search: true,
          sort: true
        }, {
          name: 'usage',
          search: true,
          sort: true
        }, {
          name: 'uom_name',
          search: false,
          sort: true
        }, {
          name: 'expired_in',
          search: true,
          sort: true
        }, {
          name: 'price',
          search: true,
          sort: true
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(id, value, type) {
      var _this = this;

      this.$Progress.start();
      var data = {
        id: id
      };
      if (type === 'active') {
        data.is_active = value;
      } else {
        data.is_daily_batch = value;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_recipe__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_recipe__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_supplier__ = __webpack_require__(68);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialDetailSupplier',
  props: {
    material_detail_id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material_detail_supplier',
      item: {
        new: true,
        material_detail_id: null,
        supplier_ids: '',
        is_active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      material_details: [],
      suppliers: []
    };
  },
  methods: {
    getListMaterialDetail: function getListMaterialDetail() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material_detail__["f" /* getMasterMaterialDetail */])().then(function (response) {
        for (var i in response.data.data) {
          _this.material_details.push({
            label: response.data.data[i].code + ' - ' + response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getListSupplier: function getListSupplier() {
      var _this2 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_4__api_master_supplier__["e" /* getMasterSupplierList */])().then(function (response) {
        for (var i in response.data.data) {
          _this2.suppliers.push({
            label: response.data.data[i].code + ' - ' + response.data.data[i].name,
            value: response.data.data[i].id
          });
        }
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        material_detail_id: this.material_detail_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__["d" /* get */])(params).then(function (response) {
        _this3.item = response.data.data;
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = {
        'material_detail_id': this.item.material_detail_id.value,
        'supplier_ids': [],
        'is_active': this.item.is_active
      };
      for (var i in this.item.supplier_ids) {
        param.supplier_ids.push(this.item.supplier_ids[i].value);
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__["e" /* update */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this5 = this;

      this.$Progress.start();
      var param = {
        'material_detail_id': this.item.material_detail_id.value,
        'is_active': this.item.is_active,
        'supplier_ids': []
      };
      for (var i in this.item.supplier_ids) {
        param.supplier_ids.push(this.item.supplier_ids[i].value);
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_detail_supplier__["b" /* create */])(param).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getListMaterialDetail();
    this.getListSupplier();
    if (this.material_detail_id != null) {
      this.item.new = false;
      this.getDetail();
    } else {
      this.item.material_detail_id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeStatusItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["e"] = update;
/* unused harmony export getMaterialDetailSupplierList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail-supplier/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail-supplier/update-status',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail-supplier/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail-supplier/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail-supplier/update',
    method: 'put',
    data: data
  });
}

function getMaterialDetailSupplierList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-detail-supplier/common-list',
    method: 'get'
  });
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material_detail_supplier__ = __webpack_require__(238);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialDetailSupplierList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material_detail_supplier',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'material_detail_name',
          search: true,
          sort: true
        }, {
          name: 'supplier_names',
          search: false,
          sort: false
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(material_detail_id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        material_detail_id: material_detail_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail_supplier__["a" /* changeStatusItem */])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_detail_supplier__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_master_material__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_master_recipe__ = __webpack_require__(104);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialRecipeMapping',
  props: {
    material_recipe_mapping_id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'master_material_recipe_mapping',
      item: {
        new: true,
        id: null,
        source_type: '',
        source_code: '',
        destination_type: '',
        destination_code: '',
        active: 1
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      materials: [],
      source_type: [{ label: 'Choose type', value: 0 }, { label: 'Material', value: 1 }, { label: 'Recipe', value: 2 }],
      source_codes: [],
      destination_codes: []
    };
  },
  methods: {
    getListSource: function getListSource(type) {
      var _this = this;

      this.$Progress.start();
      if (type === 1) {
        this.$Progress.start();
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
          for (var i in response.data.data) {
            _this.source_codes.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this.$notify({
            title: _this.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this.$Progress.finish();
        });
      } else if (type === 2) {
        Object(__WEBPACK_IMPORTED_MODULE_4__api_master_recipe__["e" /* getMasterRecipeList */])().then(function (response) {
          for (var i in response.data.data) {
            _this.source_codes.push({
              label: response.data.data[i].code + '-' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this.$notify({
            title: _this.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this.$Progress.finish();
        });
      }
    },
    getListDestination: function getListDestination(type) {
      var _this2 = this;

      this.$Progress.start();
      if (type === 1) {
        this.$Progress.start();
        Object(__WEBPACK_IMPORTED_MODULE_3__api_master_material__["f" /* getMasterMaterialList */])().then(function (response) {
          for (var i in response.data.data) {
            _this2.destination_codes.push({
              label: response.data.data[i].code + ' - ' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this2.$notify({
            title: _this2.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this2.$Progress.finish();
        });
      } else if (type === 2) {
        Object(__WEBPACK_IMPORTED_MODULE_4__api_master_recipe__["e" /* getMasterRecipeList */])().then(function (response) {
          for (var i in response.data.data) {
            _this2.destination_codes.push({
              label: response.data.data[i].code + '-' + response.data.data[i].name,
              value: response.data.data[i].id,
              code: response.data.data[i].code
            });
          }
        }).catch(function (error) {
          _this2.$notify({
            title: _this2.$t('error'),
            text: error.data.message,
            type: 'error'
          });
        }).then(function () {
          _this2.$Progress.finish();
        });
      }
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.$Progress.start();
      var params = {
        material_recipe_mapping_id: this.material_recipe_mapping_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__["d" /* get */])(params).then(function (response) {
        _this3.item = response.data.data;
        _this3.getListSource(_this3.item.source_type.value);
        _this3.getListDestination(_this3.item.destination_type.value);
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this4 = this;

      this.$Progress.start();
      var param = {};
      param.id = this.material_recipe_mapping_id;
      param.source_type = this.item.source_type.value;
      param.source_id = this.item.source_code.value;
      param.source_code = this.item.source_code.code;
      param.destination_type = this.item.destination_type.value;
      param.destination_id = this.item.destination_code.value;
      param.destination_code = this.item.destination_code.code;
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__["e" /* update */])(param).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this5 = this;

      this.$Progress.start();
      var param = {};
      param.source_type = this.item.source_type.value;
      param.source_id = this.item.source_code.value;
      param.source_code = this.item.source_code.code;
      param.destination_type = this.item.destination_type.value;
      param.destination_id = this.item.destination_code.value;
      param.destination_code = this.item.destination_code.code;
      Object(__WEBPACK_IMPORTED_MODULE_2__api_master_material_recipe_mapping__["b" /* create */])(param).then(function (response) {
        _this5.$notify({
          title: _this5.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this5.$router.push({ name: _this5.model });
      }).catch(function (error) {
        _this5.$notify({
          title: _this5.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this5.$Progress.finish();
      });
    }
  },
  created: function created() {
    if (this.material_recipe_mapping_id != null) {
      this.item.new = false;
      this.getDetail();
    } else {
      this.item.material_recipe_mapping_id = '';
    }
  },
  watch: {
    'item.source_type': function itemSource_type() {
      this.source_codes = [];
      if (this.item.source_type.value !== 0) {
        this.getListSource(this.item.source_type.value);
      }
    },
    'item.destination_type': function itemDestination_type() {
      this.destination_codes = [];
      if (this.item.destination_type.value !== 0) {
        this.getListDestination(this.item.destination_type.value);
      }
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
/* harmony export (immutable) */ __webpack_exports__["e"] = update;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-recipe-mapping/list',
    method: 'get',
    params: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-recipe-mapping/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-recipe-mapping/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-material-recipe-mapping/update',
    method: 'put',
    data: data
  });
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_master_material_recipe_mapping__ = __webpack_require__(241);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MasterMaterialRecipeMappingList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'master_material_recipe_mapping',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'source_type_name',
          search: false,
          sort: false
        }, {
          name: 'source_code',
          search: false,
          sort: false
        }, {
          name: 'destination_type_name',
          search: false,
          sort: false
        }, {
          name: 'destination_code',
          search: false,
          sort: false
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateStatusItem: function updateStatusItem(material_detail_id, is_active) {
      var _this = this;

      this.$Progress.start();
      var data = {
        is_active: is_active,
        material_detail_id: material_detail_id
      };
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_recipe_mapping__["changeStatusItem"])(data).then(function (response) {
        _this.$notify({
          title: _this.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this.refreshData();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }
      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_master_material_recipe_mapping__["c" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    }
  },
  created: function created() {
    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }
    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Switch__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_sync_master__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_table_sync__ = __webpack_require__(1251);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyncMasterForm',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_Switch__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      model: 'sync_master',
      tableSyncData: [],
      item: {
        id: null,
        version: '',
        tableSyncIds: []
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    checkAll: function checkAll(val) {
      this.item.tableSyncIds = [];
      if (val.target.checked) {
        for (var i in this.tableSyncData) {
          this.item.tableSyncIds.push(this.tableSyncData[i].id);
        }
      }
    },
    getTableSync: function getTableSync() {
      var _this = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_3__api_table_sync__["a" /* getTableSyncList */])().then(function (response) {
        _this.$Progress.finish();
        _this.tableSyncData = response.data.data;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        id: this.id
      };
      Object(__WEBPACK_IMPORTED_MODULE_2__api_sync_master__["get"])(params).then(function (response) {
        _this2.item = response.data.data;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_sync_master__["update"])(this.item).then(function (response) {
        _this3.$notify({
          title: _this3.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this3.$router.push({ name: _this3.model });
      }).catch(function (error) {
        _this3.$notify({
          title: _this3.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this3.$Progress.finish();
      });
    },
    createItem: function createItem() {
      var _this4 = this;

      this.$Progress.start();
      Object(__WEBPACK_IMPORTED_MODULE_2__api_sync_master__["a" /* create */])(this.item).then(function (response) {
        _this4.$notify({
          title: _this4.$t('success'),
          text: response.data.message,
          type: 'success'
        });
        _this4.$router.push({ name: _this4.model });
      }).catch(function (error) {
        _this4.$notify({
          title: _this4.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this4.$Progress.finish();
      });
    }
  },
  created: function created() {
    this.getTableSync();
    if (this.id != null) {
      this.getDetail();
    } else {
      this.item.id = '';
    }
  },
  watch: {}
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAll;
/* harmony export (immutable) */ __webpack_exports__["d"] = syncData;
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/sync-master/list',
    method: 'get',
    params: data
  });
}

function syncData(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/sync-master/sync-data',
    method: 'post',
    data: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/sync-master/create',
    method: 'post',
    data: data
  });
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sync_master__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_report__ = __webpack_require__(51);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyncMasterList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'sync_master',
      field: null,
      key: null,
      popup: {
        storeData: []
      },
      filter: {
        options: [],
        selected: null,
        actived: null
      },
      item: {
        id: null,
        storeIds: []
      },
      dataTable: {
        body: [],
        header: [{
          name: 'version',
          search: true,
          sort: true
        }, {
          name: 'is_sync',
          search: true,
          sort: true,
          render: function render(data) {
            if (data) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    checkAll: function checkAll(val) {
      this.item.storeIds = [];
      if (val.target.checked) {
        for (var i in this.popup.storeData) {
          this.item.storeIds.push(this.popup.storeData[i].store_code);
        }
      }
    },
    confirm: function confirm() {
      this.showMsgToConfirm();
    },
    showMsgToConfirm: function showMsgToConfirm() {
      var _this = this;

      this.$bvModal.msgBoxConfirm('Are you sure for sync to real Store', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(function (value) {
        if (value) {
          _this.$Progress.start();
          var data = {
            id: _this.item.id,
            storeIds: _this.item.storeIds
          };
          Object(__WEBPACK_IMPORTED_MODULE_1__api_sync_master__["d" /* syncData */])(data).then(function (response) {
            _this.$notify({
              title: _this.$t('success'),
              text: response.data.message,
              type: 'success'
            });
            _this.refreshData();
          }).catch(function (error) {
            _this.$notify({
              title: _this.$t('error'),
              text: error.data.message,
              type: 'error'
            });
          }).then(function () {
            _this.$Progress.finish();
          });
        }
      }).catch(function (err) {});
    },
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this2 = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.actived != null) {
        params.is_active = this.filter.actived;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_sync_master__["b" /* fetchAll */])(params).then(function (response) {
        _this2.dataTable.body = response.data.data.items;
        _this2.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this2.$notify({
          title: _this2.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this2.$Progress.finish();
      });
    },
    showStores: function showStores(id) {
      this.item.storeIds = [];
      this.item.id = id;
      this.getStore();
      this.$refs['store-modal'].show();
    },
    getStore: function getStore() {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__api_report__["e" /* store */])().then(function (response) {
        _this3.popup.storeData = response.data.data;
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.actived': function filterActived() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_sync_master_detail__ = __webpack_require__(1258);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SyncMasterDetailList',
  components: {
    SelectDropdown: __WEBPACK_IMPORTED_MODULE_0__components_Partials_SelectDropdown__["a" /* default */]
  },
  data: function data() {
    return {
      model: 'sync_master_detail',
      field: null,
      key: null,
      filter: {
        options: [],
        selected: null,
        is_sync: null
      },
      dataTable: {
        body: [],
        header: [{
          name: 'version',
          search: true,
          sort: true
        }, {
          name: 'store_code',
          search: true,
          sort: true
        }, {
          name: 'file_name',
          search: true,
          sort: true
        }, {
          name: 'is_sync',
          search: true,
          sort: true,
          render: function render(data) {
            if (data) {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    updateSort: function updateSort(field) {
      for (var i in this.dataTable.header) {
        if (this.dataTable.header[i].name == field && (this.dataTable.header[i].sort == null || this.dataTable.header[i].sort == false)) {
          return;
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        };
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          };
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          };
        }
      }

      this.refreshData();
    },
    refreshData: function refreshData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      if (this.filter.is_sync != null) {
        params.is_sync = this.filter.is_sync;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__api_sync_master_detail__["a" /* fetchAll */])(params).then(function (response) {
        _this.dataTable.body = response.data.data.items;
        _this.dataTable.total = response.data.data.total;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    }
  },
  created: function created() {

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].search) && this.dataTable.header[i].search == true) {
        this.filter.options.push(this.dataTable.header[i].name);
      }
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.refreshData();
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    },
    'filter.is_sync': function filterIs_sync() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Bar__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Pie__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_report__ = __webpack_require__(51);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_2__charts_Bar__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_3__charts_Pie__["a" /* default */],
    SquareLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      total_sales: 0,
      total_cheque: 0,
      sos: 0,
      target_sales: 0,
      current: 0,
      target: 100,
      show_target: true,
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#9B59B6', '#73818f', '#4dbd74'],
        data: []
      },
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      sale_by_type_labels: {},
      sale_by_type_datasets: {},
      cheque_by_channel_labels: {},
      cheque_by_channel_datasets: {},
      cheque_by_type_labels: {},
      cheque_by_type_datasets: {}
    };
  },
  methods: {
    updateData: function updateData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        outlet_code: this.outlet.value
      };
      Object(__WEBPACK_IMPORTED_MODULE_5__api_report__["c" /* history */])(params).then(function (response) {
        _this.total_cheque = response.data.data.total_cheque;
        _this.target_sales = response.data.data.target;
        _this.total_sales = response.data.data.total_sale;
        _this.sos = response.data.data.sos;
        _this.sale_by_channel_datasets[0].data = [response.data.data.sales.online, response.data.data.sales.call_center, response.data.data.sales.offline, response.data.data.sales.offline_go_jek, response.data.data.sales.grab];
        _this.sale_by_type_datasets[0].data = [response.data.data.sales.takeaway, response.data.data.sales.delivery, response.data.data.sales.eat_in];
        _this.cheque_by_channel_datasets[0].data = [response.data.data.bill.online, response.data.data.bill.call_center, response.data.data.bill.offline, response.data.data.bill.offline_go_jek, response.data.data.bill.grab];
        _this.cheque_by_type_datasets[0].data = [response.data.data.bill.takeaway, response.data.data.bill.delivery, response.data.data.bill.eat_in];

        for (var i in _this.languages) {
          _this.sale_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.sales.online / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.sales.call_center / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.sales.offline / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.sales.offline_go_jek / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.sales.grab / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.sale_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.sales.takeaway / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.sales.delivery / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.sales.eat_in / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.cheque_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.bill.online / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.bill.call_center / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.bill.offline / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.bill.offline_go_jek / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.bill.grab / response.data.data.total_cheque * 100).toFixed(2) + '%'];
          _this.cheque_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.bill.takeaway / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.bill.delivery / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.bill.eat_in / response.data.data.total_cheque * 100).toFixed(2) + '%'];
        }

        _this.updateProcess();
        _this.loading = false;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    updateProcess: function updateProcess() {
      var _this2 = this;

      this.show_target = false;
      var goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales;
      this.current = this.total_sales * 100 / goal;
      this.target = this.target_sales * 100 / goal;
      setTimeout(function () {
        _this2.show_target = true;
      }, 2000);
    }
  },
  created: function created() {
    var _this3 = this;

    for (var i in this.languages) {
      this.sale_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.sale_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
      this.cheque_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.cheque_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
    }
    var pieSalesChannelData = this._.cloneDeep(this.pie_data);
    var pieSalesTypeData = this._.cloneDeep(this.pie_data);
    var pieBillChannelData = this._.cloneDeep(this.pie_data);
    var pieBillTypeData = this._.cloneDeep(this.pie_data);
    this.sale_by_channel_datasets = [pieSalesChannelData];
    this.sale_by_type_datasets = [pieSalesTypeData];
    this.cheque_by_channel_datasets = [pieBillChannelData];
    this.cheque_by_type_datasets = [pieBillTypeData];
    this.$Progress.start();
    Object(__WEBPACK_IMPORTED_MODULE_5__api_report__["e" /* store */])().then(function (response) {
      _this3.outlets = {};
      for (var l in _this3.languages) {
        _this3.outlets[_this3.languages[l]] = [];
        _this3.outlets[_this3.languages[l]].push({
          label: _this3.$t('all', _this3.languages[l]),
          value: null
        });
        for (var _i in response.data.data) {
          _this3.outlets[_this3.languages[l]].push({
            label: response.data.data[_i].name,
            value: response.data.data[_i].store_code
          });
          if (_this3.outlet.value == response.data.data[_i].store_code) {
            _this3.outlet.label = response.data.data[_i].name;
          }
        }
      }

      _this3.updateData();
      _this3.updateProcess();

      setInterval(function () {
        _this3.updateData();
        _this3.updateProcess();
      }, 5 * 60 * 1000);
    }).catch(function (error) {
      _this3.$notify({
        title: _this3.$t('error'),
        text: error.response.data.message,
        type: 'error'
      });
    }).then(function () {
      _this3.$Progress.finish();
    });
  },
  watch: {
    outlet: function outlet(val) {
      this.updateData();
      this.updateProcess();
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(107);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Array,
      required: true
    }
  },
  methods: {
    render: function render() {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels;
        this.$data._chart.data.datasets = this.datasets;
        this.$data._chart.update();
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, {
          legend: {
            fullWidth: true
          },
          animation: {
            duration: 500,
            easing: 'linear'
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    labels: function labels(val) {
      this.render();
    },
    datasets: function datasets(val) {
      this.render();
    }
  }
});

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(107);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      required: true
    }
  },
  methods: {
    render: function render() {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels;
        this.$data._chart.data.datasets = this.datasets;
        this.$data._chart.update();
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, { responsive: true, maintainAspectRatio: false });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    labels: function labels(val) {
      this.render();
    },
    'datasets.0.data': function datasets0Data(val) {
      this.render();
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'SquareLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '50px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size
      }
    };
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Bar__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Pie__ = __webpack_require__(108);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_2__charts_Bar__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_3__charts_Pie__["a" /* default */]
  },
  data: function data() {
    return {
      startDate: this.$moment().format('YYYY-MM-DD'),
      endDate: this.$moment().subtract(7, 'day').format('YYYY-MM-DD'),
      outlet: null,
      type: 'weekly',
      permissions: {},
      total_sales: 736254122,
      total_cheque: 231233,
      sos: 90.23,
      target_sales: 632562541,
      current: 0,
      target: 100,
      show_target: true,
      bar_data: {
        label: '',
        backgroundColor: '#20a8d8',
        data: []
      },
      bar_line_data: {
        label: '',
        data: [],
        type: 'line',
        pointStyle: 'line',
        backgroundColor: '#f86c6b',
        pointBackgroundColor: '#f86c6b',
        pointBorderColor: '#f86c6b',
        showLine: false,
        fill: false
      },
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#4dbd74', '#63c2de', '#73818f'],
        data: []
      },
      sale_trend_labels: {},
      sale_trend_datasets: {},
      cheque_trend_labels: {},
      cheque_trend_datasets: {},
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages)
    };
  },
  methods: {
    updateDateRange: function updateDateRange(val) {
      this.startDate = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.endDate = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.updateData();
    },
    updateData: function updateData() {
      var from = this.$moment(this.startDate, 'YYYY-MM-DD');
      var to = this.$moment(this.endDate, 'YYYY-MM-DD');
      var diff = from.diff(to, 'days');
      this.total_cheque = (Math.floor(Math.random() * 50 + 1) + 50) * diff;
      this.target_sales = this.total_cheque * (Math.floor(Math.random() * 5 + 1) + 80);
      this.total_sales = this.total_cheque * (Math.floor(Math.random() * 50 + 1) + 70);
      this.sos = Math.floor(Math.random() * 15 + 1) + 85;
      var online = (Math.floor(Math.random() * 10 + 1) + 20) * diff;
      var offline = (Math.floor(Math.random() * 10 + 1) + 15) * diff;
      var callcenter = (Math.floor(Math.random() * 10 + 1) + 10) * diff;
      var aggregator = (Math.floor(Math.random() * 10 + 1) + 5) * diff;
      for (var i in this.languages) {
        this.sale_by_channel_datasets[this.languages[i]][0].data = [online, callcenter, offline, aggregator];
      }
      this.updateProcess();
    },
    updateDataByType: function updateDataByType() {
      if (this.type == 'daily') {
        var saleData = [];
        var saleTarget = [];
        var chequeData = [];
        var chequeTarget = [];
        for (var i = 11; i >= 0; i--) {
          saleData.push(Math.floor(Math.random() * 50 + 1) + 65);
          saleTarget.push(Math.floor(Math.random() * 5 + 1) + 80);
          chequeData.push(Math.floor(Math.random() * 50 + 1) + 65);
          chequeTarget.push(Math.floor(Math.random() * 5 + 1) + 80);
        }

        for (var _i in this.languages) {
          this.sale_trend_datasets[this.languages[_i]][0].data = saleTarget;
          this.sale_trend_datasets[this.languages[_i]][1].data = saleData;
          this.cheque_trend_datasets[this.languages[_i]][0].data = chequeTarget;
          this.cheque_trend_datasets[this.languages[_i]][1].data = chequeData;
        }
      } else if (this.type == 'weekly') {
        var _saleData = [];
        var _saleTarget = [];
        var _chequeData = [];
        var _chequeTarget = [];

        for (var _i2 in this.languages) {
          this.sale_trend_labels[this.languages[_i2]] = [];
          this.cheque_trend_labels[this.languages[_i2]] = [];
        }

        for (var _i3 = 11; _i3 >= 0; _i3--) {
          _saleData.push((Math.floor(Math.random() * 50 + 1) + 50) * 7);
          _saleTarget.push((Math.floor(Math.random() * 5 + 1) + 80) * 7);
          _chequeData.push((Math.floor(Math.random() * 50 + 1) + 50) * 7);
          _chequeTarget.push((Math.floor(Math.random() * 5 + 1) + 80) * 7);
        }

        for (var _i4 in this.languages) {
          this.sale_trend_datasets[this.languages[_i4]][0].data = _saleTarget;
          this.sale_trend_datasets[this.languages[_i4]][1].data = _saleData;
          this.cheque_trend_datasets[this.languages[_i4]][0].data = _chequeTarget;
          this.cheque_trend_datasets[this.languages[_i4]][1].data = _chequeData;
        }
      } else if (this.type == 'monthly') {
        var _saleData2 = [];
        var _saleTarget2 = [];
        var _chequeData2 = [];
        var _chequeTarget2 = [];

        for (var _i5 in this.languages) {
          this.sale_trend_labels[this.languages[_i5]] = [];
          this.cheque_trend_labels[this.languages[_i5]] = [];
        }
        for (var _i6 = 11; _i6 >= 0; _i6--) {
          _saleData2.push((Math.floor(Math.random() * 50 + 1) + 50) * 30);
          _saleTarget2.push((Math.floor(Math.random() * 5 + 1) + 80) * 30);
          _chequeData2.push((Math.floor(Math.random() * 50 + 1) + 50) * 30);
          _chequeTarget2.push((Math.floor(Math.random() * 5 + 1) + 80) * 30);
        }

        for (var _i7 in this.languages) {
          this.sale_trend_datasets[this.languages[_i7]][0].data = _saleTarget2;
          this.sale_trend_datasets[this.languages[_i7]][1].data = _saleData2;
          this.cheque_trend_datasets[this.languages[_i7]][0].data = _chequeTarget2;
          this.cheque_trend_datasets[this.languages[_i7]][1].data = _chequeData2;
        }
      }
    },
    updateProcess: function updateProcess() {
      var _this = this;

      this.show_target = false;
      var goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales;
      this.current = this.total_sales * 100 / goal;
      this.target = this.target_sales * 100 / goal;
      setTimeout(function () {
        _this.show_target = true;
      }, 1000);
    },
    updateLabel: function updateLabel() {
      var dates = [];
      var dbDates = [];
      if (this.type == 'daily') {
        for (var i = 11; i >= 0; i--) {
          var date = this.$moment().subtract(i, 'day');
          dates.push(date.format('DD-MM-YYYY'));
          dbDates.push({
            start: date.format('YYYY-MM-DD') + ' 00:00:00',
            end: date.format('YYYY-MM-DD') + ' 23:59:59'
          });
        }

        for (var _i8 in this.languages) {
          this.sale_trend_labels[this.languages[_i8]] = dates;
          this.cheque_trend_labels[this.languages[_i8]] = dates;
        }
      } else if (this.type == 'weekly') {
        for (var _i9 in this.languages) {
          this.sale_trend_labels[this.languages[_i9]] = [];
          this.cheque_trend_labels[this.languages[_i9]] = [];
        }

        for (var _i10 = 11; _i10 >= 0; _i10--) {
          var _date = this.$moment().subtract(_i10 * 7, 'day');

          for (var _i11 in this.languages) {
            this.sale_trend_labels[this.languages[_i11]].push(this.$t(_date.format('Wo').toLowerCase(), this.languages[_i11]));
            this.cheque_trend_labels[this.languages[_i11]].push(this.$t(_date.format('Wo').toLowerCase(), this.languages[_i11]));
          }

          dbDates.push({
            start: _date.startOf('week').format('YYYY-MM-DD') + ' 00:00:00',
            end: _date.endOf('week').format('YYYY-MM-DD') + ' 23:59:59'
          });
        }
      } else if (this.type == 'monthly') {
        for (var _i12 in this.languages) {
          this.sale_trend_labels[this.languages[_i12]] = [];
          this.cheque_trend_labels[this.languages[_i12]] = [];
        }
        for (var _i13 = 11; _i13 >= 0; _i13--) {
          var _date2 = this.$moment().subtract(_i13, 'month');

          for (var _i14 in this.languages) {
            this.sale_trend_labels[this.languages[_i14]].push(this.$t(_date2.format('MMMM').toLowerCase(), this.languages[_i14]));
            this.cheque_trend_labels[this.languages[_i14]].push(this.$t(_date2.format('MMMM').toLowerCase(), this.languages[_i14]));
          }

          dbDates.push({
            start: _date2.startOf('month').format('YYYY-MM-DD') + ' 00:00:00',
            end: _date2.endOf('month').format('YYYY-MM-DD') + ' 23:59:59'
          });
        }
      }
    }
  },
  created: function created() {
    for (var i in this.languages) {
      this.sale_trend_labels[this.languages[i]] = [];
      this.cheque_trend_labels[this.languages[i]] = [];
      var barLineData = this._.cloneDeep(this.bar_line_data);
      barLineData.label = this.$t('target', this.languages[i]);
      var barData = this._.cloneDeep(this.bar_data);
      barData.label = this.$t('sales_amount', this.languages[i]);
      this.sale_trend_datasets[this.languages[i]] = [barLineData, barData];
      this.cheque_trend_datasets[this.languages[i]] = [barLineData, barData];
      this.sale_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('aggregator', this.languages[i])];
      var pieData = this._.cloneDeep(this.pie_data);
      this.sale_by_channel_datasets[this.languages[i]] = [pieData];
    }
    this.updateDataByType();
    this.updateLabel();
    this.updateData();
    this.permissions = {};
    for (var _i15 in this.$auth.user().permissions) {
      var per = this.$auth.user().permissions[_i15];
      var array = per.split('.');
      var model = array[0];
      var action = [];
      if (this.permissions[model] == null) {
        this.permissions[model] = {
          name: model,
          func: []
        };
      }
      for (var j in array) {
        if (j > 0) {
          action.push(array[j]);
        }
      }
      this.permissions[model].func.push(action.join('_'));
    }
  },
  watch: {
    type: function type(val) {
      this.updateDataByType();
      this.updateLabel();
    },
    outlet: function outlet(val) {
      this.updateData();
      this.updateDataByType();
      this.updateLabel();
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Bar__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_Pie__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_report__ = __webpack_require__(51);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SalesHistory',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Bar: __WEBPACK_IMPORTED_MODULE_2__charts_Bar__["a" /* default */],
    Pie: __WEBPACK_IMPORTED_MODULE_3__charts_Pie__["a" /* default */],
    SquareLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_SquareLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      total_sales: 0,
      total_cheque: 0,
      sos: 0,
      target_sales: 0,
      current: 0,
      target: 100,
      show_target: true,
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#9B59B6', '#73818f', '#4dbd74'],
        data: []
      },
      sale_by_channel_labels: {},
      sale_by_channel_datasets: {},
      sale_by_type_labels: {},
      sale_by_type_datasets: {},
      cheque_by_channel_labels: {},
      cheque_by_channel_datasets: {},
      cheque_by_type_labels: {},
      cheque_by_type_datasets: {}
    };
  },
  methods: {
    updateData: function updateData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date
      };
      Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["c" /* history */])(params).then(function (response) {
        _this.total_cheque = response.data.data.total_cheque;
        _this.target_sales = response.data.data.target;
        _this.total_sales = response.data.data.total_sale;
        _this.sos = response.data.data.sos;
        _this.sale_by_channel_datasets[0].data = [response.data.data.sales.online, response.data.data.sales.call_center, response.data.data.sales.offline, response.data.data.sales.offline_go_jek, response.data.data.sales.grab];
        _this.sale_by_type_datasets[0].data = [response.data.data.sales.takeaway, response.data.data.sales.delivery, response.data.data.sales.eat_in];
        _this.cheque_by_channel_datasets[0].data = [response.data.data.bill.online, response.data.data.bill.call_center, response.data.data.bill.offline, response.data.data.bill.offline_go_jek, response.data.data.bill.grab];
        _this.cheque_by_type_datasets[0].data = [response.data.data.bill.takeaway, response.data.data.bill.delivery, response.data.data.bill.eat_in];

        for (var i in _this.languages) {
          _this.sale_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.sales.online / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.sales.call_center / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.sales.offline / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.sales.offline_go_jek / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.sales.grab / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.sale_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.sales.takeaway / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.sales.delivery / response.data.data.total_sale * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.sales.eat_in / response.data.data.total_sale * 100).toFixed(2) + '%'];
          _this.cheque_by_channel_labels[_this.languages[i]] = [_this.$t('online', _this.languages[i]) + ' ' + (response.data.data.bill.online / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('call_center', _this.languages[i]) + ' ' + (response.data.data.bill.call_center / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline', _this.languages[i]) + ' ' + (response.data.data.bill.offline / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('offline_go_jek', _this.languages[i]) + ' ' + (response.data.data.bill.offline_go_jek / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('grab', _this.languages[i]) + ' ' + (response.data.data.bill.grab / response.data.data.total_cheque * 100).toFixed(2) + '%'];
          _this.cheque_by_type_labels[_this.languages[i]] = [_this.$t('takeaway', _this.languages[i]) + ' ' + (response.data.data.bill.takeaway / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('delivery', _this.languages[i]) + ' ' + (response.data.data.bill.delivery / response.data.data.total_cheque * 100).toFixed(2) + '%', _this.$t('eat_in', _this.languages[i]) + ' ' + (response.data.data.bill.eat_in / response.data.data.total_cheque * 100).toFixed(2) + '%'];
        }

        _this.updateProcess();
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.loading = false;
        _this.$Progress.finish();
      });
    },
    updateProcess: function updateProcess() {
      var _this2 = this;

      this.show_target = false;
      var goal = this.total_sales > this.target_sales ? this.total_sales : this.target_sales;
      this.current = this.total_sales * 100 / goal;
      this.target = this.target_sales * 100 / goal;
      setTimeout(function () {
        _this2.show_target = true;
      }, 2000);
    },
    refresh: function refresh() {
      this.updateData();
      this.updateProcess();
    },
    updateDate: function updateDate(val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.refresh();
    }
  },
  created: function created() {
    var _this3 = this;

    for (var i in this.languages) {
      this.sale_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.sale_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
      this.cheque_by_channel_labels[this.languages[i]] = [this.$t('online', this.languages[i]), this.$t('call_center', this.languages[i]), this.$t('offline', this.languages[i]), this.$t('offline_go_jek', this.languages[i]), this.$t('grab', this.languages[i])];
      this.cheque_by_type_labels[this.languages[i]] = [this.$t('takeaway', this.languages[i]), this.$t('delivery', this.languages[i]), this.$t('eat_in', this.languages[i])];
    }
    var pieSalesChannelData = this._.cloneDeep(this.pie_data);
    var pieSalesTypeData = this._.cloneDeep(this.pie_data);
    var pieBillChannelData = this._.cloneDeep(this.pie_data);
    var pieBillTypeData = this._.cloneDeep(this.pie_data);
    this.sale_by_channel_datasets = [pieSalesChannelData];
    this.sale_by_type_datasets = [pieSalesTypeData];
    this.cheque_by_channel_datasets = [pieBillChannelData];
    this.cheque_by_type_datasets = [pieBillTypeData];
    this.$Progress.start();
    Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["e" /* store */])().then(function (response) {
      _this3.outlets = {};
      for (var l in _this3.languages) {
        _this3.outlets[_this3.languages[l]] = [];
        _this3.outlets[_this3.languages[l]].push({
          label: _this3.$t('all', _this3.languages[l]),
          value: null
        });
        for (var _i in response.data.data) {
          _this3.outlets[_this3.languages[l]].push({
            label: response.data.data[_i].name,
            value: response.data.data[_i].store_code
          });

          if (_this3.outlet.value == response.data.data[_i].store_code) {
            _this3.outlet.label = response.data.data[_i].name;
          }
        }
      }

      _this3.refresh();

      setInterval(function () {
        _this3.refresh();
      }, 5 * 60 * 1000);
    }).catch(function (error) {
      _this3.$notify({
        title: _this3.$t('error'),
        text: error.response.data.message,
        type: 'error'
      });
    }).then(function () {
      _this3.$Progress.finish();
    });
  },
  watch: {}
});

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_Doughnut__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_report__ = __webpack_require__(51);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductMix',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_daterange_picker___default.a,
    Doughnut: __WEBPACK_IMPORTED_MODULE_2__charts_Doughnut__["a" /* default */],
    SquareLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_SquareLoader_vue__["a" /* default */],
    datePicker: __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default.a
  },
  data: function data() {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),
      pie_data: {
        backgroundColor: ['#20a8d8', '#f86c6b', '#ffc107', '#4dbd74', '#73818f', '#17A589', '#EB984E', '#9B59B6', '#34495E', '#D98880'],
        data: []
      },
      best_sale_data: [],
      best_sale_labels: [],
      best_sale_datasets: {}
    };
  },
  methods: {
    updateOutlet: function updateOutlet(val) {
      this.outlet = val;
    },
    updateData: function updateData() {
      var _this = this;

      this.$Progress.start();
      var params = {
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date,
        top: 10
      };
      Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["a" /* best_sale */])(params).then(function (response) {
        _this.best_sale_labels = [];
        _this.best_sale_datasets[0].data = [];
        _this.best_sale_data = [];
        for (var i in response.data.data) {
          var data = response.data.data[i];
          _this.best_sale_labels.push(data.menu_name);
          _this.best_sale_datasets[0].data.push(data.total);
          _this.best_sale_data.push({
            name: data.menu_name,
            total: data.total,
            color: _this.pie_data.backgroundColor[i]
          });
        }
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.loading = false;
        _this.$Progress.finish();
      });
    },
    refresh: function refresh() {
      this.updateData();
    },
    updateDate: function updateDate(val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.refresh();
    }
  },
  created: function created() {
    var _this2 = this;

    var bestSaleData = this._.cloneDeep(this.pie_data);
    this.best_sale_datasets = [bestSaleData];
    this.$Progress.start();
    Object(__WEBPACK_IMPORTED_MODULE_6__api_report__["e" /* store */])().then(function (response) {
      _this2.outlets = {};
      for (var l in _this2.languages) {
        _this2.outlets[_this2.languages[l]] = [];
        _this2.outlets[_this2.languages[l]].push({
          label: _this2.$t('all', _this2.languages[l]),
          value: null
        });
        for (var i in response.data.data) {
          _this2.outlets[_this2.languages[l]].push({
            label: response.data.data[i].name,
            value: response.data.data[i].store_code
          });

          if (_this2.outlet.value == response.data.data[i].store_code) {
            _this2.outlet.label = response.data.data[i].name;
          }
        }
      }

      _this2.refresh();

      setInterval(function () {
        _this2.refresh();
      }, 5 * 60 * 1000);
    }).catch(function (error) {
      _this2.$notify({
        title: _this2.$t('error'),
        text: error.response.data.message,
        type: 'error'
      });
    }).then(function () {
      _this2.$Progress.finish();
    });
  },
  watch: {}
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(107);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      required: true
    }
  },
  methods: {
    render: function render() {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels;
        this.$data._chart.data.datasets = this.datasets;
        this.$data._chart.update();
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          } });
      }
    }
  },
  mounted: function mounted() {
    this.render();
  },

  watch: {
    labels: function labels(val) {
      this.render();
    },
    'datasets.0.data': function datasets0Data(val) {
      this.render();
    }
  }
});

/***/ }),
/* 383 */,
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_report__ = __webpack_require__(51);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderProcessingTime',
  components: {
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_daterange_picker___default.a,
    SquareLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_SquareLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      date: new Date(),
      date_picker_options: {
        format: 'DD/MM/YYYY',
        useCurrent: true
      },
      start_date: this.$moment().subtract(6, 'day').format('YYYY-MM-DD'),
      end_date: this.$moment().format('YYYY-MM-DD'),
      locale: {
        format: 'DD/MM/YYYY',
        separator: ' - '
      },
      outlets: [],
      outlet: {
        label: this.$auth.user().store_code,
        value: this.$auth.user().store_code
      },
      languages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$i18n.messages),

      channel: [],

      filter: {
        channel: null
      },

      dataTable: {
        body: [],
        header: [{
          name: 'order_number',
          search: true,
          sort: true
        }, {
          name: 'channel',
          search: true,
          sort: true
        }, {
          name: 'order_type',
          search: true,
          sort: true
        }, {
          name: 'order_date',
          search: true,
          sort: true
        }, {
          name: 'sent_to_kds',
          search: true,
          sort: true
        }, {
          name: 'cooked',
          search: true,
          sort: true
        }, {
          name: 'delivery_start_time',
          search: true,
          sort: true
        }, {
          name: 'customer_recieved',
          search: true,
          sort: true
        }, {
          name: 'encashment_time',
          search: true,
          sort: true
        }, {
          name: 'sos_achived',
          search: false,
          sort: true,
          render: function render(data, row) {
            if (data == 'Y') {
              return '<span class="text-success"><i class="fa fa-check"></i></span>';
            }
            return '<span class="text-danger"><i class="fa fa-close"></i></span>';
          }
        }],
        sort: {
          field: null,
          type: 'asc'
        },
        offset: 1,
        total: 0,
        paginate: 10,
        source: null
      }
    };
  },
  methods: {
    refreshData: function refreshData() {
      var _this = this;

      this.loading = true;
      var params = {
        offset: this.dataTable.offset,
        paginate: this.dataTable.paginate,
        field: this.dataTable.sort.field,
        type: this.dataTable.sort.type,
        outlet_code: this.outlet.value,
        from_date: this.start_date,
        to_date: this.end_date
      };
      var str_search_key = '';
      if (this.field == null && !this._.isEmpty(this.key)) {
        for (var i in this.dataTable.header) {
          if (this.dataTable.header[i].search != null && this.dataTable.header[i].search == true) {
            if (str_search_key != '') {
              str_search_key += ',' + this.dataTable.header[i].name;
            } else {
              str_search_key += this.dataTable.header[i].name;
            }
          }
        }
        params.search_key = str_search_key;
        params.search_value = this.key.trim();
      } else {
        if (!this._.isEmpty(this.field) && !this._.isEmpty(this.key)) {
          params.search_key = this.field;
          params.search_value = this.key.trim();
        }
      }
      Object(__WEBPACK_IMPORTED_MODULE_3__api_report__["d" /* order_processing_time */])(params).then(function (response) {
        _this.dataTable.body = response.data.data.items;
        _this.dataTable.total = response.data.data.total;
        _this.loading = false;
      }).catch(function (error) {
        _this.$notify({
          title: _this.$t('error'),
          text: error.response.data.message,
          type: 'error'
        });
      }).then(function () {
        _this.$Progress.finish();
      });
    },
    refresh: function refresh() {
      this.refreshData();
    },
    updateDate: function updateDate(val) {
      this.start_date = this.$moment(val.startDate).format('YYYY-MM-DD');
      this.end_date = this.$moment(val.endDate).format('YYYY-MM-DD');
      this.refresh();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$Progress.start();

    for (var i in this.dataTable.header) {
      if (!!this._.isEmpty(this.dataTable.header[i].sort) && this.dataTable.header[i].sort == true && !this._.isEmpty(this.dataTable.sort.field)) {
        this.dataTable.sort = {
          field: this.dataTable.header[i].name,
          type: 'asc'
        };
      }
    }

    this.axios.request({
      method: 'get',
      url: "https://betapich.phsmk.id/report/v1/report" + '/store'
    }).then(function (response) {
      _this2.outlets = {};
      for (var l in _this2.languages) {
        _this2.outlets[_this2.languages[l]] = [];
        _this2.outlets[_this2.languages[l]].push({
          label: _this2.$t('all', _this2.languages[l]),
          value: null
        });
        for (var _i in response.data.data) {
          _this2.outlets[_this2.languages[l]].push({
            label: response.data.data[_i].name,
            value: response.data.data[_i].store_code
          });

          if (_this2.outlet.value == response.data.data[_i].store_code) {
            _this2.outlet.label = response.data.data[_i].name;
          }
        }
      }
    }).catch(function (error) {});

    Object(__WEBPACK_IMPORTED_MODULE_3__api_report__["b" /* config */])().then(function (response) {
      _this2.channel = {};
      for (var l in _this2.languages) {
        _this2.channel[_this2.languages[l]] = [];
        _this2.channel[_this2.languages[l]].push({
          text: _this2.$t('all', _this2.languages[l]),
          value: null
        });
        for (var c in response.data.data.channel) {
          _this2.channel[_this2.languages[l]].push({
            text: response.data.data.channel[c],
            value: response.data.data.channel[c]
          });
        }
      }
      _this2.refreshData();

      setInterval(function () {
        _this2.refreshData();
      }, 5 * 60 * 1000);
    }).catch(function (error) {}).then(function () {
      _this2.$Progress.finish();
    });
  },
  watch: {
    'dataTable.offset': function dataTableOffset() {
      this.refreshData();
    },
    'dataTable.paginate': function dataTablePaginate() {
      this.refreshData();
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_ChangeLangues_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    ChangeLanguage: __WEBPACK_IMPORTED_MODULE_0__components_Partials_ChangeLangues_vue__["a" /* default */]
  },
  data: function data() {
    return {
      body: {
        username: '',
        password: ''
      },
      error: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  validations: {
    body: {
      username: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    login: function login() {
      this.$Progress.start();
      this.$auth.login({
        data: {
          username: this.body.username,
          password: this.body.password
        },
        headers: {
          'Accept': 'application/json'
        },
        success: function success(response) {
          this.$Progress.finish();
          this.error = null;
        },
        error: function error(_error) {
          this.$Progress.fail();
          this.$notify({
            title: this.$t('error'),
            text: _error.response.data.message,
            type: 'error'
          });
          this.error = _error.response.data.message;
        }
      });
    }
  }
});

/***/ }),
/* 388 */,
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logout',
  components: {},
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {
    this.$auth.logout();
  }
});

/***/ }),
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1084);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(549)
  __webpack_require__(1078)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b95eafac", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports
exports.i(__webpack_require__(551), "");
exports.i(__webpack_require__(1064), "");
exports.i(__webpack_require__(1071), "");
exports.i(__webpack_require__(1076), "");

// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n/* Import Font Awesome Icons Set */\n/* Import Font Awesome Icons Set */\n$fa-font-path: '~font-awesome/fonts/';\n/* Import Simple Line Icons Set */\n$simple-line-font-path: '~simple-line-icons/fonts/';\n/* Import Bootstrap Vue Styles */\n", ""]);

// exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(64);
exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".flag-icon-background{background-size:contain;background-position:50%;background-repeat:no-repeat}.flag-icon{background-size:contain;background-position:50%;background-repeat:no-repeat;position:relative;display:inline-block;width:1.33333333em;line-height:1em}.flag-icon:before{content:\"\\A0\"}.flag-icon.flag-icon-squared{width:1em}.flag-icon-ad{background-image:url(" + escape(__webpack_require__(552)) + ")}.flag-icon-ad.flag-icon-squared{background-image:url(" + escape(__webpack_require__(553)) + ")}.flag-icon-ae{background-image:url(" + escape(__webpack_require__(554)) + ")}.flag-icon-ae.flag-icon-squared{background-image:url(" + escape(__webpack_require__(555)) + ")}.flag-icon-af{background-image:url(" + escape(__webpack_require__(556)) + ")}.flag-icon-af.flag-icon-squared{background-image:url(" + escape(__webpack_require__(557)) + ")}.flag-icon-ag{background-image:url(" + escape(__webpack_require__(558)) + ")}.flag-icon-ag.flag-icon-squared{background-image:url(" + escape(__webpack_require__(559)) + ")}.flag-icon-ai{background-image:url(" + escape(__webpack_require__(560)) + ")}.flag-icon-ai.flag-icon-squared{background-image:url(" + escape(__webpack_require__(561)) + ")}.flag-icon-al{background-image:url(" + escape(__webpack_require__(562)) + ")}.flag-icon-al.flag-icon-squared{background-image:url(" + escape(__webpack_require__(563)) + ")}.flag-icon-am{background-image:url(" + escape(__webpack_require__(564)) + ")}.flag-icon-am.flag-icon-squared{background-image:url(" + escape(__webpack_require__(565)) + ")}.flag-icon-ao{background-image:url(" + escape(__webpack_require__(566)) + ")}.flag-icon-ao.flag-icon-squared{background-image:url(" + escape(__webpack_require__(567)) + ")}.flag-icon-aq{background-image:url(" + escape(__webpack_require__(568)) + ")}.flag-icon-aq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(569)) + ")}.flag-icon-ar{background-image:url(" + escape(__webpack_require__(570)) + ")}.flag-icon-ar.flag-icon-squared{background-image:url(" + escape(__webpack_require__(571)) + ")}.flag-icon-as{background-image:url(" + escape(__webpack_require__(572)) + ")}.flag-icon-as.flag-icon-squared{background-image:url(" + escape(__webpack_require__(573)) + ")}.flag-icon-at{background-image:url(" + escape(__webpack_require__(574)) + ")}.flag-icon-at.flag-icon-squared{background-image:url(" + escape(__webpack_require__(575)) + ")}.flag-icon-au{background-image:url(" + escape(__webpack_require__(576)) + ")}.flag-icon-au.flag-icon-squared{background-image:url(" + escape(__webpack_require__(577)) + ")}.flag-icon-aw{background-image:url(" + escape(__webpack_require__(578)) + ")}.flag-icon-aw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(579)) + ")}.flag-icon-ax{background-image:url(" + escape(__webpack_require__(580)) + ")}.flag-icon-ax.flag-icon-squared{background-image:url(" + escape(__webpack_require__(581)) + ")}.flag-icon-az{background-image:url(" + escape(__webpack_require__(582)) + ")}.flag-icon-az.flag-icon-squared{background-image:url(" + escape(__webpack_require__(583)) + ")}.flag-icon-ba{background-image:url(" + escape(__webpack_require__(584)) + ")}.flag-icon-ba.flag-icon-squared{background-image:url(" + escape(__webpack_require__(585)) + ")}.flag-icon-bb{background-image:url(" + escape(__webpack_require__(586)) + ")}.flag-icon-bb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(587)) + ")}.flag-icon-bd{background-image:url(" + escape(__webpack_require__(588)) + ")}.flag-icon-bd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(589)) + ")}.flag-icon-be{background-image:url(" + escape(__webpack_require__(590)) + ")}.flag-icon-be.flag-icon-squared{background-image:url(" + escape(__webpack_require__(591)) + ")}.flag-icon-bf{background-image:url(" + escape(__webpack_require__(592)) + ")}.flag-icon-bf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(593)) + ")}.flag-icon-bg{background-image:url(" + escape(__webpack_require__(594)) + ")}.flag-icon-bg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(595)) + ")}.flag-icon-bh{background-image:url(" + escape(__webpack_require__(596)) + ")}.flag-icon-bh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(597)) + ")}.flag-icon-bi{background-image:url(" + escape(__webpack_require__(598)) + ")}.flag-icon-bi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(599)) + ")}.flag-icon-bj{background-image:url(" + escape(__webpack_require__(600)) + ")}.flag-icon-bj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(601)) + ")}.flag-icon-bl{background-image:url(" + escape(__webpack_require__(602)) + ")}.flag-icon-bl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(603)) + ")}.flag-icon-bm{background-image:url(" + escape(__webpack_require__(604)) + ")}.flag-icon-bm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(605)) + ")}.flag-icon-bn{background-image:url(" + escape(__webpack_require__(606)) + ")}.flag-icon-bn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(607)) + ")}.flag-icon-bo{background-image:url(" + escape(__webpack_require__(608)) + ")}.flag-icon-bo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(609)) + ")}.flag-icon-bq{background-image:url(" + escape(__webpack_require__(610)) + ")}.flag-icon-bq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(611)) + ")}.flag-icon-br{background-image:url(" + escape(__webpack_require__(612)) + ")}.flag-icon-br.flag-icon-squared{background-image:url(" + escape(__webpack_require__(613)) + ")}.flag-icon-bs{background-image:url(" + escape(__webpack_require__(614)) + ")}.flag-icon-bs.flag-icon-squared{background-image:url(" + escape(__webpack_require__(615)) + ")}.flag-icon-bt{background-image:url(" + escape(__webpack_require__(616)) + ")}.flag-icon-bt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(617)) + ")}.flag-icon-bv{background-image:url(" + escape(__webpack_require__(618)) + ")}.flag-icon-bv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(619)) + ")}.flag-icon-bw{background-image:url(" + escape(__webpack_require__(620)) + ")}.flag-icon-bw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(621)) + ")}.flag-icon-by{background-image:url(" + escape(__webpack_require__(622)) + ")}.flag-icon-by.flag-icon-squared{background-image:url(" + escape(__webpack_require__(623)) + ")}.flag-icon-bz{background-image:url(" + escape(__webpack_require__(624)) + ")}.flag-icon-bz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(625)) + ")}.flag-icon-ca{background-image:url(" + escape(__webpack_require__(626)) + ")}.flag-icon-ca.flag-icon-squared{background-image:url(" + escape(__webpack_require__(627)) + ")}.flag-icon-cc{background-image:url(" + escape(__webpack_require__(628)) + ")}.flag-icon-cc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(629)) + ")}.flag-icon-cd{background-image:url(" + escape(__webpack_require__(630)) + ")}.flag-icon-cd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(631)) + ")}.flag-icon-cf{background-image:url(" + escape(__webpack_require__(632)) + ")}.flag-icon-cf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(633)) + ")}.flag-icon-cg{background-image:url(" + escape(__webpack_require__(634)) + ")}.flag-icon-cg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(635)) + ")}.flag-icon-ch{background-image:url(" + escape(__webpack_require__(636)) + ")}.flag-icon-ch.flag-icon-squared{background-image:url(" + escape(__webpack_require__(637)) + ")}.flag-icon-ci{background-image:url(" + escape(__webpack_require__(638)) + ")}.flag-icon-ci.flag-icon-squared{background-image:url(" + escape(__webpack_require__(639)) + ")}.flag-icon-ck{background-image:url(" + escape(__webpack_require__(640)) + ")}.flag-icon-ck.flag-icon-squared{background-image:url(" + escape(__webpack_require__(641)) + ")}.flag-icon-cl{background-image:url(" + escape(__webpack_require__(642)) + ")}.flag-icon-cl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(643)) + ")}.flag-icon-cm{background-image:url(" + escape(__webpack_require__(644)) + ")}.flag-icon-cm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(645)) + ")}.flag-icon-cn{background-image:url(" + escape(__webpack_require__(646)) + ")}.flag-icon-cn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(647)) + ")}.flag-icon-co{background-image:url(" + escape(__webpack_require__(648)) + ")}.flag-icon-co.flag-icon-squared{background-image:url(" + escape(__webpack_require__(649)) + ")}.flag-icon-cr{background-image:url(" + escape(__webpack_require__(650)) + ")}.flag-icon-cr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(651)) + ")}.flag-icon-cu{background-image:url(" + escape(__webpack_require__(652)) + ")}.flag-icon-cu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(653)) + ")}.flag-icon-cv{background-image:url(" + escape(__webpack_require__(654)) + ")}.flag-icon-cv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(655)) + ")}.flag-icon-cw{background-image:url(" + escape(__webpack_require__(656)) + ")}.flag-icon-cw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(657)) + ")}.flag-icon-cx{background-image:url(" + escape(__webpack_require__(658)) + ")}.flag-icon-cx.flag-icon-squared{background-image:url(" + escape(__webpack_require__(659)) + ")}.flag-icon-cy{background-image:url(" + escape(__webpack_require__(660)) + ")}.flag-icon-cy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(661)) + ")}.flag-icon-cz{background-image:url(" + escape(__webpack_require__(662)) + ")}.flag-icon-cz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(663)) + ")}.flag-icon-de{background-image:url(" + escape(__webpack_require__(664)) + ")}.flag-icon-de.flag-icon-squared{background-image:url(" + escape(__webpack_require__(665)) + ")}.flag-icon-dj{background-image:url(" + escape(__webpack_require__(666)) + ")}.flag-icon-dj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(667)) + ")}.flag-icon-dk{background-image:url(" + escape(__webpack_require__(668)) + ")}.flag-icon-dk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(669)) + ")}.flag-icon-dm{background-image:url(" + escape(__webpack_require__(670)) + ")}.flag-icon-dm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(671)) + ")}.flag-icon-do{background-image:url(" + escape(__webpack_require__(672)) + ")}.flag-icon-do.flag-icon-squared{background-image:url(" + escape(__webpack_require__(673)) + ")}.flag-icon-dz{background-image:url(" + escape(__webpack_require__(674)) + ")}.flag-icon-dz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(675)) + ")}.flag-icon-ec{background-image:url(" + escape(__webpack_require__(676)) + ")}.flag-icon-ec.flag-icon-squared{background-image:url(" + escape(__webpack_require__(677)) + ")}.flag-icon-ee{background-image:url(" + escape(__webpack_require__(678)) + ")}.flag-icon-ee.flag-icon-squared{background-image:url(" + escape(__webpack_require__(679)) + ")}.flag-icon-eg{background-image:url(" + escape(__webpack_require__(680)) + ")}.flag-icon-eg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(681)) + ")}.flag-icon-eh{background-image:url(" + escape(__webpack_require__(682)) + ")}.flag-icon-eh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(683)) + ")}.flag-icon-er{background-image:url(" + escape(__webpack_require__(684)) + ")}.flag-icon-er.flag-icon-squared{background-image:url(" + escape(__webpack_require__(685)) + ")}.flag-icon-es{background-image:url(" + escape(__webpack_require__(686)) + ")}.flag-icon-es.flag-icon-squared{background-image:url(" + escape(__webpack_require__(687)) + ")}.flag-icon-et{background-image:url(" + escape(__webpack_require__(688)) + ")}.flag-icon-et.flag-icon-squared{background-image:url(" + escape(__webpack_require__(689)) + ")}.flag-icon-fi{background-image:url(" + escape(__webpack_require__(690)) + ")}.flag-icon-fi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(691)) + ")}.flag-icon-fj{background-image:url(" + escape(__webpack_require__(692)) + ")}.flag-icon-fj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(693)) + ")}.flag-icon-fk{background-image:url(" + escape(__webpack_require__(694)) + ")}.flag-icon-fk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(695)) + ")}.flag-icon-fm{background-image:url(" + escape(__webpack_require__(696)) + ")}.flag-icon-fm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(697)) + ")}.flag-icon-fo{background-image:url(" + escape(__webpack_require__(698)) + ")}.flag-icon-fo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(699)) + ")}.flag-icon-fr{background-image:url(" + escape(__webpack_require__(700)) + ")}.flag-icon-fr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(701)) + ")}.flag-icon-ga{background-image:url(" + escape(__webpack_require__(702)) + ")}.flag-icon-ga.flag-icon-squared{background-image:url(" + escape(__webpack_require__(703)) + ")}.flag-icon-gb{background-image:url(" + escape(__webpack_require__(704)) + ")}.flag-icon-gb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(705)) + ")}.flag-icon-gd{background-image:url(" + escape(__webpack_require__(706)) + ")}.flag-icon-gd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(707)) + ")}.flag-icon-ge{background-image:url(" + escape(__webpack_require__(708)) + ")}.flag-icon-ge.flag-icon-squared{background-image:url(" + escape(__webpack_require__(709)) + ")}.flag-icon-gf{background-image:url(" + escape(__webpack_require__(710)) + ")}.flag-icon-gf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(711)) + ")}.flag-icon-gg{background-image:url(" + escape(__webpack_require__(712)) + ")}.flag-icon-gg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(713)) + ")}.flag-icon-gh{background-image:url(" + escape(__webpack_require__(714)) + ")}.flag-icon-gh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(715)) + ")}.flag-icon-gi{background-image:url(" + escape(__webpack_require__(716)) + ")}.flag-icon-gi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(717)) + ")}.flag-icon-gl{background-image:url(" + escape(__webpack_require__(718)) + ")}.flag-icon-gl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(719)) + ")}.flag-icon-gm{background-image:url(" + escape(__webpack_require__(720)) + ")}.flag-icon-gm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(721)) + ")}.flag-icon-gn{background-image:url(" + escape(__webpack_require__(722)) + ")}.flag-icon-gn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(723)) + ")}.flag-icon-gp{background-image:url(" + escape(__webpack_require__(724)) + ")}.flag-icon-gp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(725)) + ")}.flag-icon-gq{background-image:url(" + escape(__webpack_require__(726)) + ")}.flag-icon-gq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(727)) + ")}.flag-icon-gr{background-image:url(" + escape(__webpack_require__(728)) + ")}.flag-icon-gr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(729)) + ")}.flag-icon-gs{background-image:url(" + escape(__webpack_require__(730)) + ")}.flag-icon-gs.flag-icon-squared{background-image:url(" + escape(__webpack_require__(731)) + ")}.flag-icon-gt{background-image:url(" + escape(__webpack_require__(732)) + ")}.flag-icon-gt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(733)) + ")}.flag-icon-gu{background-image:url(" + escape(__webpack_require__(734)) + ")}.flag-icon-gu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(735)) + ")}.flag-icon-gw{background-image:url(" + escape(__webpack_require__(736)) + ")}.flag-icon-gw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(737)) + ")}.flag-icon-gy{background-image:url(" + escape(__webpack_require__(738)) + ")}.flag-icon-gy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(739)) + ")}.flag-icon-hk{background-image:url(" + escape(__webpack_require__(740)) + ")}.flag-icon-hk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(741)) + ")}.flag-icon-hm{background-image:url(" + escape(__webpack_require__(742)) + ")}.flag-icon-hm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(743)) + ")}.flag-icon-hn{background-image:url(" + escape(__webpack_require__(744)) + ")}.flag-icon-hn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(745)) + ")}.flag-icon-hr{background-image:url(" + escape(__webpack_require__(746)) + ")}.flag-icon-hr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(747)) + ")}.flag-icon-ht{background-image:url(" + escape(__webpack_require__(748)) + ")}.flag-icon-ht.flag-icon-squared{background-image:url(" + escape(__webpack_require__(749)) + ")}.flag-icon-hu{background-image:url(" + escape(__webpack_require__(750)) + ")}.flag-icon-hu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(751)) + ")}.flag-icon-id{background-image:url(" + escape(__webpack_require__(752)) + ")}.flag-icon-id.flag-icon-squared{background-image:url(" + escape(__webpack_require__(753)) + ")}.flag-icon-ie{background-image:url(" + escape(__webpack_require__(754)) + ")}.flag-icon-ie.flag-icon-squared{background-image:url(" + escape(__webpack_require__(755)) + ")}.flag-icon-il{background-image:url(" + escape(__webpack_require__(756)) + ")}.flag-icon-il.flag-icon-squared{background-image:url(" + escape(__webpack_require__(757)) + ")}.flag-icon-im{background-image:url(" + escape(__webpack_require__(758)) + ")}.flag-icon-im.flag-icon-squared{background-image:url(" + escape(__webpack_require__(759)) + ")}.flag-icon-in{background-image:url(" + escape(__webpack_require__(760)) + ")}.flag-icon-in.flag-icon-squared{background-image:url(" + escape(__webpack_require__(761)) + ")}.flag-icon-io{background-image:url(" + escape(__webpack_require__(762)) + ")}.flag-icon-io.flag-icon-squared{background-image:url(" + escape(__webpack_require__(763)) + ")}.flag-icon-iq{background-image:url(" + escape(__webpack_require__(764)) + ")}.flag-icon-iq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(765)) + ")}.flag-icon-ir{background-image:url(" + escape(__webpack_require__(766)) + ")}.flag-icon-ir.flag-icon-squared{background-image:url(" + escape(__webpack_require__(767)) + ")}.flag-icon-is{background-image:url(" + escape(__webpack_require__(768)) + ")}.flag-icon-is.flag-icon-squared{background-image:url(" + escape(__webpack_require__(769)) + ")}.flag-icon-it{background-image:url(" + escape(__webpack_require__(770)) + ")}.flag-icon-it.flag-icon-squared{background-image:url(" + escape(__webpack_require__(771)) + ")}.flag-icon-je{background-image:url(" + escape(__webpack_require__(772)) + ")}.flag-icon-je.flag-icon-squared{background-image:url(" + escape(__webpack_require__(773)) + ")}.flag-icon-jm{background-image:url(" + escape(__webpack_require__(774)) + ")}.flag-icon-jm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(775)) + ")}.flag-icon-jo{background-image:url(" + escape(__webpack_require__(776)) + ")}.flag-icon-jo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(777)) + ")}.flag-icon-jp{background-image:url(" + escape(__webpack_require__(778)) + ")}.flag-icon-jp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(779)) + ")}.flag-icon-ke{background-image:url(" + escape(__webpack_require__(780)) + ")}.flag-icon-ke.flag-icon-squared{background-image:url(" + escape(__webpack_require__(781)) + ")}.flag-icon-kg{background-image:url(" + escape(__webpack_require__(782)) + ")}.flag-icon-kg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(783)) + ")}.flag-icon-kh{background-image:url(" + escape(__webpack_require__(784)) + ")}.flag-icon-kh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(785)) + ")}.flag-icon-ki{background-image:url(" + escape(__webpack_require__(786)) + ")}.flag-icon-ki.flag-icon-squared{background-image:url(" + escape(__webpack_require__(787)) + ")}.flag-icon-km{background-image:url(" + escape(__webpack_require__(788)) + ")}.flag-icon-km.flag-icon-squared{background-image:url(" + escape(__webpack_require__(789)) + ")}.flag-icon-kn{background-image:url(" + escape(__webpack_require__(790)) + ")}.flag-icon-kn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(791)) + ")}.flag-icon-kp{background-image:url(" + escape(__webpack_require__(792)) + ")}.flag-icon-kp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(793)) + ")}.flag-icon-kr{background-image:url(" + escape(__webpack_require__(794)) + ")}.flag-icon-kr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(795)) + ")}.flag-icon-kw{background-image:url(" + escape(__webpack_require__(796)) + ")}.flag-icon-kw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(797)) + ")}.flag-icon-ky{background-image:url(" + escape(__webpack_require__(798)) + ")}.flag-icon-ky.flag-icon-squared{background-image:url(" + escape(__webpack_require__(799)) + ")}.flag-icon-kz{background-image:url(" + escape(__webpack_require__(800)) + ")}.flag-icon-kz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(801)) + ")}.flag-icon-la{background-image:url(" + escape(__webpack_require__(802)) + ")}.flag-icon-la.flag-icon-squared{background-image:url(" + escape(__webpack_require__(803)) + ")}.flag-icon-lb{background-image:url(" + escape(__webpack_require__(804)) + ")}.flag-icon-lb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(805)) + ")}.flag-icon-lc{background-image:url(" + escape(__webpack_require__(806)) + ")}.flag-icon-lc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(807)) + ")}.flag-icon-li{background-image:url(" + escape(__webpack_require__(808)) + ")}.flag-icon-li.flag-icon-squared{background-image:url(" + escape(__webpack_require__(809)) + ")}.flag-icon-lk{background-image:url(" + escape(__webpack_require__(810)) + ")}.flag-icon-lk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(811)) + ")}.flag-icon-lr{background-image:url(" + escape(__webpack_require__(812)) + ")}.flag-icon-lr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(813)) + ")}.flag-icon-ls{background-image:url(" + escape(__webpack_require__(814)) + ")}.flag-icon-ls.flag-icon-squared{background-image:url(" + escape(__webpack_require__(815)) + ")}.flag-icon-lt{background-image:url(" + escape(__webpack_require__(816)) + ")}.flag-icon-lt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(817)) + ")}.flag-icon-lu{background-image:url(" + escape(__webpack_require__(818)) + ")}.flag-icon-lu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(819)) + ")}.flag-icon-lv{background-image:url(" + escape(__webpack_require__(820)) + ")}.flag-icon-lv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(821)) + ")}.flag-icon-ly{background-image:url(" + escape(__webpack_require__(822)) + ")}.flag-icon-ly.flag-icon-squared{background-image:url(" + escape(__webpack_require__(823)) + ")}.flag-icon-ma{background-image:url(" + escape(__webpack_require__(824)) + ")}.flag-icon-ma.flag-icon-squared{background-image:url(" + escape(__webpack_require__(825)) + ")}.flag-icon-mc{background-image:url(" + escape(__webpack_require__(826)) + ")}.flag-icon-mc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(827)) + ")}.flag-icon-md{background-image:url(" + escape(__webpack_require__(828)) + ")}.flag-icon-md.flag-icon-squared{background-image:url(" + escape(__webpack_require__(829)) + ")}.flag-icon-me{background-image:url(" + escape(__webpack_require__(830)) + ")}.flag-icon-me.flag-icon-squared{background-image:url(" + escape(__webpack_require__(831)) + ")}.flag-icon-mf{background-image:url(" + escape(__webpack_require__(832)) + ")}.flag-icon-mf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(833)) + ")}.flag-icon-mg{background-image:url(" + escape(__webpack_require__(834)) + ")}.flag-icon-mg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(835)) + ")}.flag-icon-mh{background-image:url(" + escape(__webpack_require__(836)) + ")}.flag-icon-mh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(837)) + ")}.flag-icon-mk{background-image:url(" + escape(__webpack_require__(838)) + ")}.flag-icon-mk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(839)) + ")}.flag-icon-ml{background-image:url(" + escape(__webpack_require__(840)) + ")}.flag-icon-ml.flag-icon-squared{background-image:url(" + escape(__webpack_require__(841)) + ")}.flag-icon-mm{background-image:url(" + escape(__webpack_require__(842)) + ")}.flag-icon-mm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(843)) + ")}.flag-icon-mn{background-image:url(" + escape(__webpack_require__(844)) + ")}.flag-icon-mn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(845)) + ")}.flag-icon-mo{background-image:url(" + escape(__webpack_require__(846)) + ")}.flag-icon-mo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(847)) + ")}.flag-icon-mp{background-image:url(" + escape(__webpack_require__(848)) + ")}.flag-icon-mp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(849)) + ")}.flag-icon-mq{background-image:url(" + escape(__webpack_require__(850)) + ")}.flag-icon-mq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(851)) + ")}.flag-icon-mr{background-image:url(" + escape(__webpack_require__(852)) + ")}.flag-icon-mr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(853)) + ")}.flag-icon-ms{background-image:url(" + escape(__webpack_require__(854)) + ")}.flag-icon-ms.flag-icon-squared{background-image:url(" + escape(__webpack_require__(855)) + ")}.flag-icon-mt{background-image:url(" + escape(__webpack_require__(856)) + ")}.flag-icon-mt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(857)) + ")}.flag-icon-mu{background-image:url(" + escape(__webpack_require__(858)) + ")}.flag-icon-mu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(859)) + ")}.flag-icon-mv{background-image:url(" + escape(__webpack_require__(860)) + ")}.flag-icon-mv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(861)) + ")}.flag-icon-mw{background-image:url(" + escape(__webpack_require__(862)) + ")}.flag-icon-mw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(863)) + ")}.flag-icon-mx{background-image:url(" + escape(__webpack_require__(864)) + ")}.flag-icon-mx.flag-icon-squared{background-image:url(" + escape(__webpack_require__(865)) + ")}.flag-icon-my{background-image:url(" + escape(__webpack_require__(866)) + ")}.flag-icon-my.flag-icon-squared{background-image:url(" + escape(__webpack_require__(867)) + ")}.flag-icon-mz{background-image:url(" + escape(__webpack_require__(868)) + ")}.flag-icon-mz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(869)) + ")}.flag-icon-na{background-image:url(" + escape(__webpack_require__(870)) + ")}.flag-icon-na.flag-icon-squared{background-image:url(" + escape(__webpack_require__(871)) + ")}.flag-icon-nc{background-image:url(" + escape(__webpack_require__(872)) + ")}.flag-icon-nc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(873)) + ")}.flag-icon-ne{background-image:url(" + escape(__webpack_require__(874)) + ")}.flag-icon-ne.flag-icon-squared{background-image:url(" + escape(__webpack_require__(875)) + ")}.flag-icon-nf{background-image:url(" + escape(__webpack_require__(876)) + ")}.flag-icon-nf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(877)) + ")}.flag-icon-ng{background-image:url(" + escape(__webpack_require__(878)) + ")}.flag-icon-ng.flag-icon-squared{background-image:url(" + escape(__webpack_require__(879)) + ")}.flag-icon-ni{background-image:url(" + escape(__webpack_require__(880)) + ")}.flag-icon-ni.flag-icon-squared{background-image:url(" + escape(__webpack_require__(881)) + ")}.flag-icon-nl{background-image:url(" + escape(__webpack_require__(882)) + ")}.flag-icon-nl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(883)) + ")}.flag-icon-no{background-image:url(" + escape(__webpack_require__(884)) + ")}.flag-icon-no.flag-icon-squared{background-image:url(" + escape(__webpack_require__(885)) + ")}.flag-icon-np{background-image:url(" + escape(__webpack_require__(886)) + ")}.flag-icon-np.flag-icon-squared{background-image:url(" + escape(__webpack_require__(887)) + ")}.flag-icon-nr{background-image:url(" + escape(__webpack_require__(888)) + ")}.flag-icon-nr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(889)) + ")}.flag-icon-nu{background-image:url(" + escape(__webpack_require__(890)) + ")}.flag-icon-nu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(891)) + ")}.flag-icon-nz{background-image:url(" + escape(__webpack_require__(892)) + ")}.flag-icon-nz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(893)) + ")}.flag-icon-om{background-image:url(" + escape(__webpack_require__(894)) + ")}.flag-icon-om.flag-icon-squared{background-image:url(" + escape(__webpack_require__(895)) + ")}.flag-icon-pa{background-image:url(" + escape(__webpack_require__(896)) + ")}.flag-icon-pa.flag-icon-squared{background-image:url(" + escape(__webpack_require__(897)) + ")}.flag-icon-pe{background-image:url(" + escape(__webpack_require__(898)) + ")}.flag-icon-pe.flag-icon-squared{background-image:url(" + escape(__webpack_require__(899)) + ")}.flag-icon-pf{background-image:url(" + escape(__webpack_require__(900)) + ")}.flag-icon-pf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(901)) + ")}.flag-icon-pg{background-image:url(" + escape(__webpack_require__(902)) + ")}.flag-icon-pg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(903)) + ")}.flag-icon-ph{background-image:url(" + escape(__webpack_require__(904)) + ")}.flag-icon-ph.flag-icon-squared{background-image:url(" + escape(__webpack_require__(905)) + ")}.flag-icon-pk{background-image:url(" + escape(__webpack_require__(906)) + ")}.flag-icon-pk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(907)) + ")}.flag-icon-pl{background-image:url(" + escape(__webpack_require__(908)) + ")}.flag-icon-pl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(909)) + ")}.flag-icon-pm{background-image:url(" + escape(__webpack_require__(910)) + ")}.flag-icon-pm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(911)) + ")}.flag-icon-pn{background-image:url(" + escape(__webpack_require__(912)) + ")}.flag-icon-pn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(913)) + ")}.flag-icon-pr{background-image:url(" + escape(__webpack_require__(914)) + ")}.flag-icon-pr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(915)) + ")}.flag-icon-ps{background-image:url(" + escape(__webpack_require__(916)) + ")}.flag-icon-ps.flag-icon-squared{background-image:url(" + escape(__webpack_require__(917)) + ")}.flag-icon-pt{background-image:url(" + escape(__webpack_require__(918)) + ")}.flag-icon-pt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(919)) + ")}.flag-icon-pw{background-image:url(" + escape(__webpack_require__(920)) + ")}.flag-icon-pw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(921)) + ")}.flag-icon-py{background-image:url(" + escape(__webpack_require__(922)) + ")}.flag-icon-py.flag-icon-squared{background-image:url(" + escape(__webpack_require__(923)) + ")}.flag-icon-qa{background-image:url(" + escape(__webpack_require__(924)) + ")}.flag-icon-qa.flag-icon-squared{background-image:url(" + escape(__webpack_require__(925)) + ")}.flag-icon-re{background-image:url(" + escape(__webpack_require__(926)) + ")}.flag-icon-re.flag-icon-squared{background-image:url(" + escape(__webpack_require__(927)) + ")}.flag-icon-ro{background-image:url(" + escape(__webpack_require__(928)) + ")}.flag-icon-ro.flag-icon-squared{background-image:url(" + escape(__webpack_require__(929)) + ")}.flag-icon-rs{background-image:url(" + escape(__webpack_require__(930)) + ")}.flag-icon-rs.flag-icon-squared{background-image:url(" + escape(__webpack_require__(931)) + ")}.flag-icon-ru{background-image:url(" + escape(__webpack_require__(932)) + ")}.flag-icon-ru.flag-icon-squared{background-image:url(" + escape(__webpack_require__(933)) + ")}.flag-icon-rw{background-image:url(" + escape(__webpack_require__(934)) + ")}.flag-icon-rw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(935)) + ")}.flag-icon-sa{background-image:url(" + escape(__webpack_require__(936)) + ")}.flag-icon-sa.flag-icon-squared{background-image:url(" + escape(__webpack_require__(937)) + ")}.flag-icon-sb{background-image:url(" + escape(__webpack_require__(938)) + ")}.flag-icon-sb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(939)) + ")}.flag-icon-sc{background-image:url(" + escape(__webpack_require__(940)) + ")}.flag-icon-sc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(941)) + ")}.flag-icon-sd{background-image:url(" + escape(__webpack_require__(942)) + ")}.flag-icon-sd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(943)) + ")}.flag-icon-se{background-image:url(" + escape(__webpack_require__(944)) + ")}.flag-icon-se.flag-icon-squared{background-image:url(" + escape(__webpack_require__(945)) + ")}.flag-icon-sg{background-image:url(" + escape(__webpack_require__(946)) + ")}.flag-icon-sg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(947)) + ")}.flag-icon-sh{background-image:url(" + escape(__webpack_require__(948)) + ")}.flag-icon-sh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(949)) + ")}.flag-icon-si{background-image:url(" + escape(__webpack_require__(950)) + ")}.flag-icon-si.flag-icon-squared{background-image:url(" + escape(__webpack_require__(951)) + ")}.flag-icon-sj{background-image:url(" + escape(__webpack_require__(952)) + ")}.flag-icon-sj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(953)) + ")}.flag-icon-sk{background-image:url(" + escape(__webpack_require__(954)) + ")}.flag-icon-sk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(955)) + ")}.flag-icon-sl{background-image:url(" + escape(__webpack_require__(956)) + ")}.flag-icon-sl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(957)) + ")}.flag-icon-sm{background-image:url(" + escape(__webpack_require__(958)) + ")}.flag-icon-sm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(959)) + ")}.flag-icon-sn{background-image:url(" + escape(__webpack_require__(960)) + ")}.flag-icon-sn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(961)) + ")}.flag-icon-so{background-image:url(" + escape(__webpack_require__(962)) + ")}.flag-icon-so.flag-icon-squared{background-image:url(" + escape(__webpack_require__(963)) + ")}.flag-icon-sr{background-image:url(" + escape(__webpack_require__(964)) + ")}.flag-icon-sr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(965)) + ")}.flag-icon-ss{background-image:url(" + escape(__webpack_require__(966)) + ")}.flag-icon-ss.flag-icon-squared{background-image:url(" + escape(__webpack_require__(967)) + ")}.flag-icon-st{background-image:url(" + escape(__webpack_require__(968)) + ")}.flag-icon-st.flag-icon-squared{background-image:url(" + escape(__webpack_require__(969)) + ")}.flag-icon-sv{background-image:url(" + escape(__webpack_require__(970)) + ")}.flag-icon-sv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(971)) + ")}.flag-icon-sx{background-image:url(" + escape(__webpack_require__(972)) + ")}.flag-icon-sx.flag-icon-squared{background-image:url(" + escape(__webpack_require__(973)) + ")}.flag-icon-sy{background-image:url(" + escape(__webpack_require__(974)) + ")}.flag-icon-sy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(975)) + ")}.flag-icon-sz{background-image:url(" + escape(__webpack_require__(976)) + ")}.flag-icon-sz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(977)) + ")}.flag-icon-tc{background-image:url(" + escape(__webpack_require__(978)) + ")}.flag-icon-tc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(979)) + ")}.flag-icon-td{background-image:url(" + escape(__webpack_require__(980)) + ")}.flag-icon-td.flag-icon-squared{background-image:url(" + escape(__webpack_require__(981)) + ")}.flag-icon-tf{background-image:url(" + escape(__webpack_require__(982)) + ")}.flag-icon-tf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(983)) + ")}.flag-icon-tg{background-image:url(" + escape(__webpack_require__(984)) + ")}.flag-icon-tg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(985)) + ")}.flag-icon-th{background-image:url(" + escape(__webpack_require__(986)) + ")}.flag-icon-th.flag-icon-squared{background-image:url(" + escape(__webpack_require__(987)) + ")}.flag-icon-tj{background-image:url(" + escape(__webpack_require__(988)) + ")}.flag-icon-tj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(989)) + ")}.flag-icon-tk{background-image:url(" + escape(__webpack_require__(990)) + ")}.flag-icon-tk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(991)) + ")}.flag-icon-tl{background-image:url(" + escape(__webpack_require__(992)) + ")}.flag-icon-tl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(993)) + ")}.flag-icon-tm{background-image:url(" + escape(__webpack_require__(994)) + ")}.flag-icon-tm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(995)) + ")}.flag-icon-tn{background-image:url(" + escape(__webpack_require__(996)) + ")}.flag-icon-tn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(997)) + ")}.flag-icon-to{background-image:url(" + escape(__webpack_require__(998)) + ")}.flag-icon-to.flag-icon-squared{background-image:url(" + escape(__webpack_require__(999)) + ")}.flag-icon-tr{background-image:url(" + escape(__webpack_require__(1000)) + ")}.flag-icon-tr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1001)) + ")}.flag-icon-tt{background-image:url(" + escape(__webpack_require__(1002)) + ")}.flag-icon-tt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1003)) + ")}.flag-icon-tv{background-image:url(" + escape(__webpack_require__(1004)) + ")}.flag-icon-tv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1005)) + ")}.flag-icon-tw{background-image:url(" + escape(__webpack_require__(1006)) + ")}.flag-icon-tw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1007)) + ")}.flag-icon-tz{background-image:url(" + escape(__webpack_require__(1008)) + ")}.flag-icon-tz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1009)) + ")}.flag-icon-ua{background-image:url(" + escape(__webpack_require__(1010)) + ")}.flag-icon-ua.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1011)) + ")}.flag-icon-ug{background-image:url(" + escape(__webpack_require__(1012)) + ")}.flag-icon-ug.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1013)) + ")}.flag-icon-um{background-image:url(" + escape(__webpack_require__(1014)) + ")}.flag-icon-um.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1015)) + ")}.flag-icon-us{background-image:url(" + escape(__webpack_require__(1016)) + ")}.flag-icon-us.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1017)) + ")}.flag-icon-uy{background-image:url(" + escape(__webpack_require__(1018)) + ")}.flag-icon-uy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1019)) + ")}.flag-icon-uz{background-image:url(" + escape(__webpack_require__(1020)) + ")}.flag-icon-uz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1021)) + ")}.flag-icon-va{background-image:url(" + escape(__webpack_require__(1022)) + ")}.flag-icon-va.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1023)) + ")}.flag-icon-vc{background-image:url(" + escape(__webpack_require__(1024)) + ")}.flag-icon-vc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1025)) + ")}.flag-icon-ve{background-image:url(" + escape(__webpack_require__(1026)) + ")}.flag-icon-ve.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1027)) + ")}.flag-icon-vg{background-image:url(" + escape(__webpack_require__(1028)) + ")}.flag-icon-vg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1029)) + ")}.flag-icon-vi{background-image:url(" + escape(__webpack_require__(1030)) + ")}.flag-icon-vi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1031)) + ")}.flag-icon-vn{background-image:url(" + escape(__webpack_require__(1032)) + ")}.flag-icon-vn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1033)) + ")}.flag-icon-vu{background-image:url(" + escape(__webpack_require__(1034)) + ")}.flag-icon-vu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1035)) + ")}.flag-icon-wf{background-image:url(" + escape(__webpack_require__(1036)) + ")}.flag-icon-wf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1037)) + ")}.flag-icon-ws{background-image:url(" + escape(__webpack_require__(1038)) + ")}.flag-icon-ws.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1039)) + ")}.flag-icon-ye{background-image:url(" + escape(__webpack_require__(1040)) + ")}.flag-icon-ye.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1041)) + ")}.flag-icon-yt{background-image:url(" + escape(__webpack_require__(1042)) + ")}.flag-icon-yt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1043)) + ")}.flag-icon-za{background-image:url(" + escape(__webpack_require__(1044)) + ")}.flag-icon-za.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1045)) + ")}.flag-icon-zm{background-image:url(" + escape(__webpack_require__(1046)) + ")}.flag-icon-zm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1047)) + ")}.flag-icon-zw{background-image:url(" + escape(__webpack_require__(1048)) + ")}.flag-icon-zw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1049)) + ")}.flag-icon-es-ct{background-image:url(" + escape(__webpack_require__(1050)) + ")}.flag-icon-es-ct.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1051)) + ")}.flag-icon-eu{background-image:url(" + escape(__webpack_require__(1052)) + ")}.flag-icon-eu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1053)) + ")}.flag-icon-gb-eng{background-image:url(" + escape(__webpack_require__(1054)) + ")}.flag-icon-gb-eng.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1055)) + ")}.flag-icon-gb-nir{background-image:url(" + escape(__webpack_require__(1056)) + ")}.flag-icon-gb-nir.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1057)) + ")}.flag-icon-gb-sct{background-image:url(" + escape(__webpack_require__(1058)) + ")}.flag-icon-gb-sct.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1059)) + ")}.flag-icon-gb-wls{background-image:url(" + escape(__webpack_require__(1060)) + ")}.flag-icon-gb-wls.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1061)) + ")}.flag-icon-un{background-image:url(" + escape(__webpack_require__(1062)) + ")}.flag-icon-un.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1063)) + ")}", ""]);

// exports


/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ad.2d92881.svg";

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ad.8002073.svg";

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ae.998cc1f.svg";

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ae.8fc34d9.svg";

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = "../../static/img/af.1e73c9e.svg";

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "../../static/img/af.ddee87a.svg";

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ag.b8b8289.svg";

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ag.441882c.svg";

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ai.7b4552d.svg";

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ai.377c542.svg";

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = "../../static/img/al.4ed11fa.svg";

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = "../../static/img/al.0663234.svg";

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = "../../static/img/am.cb25612.svg";

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = "../../static/img/am.41e6105.svg";

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ao.b69218a.svg";

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ao.3e1baa0.svg";

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = "../../static/img/aq.02ad59b.svg";

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "../../static/img/aq.328821f.svg";

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ar.5261e63.svg";

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ar.53647ae.svg";

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = "../../static/img/as.23e6ae7.svg";

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "../../static/img/as.078ba74.svg";

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = "../../static/img/at.fa4cf04.svg";

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "../../static/img/at.0721b30.svg";

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = "../../static/img/au.bb307e7.svg";

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = "../../static/img/au.f6b7907.svg";

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = "../../static/img/aw.3f52fb1.svg";

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = "../../static/img/aw.0cd7e03.svg";

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ax.f8c4019.svg";

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ax.e939bf2.svg";

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "../../static/img/az.198dbef.svg";

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = "../../static/img/az.1edff12.svg";

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ba.7d6f56d.svg";

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ba.d5ef14f.svg";

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bb.fe3ac3f.svg";

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bb.0c916c1.svg";

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bd.a7978d3.svg";

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bd.b2af317.svg";

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "../../static/img/be.5739940.svg";

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = "../../static/img/be.f34903c.svg";

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bf.57907e6.svg";

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bf.348494c.svg";

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bg.494aa56.svg";

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bg.44d83f9.svg";

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bh.7510653.svg";

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bh.18fac7d.svg";

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bi.12a40d8.svg";

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bi.d0615c7.svg";

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bj.5561ec9.svg";

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bj.2243030.svg";

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bl.2a496da.svg";

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bl.2deb442.svg";

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bm.012b04b.svg";

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bm.f2a1782.svg";

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bn.f6d5f40.svg";

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bn.c5b9160.svg";

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bo.5f3fef0.svg";

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bo.2b6773a.svg";

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bq.fda6c02.svg";

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bq.8c6f85c.svg";

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "../../static/img/br.a31e257.svg";

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "../../static/img/br.a30c10f.svg";

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bs.cf40c6a.svg";

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bs.0f30e82.svg";

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bt.87d6525.svg";

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bt.508393d.svg";

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bv.4fbc14a.svg";

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bv.ce74737.svg";

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bw.15ed460.svg";

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bw.5f11a0b.svg";

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "../../static/img/by.c05c8c0.svg";

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "../../static/img/by.9b65127.svg";

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bz.2458dd8.svg";

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "../../static/img/bz.81f2d64.svg";

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ca.0efb6bf.svg";

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ca.a399986.svg";

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cc.dd392e2.svg";

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cc.e53abbf.svg";

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cd.d4408d3.svg";

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cd.a3ecd80.svg";

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cf.d8dd15d.svg";

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cf.8f764c6.svg";

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cg.51ec77a.svg";

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cg.4ad6f3e.svg";

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ch.a69a50e.svg";

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ch.987cb82.svg";

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ci.11ac689.svg";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ci.728ba64.svg";

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ck.fe45a10.svg";

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ck.e2686b2.svg";

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cl.2fd895c.svg";

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cl.609867e.svg";

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cm.a56034b.svg";

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cm.94ec67b.svg";

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cn.2c193ab.svg";

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cn.3a08290.svg";

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "../../static/img/co.c5d7116.svg";

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "../../static/img/co.1113104.svg";

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cr.0d349fd.svg";

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cr.13c483a.svg";

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cu.1c7cc4d.svg";

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cu.e4f897d.svg";

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cv.624a2d4.svg";

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cv.accdfa0.svg";

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cw.9c06626.svg";

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cw.ae75cba.svg";

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cx.b2a59c5.svg";

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cx.8142eab.svg";

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cy.5e40be3.svg";

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cy.dbf92cb.svg";

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cz.09a9b11.svg";

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "../../static/img/cz.b325cce.svg";

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "../../static/img/de.246a5fc.svg";

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "../../static/img/de.74018f0.svg";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dj.694ca31.svg";

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dj.63e2012.svg";

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dk.302b468.svg";

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dk.59a9d25.svg";

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dm.b163569.svg";

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dm.fda8fe7.svg";

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "../../static/img/do.704fd2a.svg";

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "../../static/img/do.88a82fc.svg";

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dz.0477e54.svg";

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = "../../static/img/dz.ff15f06.svg";

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ec.3bafd07.svg";

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ec.8fb69b7.svg";

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ee.03c3d56.svg";

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ee.9b43910.svg";

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "../../static/img/eg.b0aa9a4.svg";

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "../../static/img/eg.4137f10.svg";

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "../../static/img/eh.44d9790.svg";

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = "../../static/img/eh.780a0a9.svg";

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "../../static/img/er.b4ea80f.svg";

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "../../static/img/er.8d5171c.svg";

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = "../../static/img/es.bcf1ab9.svg";

/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "../../static/img/es.361eda2.svg";

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = "../../static/img/et.512bde1.svg";

/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = "../../static/img/et.a61da8e.svg";

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fi.8c63a9a.svg";

/***/ }),
/* 691 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fi.55109a4.svg";

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fj.caf72f6.svg";

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fj.453532c.svg";

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fk.1e53dc2.svg";

/***/ }),
/* 695 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fk.1bffbf9.svg";

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fm.2c13a5d.svg";

/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fm.41b339f.svg";

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fo.c2f6347.svg";

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fo.32019da.svg";

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fr.4e3ec04.svg";

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "../../static/img/fr.f4529ed.svg";

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ga.8629ddf.svg";

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ga.886a734.svg";

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb.85a97da.svg";

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb.fe60f83.svg";

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gd.0e3d254.svg";

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gd.7c62ce7.svg";

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ge.a129579.svg";

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ge.49a0b41.svg";

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gf.434bae0.svg";

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gf.d0185c1.svg";

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gg.c447047.svg";

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gg.02df8a5.svg";

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gh.bb3bb60.svg";

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gh.e0ca526.svg";

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gi.71cfe39.svg";

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gi.1afed1e.svg";

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gl.1495643.svg";

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gl.59e1835.svg";

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gm.39937d8.svg";

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gm.6b41079.svg";

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gn.e2dcda4.svg";

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gn.0798100.svg";

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gp.0dcdf96.svg";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gp.8fc39c3.svg";

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gq.c095a0d.svg";

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gq.88946f8.svg";

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gr.334890b.svg";

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gr.dcc2c86.svg";

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gs.21f7c99.svg";

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gs.1067356.svg";

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gt.01ce618.svg";

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gt.4eea9e0.svg";

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gu.beb28cd.svg";

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gu.d4375e9.svg";

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gw.f074233.svg";

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gw.1ea2446.svg";

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gy.cbacc8b.svg";

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gy.333d94b.svg";

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hk.029a6be.svg";

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hk.50fa2f9.svg";

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hm.8bbb575.svg";

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hm.45e61c9.svg";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hn.db7e3de.svg";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hn.4938f67.svg";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hr.176d2d5.svg";

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hr.635a609.svg";

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ht.5f6a49d.svg";

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ht.06eefed.svg";

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hu.d1065fa.svg";

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "../../static/img/hu.a382865.svg";

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "../../static/img/id.e8f1c87.svg";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "../../static/img/id.cd7ecc1.svg";

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ie.deca9e1.svg";

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ie.ce6c7d8.svg";

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "../../static/img/il.ad7a2d1.svg";

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "../../static/img/il.5a12c24.svg";

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "../../static/img/im.07fac2a.svg";

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "../../static/img/im.f6e8452.svg";

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = "../../static/img/in.98c5671.svg";

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "../../static/img/in.f1c7c9b.svg";

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "../../static/img/io.7fc155e.svg";

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "../../static/img/io.1734998.svg";

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "../../static/img/iq.77fca3a.svg";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "../../static/img/iq.a632108.svg";

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ir.28b0fb3.svg";

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ir.1a62e10.svg";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "../../static/img/is.ba30d1e.svg";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "../../static/img/is.2c3b9de.svg";

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "../../static/img/it.5a3412c.svg";

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "../../static/img/it.15a1f28.svg";

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "../../static/img/je.a2bead8.svg";

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "../../static/img/je.12bf2a5.svg";

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "../../static/img/jm.c5279e8.svg";

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "../../static/img/jm.1b388cb.svg";

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "../../static/img/jo.5806167.svg";

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "../../static/img/jo.e0c3d12.svg";

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "../../static/img/jp.28157b5.svg";

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "../../static/img/jp.b5b509c.svg";

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ke.ac8b7d8.svg";

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ke.8db0f5f.svg";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kg.0e8c2a1.svg";

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kg.20cdf61.svg";

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kh.add3236.svg";

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kh.2be5f19.svg";

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ki.db9ce4a.svg";

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ki.8484193.svg";

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "../../static/img/km.05c0e1c.svg";

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "../../static/img/km.86ad579.svg";

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kn.8d2a2ba.svg";

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kn.a1e5c90.svg";

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kp.fc45ba5.svg";

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kp.bab86a2.svg";

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kr.472436a.svg";

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kr.7ce5a14.svg";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kw.8758e4a.svg";

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kw.0a1e78f.svg";

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ky.bc2f407.svg";

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ky.58b6db2.svg";

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kz.765abf2.svg";

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "../../static/img/kz.0855baa.svg";

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "../../static/img/la.d4742a0.svg";

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "../../static/img/la.635b3d0.svg";

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lb.c43e467.svg";

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lb.bdba814.svg";

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lc.3185965.svg";

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lc.5ad24b4.svg";

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "../../static/img/li.7f2cb3e.svg";

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "../../static/img/li.f37f498.svg";

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lk.f8d21a6.svg";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lk.3ce70e5.svg";

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lr.e026e0f.svg";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lr.e3059e9.svg";

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ls.6497b84.svg";

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ls.fd0cc2e.svg";

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lt.c2b153a.svg";

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lt.76ec666.svg";

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lu.cad8b8b.svg";

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lu.57b9eec.svg";

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lv.35ddb2f.svg";

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "../../static/img/lv.4838077.svg";

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ly.4148929.svg";

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ly.27ae749.svg";

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ma.821b323.svg";

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ma.c91b740.svg";

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mc.37be465.svg";

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mc.04a4a20.svg";

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "../../static/img/md.824e3e1.svg";

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "../../static/img/md.879bb31.svg";

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "../../static/img/me.37b693f.svg";

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "../../static/img/me.be3b17d.svg";

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mf.d3fbe0d.svg";

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mf.6471238.svg";

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mg.fba4299.svg";

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mg.1491077.svg";

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mh.c1782ce.svg";

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mh.40dbb5c.svg";

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mk.4a879fd.svg";

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mk.12c1fff.svg";

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ml.64aa836.svg";

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ml.02a95bc.svg";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mm.a646bac.svg";

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mm.95787e3.svg";

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mn.5f43e0c.svg";

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mn.7ff5beb.svg";

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mo.012b278.svg";

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mo.94c09d5.svg";

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mp.bccdcb5.svg";

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mp.fec806e.svg";

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mq.9bcc4ff.svg";

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mq.37d2d68.svg";

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mr.55d8f23.svg";

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mr.38d81da.svg";

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ms.ec75da9.svg";

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ms.830476b.svg";

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mt.07ddb91.svg";

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mt.4f20d5a.svg";

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mu.33b7d11.svg";

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mu.fcbb970.svg";

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mv.c11e6ef.svg";

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mv.f1beeda.svg";

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mw.8627c92.svg";

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mw.f075545.svg";

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mx.1fcc3cf.svg";

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mx.4e358e4.svg";

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports = "../../static/img/my.789a6dd.svg";

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = "../../static/img/my.591d1e3.svg";

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mz.c830828.svg";

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = "../../static/img/mz.4fce86a.svg";

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "../../static/img/na.efac284.svg";

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports = "../../static/img/na.ca89977.svg";

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nc.846211d.svg";

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nc.b72ab6b.svg";

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ne.9a55897.svg";

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ne.a7f07f0.svg";

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nf.5e07162.svg";

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nf.44fe594.svg";

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ng.ba3bb51.svg";

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ng.f6a2347.svg";

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ni.7affd52.svg";

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ni.3f7681e.svg";

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nl.feb9eea.svg";

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nl.db2b8b1.svg";

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "../../static/img/no.fc02959.svg";

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "../../static/img/no.51a7ba8.svg";

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = "../../static/img/np.4211aa6.svg";

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports = "../../static/img/np.c28b686.svg";

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nr.66dd157.svg";

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nr.61a4246.svg";

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nu.39cb241.svg";

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nu.4826186.svg";

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nz.07d3ae5.svg";

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = "../../static/img/nz.d29645c.svg";

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "../../static/img/om.9170bae.svg";

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "../../static/img/om.7171b1e.svg";

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pa.3b4d552.svg";

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pa.943e160.svg";

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pe.fda6672.svg";

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pe.017a482.svg";

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pf.b6f4798.svg";

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pf.3ac8d5b.svg";

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pg.5c17391.svg";

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pg.4359608.svg";

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ph.807a7e5.svg";

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ph.605f522.svg";

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pk.fbfb558.svg";

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pk.f769529.svg";

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pl.6607e08.svg";

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pl.1f4f8ec.svg";

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pm.6359f9e.svg";

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pm.68469c3.svg";

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pn.97f773c.svg";

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pn.eb94153.svg";

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pr.563200c.svg";

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pr.6949cd9.svg";

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ps.658c881.svg";

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ps.1b8d039.svg";

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pt.03f36e3.svg";

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pt.6143c8e.svg";

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pw.5445894.svg";

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = "../../static/img/pw.069ec37.svg";

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports = "../../static/img/py.795e6d0.svg";

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "../../static/img/py.f1fa688.svg";

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "../../static/img/qa.4f99730.svg";

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "../../static/img/qa.29cc283.svg";

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "../../static/img/re.9c769f6.svg";

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports = "../../static/img/re.16aa0b5.svg";

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ro.b091db3.svg";

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ro.488ee90.svg";

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports = "../../static/img/rs.192092d.svg";

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports = "../../static/img/rs.95f28ec.svg";

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ru.af31e64.svg";

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ru.911c03c.svg";

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = "../../static/img/rw.dbf846e.svg";

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports = "../../static/img/rw.d724e84.svg";

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sa.45e1708.svg";

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sa.1c14b2e.svg";

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sb.ab93a79.svg";

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sb.5bc69a3.svg";

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sc.5d8966f.svg";

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sc.ed506f5.svg";

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sd.aafc9ca.svg";

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sd.d702baf.svg";

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "../../static/img/se.b54f0ef.svg";

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = "../../static/img/se.5d16ff9.svg";

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sg.814c6d6.svg";

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sg.279844e.svg";

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sh.e26b4b8.svg";

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sh.c147b9c.svg";

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "../../static/img/si.48107ae.svg";

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = "../../static/img/si.fdc1cee.svg";

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sj.d08937c.svg";

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sj.f404336.svg";

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sk.daf75e7.svg";

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sk.253c193.svg";

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sl.f5cb409.svg";

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sl.58ef1e3.svg";

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sm.890ad89.svg";

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sm.d69bce0.svg";

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sn.6d85da9.svg";

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sn.c1a6798.svg";

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "../../static/img/so.fd9745c.svg";

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = "../../static/img/so.a3c1b75.svg";

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sr.64fb37b.svg";

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sr.ceae0ff.svg";

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ss.5e0bad1.svg";

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ss.c8e5f38.svg";

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = "../../static/img/st.00f5130.svg";

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = "../../static/img/st.3589e34.svg";

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sv.abfac59.svg";

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sv.88ca96e.svg";

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sx.89f96e7.svg";

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sx.6c22419.svg";

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sy.d648066.svg";

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sy.96bb3c2.svg";

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sz.d00ba66.svg";

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = "../../static/img/sz.9ec8da3.svg";

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tc.d016024.svg";

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tc.bca9f99.svg";

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = "../../static/img/td.d6ccfa1.svg";

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "../../static/img/td.cb622bc.svg";

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tf.1129c04.svg";

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tf.3f87ed9.svg";

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tg.bf9d20b.svg";

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tg.aff94a7.svg";

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "../../static/img/th.565e3c4.svg";

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = "../../static/img/th.9c1e01f.svg";

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tj.e58f32f.svg";

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tj.1793caa.svg";

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tk.b2df385.svg";

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tk.e37e35b.svg";

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tl.547e421.svg";

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tl.214b6f8.svg";

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tm.f2dc59b.svg";

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tm.08d55ec.svg";

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tn.98351bc.svg";

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tn.34dba63.svg";

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "../../static/img/to.00aaa22.svg";

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = "../../static/img/to.ee39c2d.svg";

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tr.ac4572c.svg";

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tr.d4a61f6.svg";

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tt.333675d.svg";

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tt.3854b85.svg";

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tv.eda22a5.svg";

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tv.ec5c179.svg";

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tw.89a1429.svg";

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tw.7794932.svg";

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tz.ed1c43d.svg";

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = "../../static/img/tz.206592d.svg";

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ua.e2202cb.svg";

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ua.5196d8e.svg";

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ug.f6dbcb2.svg";

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ug.69ed487.svg";

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "../../static/img/um.f4540fe.svg";

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports = "../../static/img/um.2da266d.svg";

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "../../static/img/us.da1c4f8.svg";

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = "../../static/img/us.269666d.svg";

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = "../../static/img/uy.2ac18c6.svg";

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = "../../static/img/uy.4caed12.svg";

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "../../static/img/uz.d9b7820.svg";

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = "../../static/img/uz.0b281dd.svg";

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "../../static/img/va.8aae370.svg";

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports = "../../static/img/va.a44c6ba.svg";

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vc.fc6aa8f.svg";

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vc.0d52b11.svg";

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ve.05045bc.svg";

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ve.d384c6c.svg";

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vg.eef14ab.svg";

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vg.4236b35.svg";

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vi.2127440.svg";

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vi.8a178e2.svg";

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vn.010b0c4.svg";

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vn.7e156d1.svg";

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vu.5bc2075.svg";

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = "../../static/img/vu.9c4c893.svg";

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = "../../static/img/wf.5e6aa0d.svg";

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "../../static/img/wf.a10487a.svg";

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ws.c4eb059.svg";

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ws.2690f3d.svg";

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ye.68c3979.svg";

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = "../../static/img/ye.58d8d56.svg";

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "../../static/img/yt.0f00b10.svg";

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "../../static/img/yt.a1387f1.svg";

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = "../../static/img/za.177080d.svg";

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "../../static/img/za.9ed44ae.svg";

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = "../../static/img/zm.5ac3774.svg";

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = "../../static/img/zm.402266a.svg";

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports = "../../static/img/zw.58e2cbd.svg";

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = "../../static/img/zw.25d6732.svg";

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = "../../static/img/es-ct.2f1565e.svg";

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "../../static/img/es-ct.e6db39f.svg";

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = "../../static/img/eu.d8c5128.svg";

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = "../../static/img/eu.824e473.svg";

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-eng.e18b270.svg";

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-eng.99785a1.svg";

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-nir.080d056.svg";

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-nir.5329af5.svg";

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-sct.c436167.svg";

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-sct.6231d4d.svg";

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-wls.344dc57.svg";

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = "../../static/img/gb-wls.d67608c.svg";

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = "../../static/img/un.cc2eb7d.svg";

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = "../../static/img/un.424ca4d.svg";

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(64);
exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:'FontAwesome';src:url(" + escape(__webpack_require__(1065)) + ");src:url(" + escape(__webpack_require__(1066)) + "?#iefix&v=4.7.0) format('embedded-opentype'),url(" + escape(__webpack_require__(1067)) + ") format('woff2'),url(" + escape(__webpack_require__(1068)) + ") format('woff'),url(" + escape(__webpack_require__(1069)) + ") format('truetype'),url(" + escape(__webpack_require__(1070)) + "#fontawesomeregular) format('svg');font-weight:normal;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:solid .08em #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scale(-1, 1);-ms-transform:scale(-1, 1);transform:scale(-1, 1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scale(1, -1);-ms-transform:scale(1, -1);transform:scale(1, -1)}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-remove:before,.fa-close:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-gear:before,.fa-cog:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-rotate-right:before,.fa-repeat:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-photo:before,.fa-image:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-warning:before,.fa-exclamation-triangle:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-gears:before,.fa-cogs:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-save:before,.fa-floppy-o:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-navicon:before,.fa-reorder:before,.fa-bars:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-unsorted:before,.fa-sort:before{content:\"\\F0DC\"}.fa-sort-down:before,.fa-sort-desc:before{content:\"\\F0DD\"}.fa-sort-up:before,.fa-sort-asc:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-legal:before,.fa-gavel:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-flash:before,.fa-bolt:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-paste:before,.fa-clipboard:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-unlink:before,.fa-chain-broken:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-toggle-down:before,.fa-caret-square-o-down:before{content:\"\\F150\"}.fa-toggle-up:before,.fa-caret-square-o-up:before{content:\"\\F151\"}.fa-toggle-right:before,.fa-caret-square-o-right:before{content:\"\\F152\"}.fa-euro:before,.fa-eur:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-rupee:before,.fa-inr:before{content:\"\\F156\"}.fa-cny:before,.fa-rmb:before,.fa-yen:before,.fa-jpy:before{content:\"\\F157\"}.fa-ruble:before,.fa-rouble:before,.fa-rub:before{content:\"\\F158\"}.fa-won:before,.fa-krw:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-toggle-left:before,.fa-caret-square-o-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-turkish-lira:before,.fa-try:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-institution:before,.fa-bank:before,.fa-university:before{content:\"\\F19C\"}.fa-mortar-board:before,.fa-graduation-cap:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-photo-o:before,.fa-file-picture-o:before,.fa-file-image-o:before{content:\"\\F1C5\"}.fa-file-zip-o:before,.fa-file-archive-o:before{content:\"\\F1C6\"}.fa-file-sound-o:before,.fa-file-audio-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-saver:before,.fa-support:before,.fa-life-ring:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-resistance:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-ge:before,.fa-empire:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-y-combinator-square:before,.fa-yc-square:before,.fa-hacker-news:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-send:before,.fa-paper-plane:before{content:\"\\F1D8\"}.fa-send-o:before,.fa-paper-plane-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-soccer-ball-o:before,.fa-futbol-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-shekel:before,.fa-sheqel:before,.fa-ils:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-hotel:before,.fa-bed:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-yc:before,.fa-y-combinator:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-stop-o:before,.fa-hand-paper-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-tv:before,.fa-television:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-asl-interpreting:before,.fa-american-sign-language-interpreting:before{content:\"\\F2A3\"}.fa-deafness:before,.fa-hard-of-hearing:before,.fa-deaf:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-signing:before,.fa-sign-language:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-vcard:before,.fa-address-card:before{content:\"\\F2BB\"}.fa-vcard-o:before,.fa-address-card-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer:before,.fa-thermometer-full:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bathtub:before,.fa-s15:before,.fa-bath:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}\n", ""]);

// exports


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(64);
exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: 'simple-line-icons';\n  src: url(" + escape(__webpack_require__(174)) + ");\n  src: url(" + escape(__webpack_require__(174)) + "#iefix) format('embedded-opentype'), url(" + escape(__webpack_require__(1072)) + ") format('woff2'), url(" + escape(__webpack_require__(1073)) + ") format('truetype'), url(" + escape(__webpack_require__(1074)) + ") format('woff'), url(" + escape(__webpack_require__(1075)) + "#simple-line-icons) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*\n Use the following CSS code if you want to have a class per icon.\n Instead of a list of all class selectors, you can use the generic [class*=\"icon-\"] selector, but it's slower:\n*/\n.icon-user,\n.icon-people,\n.icon-user-female,\n.icon-user-follow,\n.icon-user-following,\n.icon-user-unfollow,\n.icon-login,\n.icon-logout,\n.icon-emotsmile,\n.icon-phone,\n.icon-call-end,\n.icon-call-in,\n.icon-call-out,\n.icon-map,\n.icon-location-pin,\n.icon-direction,\n.icon-directions,\n.icon-compass,\n.icon-layers,\n.icon-menu,\n.icon-list,\n.icon-options-vertical,\n.icon-options,\n.icon-arrow-down,\n.icon-arrow-left,\n.icon-arrow-right,\n.icon-arrow-up,\n.icon-arrow-up-circle,\n.icon-arrow-left-circle,\n.icon-arrow-right-circle,\n.icon-arrow-down-circle,\n.icon-check,\n.icon-clock,\n.icon-plus,\n.icon-minus,\n.icon-close,\n.icon-event,\n.icon-exclamation,\n.icon-organization,\n.icon-trophy,\n.icon-screen-smartphone,\n.icon-screen-desktop,\n.icon-plane,\n.icon-notebook,\n.icon-mustache,\n.icon-mouse,\n.icon-magnet,\n.icon-energy,\n.icon-disc,\n.icon-cursor,\n.icon-cursor-move,\n.icon-crop,\n.icon-chemistry,\n.icon-speedometer,\n.icon-shield,\n.icon-screen-tablet,\n.icon-magic-wand,\n.icon-hourglass,\n.icon-graduation,\n.icon-ghost,\n.icon-game-controller,\n.icon-fire,\n.icon-eyeglass,\n.icon-envelope-open,\n.icon-envelope-letter,\n.icon-bell,\n.icon-badge,\n.icon-anchor,\n.icon-wallet,\n.icon-vector,\n.icon-speech,\n.icon-puzzle,\n.icon-printer,\n.icon-present,\n.icon-playlist,\n.icon-pin,\n.icon-picture,\n.icon-handbag,\n.icon-globe-alt,\n.icon-globe,\n.icon-folder-alt,\n.icon-folder,\n.icon-film,\n.icon-feed,\n.icon-drop,\n.icon-drawer,\n.icon-docs,\n.icon-doc,\n.icon-diamond,\n.icon-cup,\n.icon-calculator,\n.icon-bubbles,\n.icon-briefcase,\n.icon-book-open,\n.icon-basket-loaded,\n.icon-basket,\n.icon-bag,\n.icon-action-undo,\n.icon-action-redo,\n.icon-wrench,\n.icon-umbrella,\n.icon-trash,\n.icon-tag,\n.icon-support,\n.icon-frame,\n.icon-size-fullscreen,\n.icon-size-actual,\n.icon-shuffle,\n.icon-share-alt,\n.icon-share,\n.icon-rocket,\n.icon-question,\n.icon-pie-chart,\n.icon-pencil,\n.icon-note,\n.icon-loop,\n.icon-home,\n.icon-grid,\n.icon-graph,\n.icon-microphone,\n.icon-music-tone-alt,\n.icon-music-tone,\n.icon-earphones-alt,\n.icon-earphones,\n.icon-equalizer,\n.icon-like,\n.icon-dislike,\n.icon-control-start,\n.icon-control-rewind,\n.icon-control-play,\n.icon-control-pause,\n.icon-control-forward,\n.icon-control-end,\n.icon-volume-1,\n.icon-volume-2,\n.icon-volume-off,\n.icon-calendar,\n.icon-bulb,\n.icon-chart,\n.icon-ban,\n.icon-bubble,\n.icon-camrecorder,\n.icon-camera,\n.icon-cloud-download,\n.icon-cloud-upload,\n.icon-envelope,\n.icon-eye,\n.icon-flag,\n.icon-heart,\n.icon-info,\n.icon-key,\n.icon-link,\n.icon-lock,\n.icon-lock-open,\n.icon-magnifier,\n.icon-magnifier-add,\n.icon-magnifier-remove,\n.icon-paper-clip,\n.icon-paper-plane,\n.icon-power,\n.icon-refresh,\n.icon-reload,\n.icon-settings,\n.icon-star,\n.icon-symbol-female,\n.icon-symbol-male,\n.icon-target,\n.icon-credit-card,\n.icon-paypal,\n.icon-social-tumblr,\n.icon-social-twitter,\n.icon-social-facebook,\n.icon-social-instagram,\n.icon-social-linkedin,\n.icon-social-pinterest,\n.icon-social-github,\n.icon-social-google,\n.icon-social-reddit,\n.icon-social-skype,\n.icon-social-dribbble,\n.icon-social-behance,\n.icon-social-foursqare,\n.icon-social-soundcloud,\n.icon-social-spotify,\n.icon-social-stumbleupon,\n.icon-social-youtube,\n.icon-social-dropbox,\n.icon-social-vkontakte,\n.icon-social-steam {\n  font-family: 'simple-line-icons';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-user:before {\n  content: \"\\E005\";\n}\n.icon-people:before {\n  content: \"\\E001\";\n}\n.icon-user-female:before {\n  content: \"\\E000\";\n}\n.icon-user-follow:before {\n  content: \"\\E002\";\n}\n.icon-user-following:before {\n  content: \"\\E003\";\n}\n.icon-user-unfollow:before {\n  content: \"\\E004\";\n}\n.icon-login:before {\n  content: \"\\E066\";\n}\n.icon-logout:before {\n  content: \"\\E065\";\n}\n.icon-emotsmile:before {\n  content: \"\\E021\";\n}\n.icon-phone:before {\n  content: \"\\E600\";\n}\n.icon-call-end:before {\n  content: \"\\E048\";\n}\n.icon-call-in:before {\n  content: \"\\E047\";\n}\n.icon-call-out:before {\n  content: \"\\E046\";\n}\n.icon-map:before {\n  content: \"\\E033\";\n}\n.icon-location-pin:before {\n  content: \"\\E096\";\n}\n.icon-direction:before {\n  content: \"\\E042\";\n}\n.icon-directions:before {\n  content: \"\\E041\";\n}\n.icon-compass:before {\n  content: \"\\E045\";\n}\n.icon-layers:before {\n  content: \"\\E034\";\n}\n.icon-menu:before {\n  content: \"\\E601\";\n}\n.icon-list:before {\n  content: \"\\E067\";\n}\n.icon-options-vertical:before {\n  content: \"\\E602\";\n}\n.icon-options:before {\n  content: \"\\E603\";\n}\n.icon-arrow-down:before {\n  content: \"\\E604\";\n}\n.icon-arrow-left:before {\n  content: \"\\E605\";\n}\n.icon-arrow-right:before {\n  content: \"\\E606\";\n}\n.icon-arrow-up:before {\n  content: \"\\E607\";\n}\n.icon-arrow-up-circle:before {\n  content: \"\\E078\";\n}\n.icon-arrow-left-circle:before {\n  content: \"\\E07A\";\n}\n.icon-arrow-right-circle:before {\n  content: \"\\E079\";\n}\n.icon-arrow-down-circle:before {\n  content: \"\\E07B\";\n}\n.icon-check:before {\n  content: \"\\E080\";\n}\n.icon-clock:before {\n  content: \"\\E081\";\n}\n.icon-plus:before {\n  content: \"\\E095\";\n}\n.icon-minus:before {\n  content: \"\\E615\";\n}\n.icon-close:before {\n  content: \"\\E082\";\n}\n.icon-event:before {\n  content: \"\\E619\";\n}\n.icon-exclamation:before {\n  content: \"\\E617\";\n}\n.icon-organization:before {\n  content: \"\\E616\";\n}\n.icon-trophy:before {\n  content: \"\\E006\";\n}\n.icon-screen-smartphone:before {\n  content: \"\\E010\";\n}\n.icon-screen-desktop:before {\n  content: \"\\E011\";\n}\n.icon-plane:before {\n  content: \"\\E012\";\n}\n.icon-notebook:before {\n  content: \"\\E013\";\n}\n.icon-mustache:before {\n  content: \"\\E014\";\n}\n.icon-mouse:before {\n  content: \"\\E015\";\n}\n.icon-magnet:before {\n  content: \"\\E016\";\n}\n.icon-energy:before {\n  content: \"\\E020\";\n}\n.icon-disc:before {\n  content: \"\\E022\";\n}\n.icon-cursor:before {\n  content: \"\\E06E\";\n}\n.icon-cursor-move:before {\n  content: \"\\E023\";\n}\n.icon-crop:before {\n  content: \"\\E024\";\n}\n.icon-chemistry:before {\n  content: \"\\E026\";\n}\n.icon-speedometer:before {\n  content: \"\\E007\";\n}\n.icon-shield:before {\n  content: \"\\E00E\";\n}\n.icon-screen-tablet:before {\n  content: \"\\E00F\";\n}\n.icon-magic-wand:before {\n  content: \"\\E017\";\n}\n.icon-hourglass:before {\n  content: \"\\E018\";\n}\n.icon-graduation:before {\n  content: \"\\E019\";\n}\n.icon-ghost:before {\n  content: \"\\E01A\";\n}\n.icon-game-controller:before {\n  content: \"\\E01B\";\n}\n.icon-fire:before {\n  content: \"\\E01C\";\n}\n.icon-eyeglass:before {\n  content: \"\\E01D\";\n}\n.icon-envelope-open:before {\n  content: \"\\E01E\";\n}\n.icon-envelope-letter:before {\n  content: \"\\E01F\";\n}\n.icon-bell:before {\n  content: \"\\E027\";\n}\n.icon-badge:before {\n  content: \"\\E028\";\n}\n.icon-anchor:before {\n  content: \"\\E029\";\n}\n.icon-wallet:before {\n  content: \"\\E02A\";\n}\n.icon-vector:before {\n  content: \"\\E02B\";\n}\n.icon-speech:before {\n  content: \"\\E02C\";\n}\n.icon-puzzle:before {\n  content: \"\\E02D\";\n}\n.icon-printer:before {\n  content: \"\\E02E\";\n}\n.icon-present:before {\n  content: \"\\E02F\";\n}\n.icon-playlist:before {\n  content: \"\\E030\";\n}\n.icon-pin:before {\n  content: \"\\E031\";\n}\n.icon-picture:before {\n  content: \"\\E032\";\n}\n.icon-handbag:before {\n  content: \"\\E035\";\n}\n.icon-globe-alt:before {\n  content: \"\\E036\";\n}\n.icon-globe:before {\n  content: \"\\E037\";\n}\n.icon-folder-alt:before {\n  content: \"\\E039\";\n}\n.icon-folder:before {\n  content: \"\\E089\";\n}\n.icon-film:before {\n  content: \"\\E03A\";\n}\n.icon-feed:before {\n  content: \"\\E03B\";\n}\n.icon-drop:before {\n  content: \"\\E03E\";\n}\n.icon-drawer:before {\n  content: \"\\E03F\";\n}\n.icon-docs:before {\n  content: \"\\E040\";\n}\n.icon-doc:before {\n  content: \"\\E085\";\n}\n.icon-diamond:before {\n  content: \"\\E043\";\n}\n.icon-cup:before {\n  content: \"\\E044\";\n}\n.icon-calculator:before {\n  content: \"\\E049\";\n}\n.icon-bubbles:before {\n  content: \"\\E04A\";\n}\n.icon-briefcase:before {\n  content: \"\\E04B\";\n}\n.icon-book-open:before {\n  content: \"\\E04C\";\n}\n.icon-basket-loaded:before {\n  content: \"\\E04D\";\n}\n.icon-basket:before {\n  content: \"\\E04E\";\n}\n.icon-bag:before {\n  content: \"\\E04F\";\n}\n.icon-action-undo:before {\n  content: \"\\E050\";\n}\n.icon-action-redo:before {\n  content: \"\\E051\";\n}\n.icon-wrench:before {\n  content: \"\\E052\";\n}\n.icon-umbrella:before {\n  content: \"\\E053\";\n}\n.icon-trash:before {\n  content: \"\\E054\";\n}\n.icon-tag:before {\n  content: \"\\E055\";\n}\n.icon-support:before {\n  content: \"\\E056\";\n}\n.icon-frame:before {\n  content: \"\\E038\";\n}\n.icon-size-fullscreen:before {\n  content: \"\\E057\";\n}\n.icon-size-actual:before {\n  content: \"\\E058\";\n}\n.icon-shuffle:before {\n  content: \"\\E059\";\n}\n.icon-share-alt:before {\n  content: \"\\E05A\";\n}\n.icon-share:before {\n  content: \"\\E05B\";\n}\n.icon-rocket:before {\n  content: \"\\E05C\";\n}\n.icon-question:before {\n  content: \"\\E05D\";\n}\n.icon-pie-chart:before {\n  content: \"\\E05E\";\n}\n.icon-pencil:before {\n  content: \"\\E05F\";\n}\n.icon-note:before {\n  content: \"\\E060\";\n}\n.icon-loop:before {\n  content: \"\\E064\";\n}\n.icon-home:before {\n  content: \"\\E069\";\n}\n.icon-grid:before {\n  content: \"\\E06A\";\n}\n.icon-graph:before {\n  content: \"\\E06B\";\n}\n.icon-microphone:before {\n  content: \"\\E063\";\n}\n.icon-music-tone-alt:before {\n  content: \"\\E061\";\n}\n.icon-music-tone:before {\n  content: \"\\E062\";\n}\n.icon-earphones-alt:before {\n  content: \"\\E03C\";\n}\n.icon-earphones:before {\n  content: \"\\E03D\";\n}\n.icon-equalizer:before {\n  content: \"\\E06C\";\n}\n.icon-like:before {\n  content: \"\\E068\";\n}\n.icon-dislike:before {\n  content: \"\\E06D\";\n}\n.icon-control-start:before {\n  content: \"\\E06F\";\n}\n.icon-control-rewind:before {\n  content: \"\\E070\";\n}\n.icon-control-play:before {\n  content: \"\\E071\";\n}\n.icon-control-pause:before {\n  content: \"\\E072\";\n}\n.icon-control-forward:before {\n  content: \"\\E073\";\n}\n.icon-control-end:before {\n  content: \"\\E074\";\n}\n.icon-volume-1:before {\n  content: \"\\E09F\";\n}\n.icon-volume-2:before {\n  content: \"\\E0A0\";\n}\n.icon-volume-off:before {\n  content: \"\\E0A1\";\n}\n.icon-calendar:before {\n  content: \"\\E075\";\n}\n.icon-bulb:before {\n  content: \"\\E076\";\n}\n.icon-chart:before {\n  content: \"\\E077\";\n}\n.icon-ban:before {\n  content: \"\\E07C\";\n}\n.icon-bubble:before {\n  content: \"\\E07D\";\n}\n.icon-camrecorder:before {\n  content: \"\\E07E\";\n}\n.icon-camera:before {\n  content: \"\\E07F\";\n}\n.icon-cloud-download:before {\n  content: \"\\E083\";\n}\n.icon-cloud-upload:before {\n  content: \"\\E084\";\n}\n.icon-envelope:before {\n  content: \"\\E086\";\n}\n.icon-eye:before {\n  content: \"\\E087\";\n}\n.icon-flag:before {\n  content: \"\\E088\";\n}\n.icon-heart:before {\n  content: \"\\E08A\";\n}\n.icon-info:before {\n  content: \"\\E08B\";\n}\n.icon-key:before {\n  content: \"\\E08C\";\n}\n.icon-link:before {\n  content: \"\\E08D\";\n}\n.icon-lock:before {\n  content: \"\\E08E\";\n}\n.icon-lock-open:before {\n  content: \"\\E08F\";\n}\n.icon-magnifier:before {\n  content: \"\\E090\";\n}\n.icon-magnifier-add:before {\n  content: \"\\E091\";\n}\n.icon-magnifier-remove:before {\n  content: \"\\E092\";\n}\n.icon-paper-clip:before {\n  content: \"\\E093\";\n}\n.icon-paper-plane:before {\n  content: \"\\E094\";\n}\n.icon-power:before {\n  content: \"\\E097\";\n}\n.icon-refresh:before {\n  content: \"\\E098\";\n}\n.icon-reload:before {\n  content: \"\\E099\";\n}\n.icon-settings:before {\n  content: \"\\E09A\";\n}\n.icon-star:before {\n  content: \"\\E09B\";\n}\n.icon-symbol-female:before {\n  content: \"\\E09C\";\n}\n.icon-symbol-male:before {\n  content: \"\\E09D\";\n}\n.icon-target:before {\n  content: \"\\E09E\";\n}\n.icon-credit-card:before {\n  content: \"\\E025\";\n}\n.icon-paypal:before {\n  content: \"\\E608\";\n}\n.icon-social-tumblr:before {\n  content: \"\\E00A\";\n}\n.icon-social-twitter:before {\n  content: \"\\E009\";\n}\n.icon-social-facebook:before {\n  content: \"\\E00B\";\n}\n.icon-social-instagram:before {\n  content: \"\\E609\";\n}\n.icon-social-linkedin:before {\n  content: \"\\E60A\";\n}\n.icon-social-pinterest:before {\n  content: \"\\E60B\";\n}\n.icon-social-github:before {\n  content: \"\\E60C\";\n}\n.icon-social-google:before {\n  content: \"\\E60D\";\n}\n.icon-social-reddit:before {\n  content: \"\\E60E\";\n}\n.icon-social-skype:before {\n  content: \"\\E60F\";\n}\n.icon-social-dribbble:before {\n  content: \"\\E00D\";\n}\n.icon-social-behance:before {\n  content: \"\\E610\";\n}\n.icon-social-foursqare:before {\n  content: \"\\E611\";\n}\n.icon-social-soundcloud:before {\n  content: \"\\E612\";\n}\n.icon-social-spotify:before {\n  content: \"\\E613\";\n}\n.icon-social-stumbleupon:before {\n  content: \"\\E614\";\n}\n.icon-social-youtube:before {\n  content: \"\\E008\";\n}\n.icon-social-dropbox:before {\n  content: \"\\E00C\";\n}\n.icon-social-vkontakte:before {\n  content: \"\\E618\";\n}\n.icon-social-steam:before {\n  content: \"\\E620\";\n}\n", ""]);

// exports


/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/Simple-Line-Icons.0cb0b9c.woff2";

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/Simple-Line-Icons.d228596.ttf";

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/Simple-Line-Icons.78f07e2.woff";

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = "../../static/fonts/Simple-Line-Icons.2fe2efe.svg";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "/*!\n * BootstrapVue Custom CSS (https://bootstrap-vue.js.org)\n */\n@media (max-width: 575.98px) {\n  .bv-d-xs-down-none {\n    display: none !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .bv-d-sm-down-none {\n    display: none !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .bv-d-md-down-none {\n    display: none !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .bv-d-lg-down-none {\n    display: none !important;\n  }\n}\n\n.bv-d-xl-down-none {\n  display: none !important;\n}\n\n.card-img-left {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-img-right {\n  border-top-right-radius: calc(0.25rem - 1px);\n  border-bottom-right-radius: calc(0.25rem - 1px);\n}\n\n.dropdown:not(.dropleft) .dropdown-toggle.dropdown-toggle-no-caret::after {\n  display: none !important;\n}\n\n.dropdown.dropleft .dropdown-toggle.dropdown-toggle-no-caret::before {\n  display: none !important;\n}\n\n.b-dropdown-form {\n  display: inline-block;\n  padding: 0.25rem 1.5rem;\n  width: 100%;\n  clear: both;\n  font-weight: 400;\n}\n\n.b-dropdown-form:first-child {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.b-dropdown-form:last-child {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.b-dropdown-text {\n  display: inline-block;\n  padding: 0.25rem 1.5rem;\n  margin-bottom: 0;\n  width: 100%;\n  clear: both;\n  font-weight: lighter;\n}\n\n.b-dropdown-text:first-child {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.b-dropdown-text:last-child {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.input-group > .input-group-prepend > .btn-group > .btn,\n.input-group > .input-group-append:not(:last-child) > .btn-group > .btn,\n.input-group > .input-group-append:last-child > .btn-group:not(:last-child):not(.dropdown-toggle) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn-group > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .btn-group > .btn,\n.input-group > .input-group-prepend:first-child > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.was-validated .form-control:invalid,\n.was-validated .form-control:valid, .form-control.is-invalid, .form-control.is-valid {\n  background-position: right calc(0.375em + 0.1875rem) center;\n}\n\ninput[type=\"color\"].form-control {\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0.125rem 0.25rem;\n}\n\ninput[type=\"color\"].form-control.form-control-sm,\n.input-group-sm input[type=\"color\"].form-control {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.125rem 0.25rem;\n}\n\ninput[type=\"color\"].form-control.form-control-lg,\n.input-group-lg input[type=\"color\"].form-control {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0.125rem 0.25rem;\n}\n\ninput[type=\"color\"].form-control:disabled {\n  background-color: #adb5bd;\n  opacity: 0.65;\n}\n\n.input-group > .custom-range {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  margin-bottom: 0;\n}\n\n.input-group > .custom-range + .form-control,\n.input-group > .custom-range + .form-control-plaintext,\n.input-group > .custom-range + .custom-select,\n.input-group > .custom-range + .custom-range,\n.input-group > .custom-range + .custom-file {\n  margin-left: -1px;\n}\n\n.input-group > .form-control + .custom-range,\n.input-group > .form-control-plaintext + .custom-range,\n.input-group > .custom-select + .custom-range,\n.input-group > .custom-range + .custom-range,\n.input-group > .custom-file + .custom-range {\n  margin-left: -1px;\n}\n\n.input-group > .custom-range:focus {\n  z-index: 3;\n}\n\n.input-group > .custom-range:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .custom-range:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group > .custom-range {\n  height: calc(1.5em + 0.75rem + 2px);\n  padding: 0 0.75rem;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  height: calc(1.5em + 0.75rem + 2px);\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .input-group > .custom-range {\n    transition: none;\n  }\n}\n\n.input-group > .custom-range:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.input-group > .custom-range:disabled, .input-group > .custom-range[readonly] {\n  background-color: #e9ecef;\n}\n\n.input-group-lg > .custom-range {\n  height: calc(1.5em + 1rem + 2px);\n  padding: 0 1rem;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .custom-range {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0 0.5rem;\n  border-radius: 0.2rem;\n}\n\n.was-validated .input-group .custom-range:valid, .input-group .custom-range.is-valid {\n  border-color: #28a745;\n}\n\n.was-validated .input-group .custom-range:valid:focus, .input-group .custom-range.is-valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated .custom-range:valid:focus::-webkit-slider-thumb, .custom-range.is-valid:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;\n}\n\n.was-validated .custom-range:valid:focus::-moz-range-thumb, .custom-range.is-valid:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;\n}\n\n.was-validated .custom-range:valid:focus::-ms-thumb, .custom-range.is-valid:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #9be7ac;\n}\n\n.was-validated .custom-range:valid::-webkit-slider-thumb, .custom-range.is-valid::-webkit-slider-thumb {\n  background-color: #28a745;\n  background-image: none;\n}\n\n.was-validated .custom-range:valid::-webkit-slider-thumb:active, .custom-range.is-valid::-webkit-slider-thumb:active {\n  background-color: #9be7ac;\n  background-image: none;\n}\n\n.was-validated .custom-range:valid::-webkit-slider-runnable-track, .custom-range.is-valid::-webkit-slider-runnable-track {\n  background-color: rgba(40, 167, 69, 0.35);\n}\n\n.was-validated .custom-range:valid::-moz-range-thumb, .custom-range.is-valid::-moz-range-thumb {\n  background-color: #28a745;\n  background-image: none;\n}\n\n.was-validated .custom-range:valid::-moz-range-thumb:active, .custom-range.is-valid::-moz-range-thumb:active {\n  background-color: #9be7ac;\n  background-image: none;\n}\n\n.was-validated .custom-range:valid::-moz-range-track, .custom-range.is-valid::-moz-range-track {\n  background: rgba(40, 167, 69, 0.35);\n}\n\n.was-validated .custom-range:valid ~ .valid-feedback,\n.was-validated .custom-range:valid ~ .valid-tooltip, .custom-range.is-valid ~ .valid-feedback,\n.custom-range.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-range:valid::-ms-thumb, .custom-range.is-valid::-ms-thumb {\n  background-color: #28a745;\n  background-image: none;\n}\n\n.was-validated .custom-range:valid::-ms-thumb:active, .custom-range.is-valid::-ms-thumb:active {\n  background-color: #9be7ac;\n  background-image: none;\n}\n\n.was-validated .custom-range:valid::-ms-track-lower, .custom-range.is-valid::-ms-track-lower {\n  background: rgba(40, 167, 69, 0.35);\n}\n\n.was-validated .custom-range:valid::-ms-track-upper, .custom-range.is-valid::-ms-track-upper {\n  background: rgba(40, 167, 69, 0.35);\n}\n\n.was-validated .input-group .custom-range:invalid, .input-group .custom-range.is-invalid {\n  border-color: #dc3545;\n}\n\n.was-validated .input-group .custom-range:invalid:focus, .input-group .custom-range.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .custom-range:invalid:focus::-webkit-slider-thumb, .custom-range.is-invalid:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;\n}\n\n.was-validated .custom-range:invalid:focus::-moz-range-thumb, .custom-range.is-invalid:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;\n}\n\n.was-validated .custom-range:invalid:focus::-ms-thumb, .custom-range.is-invalid:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem #f6cdd1;\n}\n\n.was-validated .custom-range:invalid::-webkit-slider-thumb, .custom-range.is-invalid::-webkit-slider-thumb {\n  background-color: #dc3545;\n  background-image: none;\n}\n\n.was-validated .custom-range:invalid::-webkit-slider-thumb:active, .custom-range.is-invalid::-webkit-slider-thumb:active {\n  background-color: #f6cdd1;\n  background-image: none;\n}\n\n.was-validated .custom-range:invalid::-webkit-slider-runnable-track, .custom-range.is-invalid::-webkit-slider-runnable-track {\n  background-color: rgba(220, 53, 69, 0.35);\n}\n\n.was-validated .custom-range:invalid::-moz-range-thumb, .custom-range.is-invalid::-moz-range-thumb {\n  background-color: #dc3545;\n  background-image: none;\n}\n\n.was-validated .custom-range:invalid::-moz-range-thumb:active, .custom-range.is-invalid::-moz-range-thumb:active {\n  background-color: #f6cdd1;\n  background-image: none;\n}\n\n.was-validated .custom-range:invalid::-moz-range-track, .custom-range.is-invalid::-moz-range-track {\n  background: rgba(220, 53, 69, 0.35);\n}\n\n.was-validated .custom-range:invalid ~ .invalid-feedback,\n.was-validated .custom-range:invalid ~ .invalid-tooltip, .custom-range.is-invalid ~ .invalid-feedback,\n.custom-range.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-range:invalid::-ms-thumb, .custom-range.is-invalid::-ms-thumb {\n  background-color: #dc3545;\n  background-image: none;\n}\n\n.was-validated .custom-range:invalid::-ms-thumb:active, .custom-range.is-invalid::-ms-thumb:active {\n  background-color: #f6cdd1;\n  background-image: none;\n}\n\n.was-validated .custom-range:invalid::-ms-track-lower, .custom-range.is-invalid::-ms-track-lower {\n  background: rgba(220, 53, 69, 0.35);\n}\n\n.was-validated .custom-range:invalid::-ms-track-upper, .custom-range.is-invalid::-ms-track-upper {\n  background: rgba(220, 53, 69, 0.35);\n}\n\n.table.b-table.b-table-fixed {\n  table-layout: fixed;\n}\n\n.table.b-table[aria-busy=\"true\"] {\n  opacity: 0.55;\n}\n\n.table.b-table > tbody > tr.b-table-details > td {\n  border-top: none !important;\n}\n\n.table.b-table > caption {\n  caption-side: bottom;\n}\n\n.table.b-table > caption.b-table-caption-top {\n  caption-side: top !important;\n}\n\n.table.b-table > thead > tr > th,\n.table.b-table > thead > tr > td,\n.table.b-table > tfoot > tr > th,\n.table.b-table > tfoot > tr > td {\n  position: relative;\n}\n\n.table.b-table > thead > tr > th[aria-sort],\n.table.b-table > tfoot > tr > th[aria-sort] {\n  position: relative;\n  padding-right: 1.125em;\n  cursor: pointer;\n}\n\n.table.b-table > thead > tr > th[aria-sort]::after,\n.table.b-table > tfoot > tr > th[aria-sort]::after {\n  position: absolute;\n  display: block;\n  bottom: 0;\n  right: 0.35em;\n  padding-bottom: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  opacity: 0.4;\n  content: \"\\2195\";\n  speak: none;\n}\n\n.table.b-table > thead > tr > th[aria-sort][aria-sort=\"ascending\"]::after,\n.table.b-table > tfoot > tr > th[aria-sort][aria-sort=\"ascending\"]::after {\n  opacity: 1;\n  content: \"\\2193\";\n}\n\n.table.b-table > thead > tr > th[aria-sort][aria-sort=\"descending\"]::after,\n.table.b-table > tfoot > tr > th[aria-sort][aria-sort=\"descending\"]::after {\n  opacity: 1;\n  content: \"\\2191\";\n}\n\n@media (max-width: 575.98px) {\n  .table.b-table.b-table-stacked-sm {\n    display: block;\n    width: 100%;\n  }\n  .table.b-table.b-table-stacked-sm > caption,\n  .table.b-table.b-table-stacked-sm > tbody,\n  .table.b-table.b-table-stacked-sm > tbody > tr,\n  .table.b-table.b-table-stacked-sm > tbody > tr > td,\n  .table.b-table.b-table-stacked-sm > tbody > tr > td {\n    display: block;\n  }\n  .table.b-table.b-table-stacked-sm > thead,\n  .table.b-table.b-table-stacked-sm > tfoot {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-sm > thead > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-sm > thead > tr.b-table-bottom-row,\n  .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-sm > caption {\n    caption-side: top !important;\n  }\n  .table.b-table.b-table-stacked-sm > tbody > tr > [data-label] {\n    display: grid;\n    grid-template-columns: 40% auto;\n    grid-gap: 0.25rem 1rem;\n  }\n  .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {\n    content: attr(data-label);\n    display: inline;\n    text-align: right;\n    overflow-wrap: break-word;\n    font-weight: bold;\n    font-style: normal;\n  }\n  .table.b-table.b-table-stacked-sm > tbody > tr.top-row, .table.b-table.b-table-stacked-sm > tbody > tr.bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-sm > tbody > tr > :first-child {\n    border-top-width: 3px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table.b-table.b-table-stacked-md {\n    display: block;\n    width: 100%;\n  }\n  .table.b-table.b-table-stacked-md > caption,\n  .table.b-table.b-table-stacked-md > tbody,\n  .table.b-table.b-table-stacked-md > tbody > tr,\n  .table.b-table.b-table-stacked-md > tbody > tr > td,\n  .table.b-table.b-table-stacked-md > tbody > tr > td {\n    display: block;\n  }\n  .table.b-table.b-table-stacked-md > thead,\n  .table.b-table.b-table-stacked-md > tfoot {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-md > thead > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-md > thead > tr.b-table-bottom-row,\n  .table.b-table.b-table-stacked-md > tfoot > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-md > tfoot > tr.b-table-bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-md > caption {\n    caption-side: top !important;\n  }\n  .table.b-table.b-table-stacked-md > tbody > tr > [data-label] {\n    display: grid;\n    grid-template-columns: 40% auto;\n    grid-gap: 0.25rem 1rem;\n  }\n  .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {\n    content: attr(data-label);\n    display: inline;\n    text-align: right;\n    overflow-wrap: break-word;\n    font-weight: bold;\n    font-style: normal;\n  }\n  .table.b-table.b-table-stacked-md > tbody > tr.top-row, .table.b-table.b-table-stacked-md > tbody > tr.bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-md > tbody > tr > :first-child {\n    border-top-width: 3px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table.b-table.b-table-stacked-lg {\n    display: block;\n    width: 100%;\n  }\n  .table.b-table.b-table-stacked-lg > caption,\n  .table.b-table.b-table-stacked-lg > tbody,\n  .table.b-table.b-table-stacked-lg > tbody > tr,\n  .table.b-table.b-table-stacked-lg > tbody > tr > td,\n  .table.b-table.b-table-stacked-lg > tbody > tr > td {\n    display: block;\n  }\n  .table.b-table.b-table-stacked-lg > thead,\n  .table.b-table.b-table-stacked-lg > tfoot {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-lg > thead > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-lg > thead > tr.b-table-bottom-row,\n  .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-lg > caption {\n    caption-side: top !important;\n  }\n  .table.b-table.b-table-stacked-lg > tbody > tr > [data-label] {\n    display: grid;\n    grid-template-columns: 40% auto;\n    grid-gap: 0.25rem 1rem;\n  }\n  .table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {\n    content: attr(data-label);\n    display: inline;\n    text-align: right;\n    overflow-wrap: break-word;\n    font-weight: bold;\n    font-style: normal;\n  }\n  .table.b-table.b-table-stacked-lg > tbody > tr.top-row, .table.b-table.b-table-stacked-lg > tbody > tr.bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-lg > tbody > tr > :first-child {\n    border-top-width: 3px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table.b-table.b-table-stacked-xl {\n    display: block;\n    width: 100%;\n  }\n  .table.b-table.b-table-stacked-xl > caption,\n  .table.b-table.b-table-stacked-xl > tbody,\n  .table.b-table.b-table-stacked-xl > tbody > tr,\n  .table.b-table.b-table-stacked-xl > tbody > tr > td,\n  .table.b-table.b-table-stacked-xl > tbody > tr > td {\n    display: block;\n  }\n  .table.b-table.b-table-stacked-xl > thead,\n  .table.b-table.b-table-stacked-xl > tfoot {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-xl > thead > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-xl > thead > tr.b-table-bottom-row,\n  .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-top-row,\n  .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-xl > caption {\n    caption-side: top !important;\n  }\n  .table.b-table.b-table-stacked-xl > tbody > tr > [data-label] {\n    display: grid;\n    grid-template-columns: 40% auto;\n    grid-gap: 0.25rem 1rem;\n  }\n  .table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {\n    content: attr(data-label);\n    display: inline;\n    text-align: right;\n    overflow-wrap: break-word;\n    font-weight: bold;\n    font-style: normal;\n  }\n  .table.b-table.b-table-stacked-xl > tbody > tr.top-row, .table.b-table.b-table-stacked-xl > tbody > tr.bottom-row {\n    display: none;\n  }\n  .table.b-table.b-table-stacked-xl > tbody > tr > :first-child {\n    border-top-width: 3px;\n  }\n}\n\n.table.b-table.b-table-stacked {\n  display: block;\n  width: 100%;\n}\n\n.table.b-table.b-table-stacked > caption,\n.table.b-table.b-table-stacked > tbody,\n.table.b-table.b-table-stacked > tbody > tr,\n.table.b-table.b-table-stacked > tbody > tr > td,\n.table.b-table.b-table-stacked > tbody > tr > td {\n  display: block;\n}\n\n.table.b-table.b-table-stacked > thead,\n.table.b-table.b-table-stacked > tfoot {\n  display: none;\n}\n\n.table.b-table.b-table-stacked > thead > tr.b-table-top-row,\n.table.b-table.b-table-stacked > thead > tr.b-table-bottom-row,\n.table.b-table.b-table-stacked > tfoot > tr.b-table-top-row,\n.table.b-table.b-table-stacked > tfoot > tr.b-table-bottom-row {\n  display: none;\n}\n\n.table.b-table.b-table-stacked > caption {\n  caption-side: top !important;\n}\n\n.table.b-table.b-table-stacked > tbody > tr > [data-label] {\n  display: grid;\n  grid-template-columns: 40% auto;\n  grid-gap: 0.25rem 1rem;\n}\n\n.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {\n  content: attr(data-label);\n  display: inline;\n  text-align: right;\n  overflow-wrap: break-word;\n  font-weight: bold;\n  font-style: normal;\n}\n\n.table.b-table.b-table-stacked > tbody > tr.top-row, .table.b-table.b-table-stacked > tbody > tr.bottom-row {\n  display: none;\n}\n\n.table.b-table.b-table-stacked > tbody > tr > :first-child {\n  border-top-width: 3px;\n}\n\n.table.b-table.b-table-selectable > tbody > tr {\n  cursor: pointer;\n}\n\n.table.b-table.b-table-selectable.b-table-selecting.b-table-select-range > tbody > tr {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.b-toast {\n  display: block;\n  position: relative;\n  max-width: 350px;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  background-clip: padding-box;\n  z-index: 1;\n  border-radius: 0.25rem;\n}\n\n.b-toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.b-toast.b-toast-solid .toast {\n  background-color: white;\n}\n\n.b-toast .toast .toast-body {\n  display: block;\n}\n\n.b-toast-primary .toast {\n  background-color: rgba(230, 242, 255, 0.85);\n  border-color: rgba(184, 218, 255, 0.85);\n  color: #004085;\n}\n\n.b-toast-primary .toast .toast-header {\n  color: #004085;\n  background-color: rgba(204, 229, 255, 0.85);\n  border-bottom-color: rgba(184, 218, 255, 0.85);\n}\n\n.b-toast-primary.b-toast-solid .toast {\n  background-color: #e6f2ff;\n}\n\n.b-toast-secondary .toast {\n  background-color: rgba(239, 240, 241, 0.85);\n  border-color: rgba(214, 216, 219, 0.85);\n  color: #383d41;\n}\n\n.b-toast-secondary .toast .toast-header {\n  color: #383d41;\n  background-color: rgba(226, 227, 229, 0.85);\n  border-bottom-color: rgba(214, 216, 219, 0.85);\n}\n\n.b-toast-secondary.b-toast-solid .toast {\n  background-color: #eff0f1;\n}\n\n.b-toast-success .toast {\n  background-color: rgba(230, 245, 233, 0.85);\n  border-color: rgba(195, 230, 203, 0.85);\n  color: #155724;\n}\n\n.b-toast-success .toast .toast-header {\n  color: #155724;\n  background-color: rgba(212, 237, 218, 0.85);\n  border-bottom-color: rgba(195, 230, 203, 0.85);\n}\n\n.b-toast-success.b-toast-solid .toast {\n  background-color: #e6f5e9;\n}\n\n.b-toast-info .toast {\n  background-color: rgba(229, 244, 247, 0.85);\n  border-color: rgba(190, 229, 235, 0.85);\n  color: #0c5460;\n}\n\n.b-toast-info .toast .toast-header {\n  color: #0c5460;\n  background-color: rgba(209, 236, 241, 0.85);\n  border-bottom-color: rgba(190, 229, 235, 0.85);\n}\n\n.b-toast-info.b-toast-solid .toast {\n  background-color: #e5f4f7;\n}\n\n.b-toast-warning .toast {\n  background-color: rgba(255, 249, 231, 0.85);\n  border-color: rgba(255, 238, 186, 0.85);\n  color: #856404;\n}\n\n.b-toast-warning .toast .toast-header {\n  color: #856404;\n  background-color: rgba(255, 243, 205, 0.85);\n  border-bottom-color: rgba(255, 238, 186, 0.85);\n}\n\n.b-toast-warning.b-toast-solid .toast {\n  background-color: #fff9e7;\n}\n\n.b-toast-danger .toast {\n  background-color: rgba(252, 237, 238, 0.85);\n  border-color: rgba(245, 198, 203, 0.85);\n  color: #721c24;\n}\n\n.b-toast-danger .toast .toast-header {\n  color: #721c24;\n  background-color: rgba(248, 215, 218, 0.85);\n  border-bottom-color: rgba(245, 198, 203, 0.85);\n}\n\n.b-toast-danger.b-toast-solid .toast {\n  background-color: #fcedee;\n}\n\n.b-toast-light .toast {\n  background-color: rgba(255, 255, 255, 0.85);\n  border-color: rgba(253, 253, 254, 0.85);\n  color: #818182;\n}\n\n.b-toast-light .toast .toast-header {\n  color: #818182;\n  background-color: rgba(254, 254, 254, 0.85);\n  border-bottom-color: rgba(253, 253, 254, 0.85);\n}\n\n.b-toast-light.b-toast-solid .toast {\n  background-color: white;\n}\n\n.b-toast-dark .toast {\n  background-color: rgba(227, 229, 229, 0.85);\n  border-color: rgba(198, 200, 202, 0.85);\n  color: #1b1e21;\n}\n\n.b-toast-dark .toast .toast-header {\n  color: #1b1e21;\n  background-color: rgba(214, 216, 217, 0.85);\n  border-bottom-color: rgba(198, 200, 202, 0.85);\n}\n\n.b-toast-dark.b-toast-solid .toast {\n  background-color: #e3e5e5;\n}\n\n.b-toaster {\n  z-index: 1100;\n}\n\n.b-toaster .b-toaster-slot {\n  position: relative;\n  display: block;\n}\n\n.b-toaster .b-toaster-slot:empty {\n  display: none !important;\n}\n\n.b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full, .b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {\n  position: fixed;\n  left: 0.5rem;\n  right: 0.5rem;\n  margin: 0;\n  padding: 0;\n  height: 0;\n  overflow: visible;\n}\n\n.b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {\n  position: absolute;\n  max-width: 350px;\n  left: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {\n  width: 100%;\n  max-width: 100%;\n}\n\n.b-toaster.b-toaster-top-full .b-toaster-slot .b-toast,\n.b-toaster.b-toaster-top-full .b-toaster-slot .toast, .b-toaster.b-toaster-bottom-full .b-toaster-slot .b-toast,\n.b-toaster.b-toaster-bottom-full .b-toaster-slot .toast {\n  width: 100%;\n  max-width: 100%;\n}\n\n.b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full {\n  top: 0;\n}\n\n.b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot {\n  top: 0.5rem;\n}\n\n.b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {\n  bottom: 0;\n}\n\n.b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {\n  bottom: 0.5rem;\n}\n\n.b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot {\n  margin-left: auto;\n}\n\n.b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot {\n  margin-right: auto;\n}\n\n.b-toaster.b-toaster-top-right .b-toast, .b-toaster.b-toaster-top-left .b-toast, .b-toaster.b-toaster-bottom-right .b-toast, .b-toaster.b-toaster-bottom-left .b-toast {\n  /*\n      &.b-toaster-enter-active,\n      &.b-toaster-enter-to {\n        .toast.fade {\n          // Delay the appearance of the toast until\n          // the move transition has completed\n          transition-delay: 0.175s;\n        }\n      }\n\n      &.b-toaster-move {\n        transition: transform 0.175s;\n        // transition-delay: 0.175s;\n      }\n\n      &.b-toaster-enter-active {\n        z-index: 0;\n      }\n\n      &.b-toaster-leave-active {\n        transition: transform 0.175s;\n      }\n\n      &.b-toaster-leave,\n      &.b-toaster-leave-active {\n        position: absolute;\n        z-index: 0;\n        transition-delay: 0.175s;\n\n        .toast.fade {\n          transition-delay: 0s;\n        }\n      }\n\n      &.b-toaster-leave {\n      }\n\n      &.b-toaster-leave-to {\n      }\n      */\n}\n\n.b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-move, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-move {\n  transition: -webkit-transform 0.175s;\n  transition: transform 0.175s;\n  transition: transform 0.175s, -webkit-transform 0.175s;\n}\n\n.b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active .toast.fade {\n  transition-delay: 0.175s;\n}\n\n.b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active {\n  position: absolute;\n  transition-delay: 0.175s;\n}\n\n.b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active .toast.fade {\n  transition-delay: 0s;\n}", ""]);

// exports


/***/ }),
/* 1077 */,
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("506b5844", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(64);
exports = module.exports = __webpack_require__(7)(false);
// imports
exports.i(__webpack_require__(1080), "");
exports.i(__webpack_require__(1081), "");

// module
exports.push([module.i, "\n@charset \"UTF-8\";\n/*!\n * CoreUI Pro - Bootstrap 4 Admin Template\n * @version v1.0.8\n * @link http://coreui.io/pro/\n * Copyright (c) 2018 creativeLabs Łukasz Holeczek\n * @license http://coreui.io/pro/license/\n */\n/*!\n * Bootstrap v4.0.0-beta.3 (https://getbootstrap.com)\n * Copyright 2011-2017 The Bootstrap Authors\n * Copyright 2011-2017 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n:root {\n  --blue: #20a8d8;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #f86c6b;\n  --orange: #f8cb00;\n  --yellow: #ffc107;\n  --green: #4dbd74;\n  --teal: #20c997;\n  --cyan: #63c2de;\n  --white: #fff;\n  --gray: #536c79;\n  --gray-dark: #29363d;\n  --blue: #20a8d8;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #f86c6b;\n  --orange: #f8cb00;\n  --yellow: #ffc107;\n  --green: #4dbd74;\n  --teal: #20c997;\n  --cyan: #63c2de;\n  --white: #fff;\n  --gray: #536c79;\n  --primary: #20a8d8;\n  --secondary: #a4b7c1;\n  --success: #4dbd74;\n  --info: #63c2de;\n  --warning: #ffc107;\n  --danger: #f86c6b;\n  --light: #f0f3f5;\n  --dark: #29363d;\n  --blue: #20a8d8;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #f86c6b;\n  --orange: #f8cb00;\n  --yellow: #ffc107;\n  --green: #4dbd74;\n  --teal: #20c997;\n  --cyan: #63c2de;\n  --gray-100: #f0f3f5;\n  --gray-200: #c2cfd6;\n  --gray-300: #a4b7c1;\n  --gray-400: #869fac;\n  --gray-500: #678898;\n  --gray-600: #536c79;\n  --gray-700: #3e515b;\n  --gray-800: #29363d;\n  --gray-900: #151b1e;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@-ms-viewport {\n  width: device-width;\n}\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #151b1e;\n  text-align: left;\n  background-color: #e4e5e6;\n}\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n}\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 700;\n}\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1rem;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -.25em;\n}\nsup {\n  top: -.5em;\n}\na {\n  color: #20a8d8;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n    color: #167495;\n    text-decoration: underline;\n}\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {\n    color: inherit;\n    text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n    outline: 0;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\nfigure {\n  margin: 0 0 1rem;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\na,\narea,\nbutton,\n[role=\"button\"],\ninput:not([type=\"range\"]),\nlabel,\nselect,\nsummary,\ntextarea {\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #536c79;\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: inherit;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: .5rem;\n}\nbutton {\n  border-radius: 0;\n}\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: inherit;\n}\nh1, .h1 {\n  font-size: 2.1875rem;\n}\nh2, .h2 {\n  font-size: 1.75rem;\n}\nh3, .h3 {\n  font-size: 1.53125rem;\n}\nh4, .h4 {\n  font-size: 1.3125rem;\n}\nh5, .h5 {\n  font-size: 1.09375rem;\n}\nh6, .h6 {\n  font-size: 0.875rem;\n}\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300;\n}\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n    margin-right: 0.5rem;\n}\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.09375rem;\n}\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #536c79;\n}\n.blockquote-footer::before {\n    content: \"\\2014   \\A0\";\n}\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #e4e5e6;\n  border: 1px solid #a4b7c1;\n  max-width: 100%;\n  height: auto;\n}\n.figure {\n  display: inline-block;\n}\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n.figure-caption {\n  font-size: 90%;\n  color: #536c79;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-break: break-word;\n}\na > code {\n    color: inherit;\n}\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #151b1e;\n}\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n}\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #151b1e;\n}\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal;\n}\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n.container {\n      max-width: 540px;\n}\n}\n@media (min-width: 768px) {\n.container {\n      max-width: 720px;\n}\n}\n@media (min-width: 992px) {\n.container {\n      max-width: 960px;\n}\n}\n@media (min-width: 1200px) {\n.container {\n      max-width: 1140px;\n}\n}\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n  .no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n}\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  max-width: 100%;\n}\n.col-auto {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n}\n.col-1 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 8.33333%;\n          flex: 0 0 8.33333%;\n  max-width: 8.33333%;\n}\n.col-2 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 16.66667%;\n          flex: 0 0 16.66667%;\n  max-width: 16.66667%;\n}\n.col-3 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 25%;\n          flex: 0 0 25%;\n  max-width: 25%;\n}\n.col-4 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 33.33333%;\n          flex: 0 0 33.33333%;\n  max-width: 33.33333%;\n}\n.col-5 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 41.66667%;\n          flex: 0 0 41.66667%;\n  max-width: 41.66667%;\n}\n.col-6 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 50%;\n          flex: 0 0 50%;\n  max-width: 50%;\n}\n.col-7 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 58.33333%;\n          flex: 0 0 58.33333%;\n  max-width: 58.33333%;\n}\n.col-8 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 66.66667%;\n          flex: 0 0 66.66667%;\n  max-width: 66.66667%;\n}\n.col-9 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 75%;\n          flex: 0 0 75%;\n  max-width: 75%;\n}\n.col-10 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 83.33333%;\n          flex: 0 0 83.33333%;\n  max-width: 83.33333%;\n}\n.col-11 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 91.66667%;\n          flex: 0 0 91.66667%;\n  max-width: 91.66667%;\n}\n.col-12 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 100%;\n          flex: 0 0 100%;\n  max-width: 100%;\n}\n.order-first {\n  -webkit-box-ordinal-group: 0;\n      -ms-flex-order: -1;\n          order: -1;\n}\n.order-1 {\n  -webkit-box-ordinal-group: 2;\n      -ms-flex-order: 1;\n          order: 1;\n}\n.order-2 {\n  -webkit-box-ordinal-group: 3;\n      -ms-flex-order: 2;\n          order: 2;\n}\n.order-3 {\n  -webkit-box-ordinal-group: 4;\n      -ms-flex-order: 3;\n          order: 3;\n}\n.order-4 {\n  -webkit-box-ordinal-group: 5;\n      -ms-flex-order: 4;\n          order: 4;\n}\n.order-5 {\n  -webkit-box-ordinal-group: 6;\n      -ms-flex-order: 5;\n          order: 5;\n}\n.order-6 {\n  -webkit-box-ordinal-group: 7;\n      -ms-flex-order: 6;\n          order: 6;\n}\n.order-7 {\n  -webkit-box-ordinal-group: 8;\n      -ms-flex-order: 7;\n          order: 7;\n}\n.order-8 {\n  -webkit-box-ordinal-group: 9;\n      -ms-flex-order: 8;\n          order: 8;\n}\n.order-9 {\n  -webkit-box-ordinal-group: 10;\n      -ms-flex-order: 9;\n          order: 9;\n}\n.order-10 {\n  -webkit-box-ordinal-group: 11;\n      -ms-flex-order: 10;\n          order: 10;\n}\n.order-11 {\n  -webkit-box-ordinal-group: 12;\n      -ms-flex-order: 11;\n          order: 11;\n}\n.order-12 {\n  -webkit-box-ordinal-group: 13;\n      -ms-flex-order: 12;\n          order: 12;\n}\n.offset-1 {\n  margin-left: 8.33333%;\n}\n.offset-2 {\n  margin-left: 16.66667%;\n}\n.offset-3 {\n  margin-left: 25%;\n}\n.offset-4 {\n  margin-left: 33.33333%;\n}\n.offset-5 {\n  margin-left: 41.66667%;\n}\n.offset-6 {\n  margin-left: 50%;\n}\n.offset-7 {\n  margin-left: 58.33333%;\n}\n.offset-8 {\n  margin-left: 66.66667%;\n}\n.offset-9 {\n  margin-left: 75%;\n}\n.offset-10 {\n  margin-left: 83.33333%;\n}\n.offset-11 {\n  margin-left: 91.66667%;\n}\n@media (min-width: 576px) {\n.col-sm {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    max-width: 100%;\n}\n.col-sm-auto {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n}\n.col-sm-1 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n            flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-sm-2 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n            flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-sm-3 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n            flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-sm-4 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n            flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-sm-5 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n            flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-sm-6 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n            flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-sm-7 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n            flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-sm-8 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n            flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-sm-9 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n            flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-sm-10 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n            flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-sm-11 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n            flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-sm-12 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n    max-width: 100%;\n}\n.order-sm-first {\n    -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n            order: -1;\n}\n.order-sm-1 {\n    -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n            order: 1;\n}\n.order-sm-2 {\n    -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n            order: 2;\n}\n.order-sm-3 {\n    -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n            order: 3;\n}\n.order-sm-4 {\n    -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n            order: 4;\n}\n.order-sm-5 {\n    -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n            order: 5;\n}\n.order-sm-6 {\n    -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n            order: 6;\n}\n.order-sm-7 {\n    -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n            order: 7;\n}\n.order-sm-8 {\n    -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n            order: 8;\n}\n.order-sm-9 {\n    -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n            order: 9;\n}\n.order-sm-10 {\n    -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n            order: 10;\n}\n.order-sm-11 {\n    -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n            order: 11;\n}\n.order-sm-12 {\n    -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n            order: 12;\n}\n.offset-sm-0 {\n    margin-left: 0;\n}\n.offset-sm-1 {\n    margin-left: 8.33333%;\n}\n.offset-sm-2 {\n    margin-left: 16.66667%;\n}\n.offset-sm-3 {\n    margin-left: 25%;\n}\n.offset-sm-4 {\n    margin-left: 33.33333%;\n}\n.offset-sm-5 {\n    margin-left: 41.66667%;\n}\n.offset-sm-6 {\n    margin-left: 50%;\n}\n.offset-sm-7 {\n    margin-left: 58.33333%;\n}\n.offset-sm-8 {\n    margin-left: 66.66667%;\n}\n.offset-sm-9 {\n    margin-left: 75%;\n}\n.offset-sm-10 {\n    margin-left: 83.33333%;\n}\n.offset-sm-11 {\n    margin-left: 91.66667%;\n}\n}\n@media (min-width: 768px) {\n.col-md {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    max-width: 100%;\n}\n.col-md-auto {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n}\n.col-md-1 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n            flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-md-2 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n            flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-md-3 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n            flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-md-4 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n            flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-md-5 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n            flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-md-6 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n            flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-md-7 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n            flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-md-8 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n            flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-md-9 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n            flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-md-10 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n            flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-md-11 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n            flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-md-12 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n    max-width: 100%;\n}\n.order-md-first {\n    -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n            order: -1;\n}\n.order-md-1 {\n    -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n            order: 1;\n}\n.order-md-2 {\n    -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n            order: 2;\n}\n.order-md-3 {\n    -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n            order: 3;\n}\n.order-md-4 {\n    -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n            order: 4;\n}\n.order-md-5 {\n    -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n            order: 5;\n}\n.order-md-6 {\n    -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n            order: 6;\n}\n.order-md-7 {\n    -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n            order: 7;\n}\n.order-md-8 {\n    -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n            order: 8;\n}\n.order-md-9 {\n    -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n            order: 9;\n}\n.order-md-10 {\n    -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n            order: 10;\n}\n.order-md-11 {\n    -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n            order: 11;\n}\n.order-md-12 {\n    -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n            order: 12;\n}\n.offset-md-0 {\n    margin-left: 0;\n}\n.offset-md-1 {\n    margin-left: 8.33333%;\n}\n.offset-md-2 {\n    margin-left: 16.66667%;\n}\n.offset-md-3 {\n    margin-left: 25%;\n}\n.offset-md-4 {\n    margin-left: 33.33333%;\n}\n.offset-md-5 {\n    margin-left: 41.66667%;\n}\n.offset-md-6 {\n    margin-left: 50%;\n}\n.offset-md-7 {\n    margin-left: 58.33333%;\n}\n.offset-md-8 {\n    margin-left: 66.66667%;\n}\n.offset-md-9 {\n    margin-left: 75%;\n}\n.offset-md-10 {\n    margin-left: 83.33333%;\n}\n.offset-md-11 {\n    margin-left: 91.66667%;\n}\n}\n@media (min-width: 992px) {\n.col-lg {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    max-width: 100%;\n}\n.col-lg-auto {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n}\n.col-lg-1 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n            flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-lg-2 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n            flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-lg-3 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n            flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-lg-4 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n            flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-lg-5 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n            flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-lg-6 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n            flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-lg-7 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n            flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-lg-8 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n            flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-lg-9 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n            flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-lg-10 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n            flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-lg-11 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n            flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-lg-12 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n    max-width: 100%;\n}\n.order-lg-first {\n    -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n            order: -1;\n}\n.order-lg-1 {\n    -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n            order: 1;\n}\n.order-lg-2 {\n    -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n            order: 2;\n}\n.order-lg-3 {\n    -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n            order: 3;\n}\n.order-lg-4 {\n    -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n            order: 4;\n}\n.order-lg-5 {\n    -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n            order: 5;\n}\n.order-lg-6 {\n    -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n            order: 6;\n}\n.order-lg-7 {\n    -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n            order: 7;\n}\n.order-lg-8 {\n    -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n            order: 8;\n}\n.order-lg-9 {\n    -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n            order: 9;\n}\n.order-lg-10 {\n    -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n            order: 10;\n}\n.order-lg-11 {\n    -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n            order: 11;\n}\n.order-lg-12 {\n    -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n            order: 12;\n}\n.offset-lg-0 {\n    margin-left: 0;\n}\n.offset-lg-1 {\n    margin-left: 8.33333%;\n}\n.offset-lg-2 {\n    margin-left: 16.66667%;\n}\n.offset-lg-3 {\n    margin-left: 25%;\n}\n.offset-lg-4 {\n    margin-left: 33.33333%;\n}\n.offset-lg-5 {\n    margin-left: 41.66667%;\n}\n.offset-lg-6 {\n    margin-left: 50%;\n}\n.offset-lg-7 {\n    margin-left: 58.33333%;\n}\n.offset-lg-8 {\n    margin-left: 66.66667%;\n}\n.offset-lg-9 {\n    margin-left: 75%;\n}\n.offset-lg-10 {\n    margin-left: 83.33333%;\n}\n.offset-lg-11 {\n    margin-left: 91.66667%;\n}\n}\n@media (min-width: 1200px) {\n.col-xl {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    max-width: 100%;\n}\n.col-xl-auto {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n}\n.col-xl-1 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.33333%;\n            flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n}\n.col-xl-2 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.66667%;\n            flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n}\n.col-xl-3 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n            flex: 0 0 25%;\n    max-width: 25%;\n}\n.col-xl-4 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.33333%;\n            flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n}\n.col-xl-5 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.66667%;\n            flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n}\n.col-xl-6 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n            flex: 0 0 50%;\n    max-width: 50%;\n}\n.col-xl-7 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.33333%;\n            flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n}\n.col-xl-8 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.66667%;\n            flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n}\n.col-xl-9 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n            flex: 0 0 75%;\n    max-width: 75%;\n}\n.col-xl-10 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.33333%;\n            flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n}\n.col-xl-11 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.66667%;\n            flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n}\n.col-xl-12 {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n            flex: 0 0 100%;\n    max-width: 100%;\n}\n.order-xl-first {\n    -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n            order: -1;\n}\n.order-xl-1 {\n    -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n            order: 1;\n}\n.order-xl-2 {\n    -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n            order: 2;\n}\n.order-xl-3 {\n    -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n            order: 3;\n}\n.order-xl-4 {\n    -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n            order: 4;\n}\n.order-xl-5 {\n    -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n            order: 5;\n}\n.order-xl-6 {\n    -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n            order: 6;\n}\n.order-xl-7 {\n    -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n            order: 7;\n}\n.order-xl-8 {\n    -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n            order: 8;\n}\n.order-xl-9 {\n    -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n            order: 9;\n}\n.order-xl-10 {\n    -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n            order: 10;\n}\n.order-xl-11 {\n    -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n            order: 11;\n}\n.order-xl-12 {\n    -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n            order: 12;\n}\n.offset-xl-0 {\n    margin-left: 0;\n}\n.offset-xl-1 {\n    margin-left: 8.33333%;\n}\n.offset-xl-2 {\n    margin-left: 16.66667%;\n}\n.offset-xl-3 {\n    margin-left: 25%;\n}\n.offset-xl-4 {\n    margin-left: 33.33333%;\n}\n.offset-xl-5 {\n    margin-left: 41.66667%;\n}\n.offset-xl-6 {\n    margin-left: 50%;\n}\n.offset-xl-7 {\n    margin-left: 58.33333%;\n}\n.offset-xl-8 {\n    margin-left: 66.66667%;\n}\n.offset-xl-9 {\n    margin-left: 75%;\n}\n.offset-xl-10 {\n    margin-left: 83.33333%;\n}\n.offset-xl-11 {\n    margin-left: 91.66667%;\n}\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n  background-color: transparent;\n}\n.table th,\n  .table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #a4b7c1;\n}\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #a4b7c1;\n}\n.table tbody + tbody {\n    border-top: 2px solid #a4b7c1;\n}\n.table .table {\n    background-color: #e4e5e6;\n}\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n.table-bordered {\n  border: 1px solid #a4b7c1;\n}\n.table-bordered th,\n  .table-bordered td {\n    border: 1px solid #a4b7c1;\n}\n.table-bordered thead th,\n  .table-bordered thead td {\n    border-bottom-width: 2px;\n}\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #c1e7f4;\n}\n.table-hover .table-primary:hover {\n  background-color: #abdff0;\n}\n.table-hover .table-primary:hover > td,\n  .table-hover .table-primary:hover > th {\n    background-color: #abdff0;\n}\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #e6ebee;\n}\n.table-hover .table-secondary:hover {\n  background-color: #d7dfe4;\n}\n.table-hover .table-secondary:hover > td,\n  .table-hover .table-secondary:hover > th {\n    background-color: #d7dfe4;\n}\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #cdedd8;\n}\n.table-hover .table-success:hover {\n  background-color: #bae6c9;\n}\n.table-hover .table-success:hover > td,\n  .table-hover .table-success:hover > th {\n    background-color: #bae6c9;\n}\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #d3eef6;\n}\n.table-hover .table-info:hover {\n  background-color: #bee6f2;\n}\n.table-hover .table-info:hover > td,\n  .table-hover .table-info:hover > th {\n    background-color: #bee6f2;\n}\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #ffeeba;\n}\n.table-hover .table-warning:hover {\n  background-color: #ffe8a1;\n}\n.table-hover .table-warning:hover > td,\n  .table-hover .table-warning:hover > th {\n    background-color: #ffe8a1;\n}\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #fdd6d6;\n}\n.table-hover .table-danger:hover {\n  background-color: #fcbebe;\n}\n.table-hover .table-danger:hover > td,\n  .table-hover .table-danger:hover > th {\n    background-color: #fcbebe;\n}\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fbfcfc;\n}\n.table-hover .table-light:hover {\n  background-color: #ecf1f1;\n}\n.table-hover .table-light:hover > td,\n  .table-hover .table-light:hover > th {\n    background-color: #ecf1f1;\n}\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c3c7c9;\n}\n.table-hover .table-dark:hover {\n  background-color: #b6babd;\n}\n.table-hover .table-dark:hover > td,\n  .table-hover .table-dark:hover > th {\n    background-color: #b6babd;\n}\n.table-blue,\n.table-blue > th,\n.table-blue > td {\n  background-color: #c1e7f4;\n}\n.table-hover .table-blue:hover {\n  background-color: #abdff0;\n}\n.table-hover .table-blue:hover > td,\n  .table-hover .table-blue:hover > th {\n    background-color: #abdff0;\n}\n.table-indigo,\n.table-indigo > th,\n.table-indigo > td {\n  background-color: #d4bcfb;\n}\n.table-hover .table-indigo:hover {\n  background-color: #c5a4fa;\n}\n.table-hover .table-indigo:hover > td,\n  .table-hover .table-indigo:hover > th {\n    background-color: #c5a4fa;\n}\n.table-purple,\n.table-purple > th,\n.table-purple > td {\n  background-color: #d7caee;\n}\n.table-hover .table-purple:hover {\n  background-color: #c8b7e8;\n}\n.table-hover .table-purple:hover > td,\n  .table-hover .table-purple:hover > th {\n    background-color: #c8b7e8;\n}\n.table-pink,\n.table-pink > th,\n.table-pink > td {\n  background-color: #f9c9df;\n}\n.table-hover .table-pink:hover {\n  background-color: #f6b2d1;\n}\n.table-hover .table-pink:hover > td,\n  .table-hover .table-pink:hover > th {\n    background-color: #f6b2d1;\n}\n.table-red,\n.table-red > th,\n.table-red > td {\n  background-color: #fdd6d6;\n}\n.table-hover .table-red:hover {\n  background-color: #fcbebe;\n}\n.table-hover .table-red:hover > td,\n  .table-hover .table-red:hover > th {\n    background-color: #fcbebe;\n}\n.table-orange,\n.table-orange > th,\n.table-orange > td {\n  background-color: #fdf0b8;\n}\n.table-hover .table-orange:hover {\n  background-color: #fceb9f;\n}\n.table-hover .table-orange:hover > td,\n  .table-hover .table-orange:hover > th {\n    background-color: #fceb9f;\n}\n.table-yellow,\n.table-yellow > th,\n.table-yellow > td {\n  background-color: #ffeeba;\n}\n.table-hover .table-yellow:hover {\n  background-color: #ffe8a1;\n}\n.table-hover .table-yellow:hover > td,\n  .table-hover .table-yellow:hover > th {\n    background-color: #ffe8a1;\n}\n.table-green,\n.table-green > th,\n.table-green > td {\n  background-color: #cdedd8;\n}\n.table-hover .table-green:hover {\n  background-color: #bae6c9;\n}\n.table-hover .table-green:hover > td,\n  .table-hover .table-green:hover > th {\n    background-color: #bae6c9;\n}\n.table-teal,\n.table-teal > th,\n.table-teal > td {\n  background-color: #c1f0e2;\n}\n.table-hover .table-teal:hover {\n  background-color: #acebd8;\n}\n.table-hover .table-teal:hover > td,\n  .table-hover .table-teal:hover > th {\n    background-color: #acebd8;\n}\n.table-cyan,\n.table-cyan > th,\n.table-cyan > td {\n  background-color: #d3eef6;\n}\n.table-hover .table-cyan:hover {\n  background-color: #bee6f2;\n}\n.table-hover .table-cyan:hover > td,\n  .table-hover .table-cyan:hover > th {\n    background-color: #bee6f2;\n}\n.table-gray-100,\n.table-gray-100 > th,\n.table-gray-100 > td {\n  background-color: #fbfcfc;\n}\n.table-hover .table-gray-100:hover {\n  background-color: #ecf1f1;\n}\n.table-hover .table-gray-100:hover > td,\n  .table-hover .table-gray-100:hover > th {\n    background-color: #ecf1f1;\n}\n.table-gray-200,\n.table-gray-200 > th,\n.table-gray-200 > td {\n  background-color: #eef2f4;\n}\n.table-hover .table-gray-200:hover {\n  background-color: #dfe6ea;\n}\n.table-hover .table-gray-200:hover > td,\n  .table-hover .table-gray-200:hover > th {\n    background-color: #dfe6ea;\n}\n.table-gray-300,\n.table-gray-300 > th,\n.table-gray-300 > td {\n  background-color: #e6ebee;\n}\n.table-hover .table-gray-300:hover {\n  background-color: #d7dfe4;\n}\n.table-hover .table-gray-300:hover > td,\n  .table-hover .table-gray-300:hover > th {\n    background-color: #d7dfe4;\n}\n.table-gray-400,\n.table-gray-400 > th,\n.table-gray-400 > td {\n  background-color: #dde4e8;\n}\n.table-hover .table-gray-400:hover {\n  background-color: #ced8de;\n}\n.table-hover .table-gray-400:hover > td,\n  .table-hover .table-gray-400:hover > th {\n    background-color: #ced8de;\n}\n.table-gray-500,\n.table-gray-500 > th,\n.table-gray-500 > td {\n  background-color: #d4dee2;\n}\n.table-hover .table-gray-500:hover {\n  background-color: #c5d2d8;\n}\n.table-hover .table-gray-500:hover > td,\n  .table-hover .table-gray-500:hover > th {\n    background-color: #c5d2d8;\n}\n.table-gray-600,\n.table-gray-600 > th,\n.table-gray-600 > td {\n  background-color: #cfd6d9;\n}\n.table-hover .table-gray-600:hover {\n  background-color: #c1cace;\n}\n.table-hover .table-gray-600:hover > td,\n  .table-hover .table-gray-600:hover > th {\n    background-color: #c1cace;\n}\n.table-gray-700,\n.table-gray-700 > th,\n.table-gray-700 > td {\n  background-color: #c9ced1;\n}\n.table-hover .table-gray-700:hover {\n  background-color: #bbc2c5;\n}\n.table-hover .table-gray-700:hover > td,\n  .table-hover .table-gray-700:hover > th {\n    background-color: #bbc2c5;\n}\n.table-gray-800,\n.table-gray-800 > th,\n.table-gray-800 > td {\n  background-color: #c3c7c9;\n}\n.table-hover .table-gray-800:hover {\n  background-color: #b6babd;\n}\n.table-hover .table-gray-800:hover > td,\n  .table-hover .table-gray-800:hover > th {\n    background-color: #b6babd;\n}\n.table-gray-900,\n.table-gray-900 > th,\n.table-gray-900 > td {\n  background-color: #bdbfc0;\n}\n.table-hover .table-gray-900:hover {\n  background-color: #b0b2b4;\n}\n.table-hover .table-gray-900:hover > td,\n  .table-hover .table-gray-900:hover > th {\n    background-color: #b0b2b4;\n}\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-hover .table-active:hover > td,\n  .table-hover .table-active:hover > th {\n    background-color: rgba(0, 0, 0, 0.075);\n}\n.table .thead-dark th {\n  color: #e4e5e6;\n  background-color: #151b1e;\n  border-color: #252f35;\n}\n.table .thead-light th {\n  color: #3e515b;\n  background-color: #c2cfd6;\n  border-color: #a4b7c1;\n}\n.table-dark {\n  color: #e4e5e6;\n  background-color: #151b1e;\n}\n.table-dark th,\n  .table-dark td,\n  .table-dark thead th {\n    border-color: #252f35;\n}\n.table-dark.table-bordered {\n    border: 0;\n}\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n.table-dark.table-hover tbody tr:hover {\n    background-color: rgba(255, 255, 255, 0.075);\n}\n@media (max-width: 575.99px) {\n.table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive-sm > .table-bordered {\n      border: 0;\n}\n}\n@media (max-width: 767.99px) {\n.table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive-md > .table-bordered {\n      border: 0;\n}\n}\n@media (max-width: 991.99px) {\n.table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive-lg > .table-bordered {\n      border: 0;\n}\n}\n@media (max-width: 1199.99px) {\n.table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive-xl > .table-bordered {\n      border: 0;\n}\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive > .table-bordered {\n    border: 0;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #3e515b;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #c2cfd6;\n  border-radius: 0;\n  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0;\n}\n.form-control:focus {\n    color: #3e515b;\n    background-color: #fff;\n    border-color: #8ad4ee;\n    outline: 0;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n}\n.form-control::-webkit-input-placeholder {\n    color: #536c79;\n    opacity: 1;\n}\n.form-control::-moz-placeholder {\n    color: #536c79;\n    opacity: 1;\n}\n.form-control::-ms-input-placeholder {\n    color: #536c79;\n    opacity: 1;\n}\n.form-control::placeholder {\n    color: #536c79;\n    opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n    background-color: #c2cfd6;\n    opacity: 1;\n}\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.0625rem + 2px);\n}\nselect.form-control:focus::-ms-value {\n  color: #3e515b;\n  background-color: #fff;\n}\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.09375rem;\n  line-height: 1.5;\n}\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.76562rem;\n  line-height: 1.5;\n}\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  margin-bottom: 0;\n  line-height: 1.5;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,\n  .input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,\n  .input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,\n  .input-group-sm > .input-group-prepend > .form-control-plaintext.btn,\n  .input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,\n  .input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,\n  .input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,\n  .input-group-lg > .input-group-prepend > .form-control-plaintext.btn,\n  .input-group-lg > .input-group-append > .form-control-plaintext.btn {\n    padding-right: 0;\n    padding-left: 0;\n}\n.form-control-sm, .input-group-sm > .form-control,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.76562rem;\n  line-height: 1.5;\n}\nselect.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {\n  height: calc(1.64844rem + 2px);\n}\n.form-control-lg, .input-group-lg > .form-control,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n}\nselect.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {\n  height: calc(2.64062rem + 2px);\n}\n.form-group {\n  margin-bottom: 1rem;\n}\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n.form-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n  .form-row > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input:disabled ~ .form-check-label {\n    color: #536c79;\n}\n.form-check-label {\n  margin-bottom: 0;\n}\n.form-check-inline {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: 0.3125rem;\n    margin-left: 0;\n}\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #4dbd74;\n}\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  width: 250px;\n  padding: .5rem;\n  margin-top: .1rem;\n  font-size: .875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(77, 189, 116, 0.8);\n  border-radius: .2rem;\n}\n.was-validated .form-control:valid, .form-control.is-valid, .was-validated\n.custom-select:valid,\n.custom-select.is-valid {\n  border-color: #4dbd74;\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus, .was-validated\n  .custom-select:valid:focus,\n  .custom-select.is-valid:focus {\n    border-color: #4dbd74;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.25);\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n  .was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n  .form-control.is-valid ~ .valid-tooltip, .was-validated\n  .custom-select:valid ~ .valid-feedback,\n  .was-validated\n  .custom-select:valid ~ .valid-tooltip,\n  .custom-select.is-valid ~ .valid-feedback,\n  .custom-select.is-valid ~ .valid-tooltip {\n    display: block;\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #4dbd74;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #4dbd74;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n    background-color: #aadfbd;\n}\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  background-color: #72cb91;\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  -webkit-box-shadow: 0 0 0 1px #e4e5e6, 0 0 0 0.2rem rgba(77, 189, 116, 0.25);\n          box-shadow: 0 0 0 1px #e4e5e6, 0 0 0 0.2rem rgba(77, 189, 116, 0.25);\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #4dbd74;\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {\n    border-color: inherit;\n}\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.25);\n          box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.25);\n}\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #f86c6b;\n}\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  width: 250px;\n  padding: .5rem;\n  margin-top: .1rem;\n  font-size: .875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(248, 108, 107, 0.8);\n  border-radius: .2rem;\n}\n.was-validated .form-control:invalid, .form-control.is-invalid, .was-validated\n.custom-select:invalid,\n.custom-select.is-invalid {\n  border-color: #f86c6b;\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus, .was-validated\n  .custom-select:invalid:focus,\n  .custom-select.is-invalid:focus {\n    border-color: #f86c6b;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.25);\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n  .was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n  .form-control.is-invalid ~ .invalid-tooltip, .was-validated\n  .custom-select:invalid ~ .invalid-feedback,\n  .was-validated\n  .custom-select:invalid ~ .invalid-tooltip,\n  .custom-select.is-invalid ~ .invalid-feedback,\n  .custom-select.is-invalid ~ .invalid-tooltip {\n    display: block;\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #f86c6b;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #f86c6b;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n    background-color: #fee5e5;\n}\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  background-color: #fa9c9c;\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  -webkit-box-shadow: 0 0 0 1px #e4e5e6, 0 0 0 0.2rem rgba(248, 108, 107, 0.25);\n          box-shadow: 0 0 0 1px #e4e5e6, 0 0 0 0.2rem rgba(248, 108, 107, 0.25);\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #f86c6b;\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {\n    border-color: inherit;\n}\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.25);\n          box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.25);\n}\n.form-inline {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.form-inline .form-check {\n    width: 100%;\n}\n@media (min-width: 576px) {\n.form-inline label {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      margin-bottom: 0;\n}\n.form-inline .form-group {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-flex: 0;\n          -ms-flex: 0 0 auto;\n              flex: 0 0 auto;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-flow: row wrap;\n              flex-flow: row wrap;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      margin-bottom: 0;\n}\n.form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle;\n}\n.form-inline .form-control-plaintext {\n      display: inline-block;\n}\n.form-inline .input-group {\n      width: auto;\n}\n.form-inline .form-check {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      width: auto;\n      padding-left: 0;\n}\n.form-inline .form-check-input {\n      position: relative;\n      margin-top: 0;\n      margin-right: 0.25rem;\n      margin-left: 0;\n}\n.form-inline .custom-control {\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.form-inline .custom-control-label {\n      margin-bottom: 0;\n}\n}\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0;\n  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;\n}\n.btn:focus, .btn:hover {\n    text-decoration: none;\n}\n.btn:focus, .btn.focus {\n    outline: 0;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n}\n.btn.disabled, .btn:disabled {\n    opacity: 0.65;\n}\n.btn:not([disabled]):not(.disabled) {\n    cursor: pointer;\n}\n.btn:not([disabled]):not(.disabled):active, .btn:not([disabled]):not(.disabled).active {\n    background-image: none;\n}\na.btn.disabled,\nfieldset[disabled] a.btn {\n  pointer-events: none;\n}\n.btn-primary {\n  color: #fff;\n  background-color: #20a8d8;\n  border-color: #20a8d8;\n}\n.btn-primary:hover {\n    color: #fff;\n    background-color: #1b8eb7;\n    border-color: #1985ac;\n}\n.btn-primary:focus, .btn-primary.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n}\n.btn-primary:not([disabled]):not(.disabled):active, .btn-primary:not([disabled]):not(.disabled).active,\n  .show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #1985ac;\n    border-color: #187da0;\n}\n.btn-primary:not([disabled]):not(.disabled):active:focus, .btn-primary:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-primary.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-secondary {\n  color: #151b1e;\n  background-color: #a4b7c1;\n  border-color: #a4b7c1;\n}\n.btn-secondary:hover {\n    color: #151b1e;\n    background-color: #8da5b2;\n    border-color: #869fac;\n}\n.btn-secondary:focus, .btn-secondary.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n    background-color: #a4b7c1;\n    border-color: #a4b7c1;\n}\n.btn-secondary:not([disabled]):not(.disabled):active, .btn-secondary:not([disabled]):not(.disabled).active,\n  .show > .btn-secondary.dropdown-toggle {\n    color: #151b1e;\n    background-color: #869fac;\n    border-color: #7e99a7;\n}\n.btn-secondary:not([disabled]):not(.disabled):active:focus, .btn-secondary:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-secondary.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-success {\n  color: #fff;\n  background-color: #4dbd74;\n  border-color: #4dbd74;\n}\n.btn-success:hover {\n    color: #fff;\n    background-color: #3ea662;\n    border-color: #3a9d5d;\n}\n.btn-success:focus, .btn-success.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n    background-color: #4dbd74;\n    border-color: #4dbd74;\n}\n.btn-success:not([disabled]):not(.disabled):active, .btn-success:not([disabled]):not(.disabled).active,\n  .show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #3a9d5d;\n    border-color: #379457;\n}\n.btn-success:not([disabled]):not(.disabled):active:focus, .btn-success:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-success.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-info {\n  color: #151b1e;\n  background-color: #63c2de;\n  border-color: #63c2de;\n}\n.btn-info:hover {\n    color: #151b1e;\n    background-color: #43b6d7;\n    border-color: #39b2d5;\n}\n.btn-info:focus, .btn-info.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n    background-color: #63c2de;\n    border-color: #63c2de;\n}\n.btn-info:not([disabled]):not(.disabled):active, .btn-info:not([disabled]):not(.disabled).active,\n  .show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #39b2d5;\n    border-color: #2eadd3;\n}\n.btn-info:not([disabled]):not(.disabled):active:focus, .btn-info:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-info.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-warning {\n  color: #151b1e;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n.btn-warning:hover {\n    color: #151b1e;\n    background-color: #e0a800;\n    border-color: #d39e00;\n}\n.btn-warning:focus, .btn-warning.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n.btn-warning:not([disabled]):not(.disabled):active, .btn-warning:not([disabled]):not(.disabled).active,\n  .show > .btn-warning.dropdown-toggle {\n    color: #151b1e;\n    background-color: #d39e00;\n    border-color: #c69500;\n}\n.btn-warning:not([disabled]):not(.disabled):active:focus, .btn-warning:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-warning.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-danger {\n  color: #fff;\n  background-color: #f86c6b;\n  border-color: #f86c6b;\n}\n.btn-danger:hover {\n    color: #fff;\n    background-color: #f64846;\n    border-color: #f63c3a;\n}\n.btn-danger:focus, .btn-danger.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n    background-color: #f86c6b;\n    border-color: #f86c6b;\n}\n.btn-danger:not([disabled]):not(.disabled):active, .btn-danger:not([disabled]):not(.disabled).active,\n  .show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #f63c3a;\n    border-color: #f5302e;\n}\n.btn-danger:not([disabled]):not(.disabled):active:focus, .btn-danger:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-danger.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-light {\n  color: #151b1e;\n  background-color: #f0f3f5;\n  border-color: #f0f3f5;\n}\n.btn-light:hover {\n    color: #151b1e;\n    background-color: #d9e1e6;\n    border-color: #d1dbe1;\n}\n.btn-light:focus, .btn-light.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n    background-color: #f0f3f5;\n    border-color: #f0f3f5;\n}\n.btn-light:not([disabled]):not(.disabled):active, .btn-light:not([disabled]):not(.disabled).active,\n  .show > .btn-light.dropdown-toggle {\n    color: #151b1e;\n    background-color: #d1dbe1;\n    border-color: #cad4dc;\n}\n.btn-light:not([disabled]):not(.disabled):active:focus, .btn-light:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-light.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-dark {\n  color: #fff;\n  background-color: #29363d;\n  border-color: #29363d;\n}\n.btn-dark:hover {\n    color: #fff;\n    background-color: #1a2226;\n    border-color: #151b1f;\n}\n.btn-dark:focus, .btn-dark.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n    background-color: #29363d;\n    border-color: #29363d;\n}\n.btn-dark:not([disabled]):not(.disabled):active, .btn-dark:not([disabled]):not(.disabled).active,\n  .show > .btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #151b1f;\n    border-color: #0f1417;\n}\n.btn-dark:not([disabled]):not(.disabled):active:focus, .btn-dark:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-dark.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-blue {\n  color: #fff;\n  background-color: #20a8d8;\n  border-color: #20a8d8;\n}\n.btn-blue:hover {\n    color: #fff;\n    background-color: #1b8eb7;\n    border-color: #1985ac;\n}\n.btn-blue:focus, .btn-blue.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-blue.disabled, .btn-blue:disabled {\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n}\n.btn-blue:not([disabled]):not(.disabled):active, .btn-blue:not([disabled]):not(.disabled).active,\n  .show > .btn-blue.dropdown-toggle {\n    color: #fff;\n    background-color: #1985ac;\n    border-color: #187da0;\n}\n.btn-blue:not([disabled]):not(.disabled):active:focus, .btn-blue:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-blue.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-indigo {\n  color: #fff;\n  background-color: #6610f2;\n  border-color: #6610f2;\n}\n.btn-indigo:hover {\n    color: #fff;\n    background-color: #560bd0;\n    border-color: #510bc4;\n}\n.btn-indigo:focus, .btn-indigo.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n}\n.btn-indigo.disabled, .btn-indigo:disabled {\n    background-color: #6610f2;\n    border-color: #6610f2;\n}\n.btn-indigo:not([disabled]):not(.disabled):active, .btn-indigo:not([disabled]):not(.disabled).active,\n  .show > .btn-indigo.dropdown-toggle {\n    color: #fff;\n    background-color: #510bc4;\n    border-color: #4c0ab8;\n}\n.btn-indigo:not([disabled]):not(.disabled):active:focus, .btn-indigo:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-indigo.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n}\n.btn-purple {\n  color: #fff;\n  background-color: #6f42c1;\n  border-color: #6f42c1;\n}\n.btn-purple:hover {\n    color: #fff;\n    background-color: #5e37a6;\n    border-color: #59339d;\n}\n.btn-purple:focus, .btn-purple.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n}\n.btn-purple.disabled, .btn-purple:disabled {\n    background-color: #6f42c1;\n    border-color: #6f42c1;\n}\n.btn-purple:not([disabled]):not(.disabled):active, .btn-purple:not([disabled]):not(.disabled).active,\n  .show > .btn-purple.dropdown-toggle {\n    color: #fff;\n    background-color: #59339d;\n    border-color: #533093;\n}\n.btn-purple:not([disabled]):not(.disabled):active:focus, .btn-purple:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-purple.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n}\n.btn-pink {\n  color: #fff;\n  background-color: #e83e8c;\n  border-color: #e83e8c;\n}\n.btn-pink:hover {\n    color: #fff;\n    background-color: #e41c78;\n    border-color: #d91a72;\n}\n.btn-pink:focus, .btn-pink.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n}\n.btn-pink.disabled, .btn-pink:disabled {\n    background-color: #e83e8c;\n    border-color: #e83e8c;\n}\n.btn-pink:not([disabled]):not(.disabled):active, .btn-pink:not([disabled]):not(.disabled).active,\n  .show > .btn-pink.dropdown-toggle {\n    color: #fff;\n    background-color: #d91a72;\n    border-color: #ce196c;\n}\n.btn-pink:not([disabled]):not(.disabled):active:focus, .btn-pink:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-pink.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n}\n.btn-red {\n  color: #fff;\n  background-color: #f86c6b;\n  border-color: #f86c6b;\n}\n.btn-red:hover {\n    color: #fff;\n    background-color: #f64846;\n    border-color: #f63c3a;\n}\n.btn-red:focus, .btn-red.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-red.disabled, .btn-red:disabled {\n    background-color: #f86c6b;\n    border-color: #f86c6b;\n}\n.btn-red:not([disabled]):not(.disabled):active, .btn-red:not([disabled]):not(.disabled).active,\n  .show > .btn-red.dropdown-toggle {\n    color: #fff;\n    background-color: #f63c3a;\n    border-color: #f5302e;\n}\n.btn-red:not([disabled]):not(.disabled):active:focus, .btn-red:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-red.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-orange {\n  color: #151b1e;\n  background-color: #f8cb00;\n  border-color: #f8cb00;\n}\n.btn-orange:hover {\n    color: #151b1e;\n    background-color: #d2ac00;\n    border-color: #c5a100;\n}\n.btn-orange:focus, .btn-orange.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n}\n.btn-orange.disabled, .btn-orange:disabled {\n    background-color: #f8cb00;\n    border-color: #f8cb00;\n}\n.btn-orange:not([disabled]):not(.disabled):active, .btn-orange:not([disabled]):not(.disabled).active,\n  .show > .btn-orange.dropdown-toggle {\n    color: #151b1e;\n    background-color: #c5a100;\n    border-color: #b89700;\n}\n.btn-orange:not([disabled]):not(.disabled):active:focus, .btn-orange:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-orange.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n}\n.btn-yellow {\n  color: #151b1e;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n.btn-yellow:hover {\n    color: #151b1e;\n    background-color: #e0a800;\n    border-color: #d39e00;\n}\n.btn-yellow:focus, .btn-yellow.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-yellow.disabled, .btn-yellow:disabled {\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n.btn-yellow:not([disabled]):not(.disabled):active, .btn-yellow:not([disabled]):not(.disabled).active,\n  .show > .btn-yellow.dropdown-toggle {\n    color: #151b1e;\n    background-color: #d39e00;\n    border-color: #c69500;\n}\n.btn-yellow:not([disabled]):not(.disabled):active:focus, .btn-yellow:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-yellow.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-green {\n  color: #fff;\n  background-color: #4dbd74;\n  border-color: #4dbd74;\n}\n.btn-green:hover {\n    color: #fff;\n    background-color: #3ea662;\n    border-color: #3a9d5d;\n}\n.btn-green:focus, .btn-green.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-green.disabled, .btn-green:disabled {\n    background-color: #4dbd74;\n    border-color: #4dbd74;\n}\n.btn-green:not([disabled]):not(.disabled):active, .btn-green:not([disabled]):not(.disabled).active,\n  .show > .btn-green.dropdown-toggle {\n    color: #fff;\n    background-color: #3a9d5d;\n    border-color: #379457;\n}\n.btn-green:not([disabled]):not(.disabled):active:focus, .btn-green:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-green.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-teal {\n  color: #fff;\n  background-color: #20c997;\n  border-color: #20c997;\n}\n.btn-teal:hover {\n    color: #fff;\n    background-color: #1ba87e;\n    border-color: #199d76;\n}\n.btn-teal:focus, .btn-teal.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n}\n.btn-teal.disabled, .btn-teal:disabled {\n    background-color: #20c997;\n    border-color: #20c997;\n}\n.btn-teal:not([disabled]):not(.disabled):active, .btn-teal:not([disabled]):not(.disabled).active,\n  .show > .btn-teal.dropdown-toggle {\n    color: #fff;\n    background-color: #199d76;\n    border-color: #17926e;\n}\n.btn-teal:not([disabled]):not(.disabled):active:focus, .btn-teal:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-teal.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n}\n.btn-cyan {\n  color: #151b1e;\n  background-color: #63c2de;\n  border-color: #63c2de;\n}\n.btn-cyan:hover {\n    color: #151b1e;\n    background-color: #43b6d7;\n    border-color: #39b2d5;\n}\n.btn-cyan:focus, .btn-cyan.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-cyan.disabled, .btn-cyan:disabled {\n    background-color: #63c2de;\n    border-color: #63c2de;\n}\n.btn-cyan:not([disabled]):not(.disabled):active, .btn-cyan:not([disabled]):not(.disabled).active,\n  .show > .btn-cyan.dropdown-toggle {\n    color: #fff;\n    background-color: #39b2d5;\n    border-color: #2eadd3;\n}\n.btn-cyan:not([disabled]):not(.disabled):active:focus, .btn-cyan:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-cyan.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-gray-100 {\n  color: #151b1e;\n  background-color: #f0f3f5;\n  border-color: #f0f3f5;\n}\n.btn-gray-100:hover {\n    color: #151b1e;\n    background-color: #d9e1e6;\n    border-color: #d1dbe1;\n}\n.btn-gray-100:focus, .btn-gray-100.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-gray-100.disabled, .btn-gray-100:disabled {\n    background-color: #f0f3f5;\n    border-color: #f0f3f5;\n}\n.btn-gray-100:not([disabled]):not(.disabled):active, .btn-gray-100:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-100.dropdown-toggle {\n    color: #151b1e;\n    background-color: #d1dbe1;\n    border-color: #cad4dc;\n}\n.btn-gray-100:not([disabled]):not(.disabled):active:focus, .btn-gray-100:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-100.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-gray-200 {\n  color: #151b1e;\n  background-color: #c2cfd6;\n  border-color: #c2cfd6;\n}\n.btn-gray-200:hover {\n    color: #151b1e;\n    background-color: #abbdc7;\n    border-color: #a4b7c2;\n}\n.btn-gray-200:focus, .btn-gray-200.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n}\n.btn-gray-200.disabled, .btn-gray-200:disabled {\n    background-color: #c2cfd6;\n    border-color: #c2cfd6;\n}\n.btn-gray-200:not([disabled]):not(.disabled):active, .btn-gray-200:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-200.dropdown-toggle {\n    color: #151b1e;\n    background-color: #a4b7c2;\n    border-color: #9cb1bc;\n}\n.btn-gray-200:not([disabled]):not(.disabled):active:focus, .btn-gray-200:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-200.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n}\n.btn-gray-300 {\n  color: #151b1e;\n  background-color: #a4b7c1;\n  border-color: #a4b7c1;\n}\n.btn-gray-300:hover {\n    color: #151b1e;\n    background-color: #8da5b2;\n    border-color: #869fac;\n}\n.btn-gray-300:focus, .btn-gray-300.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-gray-300.disabled, .btn-gray-300:disabled {\n    background-color: #a4b7c1;\n    border-color: #a4b7c1;\n}\n.btn-gray-300:not([disabled]):not(.disabled):active, .btn-gray-300:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-300.dropdown-toggle {\n    color: #151b1e;\n    background-color: #869fac;\n    border-color: #7e99a7;\n}\n.btn-gray-300:not([disabled]):not(.disabled):active:focus, .btn-gray-300:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-300.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-gray-400 {\n  color: #151b1e;\n  background-color: #869fac;\n  border-color: #869fac;\n}\n.btn-gray-400:hover {\n    color: #fff;\n    background-color: #6f8d9c;\n    border-color: #688797;\n}\n.btn-gray-400:focus, .btn-gray-400.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n}\n.btn-gray-400.disabled, .btn-gray-400:disabled {\n    background-color: #869fac;\n    border-color: #869fac;\n}\n.btn-gray-400:not([disabled]):not(.disabled):active, .btn-gray-400:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-400.dropdown-toggle {\n    color: #fff;\n    background-color: #688797;\n    border-color: #638090;\n}\n.btn-gray-400:not([disabled]):not(.disabled):active:focus, .btn-gray-400:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-400.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n}\n.btn-gray-500 {\n  color: #fff;\n  background-color: #678898;\n  border-color: #678898;\n}\n.btn-gray-500:hover {\n    color: #fff;\n    background-color: #587481;\n    border-color: #526d7a;\n}\n.btn-gray-500:focus, .btn-gray-500.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n}\n.btn-gray-500.disabled, .btn-gray-500:disabled {\n    background-color: #678898;\n    border-color: #678898;\n}\n.btn-gray-500:not([disabled]):not(.disabled):active, .btn-gray-500:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-500.dropdown-toggle {\n    color: #fff;\n    background-color: #526d7a;\n    border-color: #4d6672;\n}\n.btn-gray-500:not([disabled]):not(.disabled):active:focus, .btn-gray-500:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-500.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n}\n.btn-gray-600 {\n  color: #fff;\n  background-color: #536c79;\n  border-color: #536c79;\n}\n.btn-gray-600:hover {\n    color: #fff;\n    background-color: #435862;\n    border-color: #3e515b;\n}\n.btn-gray-600:focus, .btn-gray-600.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n}\n.btn-gray-600.disabled, .btn-gray-600:disabled {\n    background-color: #536c79;\n    border-color: #536c79;\n}\n.btn-gray-600:not([disabled]):not(.disabled):active, .btn-gray-600:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-600.dropdown-toggle {\n    color: #fff;\n    background-color: #3e515b;\n    border-color: #394a53;\n}\n.btn-gray-600:not([disabled]):not(.disabled):active:focus, .btn-gray-600:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-600.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n}\n.btn-gray-700 {\n  color: #fff;\n  background-color: #3e515b;\n  border-color: #3e515b;\n}\n.btn-gray-700:hover {\n    color: #fff;\n    background-color: #2f3d44;\n    border-color: #29363d;\n}\n.btn-gray-700:focus, .btn-gray-700.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n}\n.btn-gray-700.disabled, .btn-gray-700:disabled {\n    background-color: #3e515b;\n    border-color: #3e515b;\n}\n.btn-gray-700:not([disabled]):not(.disabled):active, .btn-gray-700:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-700.dropdown-toggle {\n    color: #fff;\n    background-color: #29363d;\n    border-color: #242f35;\n}\n.btn-gray-700:not([disabled]):not(.disabled):active:focus, .btn-gray-700:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-700.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n}\n.btn-gray-800 {\n  color: #fff;\n  background-color: #29363d;\n  border-color: #29363d;\n}\n.btn-gray-800:hover {\n    color: #fff;\n    background-color: #1a2226;\n    border-color: #151b1f;\n}\n.btn-gray-800:focus, .btn-gray-800.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-gray-800.disabled, .btn-gray-800:disabled {\n    background-color: #29363d;\n    border-color: #29363d;\n}\n.btn-gray-800:not([disabled]):not(.disabled):active, .btn-gray-800:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-800.dropdown-toggle {\n    color: #fff;\n    background-color: #151b1f;\n    border-color: #0f1417;\n}\n.btn-gray-800:not([disabled]):not(.disabled):active:focus, .btn-gray-800:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-800.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-gray-900 {\n  color: #fff;\n  background-color: #151b1e;\n  border-color: #151b1e;\n}\n.btn-gray-900:hover {\n    color: #fff;\n    background-color: #050708;\n    border-color: black;\n}\n.btn-gray-900:focus, .btn-gray-900.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n}\n.btn-gray-900.disabled, .btn-gray-900:disabled {\n    background-color: #151b1e;\n    border-color: #151b1e;\n}\n.btn-gray-900:not([disabled]):not(.disabled):active, .btn-gray-900:not([disabled]):not(.disabled).active,\n  .show > .btn-gray-900.dropdown-toggle {\n    color: #fff;\n    background-color: black;\n    border-color: black;\n}\n.btn-gray-900:not([disabled]):not(.disabled):active:focus, .btn-gray-900:not([disabled]):not(.disabled).active:focus,\n    .show > .btn-gray-900.dropdown-toggle:focus {\n      -webkit-box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n              box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n}\n.btn-outline-primary {\n  color: #20a8d8;\n  background-color: transparent;\n  background-image: none;\n  border-color: #20a8d8;\n}\n.btn-outline-primary:hover {\n    color: #fff;\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #20a8d8;\n    background-color: transparent;\n}\n.btn-outline-primary:not([disabled]):not(.disabled):active, .btn-outline-primary:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-primary.dropdown-toggle {\n    color: #151b1e;\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-outline-secondary {\n  color: #a4b7c1;\n  background-color: transparent;\n  background-image: none;\n  border-color: #a4b7c1;\n}\n.btn-outline-secondary:hover {\n    color: #151b1e;\n    background-color: #a4b7c1;\n    border-color: #a4b7c1;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #a4b7c1;\n    background-color: transparent;\n}\n.btn-outline-secondary:not([disabled]):not(.disabled):active, .btn-outline-secondary:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-secondary.dropdown-toggle {\n    color: #151b1e;\n    background-color: #a4b7c1;\n    border-color: #a4b7c1;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-outline-success {\n  color: #4dbd74;\n  background-color: transparent;\n  background-image: none;\n  border-color: #4dbd74;\n}\n.btn-outline-success:hover {\n    color: #fff;\n    background-color: #4dbd74;\n    border-color: #4dbd74;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #4dbd74;\n    background-color: transparent;\n}\n.btn-outline-success:not([disabled]):not(.disabled):active, .btn-outline-success:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-success.dropdown-toggle {\n    color: #151b1e;\n    background-color: #4dbd74;\n    border-color: #4dbd74;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-outline-info {\n  color: #63c2de;\n  background-color: transparent;\n  background-image: none;\n  border-color: #63c2de;\n}\n.btn-outline-info:hover {\n    color: #151b1e;\n    background-color: #63c2de;\n    border-color: #63c2de;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #63c2de;\n    background-color: transparent;\n}\n.btn-outline-info:not([disabled]):not(.disabled):active, .btn-outline-info:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-info.dropdown-toggle {\n    color: #151b1e;\n    background-color: #63c2de;\n    border-color: #63c2de;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-outline-warning {\n  color: #ffc107;\n  background-color: transparent;\n  background-image: none;\n  border-color: #ffc107;\n}\n.btn-outline-warning:hover {\n    color: #151b1e;\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #ffc107;\n    background-color: transparent;\n}\n.btn-outline-warning:not([disabled]):not(.disabled):active, .btn-outline-warning:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-warning.dropdown-toggle {\n    color: #151b1e;\n    background-color: #ffc107;\n    border-color: #ffc107;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-outline-danger {\n  color: #f86c6b;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f86c6b;\n}\n.btn-outline-danger:hover {\n    color: #fff;\n    background-color: #f86c6b;\n    border-color: #f86c6b;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #f86c6b;\n    background-color: transparent;\n}\n.btn-outline-danger:not([disabled]):not(.disabled):active, .btn-outline-danger:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-danger.dropdown-toggle {\n    color: #151b1e;\n    background-color: #f86c6b;\n    border-color: #f86c6b;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-outline-light {\n  color: #f0f3f5;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f0f3f5;\n}\n.btn-outline-light:hover {\n    color: #151b1e;\n    background-color: #f0f3f5;\n    border-color: #f0f3f5;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #f0f3f5;\n    background-color: transparent;\n}\n.btn-outline-light:not([disabled]):not(.disabled):active, .btn-outline-light:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-light.dropdown-toggle {\n    color: #fff;\n    background-color: #f0f3f5;\n    border-color: #f0f3f5;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-outline-dark {\n  color: #29363d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #29363d;\n}\n.btn-outline-dark:hover {\n    color: #fff;\n    background-color: #29363d;\n    border-color: #29363d;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n    color: #29363d;\n    background-color: transparent;\n}\n.btn-outline-dark:not([disabled]):not(.disabled):active, .btn-outline-dark:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-dark.dropdown-toggle {\n    color: #151b1e;\n    background-color: #29363d;\n    border-color: #29363d;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-outline-blue {\n  color: #20a8d8;\n  background-color: transparent;\n  background-image: none;\n  border-color: #20a8d8;\n}\n.btn-outline-blue:hover {\n    color: #fff;\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n}\n.btn-outline-blue:focus, .btn-outline-blue.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-outline-blue.disabled, .btn-outline-blue:disabled {\n    color: #20a8d8;\n    background-color: transparent;\n}\n.btn-outline-blue:not([disabled]):not(.disabled):active, .btn-outline-blue:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-blue.dropdown-toggle {\n    color: #151b1e;\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.5);\n}\n.btn-outline-indigo {\n  color: #6610f2;\n  background-color: transparent;\n  background-image: none;\n  border-color: #6610f2;\n}\n.btn-outline-indigo:hover {\n    color: #fff;\n    background-color: #6610f2;\n    border-color: #6610f2;\n}\n.btn-outline-indigo:focus, .btn-outline-indigo.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n}\n.btn-outline-indigo.disabled, .btn-outline-indigo:disabled {\n    color: #6610f2;\n    background-color: transparent;\n}\n.btn-outline-indigo:not([disabled]):not(.disabled):active, .btn-outline-indigo:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-indigo.dropdown-toggle {\n    color: #151b1e;\n    background-color: #6610f2;\n    border-color: #6610f2;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(102, 16, 242, 0.5);\n}\n.btn-outline-purple {\n  color: #6f42c1;\n  background-color: transparent;\n  background-image: none;\n  border-color: #6f42c1;\n}\n.btn-outline-purple:hover {\n    color: #fff;\n    background-color: #6f42c1;\n    border-color: #6f42c1;\n}\n.btn-outline-purple:focus, .btn-outline-purple.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n}\n.btn-outline-purple.disabled, .btn-outline-purple:disabled {\n    color: #6f42c1;\n    background-color: transparent;\n}\n.btn-outline-purple:not([disabled]):not(.disabled):active, .btn-outline-purple:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-purple.dropdown-toggle {\n    color: #151b1e;\n    background-color: #6f42c1;\n    border-color: #6f42c1;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(111, 66, 193, 0.5);\n}\n.btn-outline-pink {\n  color: #e83e8c;\n  background-color: transparent;\n  background-image: none;\n  border-color: #e83e8c;\n}\n.btn-outline-pink:hover {\n    color: #fff;\n    background-color: #e83e8c;\n    border-color: #e83e8c;\n}\n.btn-outline-pink:focus, .btn-outline-pink.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n}\n.btn-outline-pink.disabled, .btn-outline-pink:disabled {\n    color: #e83e8c;\n    background-color: transparent;\n}\n.btn-outline-pink:not([disabled]):not(.disabled):active, .btn-outline-pink:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-pink.dropdown-toggle {\n    color: #151b1e;\n    background-color: #e83e8c;\n    border-color: #e83e8c;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(232, 62, 140, 0.5);\n}\n.btn-outline-red {\n  color: #f86c6b;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f86c6b;\n}\n.btn-outline-red:hover {\n    color: #fff;\n    background-color: #f86c6b;\n    border-color: #f86c6b;\n}\n.btn-outline-red:focus, .btn-outline-red.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-outline-red.disabled, .btn-outline-red:disabled {\n    color: #f86c6b;\n    background-color: transparent;\n}\n.btn-outline-red:not([disabled]):not(.disabled):active, .btn-outline-red:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-red.dropdown-toggle {\n    color: #151b1e;\n    background-color: #f86c6b;\n    border-color: #f86c6b;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.5);\n}\n.btn-outline-orange {\n  color: #f8cb00;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f8cb00;\n}\n.btn-outline-orange:hover {\n    color: #151b1e;\n    background-color: #f8cb00;\n    border-color: #f8cb00;\n}\n.btn-outline-orange:focus, .btn-outline-orange.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n}\n.btn-outline-orange.disabled, .btn-outline-orange:disabled {\n    color: #f8cb00;\n    background-color: transparent;\n}\n.btn-outline-orange:not([disabled]):not(.disabled):active, .btn-outline-orange:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-orange.dropdown-toggle {\n    color: #151b1e;\n    background-color: #f8cb00;\n    border-color: #f8cb00;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(248, 203, 0, 0.5);\n}\n.btn-outline-yellow {\n  color: #ffc107;\n  background-color: transparent;\n  background-image: none;\n  border-color: #ffc107;\n}\n.btn-outline-yellow:hover {\n    color: #151b1e;\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n.btn-outline-yellow:focus, .btn-outline-yellow.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-outline-yellow.disabled, .btn-outline-yellow:disabled {\n    color: #ffc107;\n    background-color: transparent;\n}\n.btn-outline-yellow:not([disabled]):not(.disabled):active, .btn-outline-yellow:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-yellow.dropdown-toggle {\n    color: #151b1e;\n    background-color: #ffc107;\n    border-color: #ffc107;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n.btn-outline-green {\n  color: #4dbd74;\n  background-color: transparent;\n  background-image: none;\n  border-color: #4dbd74;\n}\n.btn-outline-green:hover {\n    color: #fff;\n    background-color: #4dbd74;\n    border-color: #4dbd74;\n}\n.btn-outline-green:focus, .btn-outline-green.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-outline-green.disabled, .btn-outline-green:disabled {\n    color: #4dbd74;\n    background-color: transparent;\n}\n.btn-outline-green:not([disabled]):not(.disabled):active, .btn-outline-green:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-green.dropdown-toggle {\n    color: #151b1e;\n    background-color: #4dbd74;\n    border-color: #4dbd74;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(77, 189, 116, 0.5);\n}\n.btn-outline-teal {\n  color: #20c997;\n  background-color: transparent;\n  background-image: none;\n  border-color: #20c997;\n}\n.btn-outline-teal:hover {\n    color: #fff;\n    background-color: #20c997;\n    border-color: #20c997;\n}\n.btn-outline-teal:focus, .btn-outline-teal.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n}\n.btn-outline-teal.disabled, .btn-outline-teal:disabled {\n    color: #20c997;\n    background-color: transparent;\n}\n.btn-outline-teal:not([disabled]):not(.disabled):active, .btn-outline-teal:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-teal.dropdown-toggle {\n    color: #151b1e;\n    background-color: #20c997;\n    border-color: #20c997;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(32, 201, 151, 0.5);\n}\n.btn-outline-cyan {\n  color: #63c2de;\n  background-color: transparent;\n  background-image: none;\n  border-color: #63c2de;\n}\n.btn-outline-cyan:hover {\n    color: #151b1e;\n    background-color: #63c2de;\n    border-color: #63c2de;\n}\n.btn-outline-cyan:focus, .btn-outline-cyan.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-outline-cyan.disabled, .btn-outline-cyan:disabled {\n    color: #63c2de;\n    background-color: transparent;\n}\n.btn-outline-cyan:not([disabled]):not(.disabled):active, .btn-outline-cyan:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-cyan.dropdown-toggle {\n    color: #151b1e;\n    background-color: #63c2de;\n    border-color: #63c2de;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(99, 194, 222, 0.5);\n}\n.btn-outline-gray-100 {\n  color: #f0f3f5;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f0f3f5;\n}\n.btn-outline-gray-100:hover {\n    color: #151b1e;\n    background-color: #f0f3f5;\n    border-color: #f0f3f5;\n}\n.btn-outline-gray-100:focus, .btn-outline-gray-100.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-outline-gray-100.disabled, .btn-outline-gray-100:disabled {\n    color: #f0f3f5;\n    background-color: transparent;\n}\n.btn-outline-gray-100:not([disabled]):not(.disabled):active, .btn-outline-gray-100:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-100.dropdown-toggle {\n    color: #151b1e;\n    background-color: #f0f3f5;\n    border-color: #f0f3f5;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(240, 243, 245, 0.5);\n}\n.btn-outline-gray-200 {\n  color: #c2cfd6;\n  background-color: transparent;\n  background-image: none;\n  border-color: #c2cfd6;\n}\n.btn-outline-gray-200:hover {\n    color: #151b1e;\n    background-color: #c2cfd6;\n    border-color: #c2cfd6;\n}\n.btn-outline-gray-200:focus, .btn-outline-gray-200.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n}\n.btn-outline-gray-200.disabled, .btn-outline-gray-200:disabled {\n    color: #c2cfd6;\n    background-color: transparent;\n}\n.btn-outline-gray-200:not([disabled]):not(.disabled):active, .btn-outline-gray-200:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-200.dropdown-toggle {\n    color: #151b1e;\n    background-color: #c2cfd6;\n    border-color: #c2cfd6;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(194, 207, 214, 0.5);\n}\n.btn-outline-gray-300 {\n  color: #a4b7c1;\n  background-color: transparent;\n  background-image: none;\n  border-color: #a4b7c1;\n}\n.btn-outline-gray-300:hover {\n    color: #151b1e;\n    background-color: #a4b7c1;\n    border-color: #a4b7c1;\n}\n.btn-outline-gray-300:focus, .btn-outline-gray-300.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-outline-gray-300.disabled, .btn-outline-gray-300:disabled {\n    color: #a4b7c1;\n    background-color: transparent;\n}\n.btn-outline-gray-300:not([disabled]):not(.disabled):active, .btn-outline-gray-300:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-300.dropdown-toggle {\n    color: #151b1e;\n    background-color: #a4b7c1;\n    border-color: #a4b7c1;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(164, 183, 193, 0.5);\n}\n.btn-outline-gray-400 {\n  color: #869fac;\n  background-color: transparent;\n  background-image: none;\n  border-color: #869fac;\n}\n.btn-outline-gray-400:hover {\n    color: #151b1e;\n    background-color: #869fac;\n    border-color: #869fac;\n}\n.btn-outline-gray-400:focus, .btn-outline-gray-400.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n}\n.btn-outline-gray-400.disabled, .btn-outline-gray-400:disabled {\n    color: #869fac;\n    background-color: transparent;\n}\n.btn-outline-gray-400:not([disabled]):not(.disabled):active, .btn-outline-gray-400:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-400.dropdown-toggle {\n    color: #151b1e;\n    background-color: #869fac;\n    border-color: #869fac;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(134, 159, 172, 0.5);\n}\n.btn-outline-gray-500 {\n  color: #678898;\n  background-color: transparent;\n  background-image: none;\n  border-color: #678898;\n}\n.btn-outline-gray-500:hover {\n    color: #fff;\n    background-color: #678898;\n    border-color: #678898;\n}\n.btn-outline-gray-500:focus, .btn-outline-gray-500.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n}\n.btn-outline-gray-500.disabled, .btn-outline-gray-500:disabled {\n    color: #678898;\n    background-color: transparent;\n}\n.btn-outline-gray-500:not([disabled]):not(.disabled):active, .btn-outline-gray-500:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-500.dropdown-toggle {\n    color: #151b1e;\n    background-color: #678898;\n    border-color: #678898;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(103, 136, 152, 0.5);\n}\n.btn-outline-gray-600 {\n  color: #536c79;\n  background-color: transparent;\n  background-image: none;\n  border-color: #536c79;\n}\n.btn-outline-gray-600:hover {\n    color: #fff;\n    background-color: #536c79;\n    border-color: #536c79;\n}\n.btn-outline-gray-600:focus, .btn-outline-gray-600.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n}\n.btn-outline-gray-600.disabled, .btn-outline-gray-600:disabled {\n    color: #536c79;\n    background-color: transparent;\n}\n.btn-outline-gray-600:not([disabled]):not(.disabled):active, .btn-outline-gray-600:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-600.dropdown-toggle {\n    color: #151b1e;\n    background-color: #536c79;\n    border-color: #536c79;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(83, 108, 121, 0.5);\n}\n.btn-outline-gray-700 {\n  color: #3e515b;\n  background-color: transparent;\n  background-image: none;\n  border-color: #3e515b;\n}\n.btn-outline-gray-700:hover {\n    color: #fff;\n    background-color: #3e515b;\n    border-color: #3e515b;\n}\n.btn-outline-gray-700:focus, .btn-outline-gray-700.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n}\n.btn-outline-gray-700.disabled, .btn-outline-gray-700:disabled {\n    color: #3e515b;\n    background-color: transparent;\n}\n.btn-outline-gray-700:not([disabled]):not(.disabled):active, .btn-outline-gray-700:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-700.dropdown-toggle {\n    color: #151b1e;\n    background-color: #3e515b;\n    border-color: #3e515b;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(62, 81, 91, 0.5);\n}\n.btn-outline-gray-800 {\n  color: #29363d;\n  background-color: transparent;\n  background-image: none;\n  border-color: #29363d;\n}\n.btn-outline-gray-800:hover {\n    color: #fff;\n    background-color: #29363d;\n    border-color: #29363d;\n}\n.btn-outline-gray-800:focus, .btn-outline-gray-800.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-outline-gray-800.disabled, .btn-outline-gray-800:disabled {\n    color: #29363d;\n    background-color: transparent;\n}\n.btn-outline-gray-800:not([disabled]):not(.disabled):active, .btn-outline-gray-800:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-800.dropdown-toggle {\n    color: #151b1e;\n    background-color: #29363d;\n    border-color: #29363d;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(41, 54, 61, 0.5);\n}\n.btn-outline-gray-900 {\n  color: #151b1e;\n  background-color: transparent;\n  background-image: none;\n  border-color: #151b1e;\n}\n.btn-outline-gray-900:hover {\n    color: #fff;\n    background-color: #151b1e;\n    border-color: #151b1e;\n}\n.btn-outline-gray-900:focus, .btn-outline-gray-900.focus {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n}\n.btn-outline-gray-900.disabled, .btn-outline-gray-900:disabled {\n    color: #151b1e;\n    background-color: transparent;\n}\n.btn-outline-gray-900:not([disabled]):not(.disabled):active, .btn-outline-gray-900:not([disabled]):not(.disabled).active,\n  .show > .btn-outline-gray-900.dropdown-toggle {\n    color: #151b1e;\n    background-color: #151b1e;\n    border-color: #151b1e;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n            box-shadow: 0 0 0 0.2rem rgba(21, 27, 30, 0.5);\n}\n.btn-link {\n  font-weight: 400;\n  color: #20a8d8;\n  background-color: transparent;\n}\n.btn-link:hover {\n    color: #167495;\n    text-decoration: underline;\n    background-color: transparent;\n    border-color: transparent;\n}\n.btn-link:focus, .btn-link.focus {\n    text-decoration: underline;\n    border-color: transparent;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n    color: #536c79;\n}\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n  border-radius: 0;\n}\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.76562rem;\n  line-height: 1.5;\n  border-radius: 0;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n    margin-top: 0.5rem;\n}\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n.fade {\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n.fade.show {\n    opacity: 1;\n}\n.collapse {\n  display: none;\n}\n.collapse.show {\n    display: block;\n}\ntr.collapse.show {\n  display: table-row;\n}\ntbody.collapse.show {\n  display: table-row-group;\n}\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  -webkit-transition: height 0.35s ease;\n  transition: height 0.35s ease;\n}\n.dropup,\n.dropdown {\n  position: relative;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.875rem;\n  color: #151b1e;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #c2cfd6;\n}\n.dropup .dropdown-menu {\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-menu {\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n.dropleft .dropdown-menu {\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #f0f3f5;\n}\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #151b1e;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:focus, .dropdown-item:hover {\n    color: #0b0e0f;\n    text-decoration: none;\n    background-color: #f0f3f5;\n}\n.dropdown-item.active, .dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #20a8d8;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n    color: #536c79;\n    background-color: transparent;\n}\n.dropdown-menu.show {\n  display: block;\n}\n.dropdown-header {\n  display: block;\n  padding: 0 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.76562rem;\n  color: #536c79;\n  white-space: nowrap;\n}\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n  .btn-group-vertical > .btn {\n    position: relative;\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 auto;\n            flex: 0 1 auto;\n}\n.btn-group > .btn:hover,\n    .btn-group-vertical > .btn:hover {\n      z-index: 1;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n    .btn-group-vertical > .btn:focus,\n    .btn-group-vertical > .btn:active,\n    .btn-group-vertical > .btn.active {\n      z-index: 1;\n}\n.btn-group .btn + .btn,\n  .btn-group .btn + .btn-group,\n  .btn-group .btn-group + .btn,\n  .btn-group .btn-group + .btn-group,\n  .btn-group-vertical .btn + .btn,\n  .btn-group-vertical .btn + .btn-group,\n  .btn-group-vertical .btn-group + .btn,\n  .btn-group-vertical .btn-group + .btn-group {\n    margin-left: -1px;\n}\n.btn-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n    width: auto;\n}\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after {\n    margin-left: 0;\n}\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n.btn-group-vertical {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.btn-group-vertical .btn,\n  .btn-group-vertical .btn-group {\n    width: 100%;\n}\n.btn-group-vertical > .btn + .btn,\n  .btn-group-vertical > .btn + .btn-group,\n  .btn-group-vertical > .btn-group + .btn,\n  .btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0;\n}\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n.btn-group-toggle > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn input[type=\"checkbox\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n  .btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none;\n}\n.input-group {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  width: 100%;\n}\n.input-group .form-control,\n  .input-group .custom-select,\n  .input-group .custom-file {\n    position: relative;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0;\n}\n.input-group .form-control:focus,\n    .input-group .custom-select:focus,\n    .input-group .custom-file:focus {\n      z-index: 3;\n}\n.input-group .form-control + .form-control,\n    .input-group .custom-select + .form-control,\n    .input-group .custom-file + .form-control {\n      margin-left: -1px;\n}\n.input-group .custom-file {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.input-group-prepend,\n.input-group-append {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.input-group-prepend .btn,\n  .input-group-append .btn {\n    position: relative;\n    z-index: 2;\n}\n.input-group-prepend .btn + .btn,\n  .input-group-prepend .btn + .input-group-text,\n  .input-group-prepend .input-group-text + .input-group-text,\n  .input-group-prepend .input-group-text + .btn,\n  .input-group-append .btn + .btn,\n  .input-group-append .btn + .input-group-text,\n  .input-group-append .input-group-text + .input-group-text,\n  .input-group-append .input-group-text + .btn {\n    margin-left: -1px;\n}\n.input-group-prepend {\n  margin-right: -1px;\n}\n.input-group-append {\n  margin-left: -1px;\n}\n.input-group-text {\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #3e515b;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #f0f3f5;\n  border: 1px solid #c2cfd6;\n}\n.input-group-text input[type=\"radio\"],\n  .input-group-text input[type=\"checkbox\"] {\n    margin-top: 0;\n}\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n}\n.custom-control-inline {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 1rem;\n}\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #20a8d8;\n}\n.custom-control-input:focus ~ .custom-control-label::before {\n    -webkit-box-shadow: 0 0 0 1px #e4e5e6, 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n            box-shadow: 0 0 0 1px #e4e5e6, 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n}\n.custom-control-input:active ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #b6e4f4;\n}\n.custom-control-input:disabled ~ .custom-control-label {\n    color: #536c79;\n}\n.custom-control-input:disabled ~ .custom-control-label::before {\n      background-color: #c2cfd6;\n}\n.custom-control-label {\n  margin-bottom: 0;\n}\n.custom-control-label::before {\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    pointer-events: none;\n    content: \"\";\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    background-color: #a4b7c1;\n}\n.custom-control-label::after {\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 50% 50%;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #20a8d8;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  background-color: #20a8d8;\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\");\n}\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #20a8d8;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\");\n}\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(2.0625rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #3e515b;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%2329363d' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n  background-size: 8px 10px;\n  border: 1px solid #c2cfd6;\n  border-radius: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.custom-select:focus {\n    border-color: #8ad4ee;\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n            box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n}\n.custom-select:focus::-ms-value {\n      color: #3e515b;\n      background-color: #fff;\n}\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: 0.75rem;\n    background-image: none;\n}\n.custom-select:disabled {\n    color: #536c79;\n    background-color: #c2cfd6;\n}\n.custom-select::-ms-expand {\n    opacity: 0;\n}\n.custom-select-sm {\n  height: calc(1.64844rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 75%;\n}\n.custom-select-lg {\n  height: calc(2.64062rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 125%;\n}\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(2.0625rem + 2px);\n  margin-bottom: 0;\n}\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(2.0625rem + 2px);\n  margin: 0;\n  opacity: 0;\n}\n.custom-file-input:focus ~ .custom-file-control {\n    border-color: #8ad4ee;\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n            box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);\n}\n.custom-file-input:focus ~ .custom-file-control::before {\n      border-color: #8ad4ee;\n}\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n    content: \"Browse\";\n}\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(2.0625rem + 2px);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #3e515b;\n  background-color: #fff;\n  border: 1px solid #c2cfd6;\n}\n.custom-file-label::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: calc(calc(2.0625rem + 2px) - 1px * 2);\n    padding: 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #3e515b;\n    content: \"Browse\";\n    background-color: #f0f3f5;\n    border-left: 1px solid #c2cfd6;\n}\n.nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.nav-link, .navbar .dropdown-toggle {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n.nav-link:focus, .navbar .dropdown-toggle:focus, .nav-link:hover, .navbar .dropdown-toggle:hover {\n    text-decoration: none;\n}\n.nav-link.disabled, .navbar .disabled.dropdown-toggle {\n    color: #536c79;\n}\n.nav-tabs {\n  border-bottom: 1px solid #a4b7c1;\n}\n.nav-tabs .nav-item {\n    margin-bottom: -1px;\n}\n.nav-tabs .nav-link, .nav-tabs .navbar .dropdown-toggle, .navbar .nav-tabs .dropdown-toggle {\n    border: 1px solid transparent;\n}\n.nav-tabs .nav-link:focus, .nav-tabs .navbar .dropdown-toggle:focus, .navbar .nav-tabs .dropdown-toggle:focus, .nav-tabs .nav-link:hover, .nav-tabs .navbar .dropdown-toggle:hover, .navbar .nav-tabs .dropdown-toggle:hover {\n      border-color: #c2cfd6 #c2cfd6 #a4b7c1;\n}\n.nav-tabs .nav-link.disabled, .nav-tabs .navbar .disabled.dropdown-toggle, .navbar .nav-tabs .disabled.dropdown-toggle {\n      color: #536c79;\n      background-color: transparent;\n      border-color: transparent;\n}\n.nav-tabs .nav-link.active, .nav-tabs .navbar .active.dropdown-toggle, .navbar .nav-tabs .active.dropdown-toggle,\n  .nav-tabs .nav-item.show .nav-link,\n  .nav-tabs .nav-item.show .navbar .dropdown-toggle,\n  .navbar .nav-tabs .nav-item.show .dropdown-toggle {\n    color: #3e515b;\n    background-color: #e4e5e6;\n    border-color: #a4b7c1 #a4b7c1 #e4e5e6;\n}\n.nav-tabs .dropdown-menu {\n    margin-top: -1px;\n}\n.nav-pills .nav-link.active, .nav-pills .navbar .active.dropdown-toggle, .navbar .nav-pills .active.dropdown-toggle,\n.nav-pills .show > .nav-link,\n.nav-pills .navbar .show > .dropdown-toggle,\n.navbar .nav-pills .show > .dropdown-toggle {\n  color: #fff;\n  background-color: #20a8d8;\n}\n.nav-fill .nav-item {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  text-align: center;\n}\n.nav-justified .nav-item {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  text-align: center;\n}\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n.navbar {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n.navbar > .container,\n  .navbar > .container-fluid {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.33594rem;\n  padding-bottom: 0.33594rem;\n  margin-right: 1rem;\n  font-size: 1.09375rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:focus, .navbar-brand:hover {\n    text-decoration: none;\n}\n.navbar-nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link, .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-nav .dropdown-toggle {\n    padding-right: 0;\n    padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.navbar-collapse {\n  -ms-flex-preferred-size: 100%;\n      flex-basis: 100%;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.09375rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n}\n.navbar-toggler:focus, .navbar-toggler:hover {\n    text-decoration: none;\n}\n.navbar-toggler:not([disabled]):not(.disabled) {\n    cursor: pointer;\n}\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n@media (max-width: 575.99px) {\n.navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 576px) {\n.navbar-expand-sm {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n            flex-flow: row nowrap;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.navbar-expand-sm .navbar-nav {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n}\n.navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute;\n}\n.navbar-expand-sm .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n}\n.navbar-expand-sm .navbar-nav .nav-link, .navbar-expand-sm .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-expand-sm .navbar-nav .dropdown-toggle {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid {\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n}\n.navbar-expand-sm .navbar-collapse {\n      display: -webkit-box !important;\n      display: -ms-flexbox !important;\n      display: flex !important;\n      -ms-flex-preferred-size: auto;\n          flex-basis: auto;\n}\n.navbar-expand-sm .navbar-toggler {\n      display: none;\n}\n.navbar-expand-sm .dropup .dropdown-menu {\n      top: auto;\n      bottom: 100%;\n}\n}\n@media (max-width: 767.99px) {\n.navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 768px) {\n.navbar-expand-md {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n            flex-flow: row nowrap;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.navbar-expand-md .navbar-nav {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n}\n.navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute;\n}\n.navbar-expand-md .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n}\n.navbar-expand-md .navbar-nav .nav-link, .navbar-expand-md .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-expand-md .navbar-nav .dropdown-toggle {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid {\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n}\n.navbar-expand-md .navbar-collapse {\n      display: -webkit-box !important;\n      display: -ms-flexbox !important;\n      display: flex !important;\n      -ms-flex-preferred-size: auto;\n          flex-basis: auto;\n}\n.navbar-expand-md .navbar-toggler {\n      display: none;\n}\n.navbar-expand-md .dropup .dropdown-menu {\n      top: auto;\n      bottom: 100%;\n}\n}\n@media (max-width: 991.99px) {\n.navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 992px) {\n.navbar-expand-lg {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n            flex-flow: row nowrap;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.navbar-expand-lg .navbar-nav {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n}\n.navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute;\n}\n.navbar-expand-lg .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n}\n.navbar-expand-lg .navbar-nav .nav-link, .navbar-expand-lg .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-expand-lg .navbar-nav .dropdown-toggle {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid {\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n}\n.navbar-expand-lg .navbar-collapse {\n      display: -webkit-box !important;\n      display: -ms-flexbox !important;\n      display: flex !important;\n      -ms-flex-preferred-size: auto;\n          flex-basis: auto;\n}\n.navbar-expand-lg .navbar-toggler {\n      display: none;\n}\n.navbar-expand-lg .dropup .dropdown-menu {\n      top: auto;\n      bottom: 100%;\n}\n}\n@media (max-width: 1199.99px) {\n.navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n}\n@media (min-width: 1200px) {\n.navbar-expand-xl {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n            flex-flow: row nowrap;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.navbar-expand-xl .navbar-nav {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n}\n.navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute;\n}\n.navbar-expand-xl .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n}\n.navbar-expand-xl .navbar-nav .nav-link, .navbar-expand-xl .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-expand-xl .navbar-nav .dropdown-toggle {\n        padding-right: .5rem;\n        padding-left: .5rem;\n}\n.navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid {\n      -ms-flex-wrap: nowrap;\n          flex-wrap: nowrap;\n}\n.navbar-expand-xl .navbar-collapse {\n      display: -webkit-box !important;\n      display: -ms-flexbox !important;\n      display: flex !important;\n      -ms-flex-preferred-size: auto;\n          flex-basis: auto;\n}\n.navbar-expand-xl .navbar-toggler {\n      display: none;\n}\n.navbar-expand-xl .dropup .dropdown-menu {\n      top: auto;\n      bottom: 100%;\n}\n}\n.navbar-expand {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row nowrap;\n          flex-flow: row nowrap;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.navbar-expand > .container,\n  .navbar-expand > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n.navbar-expand .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n      position: absolute;\n}\n.navbar-expand .navbar-nav .dropdown-menu-right {\n      right: 0;\n      left: auto;\n}\n.navbar-expand .navbar-nav .nav-link, .navbar-expand .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-expand .navbar-nav .dropdown-toggle {\n      padding-right: .5rem;\n      padding-left: .5rem;\n}\n.navbar-expand > .container,\n  .navbar-expand > .container-fluid {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n}\n.navbar-expand .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n    display: none;\n}\n.navbar-expand .dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n}\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:focus, .navbar-light .navbar-brand:hover {\n    color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link, .navbar-light .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-light .navbar-nav .dropdown-toggle {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .navbar .dropdown-toggle:focus, .navbar .navbar-light .navbar-nav .dropdown-toggle:focus, .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .navbar .dropdown-toggle:hover, .navbar .navbar-light .navbar-nav .dropdown-toggle:hover {\n    color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled, .navbar-light .navbar-nav .navbar .disabled.dropdown-toggle, .navbar .navbar-light .navbar-nav .disabled.dropdown-toggle {\n    color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link, .navbar-light .navbar-nav .navbar .show > .dropdown-toggle, .navbar .navbar-light .navbar-nav .show > .dropdown-toggle,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .navbar .active > .dropdown-toggle,\n.navbar .navbar-light .navbar-nav .active > .dropdown-toggle,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .navbar .show.dropdown-toggle,\n.navbar .navbar-light .navbar-nav .show.dropdown-toggle,\n.navbar-light .navbar-nav .nav-link.active,\n.navbar-light .navbar-nav .navbar .active.dropdown-toggle,\n.navbar .navbar-light .navbar-nav .active.dropdown-toggle {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-text a:focus, .navbar-light .navbar-text a:hover {\n      color: rgba(0, 0, 0, 0.9);\n}\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:focus, .navbar-dark .navbar-brand:hover {\n    color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link, .navbar-dark .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-dark .navbar-nav .dropdown-toggle {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .navbar .dropdown-toggle:focus, .navbar .navbar-dark .navbar-nav .dropdown-toggle:focus, .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .navbar .dropdown-toggle:hover, .navbar .navbar-dark .navbar-nav .dropdown-toggle:hover {\n    color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled, .navbar-dark .navbar-nav .navbar .disabled.dropdown-toggle, .navbar .navbar-dark .navbar-nav .disabled.dropdown-toggle {\n    color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link, .navbar-dark .navbar-nav .navbar .show > .dropdown-toggle, .navbar .navbar-dark .navbar-nav .show > .dropdown-toggle,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .navbar .active > .dropdown-toggle,\n.navbar .navbar-dark .navbar-nav .active > .dropdown-toggle,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .navbar .show.dropdown-toggle,\n.navbar .navbar-dark .navbar-nav .show.dropdown-toggle,\n.navbar-dark .navbar-nav .nav-link.active,\n.navbar-dark .navbar-nav .navbar .active.dropdown-toggle,\n.navbar .navbar-dark .navbar-nav .active.dropdown-toggle {\n  color: #fff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-text a {\n    color: #fff;\n}\n.navbar-dark .navbar-text a:focus, .navbar-dark .navbar-text a:hover {\n      color: #fff;\n}\n.card {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid #c2cfd6;\n}\n.card > hr {\n    margin-right: 0;\n    margin-left: 0;\n}\n.card-body, .card-block {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  padding: 1.25rem;\n}\n.card-title {\n  margin-bottom: 0.75rem;\n}\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n.card-text:last-child {\n  margin-bottom: 0;\n}\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1.25rem;\n}\n.card-header {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: #f0f3f5;\n  border-bottom: 1px solid #c2cfd6;\n}\n.card-header + .list-group .list-group-item:first-child {\n    border-top: 0;\n}\n.card-footer {\n  padding: 0.75rem 1.25rem;\n  background-color: #f0f3f5;\n  border-top: 1px solid #c2cfd6;\n}\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -0.75rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n}\n.card-img {\n  width: 100%;\n}\n.card-img-top {\n  width: 100%;\n}\n.card-img-bottom {\n  width: 100%;\n}\n.card-deck {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.card-deck .card {\n    margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n.card-deck {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-flow: row wrap;\n              flex-flow: row wrap;\n      margin-right: -15px;\n      margin-left: -15px;\n}\n.card-deck .card {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-flex: 1;\n            -ms-flex: 1 0 0%;\n                flex: 1 0 0%;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        margin-right: 15px;\n        margin-bottom: 0;\n        margin-left: 15px;\n}\n}\n.card-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.card-group > .card {\n    margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n.card-group {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-flow: row wrap;\n              flex-flow: row wrap;\n}\n.card-group > .card {\n        -webkit-box-flex: 1;\n            -ms-flex: 1 0 0%;\n                flex: 1 0 0%;\n        margin-bottom: 0;\n}\n.card-group > .card + .card {\n          margin-left: 0;\n          border-left: 0;\n}\n}\n.card-columns .card {\n  margin-bottom: 0.75rem;\n}\n@media (min-width: 576px) {\n.card-columns {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n    -webkit-column-gap: 1.25rem;\n       -moz-column-gap: 1.25rem;\n            column-gap: 1.25rem;\n}\n.card-columns .card {\n      display: inline-block;\n      width: 100%;\n}\n}\n.breadcrumb {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.5rem;\n  list-style: none;\n  background-color: #fff;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  color: #536c79;\n  content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n.breadcrumb-item.active {\n  color: #536c79;\n}\n.pagination {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n.page-link, .pagination-datatables li a, .pagination li a {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #20a8d8;\n  background-color: #fff;\n  border: 1px solid #a4b7c1;\n}\n.page-link:focus, .pagination-datatables li a:focus, .pagination li a:focus, .page-link:hover, .pagination-datatables li a:hover, .pagination li a:hover {\n    color: #167495;\n    text-decoration: none;\n    background-color: #c2cfd6;\n    border-color: #a4b7c1;\n}\n.page-link:not([disabled]):not(.disabled), .pagination-datatables li a:not([disabled]):not(.disabled), .pagination li a:not([disabled]):not(.disabled) {\n    cursor: pointer;\n}\n.page-item:first-child .page-link, .pagination-datatables li:first-child .page-link, .pagination li:first-child .page-link, .page-item:first-child .pagination-datatables li a, .pagination-datatables li .page-item:first-child a, .pagination-datatables li:first-child a, .page-item:first-child .pagination li a, .pagination li .page-item:first-child a, .pagination li:first-child a {\n  margin-left: 0;\n}\n.page-item.active .page-link, .pagination-datatables li.active .page-link, .pagination li.active .page-link, .page-item.active .pagination-datatables li a, .pagination-datatables li .page-item.active a, .pagination-datatables li.active a, .page-item.active .pagination li a, .pagination li .page-item.active a, .pagination li.active a {\n  z-index: 1;\n  color: #fff;\n  background-color: #20a8d8;\n  border-color: #20a8d8;\n}\n.page-item.disabled .page-link, .pagination-datatables li.disabled .page-link, .pagination li.disabled .page-link, .page-item.disabled .pagination-datatables li a, .pagination-datatables li .page-item.disabled a, .pagination-datatables li.disabled a, .page-item.disabled .pagination li a, .pagination li .page-item.disabled a, .pagination li.disabled a {\n  color: #536c79;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #a4b7c1;\n}\n.pagination-lg .page-link, .pagination-lg .pagination-datatables li a, .pagination-datatables li .pagination-lg a, .pagination-lg .pagination li a, .pagination li .pagination-lg a {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.09375rem;\n  line-height: 1.5;\n}\n.pagination-sm .page-link, .pagination-sm .pagination-datatables li a, .pagination-datatables li .pagination-sm a, .pagination-sm .pagination li a, .pagination li .pagination-sm a {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.76562rem;\n  line-height: 1.5;\n}\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n}\n.badge:empty {\n    display: none;\n}\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n}\n.badge-primary {\n  color: #fff;\n  background-color: #20a8d8;\n}\n.badge-primary[href]:focus, .badge-primary[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1985ac;\n}\n.badge-secondary {\n  color: #151b1e;\n  background-color: #a4b7c1;\n}\n.badge-secondary[href]:focus, .badge-secondary[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #869fac;\n}\n.badge-success {\n  color: #fff;\n  background-color: #4dbd74;\n}\n.badge-success[href]:focus, .badge-success[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #3a9d5d;\n}\n.badge-info {\n  color: #151b1e;\n  background-color: #63c2de;\n}\n.badge-info[href]:focus, .badge-info[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #39b2d5;\n}\n.badge-warning {\n  color: #151b1e;\n  background-color: #ffc107;\n}\n.badge-warning[href]:focus, .badge-warning[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #d39e00;\n}\n.badge-danger {\n  color: #fff;\n  background-color: #f86c6b;\n}\n.badge-danger[href]:focus, .badge-danger[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #f63c3a;\n}\n.badge-light {\n  color: #151b1e;\n  background-color: #f0f3f5;\n}\n.badge-light[href]:focus, .badge-light[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #d1dbe1;\n}\n.badge-dark {\n  color: #fff;\n  background-color: #29363d;\n}\n.badge-dark[href]:focus, .badge-dark[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #151b1f;\n}\n.badge-blue {\n  color: #fff;\n  background-color: #20a8d8;\n}\n.badge-blue[href]:focus, .badge-blue[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1985ac;\n}\n.badge-indigo {\n  color: #fff;\n  background-color: #6610f2;\n}\n.badge-indigo[href]:focus, .badge-indigo[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #510bc4;\n}\n.badge-purple {\n  color: #fff;\n  background-color: #6f42c1;\n}\n.badge-purple[href]:focus, .badge-purple[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #59339d;\n}\n.badge-pink {\n  color: #fff;\n  background-color: #e83e8c;\n}\n.badge-pink[href]:focus, .badge-pink[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #d91a72;\n}\n.badge-red {\n  color: #fff;\n  background-color: #f86c6b;\n}\n.badge-red[href]:focus, .badge-red[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #f63c3a;\n}\n.badge-orange {\n  color: #151b1e;\n  background-color: #f8cb00;\n}\n.badge-orange[href]:focus, .badge-orange[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #c5a100;\n}\n.badge-yellow {\n  color: #151b1e;\n  background-color: #ffc107;\n}\n.badge-yellow[href]:focus, .badge-yellow[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #d39e00;\n}\n.badge-green {\n  color: #fff;\n  background-color: #4dbd74;\n}\n.badge-green[href]:focus, .badge-green[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #3a9d5d;\n}\n.badge-teal {\n  color: #fff;\n  background-color: #20c997;\n}\n.badge-teal[href]:focus, .badge-teal[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #199d76;\n}\n.badge-cyan {\n  color: #151b1e;\n  background-color: #63c2de;\n}\n.badge-cyan[href]:focus, .badge-cyan[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #39b2d5;\n}\n.badge-gray-100 {\n  color: #151b1e;\n  background-color: #f0f3f5;\n}\n.badge-gray-100[href]:focus, .badge-gray-100[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #d1dbe1;\n}\n.badge-gray-200 {\n  color: #151b1e;\n  background-color: #c2cfd6;\n}\n.badge-gray-200[href]:focus, .badge-gray-200[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #a4b7c2;\n}\n.badge-gray-300 {\n  color: #151b1e;\n  background-color: #a4b7c1;\n}\n.badge-gray-300[href]:focus, .badge-gray-300[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #869fac;\n}\n.badge-gray-400 {\n  color: #151b1e;\n  background-color: #869fac;\n}\n.badge-gray-400[href]:focus, .badge-gray-400[href]:hover {\n    color: #151b1e;\n    text-decoration: none;\n    background-color: #688797;\n}\n.badge-gray-500 {\n  color: #fff;\n  background-color: #678898;\n}\n.badge-gray-500[href]:focus, .badge-gray-500[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #526d7a;\n}\n.badge-gray-600 {\n  color: #fff;\n  background-color: #536c79;\n}\n.badge-gray-600[href]:focus, .badge-gray-600[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #3e515b;\n}\n.badge-gray-700 {\n  color: #fff;\n  background-color: #3e515b;\n}\n.badge-gray-700[href]:focus, .badge-gray-700[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #29363d;\n}\n.badge-gray-800 {\n  color: #fff;\n  background-color: #29363d;\n}\n.badge-gray-800[href]:focus, .badge-gray-800[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: #151b1f;\n}\n.badge-gray-900 {\n  color: #fff;\n  background-color: #151b1e;\n}\n.badge-gray-900[href]:focus, .badge-gray-900[href]:hover {\n    color: #fff;\n    text-decoration: none;\n    background-color: black;\n}\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #c2cfd6;\n}\n@media (min-width: 576px) {\n.jumbotron {\n      padding: 4rem 2rem;\n}\n}\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n}\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n}\n.alert-heading {\n  color: inherit;\n}\n.alert-link {\n  font-weight: 700;\n}\n.alert-dismissible {\n  padding-right: 3.8125rem;\n}\n.alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0.75rem 1.25rem;\n    color: inherit;\n}\n.alert-primary {\n  color: #115770;\n  background-color: #d2eef7;\n  border-color: #c1e7f4;\n}\n.alert-primary hr {\n    border-top-color: #abdff0;\n}\n.alert-primary .alert-link {\n    color: #0a3544;\n}\n.alert-secondary {\n  color: #555f64;\n  background-color: #edf1f3;\n  border-color: #e6ebee;\n}\n.alert-secondary hr {\n    border-top-color: #d7dfe4;\n}\n.alert-secondary .alert-link {\n    color: #3e4548;\n}\n.alert-success {\n  color: #28623c;\n  background-color: #dbf2e3;\n  border-color: #cdedd8;\n}\n.alert-success hr {\n    border-top-color: #bae6c9;\n}\n.alert-success .alert-link {\n    color: #193e26;\n}\n.alert-info {\n  color: #336573;\n  background-color: #e0f3f8;\n  border-color: #d3eef6;\n}\n.alert-info hr {\n    border-top-color: #bee6f2;\n}\n.alert-info .alert-link {\n    color: #234650;\n}\n.alert-warning {\n  color: #856404;\n  background-color: #fff3cd;\n  border-color: #ffeeba;\n}\n.alert-warning hr {\n    border-top-color: #ffe8a1;\n}\n.alert-warning .alert-link {\n    color: #533f03;\n}\n.alert-danger {\n  color: #813838;\n  background-color: #fee2e1;\n  border-color: #fdd6d6;\n}\n.alert-danger hr {\n    border-top-color: #fcbebe;\n}\n.alert-danger .alert-link {\n    color: #5d2929;\n}\n.alert-light {\n  color: #7d7e7f;\n  background-color: #fcfdfd;\n  border-color: #fbfcfc;\n}\n.alert-light hr {\n    border-top-color: #ecf1f1;\n}\n.alert-light .alert-link {\n    color: #646565;\n}\n.alert-dark {\n  color: #151c20;\n  background-color: #d4d7d8;\n  border-color: #c3c7c9;\n}\n.alert-dark hr {\n    border-top-color: #b6babd;\n}\n.alert-dark .alert-link {\n    color: #010101;\n}\n.alert-blue {\n  color: #115770;\n  background-color: #d2eef7;\n  border-color: #c1e7f4;\n}\n.alert-blue hr {\n    border-top-color: #abdff0;\n}\n.alert-blue .alert-link {\n    color: #0a3544;\n}\n.alert-indigo {\n  color: #35087e;\n  background-color: #e0cffc;\n  border-color: #d4bcfb;\n}\n.alert-indigo hr {\n    border-top-color: #c5a4fa;\n}\n.alert-indigo .alert-link {\n    color: #21054e;\n}\n.alert-purple {\n  color: #3a2264;\n  background-color: #e2d9f3;\n  border-color: #d7caee;\n}\n.alert-purple hr {\n    border-top-color: #c8b7e8;\n}\n.alert-purple .alert-link {\n    color: #24153e;\n}\n.alert-pink {\n  color: #792049;\n  background-color: #fad8e8;\n  border-color: #f9c9df;\n}\n.alert-pink hr {\n    border-top-color: #f6b2d1;\n}\n.alert-pink .alert-link {\n    color: #511531;\n}\n.alert-red {\n  color: #813838;\n  background-color: #fee2e1;\n  border-color: #fdd6d6;\n}\n.alert-red hr {\n    border-top-color: #fcbebe;\n}\n.alert-red .alert-link {\n    color: #5d2929;\n}\n.alert-orange {\n  color: #816a00;\n  background-color: #fef5cc;\n  border-color: #fdf0b8;\n}\n.alert-orange hr {\n    border-top-color: #fceb9f;\n}\n.alert-orange .alert-link {\n    color: #4e4000;\n}\n.alert-yellow {\n  color: #856404;\n  background-color: #fff3cd;\n  border-color: #ffeeba;\n}\n.alert-yellow hr {\n    border-top-color: #ffe8a1;\n}\n.alert-yellow .alert-link {\n    color: #533f03;\n}\n.alert-green {\n  color: #28623c;\n  background-color: #dbf2e3;\n  border-color: #cdedd8;\n}\n.alert-green hr {\n    border-top-color: #bae6c9;\n}\n.alert-green .alert-link {\n    color: #193e26;\n}\n.alert-teal {\n  color: #11694f;\n  background-color: #d2f4ea;\n  border-color: #c1f0e2;\n}\n.alert-teal hr {\n    border-top-color: #acebd8;\n}\n.alert-teal .alert-link {\n    color: #0a3d2e;\n}\n.alert-cyan {\n  color: #336573;\n  background-color: #e0f3f8;\n  border-color: #d3eef6;\n}\n.alert-cyan hr {\n    border-top-color: #bee6f2;\n}\n.alert-cyan .alert-link {\n    color: #234650;\n}\n.alert-gray-100 {\n  color: #7d7e7f;\n  background-color: #fcfdfd;\n  border-color: #fbfcfc;\n}\n.alert-gray-100 hr {\n    border-top-color: #ecf1f1;\n}\n.alert-gray-100 .alert-link {\n    color: #646565;\n}\n.alert-gray-200 {\n  color: #656c6f;\n  background-color: #f3f5f7;\n  border-color: #eef2f4;\n}\n.alert-gray-200 hr {\n    border-top-color: #dfe6ea;\n}\n.alert-gray-200 .alert-link {\n    color: #4d5254;\n}\n.alert-gray-300 {\n  color: #555f64;\n  background-color: #edf1f3;\n  border-color: #e6ebee;\n}\n.alert-gray-300 hr {\n    border-top-color: #d7dfe4;\n}\n.alert-gray-300 .alert-link {\n    color: #3e4548;\n}\n.alert-gray-400 {\n  color: #465359;\n  background-color: #e7ecee;\n  border-color: #dde4e8;\n}\n.alert-gray-400 hr {\n    border-top-color: #ced8de;\n}\n.alert-gray-400 .alert-link {\n    color: #30383c;\n}\n.alert-gray-500 {\n  color: #36474f;\n  background-color: #e1e7ea;\n  border-color: #d4dee2;\n}\n.alert-gray-500 hr {\n    border-top-color: #c5d2d8;\n}\n.alert-gray-500 .alert-link {\n    color: #212c31;\n}\n.alert-gray-600 {\n  color: #2b383f;\n  background-color: #dde2e4;\n  border-color: #cfd6d9;\n}\n.alert-gray-600 hr {\n    border-top-color: #c1cace;\n}\n.alert-gray-600 .alert-link {\n    color: #161d21;\n}\n.alert-gray-700 {\n  color: #202a2f;\n  background-color: #d8dcde;\n  border-color: #c9ced1;\n}\n.alert-gray-700 hr {\n    border-top-color: #bbc2c5;\n}\n.alert-gray-700 .alert-link {\n    color: #0b0f11;\n}\n.alert-gray-800 {\n  color: #151c20;\n  background-color: #d4d7d8;\n  border-color: #c3c7c9;\n}\n.alert-gray-800 hr {\n    border-top-color: #b6babd;\n}\n.alert-gray-800 .alert-link {\n    color: #010101;\n}\n.alert-gray-900 {\n  color: #0b0e10;\n  background-color: #d0d1d2;\n  border-color: #bdbfc0;\n}\n.alert-gray-900 hr {\n    border-top-color: #b0b2b4;\n}\n.alert-gray-900 .alert-link {\n    color: black;\n}\n@-webkit-keyframes progress-bar-stripes {\nfrom {\n    background-position: 1rem 0;\n}\nto {\n    background-position: 0 0;\n}\n}\n@keyframes progress-bar-stripes {\nfrom {\n    background-position: 1rem 0;\n}\nto {\n    background-position: 0 0;\n}\n}\n.progress {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.65625rem;\n  background-color: #f0f3f5;\n}\n.progress-bar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: #fff;\n  text-align: center;\n  background-color: #20a8d8;\n  -webkit-transition: width 0.6s ease;\n  transition: width 0.6s ease;\n}\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n.progress-bar-animated {\n  -webkit-animation: progress-bar-stripes 1s linear infinite;\n          animation: progress-bar-stripes 1s linear infinite;\n}\n.media {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.media-body {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.list-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n.list-group-item-action {\n  width: 100%;\n  color: #3e515b;\n  text-align: inherit;\n}\n.list-group-item-action:focus, .list-group-item-action:hover {\n    color: #3e515b;\n    text-decoration: none;\n    background-color: #f0f3f5;\n}\n.list-group-item-action:active {\n    color: #151b1e;\n    background-color: #c2cfd6;\n}\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n.list-group-item:last-child {\n    margin-bottom: 0;\n}\n.list-group-item:focus, .list-group-item:hover {\n    z-index: 1;\n    text-decoration: none;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n    color: #536c79;\n    background-color: #fff;\n}\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #20a8d8;\n    border-color: #20a8d8;\n}\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n}\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0;\n}\n.list-group-flush:last-child .list-group-item:last-child {\n  border-bottom: 0;\n}\n.list-group-item-primary {\n  color: #115770;\n  background-color: #c1e7f4;\n}\na.list-group-item-primary,\nbutton.list-group-item-primary {\n  color: #115770;\n}\na.list-group-item-primary:focus, a.list-group-item-primary:hover,\n  button.list-group-item-primary:focus,\n  button.list-group-item-primary:hover {\n    color: #115770;\n    background-color: #abdff0;\n}\na.list-group-item-primary.active,\n  button.list-group-item-primary.active {\n    color: #fff;\n    background-color: #115770;\n    border-color: #115770;\n}\n.list-group-item-secondary {\n  color: #555f64;\n  background-color: #e6ebee;\n}\na.list-group-item-secondary,\nbutton.list-group-item-secondary {\n  color: #555f64;\n}\na.list-group-item-secondary:focus, a.list-group-item-secondary:hover,\n  button.list-group-item-secondary:focus,\n  button.list-group-item-secondary:hover {\n    color: #555f64;\n    background-color: #d7dfe4;\n}\na.list-group-item-secondary.active,\n  button.list-group-item-secondary.active {\n    color: #fff;\n    background-color: #555f64;\n    border-color: #555f64;\n}\n.list-group-item-success {\n  color: #28623c;\n  background-color: #cdedd8;\n}\na.list-group-item-success,\nbutton.list-group-item-success {\n  color: #28623c;\n}\na.list-group-item-success:focus, a.list-group-item-success:hover,\n  button.list-group-item-success:focus,\n  button.list-group-item-success:hover {\n    color: #28623c;\n    background-color: #bae6c9;\n}\na.list-group-item-success.active,\n  button.list-group-item-success.active {\n    color: #fff;\n    background-color: #28623c;\n    border-color: #28623c;\n}\n.list-group-item-info {\n  color: #336573;\n  background-color: #d3eef6;\n}\na.list-group-item-info,\nbutton.list-group-item-info {\n  color: #336573;\n}\na.list-group-item-info:focus, a.list-group-item-info:hover,\n  button.list-group-item-info:focus,\n  button.list-group-item-info:hover {\n    color: #336573;\n    background-color: #bee6f2;\n}\na.list-group-item-info.active,\n  button.list-group-item-info.active {\n    color: #fff;\n    background-color: #336573;\n    border-color: #336573;\n}\n.list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba;\n}\na.list-group-item-warning,\nbutton.list-group-item-warning {\n  color: #856404;\n}\na.list-group-item-warning:focus, a.list-group-item-warning:hover,\n  button.list-group-item-warning:focus,\n  button.list-group-item-warning:hover {\n    color: #856404;\n    background-color: #ffe8a1;\n}\na.list-group-item-warning.active,\n  button.list-group-item-warning.active {\n    color: #fff;\n    background-color: #856404;\n    border-color: #856404;\n}\n.list-group-item-danger {\n  color: #813838;\n  background-color: #fdd6d6;\n}\na.list-group-item-danger,\nbutton.list-group-item-danger {\n  color: #813838;\n}\na.list-group-item-danger:focus, a.list-group-item-danger:hover,\n  button.list-group-item-danger:focus,\n  button.list-group-item-danger:hover {\n    color: #813838;\n    background-color: #fcbebe;\n}\na.list-group-item-danger.active,\n  button.list-group-item-danger.active {\n    color: #fff;\n    background-color: #813838;\n    border-color: #813838;\n}\n.list-group-item-light {\n  color: #7d7e7f;\n  background-color: #fbfcfc;\n}\na.list-group-item-light,\nbutton.list-group-item-light {\n  color: #7d7e7f;\n}\na.list-group-item-light:focus, a.list-group-item-light:hover,\n  button.list-group-item-light:focus,\n  button.list-group-item-light:hover {\n    color: #7d7e7f;\n    background-color: #ecf1f1;\n}\na.list-group-item-light.active,\n  button.list-group-item-light.active {\n    color: #fff;\n    background-color: #7d7e7f;\n    border-color: #7d7e7f;\n}\n.list-group-item-dark {\n  color: #151c20;\n  background-color: #c3c7c9;\n}\na.list-group-item-dark,\nbutton.list-group-item-dark {\n  color: #151c20;\n}\na.list-group-item-dark:focus, a.list-group-item-dark:hover,\n  button.list-group-item-dark:focus,\n  button.list-group-item-dark:hover {\n    color: #151c20;\n    background-color: #b6babd;\n}\na.list-group-item-dark.active,\n  button.list-group-item-dark.active {\n    color: #fff;\n    background-color: #151c20;\n    border-color: #151c20;\n}\n.list-group-item-blue {\n  color: #115770;\n  background-color: #c1e7f4;\n}\na.list-group-item-blue,\nbutton.list-group-item-blue {\n  color: #115770;\n}\na.list-group-item-blue:focus, a.list-group-item-blue:hover,\n  button.list-group-item-blue:focus,\n  button.list-group-item-blue:hover {\n    color: #115770;\n    background-color: #abdff0;\n}\na.list-group-item-blue.active,\n  button.list-group-item-blue.active {\n    color: #fff;\n    background-color: #115770;\n    border-color: #115770;\n}\n.list-group-item-indigo {\n  color: #35087e;\n  background-color: #d4bcfb;\n}\na.list-group-item-indigo,\nbutton.list-group-item-indigo {\n  color: #35087e;\n}\na.list-group-item-indigo:focus, a.list-group-item-indigo:hover,\n  button.list-group-item-indigo:focus,\n  button.list-group-item-indigo:hover {\n    color: #35087e;\n    background-color: #c5a4fa;\n}\na.list-group-item-indigo.active,\n  button.list-group-item-indigo.active {\n    color: #fff;\n    background-color: #35087e;\n    border-color: #35087e;\n}\n.list-group-item-purple {\n  color: #3a2264;\n  background-color: #d7caee;\n}\na.list-group-item-purple,\nbutton.list-group-item-purple {\n  color: #3a2264;\n}\na.list-group-item-purple:focus, a.list-group-item-purple:hover,\n  button.list-group-item-purple:focus,\n  button.list-group-item-purple:hover {\n    color: #3a2264;\n    background-color: #c8b7e8;\n}\na.list-group-item-purple.active,\n  button.list-group-item-purple.active {\n    color: #fff;\n    background-color: #3a2264;\n    border-color: #3a2264;\n}\n.list-group-item-pink {\n  color: #792049;\n  background-color: #f9c9df;\n}\na.list-group-item-pink,\nbutton.list-group-item-pink {\n  color: #792049;\n}\na.list-group-item-pink:focus, a.list-group-item-pink:hover,\n  button.list-group-item-pink:focus,\n  button.list-group-item-pink:hover {\n    color: #792049;\n    background-color: #f6b2d1;\n}\na.list-group-item-pink.active,\n  button.list-group-item-pink.active {\n    color: #fff;\n    background-color: #792049;\n    border-color: #792049;\n}\n.list-group-item-red {\n  color: #813838;\n  background-color: #fdd6d6;\n}\na.list-group-item-red,\nbutton.list-group-item-red {\n  color: #813838;\n}\na.list-group-item-red:focus, a.list-group-item-red:hover,\n  button.list-group-item-red:focus,\n  button.list-group-item-red:hover {\n    color: #813838;\n    background-color: #fcbebe;\n}\na.list-group-item-red.active,\n  button.list-group-item-red.active {\n    color: #fff;\n    background-color: #813838;\n    border-color: #813838;\n}\n.list-group-item-orange {\n  color: #816a00;\n  background-color: #fdf0b8;\n}\na.list-group-item-orange,\nbutton.list-group-item-orange {\n  color: #816a00;\n}\na.list-group-item-orange:focus, a.list-group-item-orange:hover,\n  button.list-group-item-orange:focus,\n  button.list-group-item-orange:hover {\n    color: #816a00;\n    background-color: #fceb9f;\n}\na.list-group-item-orange.active,\n  button.list-group-item-orange.active {\n    color: #fff;\n    background-color: #816a00;\n    border-color: #816a00;\n}\n.list-group-item-yellow {\n  color: #856404;\n  background-color: #ffeeba;\n}\na.list-group-item-yellow,\nbutton.list-group-item-yellow {\n  color: #856404;\n}\na.list-group-item-yellow:focus, a.list-group-item-yellow:hover,\n  button.list-group-item-yellow:focus,\n  button.list-group-item-yellow:hover {\n    color: #856404;\n    background-color: #ffe8a1;\n}\na.list-group-item-yellow.active,\n  button.list-group-item-yellow.active {\n    color: #fff;\n    background-color: #856404;\n    border-color: #856404;\n}\n.list-group-item-green {\n  color: #28623c;\n  background-color: #cdedd8;\n}\na.list-group-item-green,\nbutton.list-group-item-green {\n  color: #28623c;\n}\na.list-group-item-green:focus, a.list-group-item-green:hover,\n  button.list-group-item-green:focus,\n  button.list-group-item-green:hover {\n    color: #28623c;\n    background-color: #bae6c9;\n}\na.list-group-item-green.active,\n  button.list-group-item-green.active {\n    color: #fff;\n    background-color: #28623c;\n    border-color: #28623c;\n}\n.list-group-item-teal {\n  color: #11694f;\n  background-color: #c1f0e2;\n}\na.list-group-item-teal,\nbutton.list-group-item-teal {\n  color: #11694f;\n}\na.list-group-item-teal:focus, a.list-group-item-teal:hover,\n  button.list-group-item-teal:focus,\n  button.list-group-item-teal:hover {\n    color: #11694f;\n    background-color: #acebd8;\n}\na.list-group-item-teal.active,\n  button.list-group-item-teal.active {\n    color: #fff;\n    background-color: #11694f;\n    border-color: #11694f;\n}\n.list-group-item-cyan {\n  color: #336573;\n  background-color: #d3eef6;\n}\na.list-group-item-cyan,\nbutton.list-group-item-cyan {\n  color: #336573;\n}\na.list-group-item-cyan:focus, a.list-group-item-cyan:hover,\n  button.list-group-item-cyan:focus,\n  button.list-group-item-cyan:hover {\n    color: #336573;\n    background-color: #bee6f2;\n}\na.list-group-item-cyan.active,\n  button.list-group-item-cyan.active {\n    color: #fff;\n    background-color: #336573;\n    border-color: #336573;\n}\n.list-group-item-gray-100 {\n  color: #7d7e7f;\n  background-color: #fbfcfc;\n}\na.list-group-item-gray-100,\nbutton.list-group-item-gray-100 {\n  color: #7d7e7f;\n}\na.list-group-item-gray-100:focus, a.list-group-item-gray-100:hover,\n  button.list-group-item-gray-100:focus,\n  button.list-group-item-gray-100:hover {\n    color: #7d7e7f;\n    background-color: #ecf1f1;\n}\na.list-group-item-gray-100.active,\n  button.list-group-item-gray-100.active {\n    color: #fff;\n    background-color: #7d7e7f;\n    border-color: #7d7e7f;\n}\n.list-group-item-gray-200 {\n  color: #656c6f;\n  background-color: #eef2f4;\n}\na.list-group-item-gray-200,\nbutton.list-group-item-gray-200 {\n  color: #656c6f;\n}\na.list-group-item-gray-200:focus, a.list-group-item-gray-200:hover,\n  button.list-group-item-gray-200:focus,\n  button.list-group-item-gray-200:hover {\n    color: #656c6f;\n    background-color: #dfe6ea;\n}\na.list-group-item-gray-200.active,\n  button.list-group-item-gray-200.active {\n    color: #fff;\n    background-color: #656c6f;\n    border-color: #656c6f;\n}\n.list-group-item-gray-300 {\n  color: #555f64;\n  background-color: #e6ebee;\n}\na.list-group-item-gray-300,\nbutton.list-group-item-gray-300 {\n  color: #555f64;\n}\na.list-group-item-gray-300:focus, a.list-group-item-gray-300:hover,\n  button.list-group-item-gray-300:focus,\n  button.list-group-item-gray-300:hover {\n    color: #555f64;\n    background-color: #d7dfe4;\n}\na.list-group-item-gray-300.active,\n  button.list-group-item-gray-300.active {\n    color: #fff;\n    background-color: #555f64;\n    border-color: #555f64;\n}\n.list-group-item-gray-400 {\n  color: #465359;\n  background-color: #dde4e8;\n}\na.list-group-item-gray-400,\nbutton.list-group-item-gray-400 {\n  color: #465359;\n}\na.list-group-item-gray-400:focus, a.list-group-item-gray-400:hover,\n  button.list-group-item-gray-400:focus,\n  button.list-group-item-gray-400:hover {\n    color: #465359;\n    background-color: #ced8de;\n}\na.list-group-item-gray-400.active,\n  button.list-group-item-gray-400.active {\n    color: #fff;\n    background-color: #465359;\n    border-color: #465359;\n}\n.list-group-item-gray-500 {\n  color: #36474f;\n  background-color: #d4dee2;\n}\na.list-group-item-gray-500,\nbutton.list-group-item-gray-500 {\n  color: #36474f;\n}\na.list-group-item-gray-500:focus, a.list-group-item-gray-500:hover,\n  button.list-group-item-gray-500:focus,\n  button.list-group-item-gray-500:hover {\n    color: #36474f;\n    background-color: #c5d2d8;\n}\na.list-group-item-gray-500.active,\n  button.list-group-item-gray-500.active {\n    color: #fff;\n    background-color: #36474f;\n    border-color: #36474f;\n}\n.list-group-item-gray-600 {\n  color: #2b383f;\n  background-color: #cfd6d9;\n}\na.list-group-item-gray-600,\nbutton.list-group-item-gray-600 {\n  color: #2b383f;\n}\na.list-group-item-gray-600:focus, a.list-group-item-gray-600:hover,\n  button.list-group-item-gray-600:focus,\n  button.list-group-item-gray-600:hover {\n    color: #2b383f;\n    background-color: #c1cace;\n}\na.list-group-item-gray-600.active,\n  button.list-group-item-gray-600.active {\n    color: #fff;\n    background-color: #2b383f;\n    border-color: #2b383f;\n}\n.list-group-item-gray-700 {\n  color: #202a2f;\n  background-color: #c9ced1;\n}\na.list-group-item-gray-700,\nbutton.list-group-item-gray-700 {\n  color: #202a2f;\n}\na.list-group-item-gray-700:focus, a.list-group-item-gray-700:hover,\n  button.list-group-item-gray-700:focus,\n  button.list-group-item-gray-700:hover {\n    color: #202a2f;\n    background-color: #bbc2c5;\n}\na.list-group-item-gray-700.active,\n  button.list-group-item-gray-700.active {\n    color: #fff;\n    background-color: #202a2f;\n    border-color: #202a2f;\n}\n.list-group-item-gray-800 {\n  color: #151c20;\n  background-color: #c3c7c9;\n}\na.list-group-item-gray-800,\nbutton.list-group-item-gray-800 {\n  color: #151c20;\n}\na.list-group-item-gray-800:focus, a.list-group-item-gray-800:hover,\n  button.list-group-item-gray-800:focus,\n  button.list-group-item-gray-800:hover {\n    color: #151c20;\n    background-color: #b6babd;\n}\na.list-group-item-gray-800.active,\n  button.list-group-item-gray-800.active {\n    color: #fff;\n    background-color: #151c20;\n    border-color: #151c20;\n}\n.list-group-item-gray-900 {\n  color: #0b0e10;\n  background-color: #bdbfc0;\n}\na.list-group-item-gray-900,\nbutton.list-group-item-gray-900 {\n  color: #0b0e10;\n}\na.list-group-item-gray-900:focus, a.list-group-item-gray-900:hover,\n  button.list-group-item-gray-900:focus,\n  button.list-group-item-gray-900:hover {\n    color: #0b0e10;\n    background-color: #b0b2b4;\n}\na.list-group-item-gray-900.active,\n  button.list-group-item-gray-900.active {\n    color: #fff;\n    background-color: #0b0e10;\n    border-color: #0b0e10;\n}\n.close {\n  float: right;\n  font-size: 1.3125rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5;\n}\n.close:focus, .close:hover {\n    color: #000;\n    text-decoration: none;\n    opacity: .75;\n}\n.close:not([disabled]):not(.disabled) {\n    cursor: pointer;\n}\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n.modal-open {\n  overflow: hidden;\n}\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  outline: 0;\n}\n.modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n    -webkit-transition: -webkit-transform 0.3s ease-out;\n    transition: -webkit-transform 0.3s ease-out;\n    transition: transform 0.3s ease-out;\n    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n    -webkit-transform: translate(0, -25%);\n            transform: translate(0, -25%);\n}\n.modal.show .modal-dialog {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0);\n}\n.modal-dialog-centered {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  min-height: calc(100% - (0.5rem * 2));\n}\n.modal-content {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  outline: 0;\n}\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n    opacity: 0;\n}\n.modal-backdrop.show {\n    opacity: 0.5;\n}\n.modal-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid #c2cfd6;\n}\n.modal-header .close {\n    padding: 1rem;\n    margin: -1rem -1rem -1rem auto;\n}\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n.modal-body {\n  position: relative;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  padding: 1rem;\n}\n.modal-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #c2cfd6;\n}\n.modal-footer > :not(:first-child) {\n    margin-left: .25rem;\n}\n.modal-footer > :not(:last-child) {\n    margin-right: .25rem;\n}\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n@media (min-width: 576px) {\n.modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n}\n.modal-dialog-centered {\n    min-height: calc(100% - (1.75rem * 2));\n}\n.modal-sm {\n    max-width: 300px;\n}\n}\n@media (min-width: 992px) {\n.modal-lg {\n    max-width: 800px;\n}\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.76562rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n    opacity: 0.9;\n}\n.tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: 0.8rem;\n    height: 0.4rem;\n}\n.tooltip .arrow::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n}\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n    bottom: 0;\n}\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n      top: 0;\n      border-width: 0.4rem 0.4rem 0;\n      border-top-color: #000;\n}\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    width: 0.4rem;\n    height: 0.8rem;\n}\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n      right: 0;\n      border-width: 0.4rem 0.4rem 0.4rem 0;\n      border-right-color: #000;\n}\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n    top: 0;\n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n      bottom: 0;\n      border-width: 0 0.4rem 0.4rem;\n      border-bottom-color: #000;\n}\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    width: 0.4rem;\n    height: 0.8rem;\n}\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n      left: 0;\n      border-width: 0.4rem 0 0.4rem 0.4rem;\n      border-left-color: #000;\n}\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n}\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.76562rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}\n.popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 0.3rem;\n}\n.popover .arrow::before, .popover .arrow::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n}\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem;\n}\n.bs-popover-top .arrow, .bs-popover-auto[x-placement^=\"top\"] .arrow {\n    bottom: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=\"top\"] .arrow::before,\n  .bs-popover-top .arrow::after,\n  .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    border-width: 0.5rem 0.5rem 0;\n}\n.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=\"top\"] .arrow::before {\n    bottom: 0;\n    border-top-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-top .arrow::after,\n  .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    bottom: 1px;\n    border-top-color: #fff;\n}\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem;\n}\n.bs-popover-right .arrow, .bs-popover-auto[x-placement^=\"right\"] .arrow {\n    left: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0;\n}\n.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=\"right\"] .arrow::before,\n  .bs-popover-right .arrow::after,\n  .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    border-width: 0.5rem 0.5rem 0.5rem 0;\n}\n.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=\"right\"] .arrow::before {\n    left: 0;\n    border-right-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-right .arrow::after,\n  .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    left: 1px;\n    border-right-color: #fff;\n}\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem;\n}\n.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=\"bottom\"] .arrow {\n    top: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before,\n  .bs-popover-bottom .arrow::after,\n  .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    border-width: 0 0.5rem 0.5rem 0.5rem;\n}\n.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before {\n    top: 0;\n    border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-bottom .arrow::after,\n  .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    top: 1px;\n    border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -0.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7;\n}\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem;\n}\n.bs-popover-left .arrow, .bs-popover-auto[x-placement^=\"left\"] .arrow {\n    right: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0;\n}\n.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=\"left\"] .arrow::before,\n  .bs-popover-left .arrow::after,\n  .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    border-width: 0.5rem 0 0.5rem 0.5rem;\n}\n.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=\"left\"] .arrow::before {\n    right: 0;\n    border-left-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-left .arrow::after,\n  .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    right: 1px;\n    border-left-color: #fff;\n}\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: inherit;\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #ebebeb;\n}\n.popover-header:empty {\n    display: none;\n}\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #151b1e;\n}\n.carousel {\n  position: relative;\n}\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-item {\n  position: relative;\n  display: none;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  -webkit-transition: -webkit-transform 0.6s ease;\n  transition: -webkit-transform 0.6s ease;\n  transition: transform 0.6s ease;\n  transition: transform 0.6s ease, -webkit-transform 0.6s ease;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-perspective: 1000px;\n          perspective: 1000px;\n}\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n.carousel-item-next,\n.carousel-item-prev {\n  position: absolute;\n  top: 0;\n}\n.carousel-item-next.carousel-item-left,\n.carousel-item-prev.carousel-item-right {\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {\n.carousel-item-next.carousel-item-left,\n    .carousel-item-prev.carousel-item-right {\n      -webkit-transform: translate3d(0, 0, 0);\n              transform: translate3d(0, 0, 0);\n}\n}\n.carousel-item-next,\n.active.carousel-item-right {\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {\n.carousel-item-next,\n    .active.carousel-item-right {\n      -webkit-transform: translate3d(100%, 0, 0);\n              transform: translate3d(100%, 0, 0);\n}\n}\n.carousel-item-prev,\n.active.carousel-item-left {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {\n.carousel-item-prev,\n    .active.carousel-item-left {\n      -webkit-transform: translate3d(-100%, 0, 0);\n              transform: translate3d(-100%, 0, 0);\n}\n}\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n}\n.carousel-control-prev:focus, .carousel-control-prev:hover,\n  .carousel-control-next:focus,\n  .carousel-control-next:hover {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9;\n}\n.carousel-control-prev {\n  left: 0;\n}\n.carousel-control-next {\n  right: 0;\n}\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: transparent no-repeat center center;\n  background-size: 100% 100%;\n}\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\");\n}\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\");\n}\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n  left: 0;\n  z-index: 15;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n    position: relative;\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 auto;\n            flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    background-color: rgba(255, 255, 255, 0.5);\n}\n.carousel-indicators li::before {\n      position: absolute;\n      top: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\";\n}\n.carousel-indicators li::after {\n      position: absolute;\n      bottom: -10px;\n      left: 0;\n      display: inline-block;\n      width: 100%;\n      height: 10px;\n      content: \"\";\n}\n.carousel-indicators .active {\n    background-color: #fff;\n}\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n.align-baseline {\n  vertical-align: baseline !important;\n}\n.align-top {\n  vertical-align: top !important;\n}\n.align-middle {\n  vertical-align: middle !important;\n}\n.align-bottom {\n  vertical-align: bottom !important;\n}\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n.align-text-top {\n  vertical-align: text-top !important;\n}\n.bg-primary {\n  background-color: #20a8d8 !important;\n}\na.bg-primary:focus, a.bg-primary:hover,\nbutton.bg-primary:focus,\nbutton.bg-primary:hover {\n  background-color: #1985ac !important;\n}\n.bg-secondary {\n  background-color: #a4b7c1 !important;\n}\na.bg-secondary:focus, a.bg-secondary:hover,\nbutton.bg-secondary:focus,\nbutton.bg-secondary:hover {\n  background-color: #869fac !important;\n}\n.bg-success {\n  background-color: #4dbd74 !important;\n}\na.bg-success:focus, a.bg-success:hover,\nbutton.bg-success:focus,\nbutton.bg-success:hover {\n  background-color: #3a9d5d !important;\n}\n.bg-info {\n  background-color: #63c2de !important;\n}\na.bg-info:focus, a.bg-info:hover,\nbutton.bg-info:focus,\nbutton.bg-info:hover {\n  background-color: #39b2d5 !important;\n}\n.bg-warning {\n  background-color: #ffc107 !important;\n}\na.bg-warning:focus, a.bg-warning:hover,\nbutton.bg-warning:focus,\nbutton.bg-warning:hover {\n  background-color: #d39e00 !important;\n}\n.bg-danger {\n  background-color: #f86c6b !important;\n}\na.bg-danger:focus, a.bg-danger:hover,\nbutton.bg-danger:focus,\nbutton.bg-danger:hover {\n  background-color: #f63c3a !important;\n}\n.bg-light {\n  background-color: #f0f3f5 !important;\n}\na.bg-light:focus, a.bg-light:hover,\nbutton.bg-light:focus,\nbutton.bg-light:hover {\n  background-color: #d1dbe1 !important;\n}\n.bg-dark {\n  background-color: #29363d !important;\n}\na.bg-dark:focus, a.bg-dark:hover,\nbutton.bg-dark:focus,\nbutton.bg-dark:hover {\n  background-color: #151b1f !important;\n}\n.bg-blue {\n  background-color: #20a8d8 !important;\n}\na.bg-blue:focus, a.bg-blue:hover,\nbutton.bg-blue:focus,\nbutton.bg-blue:hover {\n  background-color: #1985ac !important;\n}\n.bg-indigo {\n  background-color: #6610f2 !important;\n}\na.bg-indigo:focus, a.bg-indigo:hover,\nbutton.bg-indigo:focus,\nbutton.bg-indigo:hover {\n  background-color: #510bc4 !important;\n}\n.bg-purple {\n  background-color: #6f42c1 !important;\n}\na.bg-purple:focus, a.bg-purple:hover,\nbutton.bg-purple:focus,\nbutton.bg-purple:hover {\n  background-color: #59339d !important;\n}\n.bg-pink {\n  background-color: #e83e8c !important;\n}\na.bg-pink:focus, a.bg-pink:hover,\nbutton.bg-pink:focus,\nbutton.bg-pink:hover {\n  background-color: #d91a72 !important;\n}\n.bg-red {\n  background-color: #f86c6b !important;\n}\na.bg-red:focus, a.bg-red:hover,\nbutton.bg-red:focus,\nbutton.bg-red:hover {\n  background-color: #f63c3a !important;\n}\n.bg-orange {\n  background-color: #f8cb00 !important;\n}\na.bg-orange:focus, a.bg-orange:hover,\nbutton.bg-orange:focus,\nbutton.bg-orange:hover {\n  background-color: #c5a100 !important;\n}\n.bg-yellow {\n  background-color: #ffc107 !important;\n}\na.bg-yellow:focus, a.bg-yellow:hover,\nbutton.bg-yellow:focus,\nbutton.bg-yellow:hover {\n  background-color: #d39e00 !important;\n}\n.bg-green {\n  background-color: #4dbd74 !important;\n}\na.bg-green:focus, a.bg-green:hover,\nbutton.bg-green:focus,\nbutton.bg-green:hover {\n  background-color: #3a9d5d !important;\n}\n.bg-teal {\n  background-color: #20c997 !important;\n}\na.bg-teal:focus, a.bg-teal:hover,\nbutton.bg-teal:focus,\nbutton.bg-teal:hover {\n  background-color: #199d76 !important;\n}\n.bg-cyan {\n  background-color: #63c2de !important;\n}\na.bg-cyan:focus, a.bg-cyan:hover,\nbutton.bg-cyan:focus,\nbutton.bg-cyan:hover {\n  background-color: #39b2d5 !important;\n}\n.bg-gray-100 {\n  background-color: #f0f3f5 !important;\n}\na.bg-gray-100:focus, a.bg-gray-100:hover,\nbutton.bg-gray-100:focus,\nbutton.bg-gray-100:hover {\n  background-color: #d1dbe1 !important;\n}\n.bg-gray-200 {\n  background-color: #c2cfd6 !important;\n}\na.bg-gray-200:focus, a.bg-gray-200:hover,\nbutton.bg-gray-200:focus,\nbutton.bg-gray-200:hover {\n  background-color: #a4b7c2 !important;\n}\n.bg-gray-300 {\n  background-color: #a4b7c1 !important;\n}\na.bg-gray-300:focus, a.bg-gray-300:hover,\nbutton.bg-gray-300:focus,\nbutton.bg-gray-300:hover {\n  background-color: #869fac !important;\n}\n.bg-gray-400 {\n  background-color: #869fac !important;\n}\na.bg-gray-400:focus, a.bg-gray-400:hover,\nbutton.bg-gray-400:focus,\nbutton.bg-gray-400:hover {\n  background-color: #688797 !important;\n}\n.bg-gray-500 {\n  background-color: #678898 !important;\n}\na.bg-gray-500:focus, a.bg-gray-500:hover,\nbutton.bg-gray-500:focus,\nbutton.bg-gray-500:hover {\n  background-color: #526d7a !important;\n}\n.bg-gray-600 {\n  background-color: #536c79 !important;\n}\na.bg-gray-600:focus, a.bg-gray-600:hover,\nbutton.bg-gray-600:focus,\nbutton.bg-gray-600:hover {\n  background-color: #3e515b !important;\n}\n.bg-gray-700 {\n  background-color: #3e515b !important;\n}\na.bg-gray-700:focus, a.bg-gray-700:hover,\nbutton.bg-gray-700:focus,\nbutton.bg-gray-700:hover {\n  background-color: #29363d !important;\n}\n.bg-gray-800 {\n  background-color: #29363d !important;\n}\na.bg-gray-800:focus, a.bg-gray-800:hover,\nbutton.bg-gray-800:focus,\nbutton.bg-gray-800:hover {\n  background-color: #151b1f !important;\n}\n.bg-gray-900 {\n  background-color: #151b1e !important;\n}\na.bg-gray-900:focus, a.bg-gray-900:hover,\nbutton.bg-gray-900:focus,\nbutton.bg-gray-900:hover {\n  background-color: black !important;\n}\n.bg-white {\n  background-color: #fff !important;\n}\n.bg-transparent {\n  background-color: transparent !important;\n}\n.border {\n  border: 1px solid #c2cfd6 !important;\n}\n.border-0 {\n  border: 0 !important;\n}\n.border-top-0 {\n  border-top: 0 !important;\n}\n.border-right-0 {\n  border-right: 0 !important;\n}\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n.border-left-0 {\n  border-left: 0 !important;\n}\n.border-primary {\n  border-color: #20a8d8 !important;\n}\n.border-secondary {\n  border-color: #a4b7c1 !important;\n}\n.border-success {\n  border-color: #4dbd74 !important;\n}\n.border-info {\n  border-color: #63c2de !important;\n}\n.border-warning {\n  border-color: #ffc107 !important;\n}\n.border-danger {\n  border-color: #f86c6b !important;\n}\n.border-light {\n  border-color: #f0f3f5 !important;\n}\n.border-dark {\n  border-color: #29363d !important;\n}\n.border-blue {\n  border-color: #20a8d8 !important;\n}\n.border-indigo {\n  border-color: #6610f2 !important;\n}\n.border-purple {\n  border-color: #6f42c1 !important;\n}\n.border-pink {\n  border-color: #e83e8c !important;\n}\n.border-red {\n  border-color: #f86c6b !important;\n}\n.border-orange {\n  border-color: #f8cb00 !important;\n}\n.border-yellow {\n  border-color: #ffc107 !important;\n}\n.border-green {\n  border-color: #4dbd74 !important;\n}\n.border-teal {\n  border-color: #20c997 !important;\n}\n.border-cyan {\n  border-color: #63c2de !important;\n}\n.border-gray-100 {\n  border-color: #f0f3f5 !important;\n}\n.border-gray-200 {\n  border-color: #c2cfd6 !important;\n}\n.border-gray-300 {\n  border-color: #a4b7c1 !important;\n}\n.border-gray-400 {\n  border-color: #869fac !important;\n}\n.border-gray-500 {\n  border-color: #678898 !important;\n}\n.border-gray-600 {\n  border-color: #536c79 !important;\n}\n.border-gray-700 {\n  border-color: #3e515b !important;\n}\n.border-gray-800 {\n  border-color: #29363d !important;\n}\n.border-gray-900 {\n  border-color: #151b1e !important;\n}\n.border-white {\n  border-color: #fff !important;\n}\n.rounded {\n  border-radius: 0.25rem !important;\n}\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n.rounded-right {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n.rounded-left {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n.rounded-circle {\n  border-radius: 50% !important;\n}\n.rounded-0 {\n  border-radius: 0 !important;\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n.d-none {\n  display: none !important;\n}\n.d-inline {\n  display: inline !important;\n}\n.d-inline-block {\n  display: inline-block !important;\n}\n.d-block {\n  display: block !important;\n}\n.d-table {\n  display: table !important;\n}\n.d-table-row {\n  display: table-row !important;\n}\n.d-table-cell {\n  display: table-cell !important;\n}\n.d-flex {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.d-inline-flex {\n  display: -webkit-inline-box !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n@media (min-width: 576px) {\n.d-sm-none {\n    display: none !important;\n}\n.d-sm-inline {\n    display: inline !important;\n}\n.d-sm-inline-block {\n    display: inline-block !important;\n}\n.d-sm-block {\n    display: block !important;\n}\n.d-sm-table {\n    display: table !important;\n}\n.d-sm-table-row {\n    display: table-row !important;\n}\n.d-sm-table-cell {\n    display: table-cell !important;\n}\n.d-sm-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-sm-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media (min-width: 768px) {\n.d-md-none {\n    display: none !important;\n}\n.d-md-inline {\n    display: inline !important;\n}\n.d-md-inline-block {\n    display: inline-block !important;\n}\n.d-md-block {\n    display: block !important;\n}\n.d-md-table {\n    display: table !important;\n}\n.d-md-table-row {\n    display: table-row !important;\n}\n.d-md-table-cell {\n    display: table-cell !important;\n}\n.d-md-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-md-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media (min-width: 992px) {\n.d-lg-none {\n    display: none !important;\n}\n.d-lg-inline {\n    display: inline !important;\n}\n.d-lg-inline-block {\n    display: inline-block !important;\n}\n.d-lg-block {\n    display: block !important;\n}\n.d-lg-table {\n    display: table !important;\n}\n.d-lg-table-row {\n    display: table-row !important;\n}\n.d-lg-table-cell {\n    display: table-cell !important;\n}\n.d-lg-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-lg-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media (min-width: 1200px) {\n.d-xl-none {\n    display: none !important;\n}\n.d-xl-inline {\n    display: inline !important;\n}\n.d-xl-inline-block {\n    display: inline-block !important;\n}\n.d-xl-block {\n    display: block !important;\n}\n.d-xl-table {\n    display: table !important;\n}\n.d-xl-table-row {\n    display: table-row !important;\n}\n.d-xl-table-cell {\n    display: table-cell !important;\n}\n.d-xl-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n.d-xl-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n.d-print-block {\n  display: none !important;\n}\n@media print {\n.d-print-block {\n      display: block !important;\n}\n}\n.d-print-inline {\n  display: none !important;\n}\n@media print {\n.d-print-inline {\n      display: inline !important;\n}\n}\n.d-print-inline-block {\n  display: none !important;\n}\n@media print {\n.d-print-inline-block {\n      display: inline-block !important;\n}\n}\n@media print {\n.d-print-none {\n    display: none !important;\n}\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n    display: block;\n    content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n  .embed-responsive iframe,\n  .embed-responsive embed,\n  .embed-responsive object,\n  .embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n}\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%;\n}\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n.flex-row {\n  -webkit-box-orient: horizontal !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: row !important;\n          flex-direction: row !important;\n}\n.flex-column {\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: column !important;\n          flex-direction: column !important;\n}\n.flex-row-reverse {\n  -webkit-box-orient: horizontal !important;\n  -webkit-box-direction: reverse !important;\n      -ms-flex-direction: row-reverse !important;\n          flex-direction: row-reverse !important;\n}\n.flex-column-reverse {\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: reverse !important;\n      -ms-flex-direction: column-reverse !important;\n          flex-direction: column-reverse !important;\n}\n.flex-wrap {\n  -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n}\n.flex-nowrap {\n  -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n}\n.flex-wrap-reverse {\n  -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n}\n.justify-content-start {\n  -webkit-box-pack: start !important;\n      -ms-flex-pack: start !important;\n          justify-content: flex-start !important;\n}\n.justify-content-end {\n  -webkit-box-pack: end !important;\n      -ms-flex-pack: end !important;\n          justify-content: flex-end !important;\n}\n.justify-content-center {\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.justify-content-between {\n  -webkit-box-pack: justify !important;\n      -ms-flex-pack: justify !important;\n          justify-content: space-between !important;\n}\n.justify-content-around {\n  -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n}\n.align-items-start {\n  -webkit-box-align: start !important;\n      -ms-flex-align: start !important;\n          align-items: flex-start !important;\n}\n.align-items-end {\n  -webkit-box-align: end !important;\n      -ms-flex-align: end !important;\n          align-items: flex-end !important;\n}\n.align-items-center {\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n}\n.align-items-baseline {\n  -webkit-box-align: baseline !important;\n      -ms-flex-align: baseline !important;\n          align-items: baseline !important;\n}\n.align-items-stretch {\n  -webkit-box-align: stretch !important;\n      -ms-flex-align: stretch !important;\n          align-items: stretch !important;\n}\n.align-content-start {\n  -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n}\n.align-content-end {\n  -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n}\n.align-content-center {\n  -ms-flex-line-pack: center !important;\n      align-content: center !important;\n}\n.align-content-between {\n  -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n}\n.align-content-around {\n  -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n}\n.align-content-stretch {\n  -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n}\n.align-self-auto {\n  -ms-flex-item-align: auto !important;\n      align-self: auto !important;\n}\n.align-self-start {\n  -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n}\n.align-self-end {\n  -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n}\n.align-self-center {\n  -ms-flex-item-align: center !important;\n      align-self: center !important;\n}\n.align-self-baseline {\n  -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n}\n.align-self-stretch {\n  -ms-flex-item-align: stretch !important;\n      align-self: stretch !important;\n}\n@media (min-width: 576px) {\n.flex-sm-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n}\n.flex-sm-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.flex-sm-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n            flex-direction: row-reverse !important;\n}\n.flex-sm-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n            flex-direction: column-reverse !important;\n}\n.flex-sm-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-sm-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-sm-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-sm-start {\n    -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n            justify-content: flex-start !important;\n}\n.justify-content-sm-end {\n    -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n            justify-content: flex-end !important;\n}\n.justify-content-sm-center {\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n}\n.justify-content-sm-between {\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.justify-content-sm-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-sm-start {\n    -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n            align-items: flex-start !important;\n}\n.align-items-sm-end {\n    -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n            align-items: flex-end !important;\n}\n.align-items-sm-center {\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n}\n.align-items-sm-baseline {\n    -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n            align-items: baseline !important;\n}\n.align-items-sm-stretch {\n    -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n            align-items: stretch !important;\n}\n.align-content-sm-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-sm-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-sm-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-sm-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-sm-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-sm-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-sm-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-sm-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-sm-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-sm-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n}\n.align-self-sm-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-sm-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n@media (min-width: 768px) {\n.flex-md-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n}\n.flex-md-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.flex-md-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n            flex-direction: row-reverse !important;\n}\n.flex-md-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n            flex-direction: column-reverse !important;\n}\n.flex-md-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-md-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-md-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-md-start {\n    -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n            justify-content: flex-start !important;\n}\n.justify-content-md-end {\n    -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n            justify-content: flex-end !important;\n}\n.justify-content-md-center {\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n}\n.justify-content-md-between {\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.justify-content-md-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-md-start {\n    -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n            align-items: flex-start !important;\n}\n.align-items-md-end {\n    -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n            align-items: flex-end !important;\n}\n.align-items-md-center {\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n}\n.align-items-md-baseline {\n    -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n            align-items: baseline !important;\n}\n.align-items-md-stretch {\n    -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n            align-items: stretch !important;\n}\n.align-content-md-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-md-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-md-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-md-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-md-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-md-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-md-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-md-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-md-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-md-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n}\n.align-self-md-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-md-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n@media (min-width: 992px) {\n.flex-lg-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n}\n.flex-lg-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.flex-lg-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n            flex-direction: row-reverse !important;\n}\n.flex-lg-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n            flex-direction: column-reverse !important;\n}\n.flex-lg-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-lg-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-lg-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-lg-start {\n    -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n            justify-content: flex-start !important;\n}\n.justify-content-lg-end {\n    -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n            justify-content: flex-end !important;\n}\n.justify-content-lg-center {\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n}\n.justify-content-lg-between {\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.justify-content-lg-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-lg-start {\n    -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n            align-items: flex-start !important;\n}\n.align-items-lg-end {\n    -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n            align-items: flex-end !important;\n}\n.align-items-lg-center {\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n}\n.align-items-lg-baseline {\n    -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n            align-items: baseline !important;\n}\n.align-items-lg-stretch {\n    -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n            align-items: stretch !important;\n}\n.align-content-lg-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-lg-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-lg-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-lg-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-lg-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-lg-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-lg-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-lg-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-lg-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-lg-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n}\n.align-self-lg-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-lg-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n@media (min-width: 1200px) {\n.flex-xl-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n}\n.flex-xl-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n            flex-direction: column !important;\n}\n.flex-xl-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n            flex-direction: row-reverse !important;\n}\n.flex-xl-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n            flex-direction: column-reverse !important;\n}\n.flex-xl-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n}\n.flex-xl-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n}\n.flex-xl-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n}\n.justify-content-xl-start {\n    -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n            justify-content: flex-start !important;\n}\n.justify-content-xl-end {\n    -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n            justify-content: flex-end !important;\n}\n.justify-content-xl-center {\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n}\n.justify-content-xl-between {\n    -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n}\n.justify-content-xl-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n}\n.align-items-xl-start {\n    -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n            align-items: flex-start !important;\n}\n.align-items-xl-end {\n    -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n            align-items: flex-end !important;\n}\n.align-items-xl-center {\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n}\n.align-items-xl-baseline {\n    -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n            align-items: baseline !important;\n}\n.align-items-xl-stretch {\n    -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n            align-items: stretch !important;\n}\n.align-content-xl-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n}\n.align-content-xl-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n}\n.align-content-xl-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n}\n.align-content-xl-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n}\n.align-content-xl-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n}\n.align-content-xl-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n}\n.align-self-xl-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n}\n.align-self-xl-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n}\n.align-self-xl-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n}\n.align-self-xl-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n}\n.align-self-xl-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n}\n.align-self-xl-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n}\n}\n.float-left {\n  float: left !important;\n}\n.float-right {\n  float: right !important;\n}\n.float-none {\n  float: none !important;\n}\n@media (min-width: 576px) {\n.float-sm-left {\n    float: left !important;\n}\n.float-sm-right {\n    float: right !important;\n}\n.float-sm-none {\n    float: none !important;\n}\n}\n@media (min-width: 768px) {\n.float-md-left {\n    float: left !important;\n}\n.float-md-right {\n    float: right !important;\n}\n.float-md-none {\n    float: none !important;\n}\n}\n@media (min-width: 992px) {\n.float-lg-left {\n    float: left !important;\n}\n.float-lg-right {\n    float: right !important;\n}\n.float-lg-none {\n    float: none !important;\n}\n}\n@media (min-width: 1200px) {\n.float-xl-left {\n    float: left !important;\n}\n.float-xl-right {\n    float: right !important;\n}\n.float-xl-none {\n    float: none !important;\n}\n}\n.position-static {\n  position: static !important;\n}\n.position-relative {\n  position: relative !important;\n}\n.position-absolute {\n  position: absolute !important;\n}\n.position-fixed {\n  position: fixed !important;\n}\n.position-sticky {\n  position: -webkit-sticky !important;\n  position: sticky !important;\n}\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n@supports ((position: -webkit-sticky) or (position: sticky)) {\n.sticky-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n}\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  -webkit-clip-path: inset(50%);\n          clip-path: inset(50%);\n  border: 0;\n}\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n  -webkit-clip-path: none;\n          clip-path: none;\n}\n.w-25 {\n  width: 25% !important;\n}\n.w-50 {\n  width: 50% !important;\n}\n.w-75 {\n  width: 75% !important;\n}\n.w-100 {\n  width: 100% !important;\n}\n.h-25 {\n  height: 25% !important;\n}\n.h-50 {\n  height: 50% !important;\n}\n.h-75 {\n  height: 75% !important;\n}\n.h-100 {\n  height: 100% !important;\n}\n.mw-100 {\n  max-width: 100% !important;\n}\n.mh-100 {\n  max-height: 100% !important;\n}\n.m-0 {\n  margin: 0 !important;\n}\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n.m-1 {\n  margin: 0.25rem !important;\n}\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n.m-2 {\n  margin: 0.5rem !important;\n}\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n.m-3 {\n  margin: 1rem !important;\n}\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n.m-4 {\n  margin: 1.5rem !important;\n}\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n.m-5 {\n  margin: 3rem !important;\n}\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n.p-0 {\n  padding: 0 !important;\n}\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n.p-1 {\n  padding: 0.25rem !important;\n}\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n.p-3 {\n  padding: 1rem !important;\n}\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n.p-4 {\n  padding: 1.5rem !important;\n}\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n.p-5 {\n  padding: 3rem !important;\n}\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n.m-auto {\n  margin: auto !important;\n}\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n@media (min-width: 576px) {\n.m-sm-0 {\n    margin: 0 !important;\n}\n.mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n}\n.mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n}\n.mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n}\n.ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n}\n.m-sm-1 {\n    margin: 0.25rem !important;\n}\n.mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n}\n.m-sm-2 {\n    margin: 0.5rem !important;\n}\n.mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n}\n.m-sm-3 {\n    margin: 1rem !important;\n}\n.mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n}\n.mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n}\n.mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n}\n.m-sm-4 {\n    margin: 1.5rem !important;\n}\n.mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n}\n.m-sm-5 {\n    margin: 3rem !important;\n}\n.mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n}\n.mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n}\n.mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n}\n.p-sm-0 {\n    padding: 0 !important;\n}\n.pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n}\n.pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n}\n.pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n}\n.pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n}\n.p-sm-1 {\n    padding: 0.25rem !important;\n}\n.pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n}\n.p-sm-2 {\n    padding: 0.5rem !important;\n}\n.pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n}\n.p-sm-3 {\n    padding: 1rem !important;\n}\n.pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n}\n.pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n}\n.pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n}\n.p-sm-4 {\n    padding: 1.5rem !important;\n}\n.pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n}\n.p-sm-5 {\n    padding: 3rem !important;\n}\n.pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n}\n.pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n}\n.pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n}\n.m-sm-auto {\n    margin: auto !important;\n}\n.mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n}\n.mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n}\n.mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n}\n.ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n}\n}\n@media (min-width: 768px) {\n.m-md-0 {\n    margin: 0 !important;\n}\n.mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n}\n.mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n}\n.mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n}\n.ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n}\n.m-md-1 {\n    margin: 0.25rem !important;\n}\n.mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n}\n.m-md-2 {\n    margin: 0.5rem !important;\n}\n.mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n}\n.m-md-3 {\n    margin: 1rem !important;\n}\n.mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n}\n.mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n}\n.mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n}\n.m-md-4 {\n    margin: 1.5rem !important;\n}\n.mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n}\n.m-md-5 {\n    margin: 3rem !important;\n}\n.mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n}\n.mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n}\n.mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n}\n.p-md-0 {\n    padding: 0 !important;\n}\n.pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n}\n.pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n}\n.pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n}\n.pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n}\n.p-md-1 {\n    padding: 0.25rem !important;\n}\n.pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n}\n.p-md-2 {\n    padding: 0.5rem !important;\n}\n.pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n}\n.p-md-3 {\n    padding: 1rem !important;\n}\n.pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n}\n.pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n}\n.pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n}\n.p-md-4 {\n    padding: 1.5rem !important;\n}\n.pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n}\n.p-md-5 {\n    padding: 3rem !important;\n}\n.pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n}\n.pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n}\n.pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n}\n.m-md-auto {\n    margin: auto !important;\n}\n.mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n}\n.mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n}\n.mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n}\n.ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n}\n}\n@media (min-width: 992px) {\n.m-lg-0 {\n    margin: 0 !important;\n}\n.mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n}\n.mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n}\n.mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n}\n.ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n}\n.m-lg-1 {\n    margin: 0.25rem !important;\n}\n.mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n}\n.m-lg-2 {\n    margin: 0.5rem !important;\n}\n.mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n}\n.m-lg-3 {\n    margin: 1rem !important;\n}\n.mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n}\n.mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n}\n.mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n}\n.m-lg-4 {\n    margin: 1.5rem !important;\n}\n.mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n}\n.m-lg-5 {\n    margin: 3rem !important;\n}\n.mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n}\n.mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n}\n.mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n}\n.p-lg-0 {\n    padding: 0 !important;\n}\n.pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n}\n.pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n}\n.pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n}\n.pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n}\n.p-lg-1 {\n    padding: 0.25rem !important;\n}\n.pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n}\n.p-lg-2 {\n    padding: 0.5rem !important;\n}\n.pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n}\n.p-lg-3 {\n    padding: 1rem !important;\n}\n.pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n}\n.pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n}\n.pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n}\n.p-lg-4 {\n    padding: 1.5rem !important;\n}\n.pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n}\n.p-lg-5 {\n    padding: 3rem !important;\n}\n.pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n}\n.pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n}\n.pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n}\n.m-lg-auto {\n    margin: auto !important;\n}\n.mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n}\n.mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n}\n.mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n}\n.ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n}\n}\n@media (min-width: 1200px) {\n.m-xl-0 {\n    margin: 0 !important;\n}\n.mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n}\n.mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n}\n.mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n}\n.ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n}\n.m-xl-1 {\n    margin: 0.25rem !important;\n}\n.mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n}\n.mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n}\n.mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n}\n.ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n}\n.m-xl-2 {\n    margin: 0.5rem !important;\n}\n.mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n}\n.mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n}\n.mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n}\n.ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n}\n.m-xl-3 {\n    margin: 1rem !important;\n}\n.mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n}\n.mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n}\n.mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n}\n.ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n}\n.m-xl-4 {\n    margin: 1.5rem !important;\n}\n.mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n}\n.mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n}\n.mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n}\n.ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n}\n.m-xl-5 {\n    margin: 3rem !important;\n}\n.mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n}\n.mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n}\n.mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n}\n.ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n}\n.p-xl-0 {\n    padding: 0 !important;\n}\n.pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n}\n.pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n}\n.pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n}\n.pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n}\n.p-xl-1 {\n    padding: 0.25rem !important;\n}\n.pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n}\n.pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n}\n.pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n}\n.pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n}\n.p-xl-2 {\n    padding: 0.5rem !important;\n}\n.pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n}\n.pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n}\n.pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n}\n.pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n}\n.p-xl-3 {\n    padding: 1rem !important;\n}\n.pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n}\n.pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n}\n.pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n}\n.pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n}\n.p-xl-4 {\n    padding: 1.5rem !important;\n}\n.pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n}\n.pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n}\n.pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n}\n.pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n}\n.p-xl-5 {\n    padding: 3rem !important;\n}\n.pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n}\n.pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n}\n.pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n}\n.pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n}\n.m-xl-auto {\n    margin: auto !important;\n}\n.mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n}\n.mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n}\n.mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n}\n.ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n}\n}\n.text-justify {\n  text-align: justify !important;\n}\n.text-nowrap {\n  white-space: nowrap !important;\n}\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-right {\n  text-align: right !important;\n}\n.text-center {\n  text-align: center !important;\n}\n@media (min-width: 576px) {\n.text-sm-left {\n    text-align: left !important;\n}\n.text-sm-right {\n    text-align: right !important;\n}\n.text-sm-center {\n    text-align: center !important;\n}\n}\n@media (min-width: 768px) {\n.text-md-left {\n    text-align: left !important;\n}\n.text-md-right {\n    text-align: right !important;\n}\n.text-md-center {\n    text-align: center !important;\n}\n}\n@media (min-width: 992px) {\n.text-lg-left {\n    text-align: left !important;\n}\n.text-lg-right {\n    text-align: right !important;\n}\n.text-lg-center {\n    text-align: center !important;\n}\n}\n@media (min-width: 1200px) {\n.text-xl-left {\n    text-align: left !important;\n}\n.text-xl-right {\n    text-align: right !important;\n}\n.text-xl-center {\n    text-align: center !important;\n}\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n.font-weight-light {\n  font-weight: 300 !important;\n}\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n.font-italic {\n  font-style: italic !important;\n}\n.text-white {\n  color: #fff !important;\n}\n.text-primary {\n  color: #20a8d8 !important;\n}\na.text-primary:focus, a.text-primary:hover {\n  color: #1985ac !important;\n}\n.text-secondary {\n  color: #a4b7c1 !important;\n}\na.text-secondary:focus, a.text-secondary:hover {\n  color: #869fac !important;\n}\n.text-success {\n  color: #4dbd74 !important;\n}\na.text-success:focus, a.text-success:hover {\n  color: #3a9d5d !important;\n}\n.text-info {\n  color: #63c2de !important;\n}\na.text-info:focus, a.text-info:hover {\n  color: #39b2d5 !important;\n}\n.text-warning {\n  color: #ffc107 !important;\n}\na.text-warning:focus, a.text-warning:hover {\n  color: #d39e00 !important;\n}\n.text-danger {\n  color: #f86c6b !important;\n}\na.text-danger:focus, a.text-danger:hover {\n  color: #f63c3a !important;\n}\n.text-light {\n  color: #f0f3f5 !important;\n}\na.text-light:focus, a.text-light:hover {\n  color: #d1dbe1 !important;\n}\n.text-dark {\n  color: #29363d !important;\n}\na.text-dark:focus, a.text-dark:hover {\n  color: #151b1f !important;\n}\n.text-blue {\n  color: #20a8d8 !important;\n}\na.text-blue:focus, a.text-blue:hover {\n  color: #1985ac !important;\n}\n.text-indigo {\n  color: #6610f2 !important;\n}\na.text-indigo:focus, a.text-indigo:hover {\n  color: #510bc4 !important;\n}\n.text-purple {\n  color: #6f42c1 !important;\n}\na.text-purple:focus, a.text-purple:hover {\n  color: #59339d !important;\n}\n.text-pink {\n  color: #e83e8c !important;\n}\na.text-pink:focus, a.text-pink:hover {\n  color: #d91a72 !important;\n}\n.text-red {\n  color: #f86c6b !important;\n}\na.text-red:focus, a.text-red:hover {\n  color: #f63c3a !important;\n}\n.text-orange {\n  color: #f8cb00 !important;\n}\na.text-orange:focus, a.text-orange:hover {\n  color: #c5a100 !important;\n}\n.text-yellow {\n  color: #ffc107 !important;\n}\na.text-yellow:focus, a.text-yellow:hover {\n  color: #d39e00 !important;\n}\n.text-green {\n  color: #4dbd74 !important;\n}\na.text-green:focus, a.text-green:hover {\n  color: #3a9d5d !important;\n}\n.text-teal {\n  color: #20c997 !important;\n}\na.text-teal:focus, a.text-teal:hover {\n  color: #199d76 !important;\n}\n.text-cyan {\n  color: #63c2de !important;\n}\na.text-cyan:focus, a.text-cyan:hover {\n  color: #39b2d5 !important;\n}\n.text-gray-100 {\n  color: #f0f3f5 !important;\n}\na.text-gray-100:focus, a.text-gray-100:hover {\n  color: #d1dbe1 !important;\n}\n.text-gray-200 {\n  color: #c2cfd6 !important;\n}\na.text-gray-200:focus, a.text-gray-200:hover {\n  color: #a4b7c2 !important;\n}\n.text-gray-300 {\n  color: #a4b7c1 !important;\n}\na.text-gray-300:focus, a.text-gray-300:hover {\n  color: #869fac !important;\n}\n.text-gray-400 {\n  color: #869fac !important;\n}\na.text-gray-400:focus, a.text-gray-400:hover {\n  color: #688797 !important;\n}\n.text-gray-500 {\n  color: #678898 !important;\n}\na.text-gray-500:focus, a.text-gray-500:hover {\n  color: #526d7a !important;\n}\n.text-gray-600 {\n  color: #536c79 !important;\n}\na.text-gray-600:focus, a.text-gray-600:hover {\n  color: #3e515b !important;\n}\n.text-gray-700 {\n  color: #3e515b !important;\n}\na.text-gray-700:focus, a.text-gray-700:hover {\n  color: #29363d !important;\n}\n.text-gray-800 {\n  color: #29363d !important;\n}\na.text-gray-800:focus, a.text-gray-800:hover {\n  color: #151b1f !important;\n}\n.text-gray-900 {\n  color: #151b1e !important;\n}\na.text-gray-900:focus, a.text-gray-900:hover {\n  color: black !important;\n}\n.text-muted {\n  color: #536c79 !important;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.visible {\n  visibility: visible !important;\n}\n.invisible {\n  visibility: hidden !important;\n}\n@media print {\n*,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    -webkit-box-shadow: none !important;\n            box-shadow: none !important;\n}\na,\n  a:visited {\n    text-decoration: underline;\n}\nabbr[title]::after {\n    content: \" (\" attr(title) \")\";\n}\npre {\n    white-space: pre-wrap !important;\n}\npre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n}\nthead {\n    display: table-header-group;\n}\ntr,\n  img {\n    page-break-inside: avoid;\n}\np,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n}\nh2,\n  h3 {\n    page-break-after: avoid;\n}\n.navbar {\n    display: none;\n}\n.badge {\n    border: 1px solid #000;\n}\n.table {\n    border-collapse: collapse !important;\n}\n.table td,\n    .table th {\n      background-color: #fff !important;\n}\n.table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n}\n}\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n.font-xs {\n  font-size: .75rem !important;\n}\n.font-sm {\n  font-size: .85rem !important;\n}\n.font-lg {\n  font-size: 1rem !important;\n}\n.font-xl {\n  font-size: 1.25rem !important;\n}\n.font-2xl {\n  font-size: 1.5rem !important;\n}\n.font-3xl {\n  font-size: 1.75rem !important;\n}\n.font-4xl {\n  font-size: 2rem !important;\n}\n.font-5xl {\n  font-size: 2.5rem !important;\n}\n.animated {\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n}\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n}\n@-webkit-keyframes fadeIn {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n@keyframes fadeIn {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n          animation-name: fadeIn;\n}\n.aside-menu {\n  z-index: 1019;\n  width: 250px;\n  color: #29363d;\n  background: #fff;\n  border-left: 1px solid #c2cfd6;\n}\n.aside-menu .nav-tabs {\n    border-color: #c2cfd6;\n}\n.aside-menu .nav-tabs .nav-link, .aside-menu .nav-tabs .navbar .dropdown-toggle, .navbar .aside-menu .nav-tabs .dropdown-toggle {\n      padding: 0.75rem 1rem;\n      color: #151b1e;\n      border-top: 0;\n}\n.aside-menu .nav-tabs .nav-link.active, .aside-menu .nav-tabs .navbar .active.dropdown-toggle, .navbar .aside-menu .nav-tabs .active.dropdown-toggle {\n        color: #20a8d8;\n        border-right-color: #c2cfd6;\n        border-left-color: #c2cfd6;\n}\n.aside-menu .nav-tabs .nav-item:first-child .nav-link, .aside-menu .nav-tabs .nav-item:first-child .navbar .dropdown-toggle, .navbar .aside-menu .nav-tabs .nav-item:first-child .dropdown-toggle {\n      border-left: 0;\n}\n.aside-menu .tab-content {\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: auto;\n    border: 0;\n    border-top: 1px solid #c2cfd6;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.aside-menu .tab-content::-webkit-scrollbar {\n      width: 10px;\n      margin-left: -10px;\n      -webkit-appearance: none;\n}\n.aside-menu .tab-content::-webkit-scrollbar-track {\n      background-color: white;\n      border-right: 1px solid #f2f2f2;\n      border-left: 1px solid #f2f2f2;\n}\n.aside-menu .tab-content::-webkit-scrollbar-thumb {\n      height: 50px;\n      background-color: #e6e6e6;\n      background-clip: content-box;\n      border-color: transparent;\n      border-style: solid;\n      border-width: 1px 2px;\n}\n.aside-menu .tab-content .tab-pane {\n      padding: 0;\n}\n.img-avatar {\n  border-radius: 50em;\n}\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n}\n.avatar .img-avatar {\n    width: 36px;\n    height: 36px;\n}\n.avatar .avatar-status {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n    width: 10px;\n    height: 10px;\n    border: 1px solid #fff;\n    border-radius: 50em;\n}\n.avatar.avatar-xs {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n}\n.avatar.avatar-xs .img-avatar {\n    width: 20px;\n    height: 20px;\n}\n.avatar.avatar-xs .avatar-status {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n    width: 8px;\n    height: 8px;\n    border: 1px solid #fff;\n    border-radius: 50em;\n}\n.avatar.avatar-sm {\n  position: relative;\n  display: inline-block;\n  width: 24px;\n}\n.avatar.avatar-sm .img-avatar {\n    width: 24px;\n    height: 24px;\n}\n.avatar.avatar-sm .avatar-status {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n    width: 8px;\n    height: 8px;\n    border: 1px solid #fff;\n    border-radius: 50em;\n}\n.avatar.avatar-lg {\n  position: relative;\n  display: inline-block;\n  width: 72px;\n}\n.avatar.avatar-lg .img-avatar {\n    width: 72px;\n    height: 72px;\n}\n.avatar.avatar-lg .avatar-status {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #fff;\n    border-radius: 50em;\n}\n.avatars-stack .avatar.avatar-xs {\n  margin-right: -10px;\n}\n.avatars-stack .avatar {\n  margin-right: -15px;\n  -webkit-transition: margin-left 0.25s, margin-right 0.25s;\n  transition: margin-left 0.25s, margin-right 0.25s;\n}\n.avatars-stack .avatar:hover {\n    margin-right: 0 !important;\n}\n.badge-pill {\n  border-radius: 10rem;\n}\n.breadcrumb-menu {\n  margin-left: auto;\n}\n.breadcrumb-menu::before {\n    display: none;\n}\n.breadcrumb-menu .btn-group {\n    vertical-align: top;\n}\n.breadcrumb-menu .btn {\n    padding: 0 0.75rem;\n    color: #536c79;\n    vertical-align: top;\n    border: 0;\n}\n.breadcrumb-menu .btn:hover, .breadcrumb-menu .btn.active {\n      color: #151b1e;\n      background: transparent;\n}\n.breadcrumb-menu .open .btn {\n    color: #151b1e;\n    background: transparent;\n}\n.breadcrumb-menu .dropdown-menu {\n    min-width: 180px;\n    line-height: 1.5;\n}\n.breadcrumb {\n  position: relative;\n  border-bottom: 1px solid #c2cfd6;\n}\nbutton {\n  cursor: pointer;\n}\n.btn-transparent {\n  color: #fff;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn [class^=\"icon-\"], .btn [class*=\" icon-\"] {\n  display: inline-block;\n  margin-top: -2px;\n  vertical-align: middle;\n}\n.btn-facebook,\n.btn-twitter,\n.btn-linkedin,\n.btn-flickr,\n.btn-tumblr,\n.btn-xing,\n.btn-github,\n.btn-html5,\n.btn-openid,\n.btn-stack-overflow,\n.btn-youtube,\n.btn-css3,\n.btn-dribbble,\n.btn-google-plus,\n.btn-instagram,\n.btn-pinterest,\n.btn-vk,\n.btn-yahoo,\n.btn-behance,\n.btn-dropbox,\n.btn-reddit,\n.btn-spotify,\n.btn-vine,\n.btn-foursquare,\n.btn-vimeo {\n  position: relative;\n  overflow: hidden;\n  color: #fff !important;\n  text-align: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border: 0;\n}\n.btn-facebook::before,\n  .btn-twitter::before,\n  .btn-linkedin::before,\n  .btn-flickr::before,\n  .btn-tumblr::before,\n  .btn-xing::before,\n  .btn-github::before,\n  .btn-html5::before,\n  .btn-openid::before,\n  .btn-stack-overflow::before,\n  .btn-youtube::before,\n  .btn-css3::before,\n  .btn-dribbble::before,\n  .btn-google-plus::before,\n  .btn-instagram::before,\n  .btn-pinterest::before,\n  .btn-vk::before,\n  .btn-yahoo::before,\n  .btn-behance::before,\n  .btn-dropbox::before,\n  .btn-reddit::before,\n  .btn-spotify::before,\n  .btn-vine::before,\n  .btn-foursquare::before,\n  .btn-vimeo::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    font-family: \"FontAwesome\";\n    font-style: normal;\n    font-weight: normal;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n}\n.btn-facebook:hover,\n  .btn-twitter:hover,\n  .btn-linkedin:hover,\n  .btn-flickr:hover,\n  .btn-tumblr:hover,\n  .btn-xing:hover,\n  .btn-github:hover,\n  .btn-html5:hover,\n  .btn-openid:hover,\n  .btn-stack-overflow:hover,\n  .btn-youtube:hover,\n  .btn-css3:hover,\n  .btn-dribbble:hover,\n  .btn-google-plus:hover,\n  .btn-instagram:hover,\n  .btn-pinterest:hover,\n  .btn-vk:hover,\n  .btn-yahoo:hover,\n  .btn-behance:hover,\n  .btn-dropbox:hover,\n  .btn-reddit:hover,\n  .btn-spotify:hover,\n  .btn-vine:hover,\n  .btn-foursquare:hover,\n  .btn-vimeo:hover {\n    color: #fff;\n}\n.btn-facebook.icon span,\n  .btn-twitter.icon span,\n  .btn-linkedin.icon span,\n  .btn-flickr.icon span,\n  .btn-tumblr.icon span,\n  .btn-xing.icon span,\n  .btn-github.icon span,\n  .btn-html5.icon span,\n  .btn-openid.icon span,\n  .btn-stack-overflow.icon span,\n  .btn-youtube.icon span,\n  .btn-css3.icon span,\n  .btn-dribbble.icon span,\n  .btn-google-plus.icon span,\n  .btn-instagram.icon span,\n  .btn-pinterest.icon span,\n  .btn-vk.icon span,\n  .btn-yahoo.icon span,\n  .btn-behance.icon span,\n  .btn-dropbox.icon span,\n  .btn-reddit.icon span,\n  .btn-spotify.icon span,\n  .btn-vine.icon span,\n  .btn-foursquare.icon span,\n  .btn-vimeo.icon span {\n    display: none;\n}\n.btn-facebook.text::before,\n  .btn-twitter.text::before,\n  .btn-linkedin.text::before,\n  .btn-flickr.text::before,\n  .btn-tumblr.text::before,\n  .btn-xing.text::before,\n  .btn-github.text::before,\n  .btn-html5.text::before,\n  .btn-openid.text::before,\n  .btn-stack-overflow.text::before,\n  .btn-youtube.text::before,\n  .btn-css3.text::before,\n  .btn-dribbble.text::before,\n  .btn-google-plus.text::before,\n  .btn-instagram.text::before,\n  .btn-pinterest.text::before,\n  .btn-vk.text::before,\n  .btn-yahoo.text::before,\n  .btn-behance.text::before,\n  .btn-dropbox.text::before,\n  .btn-reddit.text::before,\n  .btn-spotify.text::before,\n  .btn-vine.text::before,\n  .btn-foursquare.text::before,\n  .btn-vimeo.text::before {\n    display: none;\n}\n.btn-facebook.text span,\n  .btn-twitter.text span,\n  .btn-linkedin.text span,\n  .btn-flickr.text span,\n  .btn-tumblr.text span,\n  .btn-xing.text span,\n  .btn-github.text span,\n  .btn-html5.text span,\n  .btn-openid.text span,\n  .btn-stack-overflow.text span,\n  .btn-youtube.text span,\n  .btn-css3.text span,\n  .btn-dribbble.text span,\n  .btn-google-plus.text span,\n  .btn-instagram.text span,\n  .btn-pinterest.text span,\n  .btn-vk.text span,\n  .btn-yahoo.text span,\n  .btn-behance.text span,\n  .btn-dropbox.text span,\n  .btn-reddit.text span,\n  .btn-spotify.text span,\n  .btn-vine.text span,\n  .btn-foursquare.text span,\n  .btn-vimeo.text span {\n    margin-left: 0 !important;\n}\n.btn-facebook::before,\n  .btn-twitter::before,\n  .btn-linkedin::before,\n  .btn-flickr::before,\n  .btn-tumblr::before,\n  .btn-xing::before,\n  .btn-github::before,\n  .btn-html5::before,\n  .btn-openid::before,\n  .btn-stack-overflow::before,\n  .btn-youtube::before,\n  .btn-css3::before,\n  .btn-dribbble::before,\n  .btn-google-plus::before,\n  .btn-instagram::before,\n  .btn-pinterest::before,\n  .btn-vk::before,\n  .btn-yahoo::before,\n  .btn-behance::before,\n  .btn-dropbox::before,\n  .btn-reddit::before,\n  .btn-spotify::before,\n  .btn-vine::before,\n  .btn-foursquare::before,\n  .btn-vimeo::before {\n    width: 2.0625rem;\n    height: 2.0625rem;\n    padding: 0.375rem 0;\n    font-size: 0.875rem;\n    line-height: 1.5;\n}\n.btn-facebook span,\n  .btn-twitter span,\n  .btn-linkedin span,\n  .btn-flickr span,\n  .btn-tumblr span,\n  .btn-xing span,\n  .btn-github span,\n  .btn-html5 span,\n  .btn-openid span,\n  .btn-stack-overflow span,\n  .btn-youtube span,\n  .btn-css3 span,\n  .btn-dribbble span,\n  .btn-google-plus span,\n  .btn-instagram span,\n  .btn-pinterest span,\n  .btn-vk span,\n  .btn-yahoo span,\n  .btn-behance span,\n  .btn-dropbox span,\n  .btn-reddit span,\n  .btn-spotify span,\n  .btn-vine span,\n  .btn-foursquare span,\n  .btn-vimeo span {\n    margin-left: 2.0625rem;\n}\n.btn-facebook.icon,\n  .btn-twitter.icon,\n  .btn-linkedin.icon,\n  .btn-flickr.icon,\n  .btn-tumblr.icon,\n  .btn-xing.icon,\n  .btn-github.icon,\n  .btn-html5.icon,\n  .btn-openid.icon,\n  .btn-stack-overflow.icon,\n  .btn-youtube.icon,\n  .btn-css3.icon,\n  .btn-dribbble.icon,\n  .btn-google-plus.icon,\n  .btn-instagram.icon,\n  .btn-pinterest.icon,\n  .btn-vk.icon,\n  .btn-yahoo.icon,\n  .btn-behance.icon,\n  .btn-dropbox.icon,\n  .btn-reddit.icon,\n  .btn-spotify.icon,\n  .btn-vine.icon,\n  .btn-foursquare.icon,\n  .btn-vimeo.icon {\n    width: 2.0625rem;\n    height: 2.0625rem;\n}\n.btn-facebook.btn-lg, .btn-group-lg > .btn-facebook.btn,\n  .btn-twitter.btn-lg,\n  .btn-group-lg > .btn-twitter.btn,\n  .btn-linkedin.btn-lg,\n  .btn-group-lg > .btn-linkedin.btn,\n  .btn-flickr.btn-lg,\n  .btn-group-lg > .btn-flickr.btn,\n  .btn-tumblr.btn-lg,\n  .btn-group-lg > .btn-tumblr.btn,\n  .btn-xing.btn-lg,\n  .btn-group-lg > .btn-xing.btn,\n  .btn-github.btn-lg,\n  .btn-group-lg > .btn-github.btn,\n  .btn-html5.btn-lg,\n  .btn-group-lg > .btn-html5.btn,\n  .btn-openid.btn-lg,\n  .btn-group-lg > .btn-openid.btn,\n  .btn-stack-overflow.btn-lg,\n  .btn-group-lg > .btn-stack-overflow.btn,\n  .btn-youtube.btn-lg,\n  .btn-group-lg > .btn-youtube.btn,\n  .btn-css3.btn-lg,\n  .btn-group-lg > .btn-css3.btn,\n  .btn-dribbble.btn-lg,\n  .btn-group-lg > .btn-dribbble.btn,\n  .btn-google-plus.btn-lg,\n  .btn-group-lg > .btn-google-plus.btn,\n  .btn-instagram.btn-lg,\n  .btn-group-lg > .btn-instagram.btn,\n  .btn-pinterest.btn-lg,\n  .btn-group-lg > .btn-pinterest.btn,\n  .btn-vk.btn-lg,\n  .btn-group-lg > .btn-vk.btn,\n  .btn-yahoo.btn-lg,\n  .btn-group-lg > .btn-yahoo.btn,\n  .btn-behance.btn-lg,\n  .btn-group-lg > .btn-behance.btn,\n  .btn-dropbox.btn-lg,\n  .btn-group-lg > .btn-dropbox.btn,\n  .btn-reddit.btn-lg,\n  .btn-group-lg > .btn-reddit.btn,\n  .btn-spotify.btn-lg,\n  .btn-group-lg > .btn-spotify.btn,\n  .btn-vine.btn-lg,\n  .btn-group-lg > .btn-vine.btn,\n  .btn-foursquare.btn-lg,\n  .btn-group-lg > .btn-foursquare.btn,\n  .btn-vimeo.btn-lg,\n  .btn-group-lg > .btn-vimeo.btn {\n    padding: 0.5rem 1rem;\n    font-size: 1.09375rem;\n    line-height: 1.5;\n    border: 0;\n}\n.btn-facebook.btn-lg::before, .btn-group-lg > .btn-facebook.btn::before,\n    .btn-twitter.btn-lg::before,\n    .btn-group-lg > .btn-twitter.btn::before,\n    .btn-linkedin.btn-lg::before,\n    .btn-group-lg > .btn-linkedin.btn::before,\n    .btn-flickr.btn-lg::before,\n    .btn-group-lg > .btn-flickr.btn::before,\n    .btn-tumblr.btn-lg::before,\n    .btn-group-lg > .btn-tumblr.btn::before,\n    .btn-xing.btn-lg::before,\n    .btn-group-lg > .btn-xing.btn::before,\n    .btn-github.btn-lg::before,\n    .btn-group-lg > .btn-github.btn::before,\n    .btn-html5.btn-lg::before,\n    .btn-group-lg > .btn-html5.btn::before,\n    .btn-openid.btn-lg::before,\n    .btn-group-lg > .btn-openid.btn::before,\n    .btn-stack-overflow.btn-lg::before,\n    .btn-group-lg > .btn-stack-overflow.btn::before,\n    .btn-youtube.btn-lg::before,\n    .btn-group-lg > .btn-youtube.btn::before,\n    .btn-css3.btn-lg::before,\n    .btn-group-lg > .btn-css3.btn::before,\n    .btn-dribbble.btn-lg::before,\n    .btn-group-lg > .btn-dribbble.btn::before,\n    .btn-google-plus.btn-lg::before,\n    .btn-group-lg > .btn-google-plus.btn::before,\n    .btn-instagram.btn-lg::before,\n    .btn-group-lg > .btn-instagram.btn::before,\n    .btn-pinterest.btn-lg::before,\n    .btn-group-lg > .btn-pinterest.btn::before,\n    .btn-vk.btn-lg::before,\n    .btn-group-lg > .btn-vk.btn::before,\n    .btn-yahoo.btn-lg::before,\n    .btn-group-lg > .btn-yahoo.btn::before,\n    .btn-behance.btn-lg::before,\n    .btn-group-lg > .btn-behance.btn::before,\n    .btn-dropbox.btn-lg::before,\n    .btn-group-lg > .btn-dropbox.btn::before,\n    .btn-reddit.btn-lg::before,\n    .btn-group-lg > .btn-reddit.btn::before,\n    .btn-spotify.btn-lg::before,\n    .btn-group-lg > .btn-spotify.btn::before,\n    .btn-vine.btn-lg::before,\n    .btn-group-lg > .btn-vine.btn::before,\n    .btn-foursquare.btn-lg::before,\n    .btn-group-lg > .btn-foursquare.btn::before,\n    .btn-vimeo.btn-lg::before,\n    .btn-group-lg > .btn-vimeo.btn::before {\n      width: 2.64062rem;\n      height: 2.64062rem;\n      padding: 0.5rem 0;\n      font-size: 1.09375rem;\n      line-height: 1.5;\n}\n.btn-facebook.btn-lg span, .btn-group-lg > .btn-facebook.btn span,\n    .btn-twitter.btn-lg span,\n    .btn-group-lg > .btn-twitter.btn span,\n    .btn-linkedin.btn-lg span,\n    .btn-group-lg > .btn-linkedin.btn span,\n    .btn-flickr.btn-lg span,\n    .btn-group-lg > .btn-flickr.btn span,\n    .btn-tumblr.btn-lg span,\n    .btn-group-lg > .btn-tumblr.btn span,\n    .btn-xing.btn-lg span,\n    .btn-group-lg > .btn-xing.btn span,\n    .btn-github.btn-lg span,\n    .btn-group-lg > .btn-github.btn span,\n    .btn-html5.btn-lg span,\n    .btn-group-lg > .btn-html5.btn span,\n    .btn-openid.btn-lg span,\n    .btn-group-lg > .btn-openid.btn span,\n    .btn-stack-overflow.btn-lg span,\n    .btn-group-lg > .btn-stack-overflow.btn span,\n    .btn-youtube.btn-lg span,\n    .btn-group-lg > .btn-youtube.btn span,\n    .btn-css3.btn-lg span,\n    .btn-group-lg > .btn-css3.btn span,\n    .btn-dribbble.btn-lg span,\n    .btn-group-lg > .btn-dribbble.btn span,\n    .btn-google-plus.btn-lg span,\n    .btn-group-lg > .btn-google-plus.btn span,\n    .btn-instagram.btn-lg span,\n    .btn-group-lg > .btn-instagram.btn span,\n    .btn-pinterest.btn-lg span,\n    .btn-group-lg > .btn-pinterest.btn span,\n    .btn-vk.btn-lg span,\n    .btn-group-lg > .btn-vk.btn span,\n    .btn-yahoo.btn-lg span,\n    .btn-group-lg > .btn-yahoo.btn span,\n    .btn-behance.btn-lg span,\n    .btn-group-lg > .btn-behance.btn span,\n    .btn-dropbox.btn-lg span,\n    .btn-group-lg > .btn-dropbox.btn span,\n    .btn-reddit.btn-lg span,\n    .btn-group-lg > .btn-reddit.btn span,\n    .btn-spotify.btn-lg span,\n    .btn-group-lg > .btn-spotify.btn span,\n    .btn-vine.btn-lg span,\n    .btn-group-lg > .btn-vine.btn span,\n    .btn-foursquare.btn-lg span,\n    .btn-group-lg > .btn-foursquare.btn span,\n    .btn-vimeo.btn-lg span,\n    .btn-group-lg > .btn-vimeo.btn span {\n      margin-left: 2.64062rem;\n}\n.btn-facebook.btn-lg.icon, .btn-group-lg > .btn-facebook.icon.btn,\n    .btn-twitter.btn-lg.icon,\n    .btn-group-lg > .btn-twitter.icon.btn,\n    .btn-linkedin.btn-lg.icon,\n    .btn-group-lg > .btn-linkedin.icon.btn,\n    .btn-flickr.btn-lg.icon,\n    .btn-group-lg > .btn-flickr.icon.btn,\n    .btn-tumblr.btn-lg.icon,\n    .btn-group-lg > .btn-tumblr.icon.btn,\n    .btn-xing.btn-lg.icon,\n    .btn-group-lg > .btn-xing.icon.btn,\n    .btn-github.btn-lg.icon,\n    .btn-group-lg > .btn-github.icon.btn,\n    .btn-html5.btn-lg.icon,\n    .btn-group-lg > .btn-html5.icon.btn,\n    .btn-openid.btn-lg.icon,\n    .btn-group-lg > .btn-openid.icon.btn,\n    .btn-stack-overflow.btn-lg.icon,\n    .btn-group-lg > .btn-stack-overflow.icon.btn,\n    .btn-youtube.btn-lg.icon,\n    .btn-group-lg > .btn-youtube.icon.btn,\n    .btn-css3.btn-lg.icon,\n    .btn-group-lg > .btn-css3.icon.btn,\n    .btn-dribbble.btn-lg.icon,\n    .btn-group-lg > .btn-dribbble.icon.btn,\n    .btn-google-plus.btn-lg.icon,\n    .btn-group-lg > .btn-google-plus.icon.btn,\n    .btn-instagram.btn-lg.icon,\n    .btn-group-lg > .btn-instagram.icon.btn,\n    .btn-pinterest.btn-lg.icon,\n    .btn-group-lg > .btn-pinterest.icon.btn,\n    .btn-vk.btn-lg.icon,\n    .btn-group-lg > .btn-vk.icon.btn,\n    .btn-yahoo.btn-lg.icon,\n    .btn-group-lg > .btn-yahoo.icon.btn,\n    .btn-behance.btn-lg.icon,\n    .btn-group-lg > .btn-behance.icon.btn,\n    .btn-dropbox.btn-lg.icon,\n    .btn-group-lg > .btn-dropbox.icon.btn,\n    .btn-reddit.btn-lg.icon,\n    .btn-group-lg > .btn-reddit.icon.btn,\n    .btn-spotify.btn-lg.icon,\n    .btn-group-lg > .btn-spotify.icon.btn,\n    .btn-vine.btn-lg.icon,\n    .btn-group-lg > .btn-vine.icon.btn,\n    .btn-foursquare.btn-lg.icon,\n    .btn-group-lg > .btn-foursquare.icon.btn,\n    .btn-vimeo.btn-lg.icon,\n    .btn-group-lg > .btn-vimeo.icon.btn {\n      width: 2.64062rem;\n      height: 2.64062rem;\n}\n.btn-facebook.btn-sm, .btn-group-sm > .btn-facebook.btn,\n  .btn-twitter.btn-sm,\n  .btn-group-sm > .btn-twitter.btn,\n  .btn-linkedin.btn-sm,\n  .btn-group-sm > .btn-linkedin.btn,\n  .btn-flickr.btn-sm,\n  .btn-group-sm > .btn-flickr.btn,\n  .btn-tumblr.btn-sm,\n  .btn-group-sm > .btn-tumblr.btn,\n  .btn-xing.btn-sm,\n  .btn-group-sm > .btn-xing.btn,\n  .btn-github.btn-sm,\n  .btn-group-sm > .btn-github.btn,\n  .btn-html5.btn-sm,\n  .btn-group-sm > .btn-html5.btn,\n  .btn-openid.btn-sm,\n  .btn-group-sm > .btn-openid.btn,\n  .btn-stack-overflow.btn-sm,\n  .btn-group-sm > .btn-stack-overflow.btn,\n  .btn-youtube.btn-sm,\n  .btn-group-sm > .btn-youtube.btn,\n  .btn-css3.btn-sm,\n  .btn-group-sm > .btn-css3.btn,\n  .btn-dribbble.btn-sm,\n  .btn-group-sm > .btn-dribbble.btn,\n  .btn-google-plus.btn-sm,\n  .btn-group-sm > .btn-google-plus.btn,\n  .btn-instagram.btn-sm,\n  .btn-group-sm > .btn-instagram.btn,\n  .btn-pinterest.btn-sm,\n  .btn-group-sm > .btn-pinterest.btn,\n  .btn-vk.btn-sm,\n  .btn-group-sm > .btn-vk.btn,\n  .btn-yahoo.btn-sm,\n  .btn-group-sm > .btn-yahoo.btn,\n  .btn-behance.btn-sm,\n  .btn-group-sm > .btn-behance.btn,\n  .btn-dropbox.btn-sm,\n  .btn-group-sm > .btn-dropbox.btn,\n  .btn-reddit.btn-sm,\n  .btn-group-sm > .btn-reddit.btn,\n  .btn-spotify.btn-sm,\n  .btn-group-sm > .btn-spotify.btn,\n  .btn-vine.btn-sm,\n  .btn-group-sm > .btn-vine.btn,\n  .btn-foursquare.btn-sm,\n  .btn-group-sm > .btn-foursquare.btn,\n  .btn-vimeo.btn-sm,\n  .btn-group-sm > .btn-vimeo.btn {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.76562rem;\n    line-height: 1.5;\n    border: 0;\n}\n.btn-facebook.btn-sm::before, .btn-group-sm > .btn-facebook.btn::before,\n    .btn-twitter.btn-sm::before,\n    .btn-group-sm > .btn-twitter.btn::before,\n    .btn-linkedin.btn-sm::before,\n    .btn-group-sm > .btn-linkedin.btn::before,\n    .btn-flickr.btn-sm::before,\n    .btn-group-sm > .btn-flickr.btn::before,\n    .btn-tumblr.btn-sm::before,\n    .btn-group-sm > .btn-tumblr.btn::before,\n    .btn-xing.btn-sm::before,\n    .btn-group-sm > .btn-xing.btn::before,\n    .btn-github.btn-sm::before,\n    .btn-group-sm > .btn-github.btn::before,\n    .btn-html5.btn-sm::before,\n    .btn-group-sm > .btn-html5.btn::before,\n    .btn-openid.btn-sm::before,\n    .btn-group-sm > .btn-openid.btn::before,\n    .btn-stack-overflow.btn-sm::before,\n    .btn-group-sm > .btn-stack-overflow.btn::before,\n    .btn-youtube.btn-sm::before,\n    .btn-group-sm > .btn-youtube.btn::before,\n    .btn-css3.btn-sm::before,\n    .btn-group-sm > .btn-css3.btn::before,\n    .btn-dribbble.btn-sm::before,\n    .btn-group-sm > .btn-dribbble.btn::before,\n    .btn-google-plus.btn-sm::before,\n    .btn-group-sm > .btn-google-plus.btn::before,\n    .btn-instagram.btn-sm::before,\n    .btn-group-sm > .btn-instagram.btn::before,\n    .btn-pinterest.btn-sm::before,\n    .btn-group-sm > .btn-pinterest.btn::before,\n    .btn-vk.btn-sm::before,\n    .btn-group-sm > .btn-vk.btn::before,\n    .btn-yahoo.btn-sm::before,\n    .btn-group-sm > .btn-yahoo.btn::before,\n    .btn-behance.btn-sm::before,\n    .btn-group-sm > .btn-behance.btn::before,\n    .btn-dropbox.btn-sm::before,\n    .btn-group-sm > .btn-dropbox.btn::before,\n    .btn-reddit.btn-sm::before,\n    .btn-group-sm > .btn-reddit.btn::before,\n    .btn-spotify.btn-sm::before,\n    .btn-group-sm > .btn-spotify.btn::before,\n    .btn-vine.btn-sm::before,\n    .btn-group-sm > .btn-vine.btn::before,\n    .btn-foursquare.btn-sm::before,\n    .btn-group-sm > .btn-foursquare.btn::before,\n    .btn-vimeo.btn-sm::before,\n    .btn-group-sm > .btn-vimeo.btn::before {\n      width: 1.64844rem;\n      height: 1.64844rem;\n      padding: 0.25rem 0;\n      font-size: 0.76562rem;\n      line-height: 1.5;\n}\n.btn-facebook.btn-sm span, .btn-group-sm > .btn-facebook.btn span,\n    .btn-twitter.btn-sm span,\n    .btn-group-sm > .btn-twitter.btn span,\n    .btn-linkedin.btn-sm span,\n    .btn-group-sm > .btn-linkedin.btn span,\n    .btn-flickr.btn-sm span,\n    .btn-group-sm > .btn-flickr.btn span,\n    .btn-tumblr.btn-sm span,\n    .btn-group-sm > .btn-tumblr.btn span,\n    .btn-xing.btn-sm span,\n    .btn-group-sm > .btn-xing.btn span,\n    .btn-github.btn-sm span,\n    .btn-group-sm > .btn-github.btn span,\n    .btn-html5.btn-sm span,\n    .btn-group-sm > .btn-html5.btn span,\n    .btn-openid.btn-sm span,\n    .btn-group-sm > .btn-openid.btn span,\n    .btn-stack-overflow.btn-sm span,\n    .btn-group-sm > .btn-stack-overflow.btn span,\n    .btn-youtube.btn-sm span,\n    .btn-group-sm > .btn-youtube.btn span,\n    .btn-css3.btn-sm span,\n    .btn-group-sm > .btn-css3.btn span,\n    .btn-dribbble.btn-sm span,\n    .btn-group-sm > .btn-dribbble.btn span,\n    .btn-google-plus.btn-sm span,\n    .btn-group-sm > .btn-google-plus.btn span,\n    .btn-instagram.btn-sm span,\n    .btn-group-sm > .btn-instagram.btn span,\n    .btn-pinterest.btn-sm span,\n    .btn-group-sm > .btn-pinterest.btn span,\n    .btn-vk.btn-sm span,\n    .btn-group-sm > .btn-vk.btn span,\n    .btn-yahoo.btn-sm span,\n    .btn-group-sm > .btn-yahoo.btn span,\n    .btn-behance.btn-sm span,\n    .btn-group-sm > .btn-behance.btn span,\n    .btn-dropbox.btn-sm span,\n    .btn-group-sm > .btn-dropbox.btn span,\n    .btn-reddit.btn-sm span,\n    .btn-group-sm > .btn-reddit.btn span,\n    .btn-spotify.btn-sm span,\n    .btn-group-sm > .btn-spotify.btn span,\n    .btn-vine.btn-sm span,\n    .btn-group-sm > .btn-vine.btn span,\n    .btn-foursquare.btn-sm span,\n    .btn-group-sm > .btn-foursquare.btn span,\n    .btn-vimeo.btn-sm span,\n    .btn-group-sm > .btn-vimeo.btn span {\n      margin-left: 1.64844rem;\n}\n.btn-facebook.btn-sm.icon, .btn-group-sm > .btn-facebook.icon.btn,\n    .btn-twitter.btn-sm.icon,\n    .btn-group-sm > .btn-twitter.icon.btn,\n    .btn-linkedin.btn-sm.icon,\n    .btn-group-sm > .btn-linkedin.icon.btn,\n    .btn-flickr.btn-sm.icon,\n    .btn-group-sm > .btn-flickr.icon.btn,\n    .btn-tumblr.btn-sm.icon,\n    .btn-group-sm > .btn-tumblr.icon.btn,\n    .btn-xing.btn-sm.icon,\n    .btn-group-sm > .btn-xing.icon.btn,\n    .btn-github.btn-sm.icon,\n    .btn-group-sm > .btn-github.icon.btn,\n    .btn-html5.btn-sm.icon,\n    .btn-group-sm > .btn-html5.icon.btn,\n    .btn-openid.btn-sm.icon,\n    .btn-group-sm > .btn-openid.icon.btn,\n    .btn-stack-overflow.btn-sm.icon,\n    .btn-group-sm > .btn-stack-overflow.icon.btn,\n    .btn-youtube.btn-sm.icon,\n    .btn-group-sm > .btn-youtube.icon.btn,\n    .btn-css3.btn-sm.icon,\n    .btn-group-sm > .btn-css3.icon.btn,\n    .btn-dribbble.btn-sm.icon,\n    .btn-group-sm > .btn-dribbble.icon.btn,\n    .btn-google-plus.btn-sm.icon,\n    .btn-group-sm > .btn-google-plus.icon.btn,\n    .btn-instagram.btn-sm.icon,\n    .btn-group-sm > .btn-instagram.icon.btn,\n    .btn-pinterest.btn-sm.icon,\n    .btn-group-sm > .btn-pinterest.icon.btn,\n    .btn-vk.btn-sm.icon,\n    .btn-group-sm > .btn-vk.icon.btn,\n    .btn-yahoo.btn-sm.icon,\n    .btn-group-sm > .btn-yahoo.icon.btn,\n    .btn-behance.btn-sm.icon,\n    .btn-group-sm > .btn-behance.icon.btn,\n    .btn-dropbox.btn-sm.icon,\n    .btn-group-sm > .btn-dropbox.icon.btn,\n    .btn-reddit.btn-sm.icon,\n    .btn-group-sm > .btn-reddit.icon.btn,\n    .btn-spotify.btn-sm.icon,\n    .btn-group-sm > .btn-spotify.icon.btn,\n    .btn-vine.btn-sm.icon,\n    .btn-group-sm > .btn-vine.icon.btn,\n    .btn-foursquare.btn-sm.icon,\n    .btn-group-sm > .btn-foursquare.icon.btn,\n    .btn-vimeo.btn-sm.icon,\n    .btn-group-sm > .btn-vimeo.icon.btn {\n      width: 1.64844rem;\n      height: 1.64844rem;\n}\n.btn-facebook {\n  background: #3b5998;\n}\n.btn-facebook::before {\n    content: \"\\F09A\";\n    background: #344e86;\n}\n.btn-facebook:hover {\n    background: #344e86;\n}\n.btn-facebook:hover::before {\n      background: #2d4373;\n}\n.btn-twitter {\n  background: #00aced;\n}\n.btn-twitter::before {\n    content: \"\\F099\";\n    background: #0099d4;\n}\n.btn-twitter:hover {\n    background: #0099d4;\n}\n.btn-twitter:hover::before {\n      background: #0087ba;\n}\n.btn-linkedin {\n  background: #4875b4;\n}\n.btn-linkedin::before {\n    content: \"\\F0E1\";\n    background: #4169a2;\n}\n.btn-linkedin:hover {\n    background: #4169a2;\n}\n.btn-linkedin:hover::before {\n      background: #395d90;\n}\n.btn-flickr {\n  background: #ff0084;\n}\n.btn-flickr::before {\n    content: \"\\F16E\";\n    background: #e60077;\n}\n.btn-flickr:hover {\n    background: #e60077;\n}\n.btn-flickr:hover::before {\n      background: #cc006a;\n}\n.btn-tumblr {\n  background: #32506d;\n}\n.btn-tumblr::before {\n    content: \"\\F173\";\n    background: #2a435c;\n}\n.btn-tumblr:hover {\n    background: #2a435c;\n}\n.btn-tumblr:hover::before {\n      background: #22364a;\n}\n.btn-xing {\n  background: #026466;\n}\n.btn-xing::before {\n    content: \"\\F168\";\n    background: #024b4d;\n}\n.btn-xing:hover {\n    background: #024b4d;\n}\n.btn-xing:hover::before {\n      background: #013334;\n}\n.btn-github {\n  background: #4183c4;\n}\n.btn-github::before {\n    content: \"\\F09B\";\n    background: #3876b4;\n}\n.btn-github:hover {\n    background: #3876b4;\n}\n.btn-github:hover::before {\n      background: #3269a0;\n}\n.btn-html5 {\n  background: #e34f26;\n}\n.btn-html5::before {\n    content: \"\\F13B\";\n    background: #d4431b;\n}\n.btn-html5:hover {\n    background: #d4431b;\n}\n.btn-html5:hover::before {\n      background: #be3c18;\n}\n.btn-openid {\n  background: #f78c40;\n}\n.btn-openid::before {\n    content: \"\\F19B\";\n    background: #f67d28;\n}\n.btn-openid:hover {\n    background: #f67d28;\n}\n.btn-openid:hover::before {\n      background: #f56f0f;\n}\n.btn-stack-overflow {\n  background: #fe7a15;\n}\n.btn-stack-overflow::before {\n    content: \"\\F16C\";\n    background: #f86c01;\n}\n.btn-stack-overflow:hover {\n    background: #f86c01;\n}\n.btn-stack-overflow:hover::before {\n      background: #df6101;\n}\n.btn-css3 {\n  background: #0170ba;\n}\n.btn-css3::before {\n    content: \"\\F13C\";\n    background: #0161a1;\n}\n.btn-css3:hover {\n    background: #0161a1;\n}\n.btn-css3:hover::before {\n      background: #015187;\n}\n.btn-youtube {\n  background: #b00;\n}\n.btn-youtube::before {\n    content: \"\\F167\";\n    background: #a20000;\n}\n.btn-youtube:hover {\n    background: #a20000;\n}\n.btn-youtube:hover::before {\n      background: #880000;\n}\n.btn-dribbble {\n  background: #ea4c89;\n}\n.btn-dribbble::before {\n    content: \"\\F17D\";\n    background: #e7357a;\n}\n.btn-dribbble:hover {\n    background: #e7357a;\n}\n.btn-dribbble:hover::before {\n      background: #e51e6b;\n}\n.btn-google-plus {\n  background: #d34836;\n}\n.btn-google-plus::before {\n    content: \"\\F0D5\";\n    background: #c43d2b;\n}\n.btn-google-plus:hover {\n    background: #c43d2b;\n}\n.btn-google-plus:hover::before {\n      background: #b03626;\n}\n.btn-instagram {\n  background: #517fa4;\n}\n.btn-instagram::before {\n    content: \"\\F16D\";\n    background: #497293;\n}\n.btn-instagram:hover {\n    background: #497293;\n}\n.btn-instagram:hover::before {\n      background: #406582;\n}\n.btn-pinterest {\n  background: #cb2027;\n}\n.btn-pinterest::before {\n    content: \"\\F0D2\";\n    background: #b51d23;\n}\n.btn-pinterest:hover {\n    background: #b51d23;\n}\n.btn-pinterest:hover::before {\n      background: #9f191f;\n}\n.btn-vk {\n  background: #45668e;\n}\n.btn-vk::before {\n    content: \"\\F189\";\n    background: #3d5a7d;\n}\n.btn-vk:hover {\n    background: #3d5a7d;\n}\n.btn-vk:hover::before {\n      background: #344d6c;\n}\n.btn-yahoo {\n  background: #400191;\n}\n.btn-yahoo::before {\n    content: \"\\F19E\";\n    background: #350178;\n}\n.btn-yahoo:hover {\n    background: #350178;\n}\n.btn-yahoo:hover::before {\n      background: #2a015e;\n}\n.btn-behance {\n  background: #1769ff;\n}\n.btn-behance::before {\n    content: \"\\F1B4\";\n    background: #0059fd;\n}\n.btn-behance:hover {\n    background: #0059fd;\n}\n.btn-behance:hover::before {\n      background: #0050e3;\n}\n.btn-dropbox {\n  background: #007ee5;\n}\n.btn-dropbox::before {\n    content: \"\\F16B\";\n    background: #0070cc;\n}\n.btn-dropbox:hover {\n    background: #0070cc;\n}\n.btn-dropbox:hover::before {\n      background: #0062b2;\n}\n.btn-reddit {\n  background: #ff4500;\n}\n.btn-reddit::before {\n    content: \"\\F1A1\";\n    background: #e63e00;\n}\n.btn-reddit:hover {\n    background: #e63e00;\n}\n.btn-reddit:hover::before {\n      background: #cc3700;\n}\n.btn-spotify {\n  background: #7ab800;\n}\n.btn-spotify::before {\n    content: \"\\F1BC\";\n    background: #699f00;\n}\n.btn-spotify:hover {\n    background: #699f00;\n}\n.btn-spotify:hover::before {\n      background: #588500;\n}\n.btn-vine {\n  background: #00bf8f;\n}\n.btn-vine::before {\n    content: \"\\F1CA\";\n    background: #00a67c;\n}\n.btn-vine:hover {\n    background: #00a67c;\n}\n.btn-vine:hover::before {\n      background: #008c69;\n}\n.btn-foursquare {\n  background: #1073af;\n}\n.btn-foursquare::before {\n    content: \"\\F180\";\n    background: #0e6498;\n}\n.btn-foursquare:hover {\n    background: #0e6498;\n}\n.btn-foursquare:hover::before {\n      background: #0c5480;\n}\n.btn-vimeo {\n  background: #aad450;\n}\n.btn-vimeo::before {\n    content: \"\\F194\";\n    background: #a0cf3c;\n}\n.btn-vimeo:hover {\n    background: #a0cf3c;\n}\n.btn-vimeo:hover::before {\n      background: #93c130;\n}\n.callout {\n  position: relative;\n  padding: 0 1rem;\n  margin: 1rem 0;\n  border: 0 solid #c2cfd6;\n  border-left-width: .25rem;\n}\n.callout .chart-wrapper {\n    position: absolute;\n    top: 10px;\n    left: 50%;\n    float: right;\n    width: 50%;\n}\n.callout-bordered {\n  border: 1px solid #c2cfd6;\n  border-left-width: .25rem;\n}\n.callout code {\n  border-radius: .25rem;\n}\n.callout h4 {\n  margin-top: 0;\n  margin-bottom: .25rem;\n}\n.callout p:last-child {\n  margin-bottom: 0;\n}\n.callout + .callout {\n  margin-top: -0.25rem;\n}\n.callout-default {\n  border-left-color: #536c79;\n}\n.callout-default h4 {\n    color: #536c79;\n}\n.callout-primary {\n  border-left-color: #20a8d8;\n}\n.callout-primary h4 {\n    color: #20a8d8;\n}\n.callout-secondary {\n  border-left-color: #a4b7c1;\n}\n.callout-secondary h4 {\n    color: #a4b7c1;\n}\n.callout-success {\n  border-left-color: #4dbd74;\n}\n.callout-success h4 {\n    color: #4dbd74;\n}\n.callout-info {\n  border-left-color: #63c2de;\n}\n.callout-info h4 {\n    color: #63c2de;\n}\n.callout-warning {\n  border-left-color: #ffc107;\n}\n.callout-warning h4 {\n    color: #ffc107;\n}\n.callout-danger {\n  border-left-color: #f86c6b;\n}\n.callout-danger h4 {\n    color: #f86c6b;\n}\n.callout-light {\n  border-left-color: #f0f3f5;\n}\n.callout-light h4 {\n    color: #f0f3f5;\n}\n.callout-dark {\n  border-left-color: #29363d;\n}\n.callout-dark h4 {\n    color: #29363d;\n}\n.callout-blue {\n  border-left-color: #20a8d8;\n}\n.callout-blue h4 {\n    color: #20a8d8;\n}\n.callout-indigo {\n  border-left-color: #6610f2;\n}\n.callout-indigo h4 {\n    color: #6610f2;\n}\n.callout-purple {\n  border-left-color: #6f42c1;\n}\n.callout-purple h4 {\n    color: #6f42c1;\n}\n.callout-pink {\n  border-left-color: #e83e8c;\n}\n.callout-pink h4 {\n    color: #e83e8c;\n}\n.callout-red {\n  border-left-color: #f86c6b;\n}\n.callout-red h4 {\n    color: #f86c6b;\n}\n.callout-orange {\n  border-left-color: #f8cb00;\n}\n.callout-orange h4 {\n    color: #f8cb00;\n}\n.callout-yellow {\n  border-left-color: #ffc107;\n}\n.callout-yellow h4 {\n    color: #ffc107;\n}\n.callout-green {\n  border-left-color: #4dbd74;\n}\n.callout-green h4 {\n    color: #4dbd74;\n}\n.callout-teal {\n  border-left-color: #20c997;\n}\n.callout-teal h4 {\n    color: #20c997;\n}\n.callout-cyan {\n  border-left-color: #63c2de;\n}\n.callout-cyan h4 {\n    color: #63c2de;\n}\n.callout-gray-100 {\n  border-left-color: #f0f3f5;\n}\n.callout-gray-100 h4 {\n    color: #f0f3f5;\n}\n.callout-gray-200 {\n  border-left-color: #c2cfd6;\n}\n.callout-gray-200 h4 {\n    color: #c2cfd6;\n}\n.callout-gray-300 {\n  border-left-color: #a4b7c1;\n}\n.callout-gray-300 h4 {\n    color: #a4b7c1;\n}\n.callout-gray-400 {\n  border-left-color: #869fac;\n}\n.callout-gray-400 h4 {\n    color: #869fac;\n}\n.callout-gray-500 {\n  border-left-color: #678898;\n}\n.callout-gray-500 h4 {\n    color: #678898;\n}\n.callout-gray-600 {\n  border-left-color: #536c79;\n}\n.callout-gray-600 h4 {\n    color: #536c79;\n}\n.callout-gray-700 {\n  border-left-color: #3e515b;\n}\n.callout-gray-700 h4 {\n    color: #3e515b;\n}\n.callout-gray-800 {\n  border-left-color: #29363d;\n}\n.callout-gray-800 h4 {\n    color: #29363d;\n}\n.callout-gray-900 {\n  border-left-color: #151b1e;\n}\n.callout-gray-900 h4 {\n    color: #151b1e;\n}\n.card {\n  margin-bottom: 1.5rem;\n}\n.card.bg-primary {\n    border-color: #187da0;\n}\n.card.bg-primary .card-header {\n      background-color: #1e9ecb;\n      border-color: #187da0;\n}\n.card.bg-secondary {\n    border-color: #7e99a7;\n}\n.card.bg-secondary .card-header {\n      background-color: #9bb0bb;\n      border-color: #7e99a7;\n}\n.card.bg-success {\n    border-color: #379457;\n}\n.card.bg-success .card-header {\n      background-color: #44b76c;\n      border-color: #379457;\n}\n.card.bg-info {\n    border-color: #2eadd3;\n}\n.card.bg-info .card-header {\n      background-color: #56bddb;\n      border-color: #2eadd3;\n}\n.card.bg-warning {\n    border-color: #c69500;\n}\n.card.bg-warning .card-header {\n      background-color: #f7b900;\n      border-color: #c69500;\n}\n.card.bg-danger {\n    border-color: #f5302e;\n}\n.card.bg-danger .card-header {\n      background-color: #f75d5c;\n      border-color: #f5302e;\n}\n.card.bg-light {\n    border-color: #cad4dc;\n}\n.card.bg-light .card-header {\n      background-color: #e7ecef;\n      border-color: #cad4dc;\n}\n.card.bg-dark {\n    border-color: #0f1417;\n}\n.card.bg-dark .card-header {\n      background-color: #232e34;\n      border-color: #0f1417;\n}\n.card.bg-blue {\n    border-color: #187da0;\n}\n.card.bg-blue .card-header {\n      background-color: #1e9ecb;\n      border-color: #187da0;\n}\n.card.bg-indigo {\n    border-color: #4c0ab8;\n}\n.card.bg-indigo .card-header {\n      background-color: #5f0de6;\n      border-color: #4c0ab8;\n}\n.card.bg-purple {\n    border-color: #533093;\n}\n.card.bg-purple .card-header {\n      background-color: #683cb8;\n      border-color: #533093;\n}\n.card.bg-pink {\n    border-color: #ce196c;\n}\n.card.bg-pink .card-header {\n      background-color: #e63084;\n      border-color: #ce196c;\n}\n.card.bg-red {\n    border-color: #f5302e;\n}\n.card.bg-red .card-header {\n      background-color: #f75d5c;\n      border-color: #f5302e;\n}\n.card.bg-orange {\n    border-color: #b89700;\n}\n.card.bg-orange .card-header {\n      background-color: #e9be00;\n      border-color: #b89700;\n}\n.card.bg-yellow {\n    border-color: #c69500;\n}\n.card.bg-yellow .card-header {\n      background-color: #f7b900;\n      border-color: #c69500;\n}\n.card.bg-green {\n    border-color: #379457;\n}\n.card.bg-green .card-header {\n      background-color: #44b76c;\n      border-color: #379457;\n}\n.card.bg-teal {\n    border-color: #17926e;\n}\n.card.bg-teal .card-header {\n      background-color: #1ebc8d;\n      border-color: #17926e;\n}\n.card.bg-cyan {\n    border-color: #2eadd3;\n}\n.card.bg-cyan .card-header {\n      background-color: #56bddb;\n      border-color: #2eadd3;\n}\n.card.bg-gray-100 {\n    border-color: #cad4dc;\n}\n.card.bg-gray-100 .card-header {\n      background-color: #e7ecef;\n      border-color: #cad4dc;\n}\n.card.bg-gray-200 {\n    border-color: #9cb1bc;\n}\n.card.bg-gray-200 .card-header {\n      background-color: #b9c8d0;\n      border-color: #9cb1bc;\n}\n.card.bg-gray-300 {\n    border-color: #7e99a7;\n}\n.card.bg-gray-300 .card-header {\n      background-color: #9bb0bb;\n      border-color: #7e99a7;\n}\n.card.bg-gray-400 {\n    border-color: #638090;\n}\n.card.bg-gray-400 .card-header {\n      background-color: #7d98a6;\n      border-color: #638090;\n}\n.card.bg-gray-500 {\n    border-color: #4d6672;\n}\n.card.bg-gray-500 .card-header {\n      background-color: #61808f;\n      border-color: #4d6672;\n}\n.card.bg-gray-600 {\n    border-color: #394a53;\n}\n.card.bg-gray-600 .card-header {\n      background-color: #4d6470;\n      border-color: #394a53;\n}\n.card.bg-gray-700 {\n    border-color: #242f35;\n}\n.card.bg-gray-700 .card-header {\n      background-color: #384952;\n      border-color: #242f35;\n}\n.card.bg-gray-800 {\n    border-color: #0f1417;\n}\n.card.bg-gray-800 .card-header {\n      background-color: #232e34;\n      border-color: #0f1417;\n}\n.card.bg-gray-900 {\n    border-color: black;\n}\n.card.bg-gray-900 .card-header {\n      background-color: #0f1315;\n      border-color: black;\n}\n.text-white .text-muted {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n.card-header .icon-bg {\n  display: inline-body;\n  padding: 0.75rem 1.25rem !important;\n  margin-top: -0.75rem;\n  margin-right: 1.25rem;\n  margin-bottom: -0.75rem;\n  margin-left: -1.25rem;\n  line-height: inherit;\n  color: #151b1e;\n  vertical-align: bottom;\n  background: transparent;\n  border-right: 1px solid #c2cfd6;\n}\n.card-header .nav.nav-tabs {\n  margin-top: -0.75rem;\n  margin-bottom: -0.75rem;\n  border-bottom: 0;\n}\n.card-header .nav.nav-tabs .nav-item {\n    border-top: 0;\n}\n.card-header .nav.nav-tabs .nav-link, .card-header .nav.nav-tabs .navbar .dropdown-toggle, .navbar .card-header .nav.nav-tabs .dropdown-toggle {\n    padding: 0.75rem 0.625rem;\n    color: #536c79;\n    border-top: 0;\n}\n.card-header .nav.nav-tabs .nav-link.active, .card-header .nav.nav-tabs .navbar .active.dropdown-toggle, .navbar .card-header .nav.nav-tabs .active.dropdown-toggle {\n      color: #151b1e;\n      background: #fff;\n}\n.card-header.card-header-inverse {\n  color: #fff;\n}\n.card-header .btn {\n  margin-top: -0.375rem;\n}\n.card-header .btn-sm, .card-header .btn-group-sm > .btn {\n  margin-top: -0.25rem;\n}\n.card-header .btn-lg, .card-header .btn-group-lg > .btn {\n  margin-top: -0.5rem;\n}\n.card-footer ul {\n  display: table;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  table-layout: fixed;\n}\n.card-footer ul li {\n    display: table-cell;\n    padding: 0 1.25rem;\n    text-align: center;\n}\n[class*=\"card-outline-\"] .card-body, [class*=\"card-outline-\"] .card-block {\n  background: #fff !important;\n}\n[class*=\"card-outline-\"].card-outline-top {\n  border-top-width: 2px;\n  border-right-color: #c2cfd6;\n  border-bottom-color: #c2cfd6;\n  border-left-color: #c2cfd6;\n}\n.card-accent-primary {\n  border-top-width: 2px;\n  border-top-color: #20a8d8;\n}\n.card-accent-secondary {\n  border-top-width: 2px;\n  border-top-color: #a4b7c1;\n}\n.card-accent-success {\n  border-top-width: 2px;\n  border-top-color: #4dbd74;\n}\n.card-accent-info {\n  border-top-width: 2px;\n  border-top-color: #63c2de;\n}\n.card-accent-warning {\n  border-top-width: 2px;\n  border-top-color: #ffc107;\n}\n.card-accent-danger {\n  border-top-width: 2px;\n  border-top-color: #f86c6b;\n}\n.card-accent-light {\n  border-top-width: 2px;\n  border-top-color: #f0f3f5;\n}\n.card-accent-dark {\n  border-top-width: 2px;\n  border-top-color: #29363d;\n}\n.card-accent-blue {\n  border-top-width: 2px;\n  border-top-color: #20a8d8;\n}\n.card-accent-indigo {\n  border-top-width: 2px;\n  border-top-color: #6610f2;\n}\n.card-accent-purple {\n  border-top-width: 2px;\n  border-top-color: #6f42c1;\n}\n.card-accent-pink {\n  border-top-width: 2px;\n  border-top-color: #e83e8c;\n}\n.card-accent-red {\n  border-top-width: 2px;\n  border-top-color: #f86c6b;\n}\n.card-accent-orange {\n  border-top-width: 2px;\n  border-top-color: #f8cb00;\n}\n.card-accent-yellow {\n  border-top-width: 2px;\n  border-top-color: #ffc107;\n}\n.card-accent-green {\n  border-top-width: 2px;\n  border-top-color: #4dbd74;\n}\n.card-accent-teal {\n  border-top-width: 2px;\n  border-top-color: #20c997;\n}\n.card-accent-cyan {\n  border-top-width: 2px;\n  border-top-color: #63c2de;\n}\n.card-accent-gray-100 {\n  border-top-width: 2px;\n  border-top-color: #f0f3f5;\n}\n.card-accent-gray-200 {\n  border-top-width: 2px;\n  border-top-color: #c2cfd6;\n}\n.card-accent-gray-300 {\n  border-top-width: 2px;\n  border-top-color: #a4b7c1;\n}\n.card-accent-gray-400 {\n  border-top-width: 2px;\n  border-top-color: #869fac;\n}\n.card-accent-gray-500 {\n  border-top-width: 2px;\n  border-top-color: #678898;\n}\n.card-accent-gray-600 {\n  border-top-width: 2px;\n  border-top-color: #536c79;\n}\n.card-accent-gray-700 {\n  border-top-width: 2px;\n  border-top-color: #3e515b;\n}\n.card-accent-gray-800 {\n  border-top-width: 2px;\n  border-top-color: #29363d;\n}\n.card-accent-gray-900 {\n  border-top-width: 2px;\n  border-top-color: #151b1e;\n}\n.card-header > i {\n  margin-right: 0.5rem;\n}\n.card-header .card-actions {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.card-header .card-actions a, .card-header .card-actions button {\n    display: block;\n    float: left;\n    width: 50px;\n    padding: 0.75rem 0;\n    margin: 0 !important;\n    color: #151b1e;\n    text-align: center;\n    background: transparent;\n    border: 0;\n    border-left: 1px solid #c2cfd6;\n    -webkit-box-shadow: 0;\n            box-shadow: 0;\n}\n.card-header .card-actions a:hover, .card-header .card-actions button:hover {\n      text-decoration: none;\n}\n.card-header .card-actions a [class^=\"icon-\"], .card-header .card-actions a [class*=\" icon-\"], .card-header .card-actions button [class^=\"icon-\"], .card-header .card-actions button [class*=\" icon-\"] {\n      display: inline-body;\n      vertical-align: middle;\n}\n.card-header .card-actions a i, .card-header .card-actions button i {\n      display: inline-body;\n      -webkit-transition: .4s;\n      transition: .4s;\n}\n.card-header .card-actions a .r180, .card-header .card-actions button .r180 {\n      -webkit-transform: rotate(180deg);\n              transform: rotate(180deg);\n}\n.card-header .card-actions .input-group {\n    width: 230px;\n    margin: 6px;\n}\n.card-header .card-actions .input-group .input-group-addon {\n      background: #fff;\n}\n.card-header .card-actions .input-group input {\n      border-left: 0;\n}\n.card-full {\n  margin-top: -1rem;\n  margin-right: -15px;\n  margin-left: -15px;\n  border: 0;\n  border-bottom: 1px solid #c2cfd6;\n}\n@media (min-width: 576px) {\n.card-columns.cols-2 {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n}\n}\n.card.drag, .card .drag {\n  cursor: move;\n}\n.card-placeholder {\n  background: rgba(0, 0, 0, 0.025);\n  border: 1px dashed #a4b7c1;\n}\n.chart-wrapper canvas {\n  width: 100% !important;\n}\nbase-chart.chart {\n  display: block !important;\n}\n.dropdown-item {\n  position: relative;\n  padding: 10px 20px;\n  border-bottom: 1px solid #c2cfd6;\n}\n.dropdown-item:last-child {\n    border-bottom: 0;\n}\n.dropdown-item i {\n    display: inline-block;\n    width: 20px;\n    margin-right: 10px;\n    margin-left: -10px;\n    color: #c2cfd6;\n    text-align: center;\n}\n.dropdown-item .badge {\n    position: absolute;\n    right: 10px;\n    margin-top: 2px;\n}\n.dropdown-header {\n  padding: 8px 20px;\n  background: #f0f3f5;\n  border-bottom: 1px solid #c2cfd6;\n}\n.dropdown-header .btn {\n    margin-top: -7px;\n    color: #536c79;\n}\n.dropdown-header .btn:hover {\n      color: #151b1e;\n}\n.dropdown-header .btn.pull-right {\n      margin-right: -20px;\n}\n.dropdown-menu-lg {\n  width: 250px;\n}\n.app-header .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.app-header .navbar-nav .dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.app-header .navbar-nav .dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n.app-footer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 0 1rem;\n  color: #151b1e;\n  background: #f0f3f5;\n  border-top: 1px solid #c2cfd6;\n}\n.row.row-equal {\n  padding-right: 7.5px;\n  padding-left: 7.5px;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.row.row-equal [class*=\"col-\"] {\n    padding-right: 7.5px;\n    padding-left: 7.5px;\n}\n.main .container-fluid {\n  padding: 0 30px;\n}\n.input-group-addon,\n.input-group-btn {\n  min-width: 40px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n#loading-bar,\n#loading-bar-spinner {\n  -webkit-pointer-events: none;\n  pointer-events: none;\n  -webkit-transition: 350ms linear all;\n  transition: 350ms linear all;\n}\n#loading-bar.ng-enter,\n#loading-bar.ng-leave.ng-leave-active,\n#loading-bar-spinner.ng-enter,\n#loading-bar-spinner.ng-leave.ng-leave-active {\n  opacity: 0;\n}\n#loading-bar.ng-enter.ng-enter-active,\n#loading-bar.ng-leave,\n#loading-bar-spinner.ng-enter.ng-enter-active,\n#loading-bar-spinner.ng-leave {\n  opacity: 1;\n}\n#loading-bar .bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 20002;\n  width: 100%;\n  height: 2px;\n  background: #20a8d8;\n  border-top-right-radius: 1px;\n  border-bottom-right-radius: 1px;\n  -webkit-transition: width 350ms;\n  transition: width 350ms;\n}\n#loading-bar .peg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 70px;\n  height: 2px;\n  border-radius: 100%;\n  -ms-box-shadow: #29d 1px 0 6px 1px;\n  -webkit-box-shadow: #29d 1px 0 6px 1px;\n  box-shadow: #29d 1px 0 6px 1px;\n  opacity: .45;\n}\n#loading-bar-spinner {\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  z-index: 10002;\n  display: block;\n}\n#loading-bar-spinner .spinner-icon {\n  width: 14px;\n  height: 14px;\n  border: solid 2px transparent;\n  border-top-color: #29d;\n  border-left-color: #29d;\n  border-radius: 50%;\n  -webkit-animation: loading-bar-spinner 400ms linear infinite;\n  animation: loading-bar-spinner 400ms linear infinite;\n}\n@-webkit-keyframes loading-bar-spinner {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes loading-bar-spinner {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n.pace {\n  -webkit-pointer-events: none;\n  pointer-events: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n      user-select: none;\n}\n.pace-inactive {\n  display: none;\n}\n.pace .pace-progress {\n  position: fixed;\n  top: 0;\n  right: 100%;\n  z-index: 2000;\n  width: 100%;\n  height: 2px;\n  background: #20a8d8;\n}\n.modal-primary .modal-content {\n  border-color: #20a8d8;\n}\n.modal-primary .modal-header {\n  color: #fff;\n  background-color: #20a8d8;\n}\n.modal-secondary .modal-content {\n  border-color: #a4b7c1;\n}\n.modal-secondary .modal-header {\n  color: #fff;\n  background-color: #a4b7c1;\n}\n.modal-success .modal-content {\n  border-color: #4dbd74;\n}\n.modal-success .modal-header {\n  color: #fff;\n  background-color: #4dbd74;\n}\n.modal-info .modal-content {\n  border-color: #63c2de;\n}\n.modal-info .modal-header {\n  color: #fff;\n  background-color: #63c2de;\n}\n.modal-warning .modal-content {\n  border-color: #ffc107;\n}\n.modal-warning .modal-header {\n  color: #fff;\n  background-color: #ffc107;\n}\n.modal-danger .modal-content {\n  border-color: #f86c6b;\n}\n.modal-danger .modal-header {\n  color: #fff;\n  background-color: #f86c6b;\n}\n.modal-light .modal-content {\n  border-color: #f0f3f5;\n}\n.modal-light .modal-header {\n  color: #fff;\n  background-color: #f0f3f5;\n}\n.modal-dark .modal-content {\n  border-color: #29363d;\n}\n.modal-dark .modal-header {\n  color: #fff;\n  background-color: #29363d;\n}\n.modal-blue .modal-content {\n  border-color: #20a8d8;\n}\n.modal-blue .modal-header {\n  color: #fff;\n  background-color: #20a8d8;\n}\n.modal-indigo .modal-content {\n  border-color: #6610f2;\n}\n.modal-indigo .modal-header {\n  color: #fff;\n  background-color: #6610f2;\n}\n.modal-purple .modal-content {\n  border-color: #6f42c1;\n}\n.modal-purple .modal-header {\n  color: #fff;\n  background-color: #6f42c1;\n}\n.modal-pink .modal-content {\n  border-color: #e83e8c;\n}\n.modal-pink .modal-header {\n  color: #fff;\n  background-color: #e83e8c;\n}\n.modal-red .modal-content {\n  border-color: #f86c6b;\n}\n.modal-red .modal-header {\n  color: #fff;\n  background-color: #f86c6b;\n}\n.modal-orange .modal-content {\n  border-color: #f8cb00;\n}\n.modal-orange .modal-header {\n  color: #fff;\n  background-color: #f8cb00;\n}\n.modal-yellow .modal-content {\n  border-color: #ffc107;\n}\n.modal-yellow .modal-header {\n  color: #fff;\n  background-color: #ffc107;\n}\n.modal-green .modal-content {\n  border-color: #4dbd74;\n}\n.modal-green .modal-header {\n  color: #fff;\n  background-color: #4dbd74;\n}\n.modal-teal .modal-content {\n  border-color: #20c997;\n}\n.modal-teal .modal-header {\n  color: #fff;\n  background-color: #20c997;\n}\n.modal-cyan .modal-content {\n  border-color: #63c2de;\n}\n.modal-cyan .modal-header {\n  color: #fff;\n  background-color: #63c2de;\n}\n.modal-gray-100 .modal-content {\n  border-color: #f0f3f5;\n}\n.modal-gray-100 .modal-header {\n  color: #fff;\n  background-color: #f0f3f5;\n}\n.modal-gray-200 .modal-content {\n  border-color: #c2cfd6;\n}\n.modal-gray-200 .modal-header {\n  color: #fff;\n  background-color: #c2cfd6;\n}\n.modal-gray-300 .modal-content {\n  border-color: #a4b7c1;\n}\n.modal-gray-300 .modal-header {\n  color: #fff;\n  background-color: #a4b7c1;\n}\n.modal-gray-400 .modal-content {\n  border-color: #869fac;\n}\n.modal-gray-400 .modal-header {\n  color: #fff;\n  background-color: #869fac;\n}\n.modal-gray-500 .modal-content {\n  border-color: #678898;\n}\n.modal-gray-500 .modal-header {\n  color: #fff;\n  background-color: #678898;\n}\n.modal-gray-600 .modal-content {\n  border-color: #536c79;\n}\n.modal-gray-600 .modal-header {\n  color: #fff;\n  background-color: #536c79;\n}\n.modal-gray-700 .modal-content {\n  border-color: #3e515b;\n}\n.modal-gray-700 .modal-header {\n  color: #fff;\n  background-color: #3e515b;\n}\n.modal-gray-800 .modal-content {\n  border-color: #29363d;\n}\n.modal-gray-800 .modal-header {\n  color: #fff;\n  background-color: #29363d;\n}\n.modal-gray-900 .modal-content {\n  border-color: #151b1e;\n}\n.modal-gray-900 .modal-header {\n  color: #fff;\n  background-color: #151b1e;\n}\n.nav-tabs .nav-link, .nav-tabs .navbar .dropdown-toggle, .navbar .nav-tabs .dropdown-toggle {\n  color: #536c79;\n}\n.nav-tabs .nav-link.active, .nav-tabs .navbar .active.dropdown-toggle, .navbar .nav-tabs .active.dropdown-toggle {\n    color: #29363d;\n    background: #fff;\n    border-color: #c2cfd6;\n    border-bottom-color: #fff;\n}\n.nav-tabs .nav-link.active:focus, .nav-tabs .navbar .active.dropdown-toggle:focus, .navbar .nav-tabs .active.dropdown-toggle:focus {\n      background: #fff;\n      border-color: #c2cfd6;\n      border-bottom-color: #fff;\n}\n.tab-content {\n  margin-top: -1px;\n  background: #fff;\n  border: 1px solid #c2cfd6;\n}\n.tab-content .tab-pane {\n    padding: 1rem;\n}\n.card-block .tab-content {\n  margin-top: 0;\n  border: 0;\n}\n.app-header.navbar {\n  position: relative;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  height: 55px;\n  padding: 0;\n  margin: 0;\n  background-color: #fff;\n  border-bottom: 1px solid #c2cfd6;\n}\n.app-header.navbar .navbar-brand {\n    display: inline-block;\n    width: 155px;\n    height: 55px;\n    padding: 0.5rem 1rem;\n    margin-right: 0;\n    background-color: #fff;\n    background-image: url(" + escape(__webpack_require__(1082)) + ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 70px auto;\n    border-bottom: 1px solid #c2cfd6;\n}\n.app-header.navbar .navbar-toggler {\n    min-width: 50px;\n    padding: 0.25rem 0;\n}\n.app-header.navbar .navbar-toggler:hover .navbar-toggler-icon {\n      background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%2329363d' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n.app-header.navbar .navbar-toggler-icon {\n    height: 23px;\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23536c79' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n.app-header.navbar .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.app-header.navbar .nav-item {\n    position: relative;\n    min-width: 50px;\n    margin: 0 !important;\n    text-align: center;\n}\n.app-header.navbar .nav-item button {\n      margin: 0 auto;\n}\n.app-header.navbar .nav-item .nav-link, .app-header.navbar .nav-item .dropdown-toggle {\n      padding-top: 0;\n      padding-bottom: 0;\n      background: 0;\n      border: 0;\n}\n.app-header.navbar .nav-item .nav-link .badge, .app-header.navbar .nav-item .dropdown-toggle .badge {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-top: -16px;\n        margin-left: 0;\n}\n.app-header.navbar .nav-item .nav-link > .img-avatar, .app-header.navbar .nav-item .dropdown-toggle > .img-avatar {\n        height: 35px;\n        margin: 0 10px;\n}\n.app-header.navbar .dropdown-menu {\n    padding-bottom: 0;\n    line-height: 1.5;\n}\n.app-header.navbar .dropdown-item {\n    min-width: 180px;\n}\n.navbar-brand {\n  color: #29363d;\n}\n.navbar-brand:focus, .navbar-brand:hover {\n    color: #29363d;\n}\n.navbar-nav .nav-link, .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-nav .dropdown-toggle {\n  color: #536c79;\n}\n.navbar-nav .nav-link:focus, .navbar-nav .navbar .dropdown-toggle:focus, .navbar .navbar-nav .dropdown-toggle:focus, .navbar-nav .nav-link:hover, .navbar-nav .navbar .dropdown-toggle:hover, .navbar .navbar-nav .dropdown-toggle:hover {\n    color: #29363d;\n}\n.navbar-nav .open > .nav-link, .navbar-nav .navbar .open > .dropdown-toggle, .navbar .navbar-nav .open > .dropdown-toggle, .navbar-nav .open > .nav-link:focus, .navbar-nav .navbar .open > .dropdown-toggle:focus, .navbar .navbar-nav .open > .dropdown-toggle:focus, .navbar-nav .open > .nav-link:hover, .navbar-nav .navbar .open > .dropdown-toggle:hover, .navbar .navbar-nav .open > .dropdown-toggle:hover,\n.navbar-nav .active > .nav-link,\n.navbar-nav .navbar .active > .dropdown-toggle,\n.navbar .navbar-nav .active > .dropdown-toggle,\n.navbar-nav .active > .nav-link:focus,\n.navbar-nav .navbar .active > .dropdown-toggle:focus,\n.navbar .navbar-nav .active > .dropdown-toggle:focus,\n.navbar-nav .active > .nav-link:hover,\n.navbar-nav .navbar .active > .dropdown-toggle:hover,\n.navbar .navbar-nav .active > .dropdown-toggle:hover,\n.navbar-nav .nav-link.open,\n.navbar-nav .navbar .open.dropdown-toggle,\n.navbar .navbar-nav .open.dropdown-toggle,\n.navbar-nav .nav-link.open:focus,\n.navbar-nav .navbar .open.dropdown-toggle:focus,\n.navbar .navbar-nav .open.dropdown-toggle:focus,\n.navbar-nav .nav-link.open:hover,\n.navbar-nav .navbar .open.dropdown-toggle:hover,\n.navbar .navbar-nav .open.dropdown-toggle:hover,\n.navbar-nav .nav-link.active,\n.navbar-nav .navbar .active.dropdown-toggle,\n.navbar .navbar-nav .active.dropdown-toggle,\n.navbar-nav .nav-link.active:focus,\n.navbar-nav .navbar .active.dropdown-toggle:focus,\n.navbar .navbar-nav .active.dropdown-toggle:focus,\n.navbar-nav .nav-link.active:hover,\n.navbar-nav .navbar .active.dropdown-toggle:hover,\n.navbar .navbar-nav .active.dropdown-toggle:hover {\n  color: #29363d;\n}\n.navbar-divider {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n@media (min-width: 992px) {\n.brand-minimized .app-header.navbar .navbar-brand {\n    width: 50px;\n    background-color: #fff;\n    background-image: url(" + escape(__webpack_require__(1083)) + ");\n    background-size: 24px;\n    border-bottom: 1px solid #c2cfd6;\n}\n}\n.progress-xs {\n  height: 4px;\n}\n.progress-sm {\n  height: 8px;\n}\n.progress-white {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n.progress-white .progress-bar {\n    background-color: #fff;\n}\n.sidebar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 0;\n  color: #fff;\n  background: #29363d;\n}\n.sidebar .sidebar-close {\n    position: absolute;\n    right: 0;\n    display: none;\n    padding: 0 1rem;\n    font-size: 24px;\n    font-weight: 800;\n    line-height: 55px;\n    color: #fff;\n    background: 0;\n    border: 0;\n    opacity: .8;\n}\n.sidebar .sidebar-close:hover {\n      opacity: 1;\n}\n.sidebar .sidebar-header {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    padding: 0.75rem 1rem;\n    text-align: center;\n    background: rgba(0, 0, 0, 0.2);\n}\n.sidebar .sidebar-form .form-control {\n    color: #fff;\n    background: #151b1f;\n    border: 0;\n}\n.sidebar .sidebar-form .form-control::-webkit-input-placeholder {\n      color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .sidebar-form .form-control::-moz-placeholder {\n      color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .sidebar-form .form-control::-ms-input-placeholder {\n      color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .sidebar-form .form-control::placeholder {\n      color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .sidebar-nav {\n    position: relative;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    width: 200px;\n}\n.sidebar .sidebar-nav::-webkit-scrollbar {\n      position: absolute;\n      width: 10px;\n      margin-left: -10px;\n      -webkit-appearance: none;\n}\n.sidebar .sidebar-nav::-webkit-scrollbar-track {\n      background-color: #33444c;\n      border-right: 1px solid #1f292e;\n      border-left: 1px solid #1f292e;\n}\n.sidebar .sidebar-nav::-webkit-scrollbar-thumb {\n      height: 50px;\n      background-color: #151b1f;\n      background-clip: content-box;\n      border-color: transparent;\n      border-style: solid;\n      border-width: 1px 2px;\n}\n.sidebar .nav {\n    width: 200px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    min-height: 100%;\n}\n.sidebar .nav-title {\n    padding: 0.75rem 1rem;\n    font-size: 11px;\n    font-weight: 600;\n    color: #c2cfd6;\n    text-transform: uppercase;\n}\n.sidebar .nav-divider, .sidebar .divider {\n    height: 10px;\n}\n.sidebar .nav-item {\n    position: relative;\n    margin: 0;\n    -webkit-transition: background .3s ease-in-out;\n    transition: background .3s ease-in-out;\n}\n.sidebar .nav-dropdown-items {\n    max-height: 0;\n    padding: 0;\n    margin: 0;\n    overflow-y: hidden;\n    -webkit-transition: max-height .3s ease-in-out;\n    transition: max-height .3s ease-in-out;\n}\n.sidebar .nav-dropdown-items .nav-item {\n      padding: 0;\n      list-style: none;\n}\n.sidebar .nav-link, .sidebar .navbar .dropdown-toggle, .navbar .sidebar .dropdown-toggle {\n    display: block;\n    padding: 0.75rem 1rem;\n    color: #fff;\n    text-decoration: none;\n    background: transparent;\n}\n.sidebar .nav-link i, .sidebar .navbar .dropdown-toggle i, .navbar .sidebar .dropdown-toggle i {\n      display: inline-block;\n      width: 20px;\n      margin: 0 0.5rem 0 0;\n      font-size: 14px;\n      color: #536c79;\n      text-align: center;\n}\n.sidebar .nav-link .badge, .sidebar .navbar .dropdown-toggle .badge, .navbar .sidebar .dropdown-toggle .badge {\n      float: right;\n      margin-top: 2px;\n}\n.sidebar .nav-link.active, .sidebar .navbar .active.dropdown-toggle, .navbar .sidebar .active.dropdown-toggle {\n      color: #fff;\n      background: #33444c;\n}\n.sidebar .nav-link.active i, .sidebar .navbar .active.dropdown-toggle i, .navbar .sidebar .active.dropdown-toggle i {\n        color: #20a8d8;\n}\n.sidebar .nav-link:hover, .sidebar .navbar .dropdown-toggle:hover, .navbar .sidebar .dropdown-toggle:hover {\n      color: #fff;\n      background: #20a8d8;\n}\n.sidebar .nav-link:hover i, .sidebar .navbar .dropdown-toggle:hover i, .navbar .sidebar .dropdown-toggle:hover i {\n        color: #fff;\n}\n.sidebar .nav-link:hover.nav-dropdown-toggle::before, .sidebar .navbar .dropdown-toggle:hover.nav-dropdown-toggle::before, .navbar .sidebar .dropdown-toggle:hover.nav-dropdown-toggle::before {\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23fff' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\");\n}\n.sidebar .nav-link.nav-link-primary, .sidebar .navbar .nav-link-primary.dropdown-toggle, .navbar .sidebar .nav-link-primary.dropdown-toggle {\n      background: #20a8d8;\n}\n.sidebar .nav-link.nav-link-primary i, .sidebar .navbar .nav-link-primary.dropdown-toggle i, .navbar .sidebar .nav-link-primary.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-primary:hover, .sidebar .navbar .nav-link-primary.dropdown-toggle:hover, .navbar .sidebar .nav-link-primary.dropdown-toggle:hover {\n        background: #1d97c2 !important;\n}\n.sidebar .nav-link.nav-link-primary:hover i, .sidebar .navbar .nav-link-primary.dropdown-toggle:hover i, .navbar .sidebar .nav-link-primary.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-secondary, .sidebar .navbar .nav-link-secondary.dropdown-toggle, .navbar .sidebar .nav-link-secondary.dropdown-toggle {\n      background: #a4b7c1;\n}\n.sidebar .nav-link.nav-link-secondary i, .sidebar .navbar .nav-link-secondary.dropdown-toggle i, .navbar .sidebar .nav-link-secondary.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-secondary:hover, .sidebar .navbar .nav-link-secondary.dropdown-toggle:hover, .navbar .sidebar .nav-link-secondary.dropdown-toggle:hover {\n        background: #95abb7 !important;\n}\n.sidebar .nav-link.nav-link-secondary:hover i, .sidebar .navbar .nav-link-secondary.dropdown-toggle:hover i, .navbar .sidebar .nav-link-secondary.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-success, .sidebar .navbar .nav-link-success.dropdown-toggle, .navbar .sidebar .nav-link-success.dropdown-toggle {\n      background: #4dbd74;\n}\n.sidebar .nav-link.nav-link-success i, .sidebar .navbar .nav-link-success.dropdown-toggle i, .navbar .sidebar .nav-link-success.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-success:hover, .sidebar .navbar .nav-link-success.dropdown-toggle:hover, .navbar .sidebar .nav-link-success.dropdown-toggle:hover {\n        background: #41af67 !important;\n}\n.sidebar .nav-link.nav-link-success:hover i, .sidebar .navbar .nav-link-success.dropdown-toggle:hover i, .navbar .sidebar .nav-link-success.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-info, .sidebar .navbar .nav-link-info.dropdown-toggle, .navbar .sidebar .nav-link-info.dropdown-toggle {\n      background: #63c2de;\n}\n.sidebar .nav-link.nav-link-info i, .sidebar .navbar .nav-link-info.dropdown-toggle i, .navbar .sidebar .nav-link-info.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-info:hover, .sidebar .navbar .nav-link-info.dropdown-toggle:hover, .navbar .sidebar .nav-link-info.dropdown-toggle:hover {\n        background: #4ebada !important;\n}\n.sidebar .nav-link.nav-link-info:hover i, .sidebar .navbar .nav-link-info.dropdown-toggle:hover i, .navbar .sidebar .nav-link-info.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-warning, .sidebar .navbar .nav-link-warning.dropdown-toggle, .navbar .sidebar .nav-link-warning.dropdown-toggle {\n      background: #ffc107;\n}\n.sidebar .nav-link.nav-link-warning i, .sidebar .navbar .nav-link-warning.dropdown-toggle i, .navbar .sidebar .nav-link-warning.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-warning:hover, .sidebar .navbar .nav-link-warning.dropdown-toggle:hover, .navbar .sidebar .nav-link-warning.dropdown-toggle:hover {\n        background: #edb100 !important;\n}\n.sidebar .nav-link.nav-link-warning:hover i, .sidebar .navbar .nav-link-warning.dropdown-toggle:hover i, .navbar .sidebar .nav-link-warning.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-danger, .sidebar .navbar .nav-link-danger.dropdown-toggle, .navbar .sidebar .nav-link-danger.dropdown-toggle {\n      background: #f86c6b;\n}\n.sidebar .nav-link.nav-link-danger i, .sidebar .navbar .nav-link-danger.dropdown-toggle i, .navbar .sidebar .nav-link-danger.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-danger:hover, .sidebar .navbar .nav-link-danger.dropdown-toggle:hover, .navbar .sidebar .nav-link-danger.dropdown-toggle:hover {\n        background: #f75453 !important;\n}\n.sidebar .nav-link.nav-link-danger:hover i, .sidebar .navbar .nav-link-danger.dropdown-toggle:hover i, .navbar .sidebar .nav-link-danger.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-light, .sidebar .navbar .nav-link-light.dropdown-toggle, .navbar .sidebar .nav-link-light.dropdown-toggle {\n      background: #f0f3f5;\n}\n.sidebar .nav-link.nav-link-light i, .sidebar .navbar .nav-link-light.dropdown-toggle i, .navbar .sidebar .nav-link-light.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-light:hover, .sidebar .navbar .nav-link-light.dropdown-toggle:hover, .navbar .sidebar .nav-link-light.dropdown-toggle:hover {\n        background: #e1e7eb !important;\n}\n.sidebar .nav-link.nav-link-light:hover i, .sidebar .navbar .nav-link-light.dropdown-toggle:hover i, .navbar .sidebar .nav-link-light.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-dark, .sidebar .navbar .nav-link-dark.dropdown-toggle, .navbar .sidebar .nav-link-dark.dropdown-toggle {\n      background: #29363d;\n}\n.sidebar .nav-link.nav-link-dark i, .sidebar .navbar .nav-link-dark.dropdown-toggle i, .navbar .sidebar .nav-link-dark.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-dark:hover, .sidebar .navbar .nav-link-dark.dropdown-toggle:hover, .navbar .sidebar .nav-link-dark.dropdown-toggle:hover {\n        background: #1f292e !important;\n}\n.sidebar .nav-link.nav-link-dark:hover i, .sidebar .navbar .nav-link-dark.dropdown-toggle:hover i, .navbar .sidebar .nav-link-dark.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-blue, .sidebar .navbar .nav-link-blue.dropdown-toggle, .navbar .sidebar .nav-link-blue.dropdown-toggle {\n      background: #20a8d8;\n}\n.sidebar .nav-link.nav-link-blue i, .sidebar .navbar .nav-link-blue.dropdown-toggle i, .navbar .sidebar .nav-link-blue.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-blue:hover, .sidebar .navbar .nav-link-blue.dropdown-toggle:hover, .navbar .sidebar .nav-link-blue.dropdown-toggle:hover {\n        background: #1d97c2 !important;\n}\n.sidebar .nav-link.nav-link-blue:hover i, .sidebar .navbar .nav-link-blue.dropdown-toggle:hover i, .navbar .sidebar .nav-link-blue.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-indigo, .sidebar .navbar .nav-link-indigo.dropdown-toggle, .navbar .sidebar .nav-link-indigo.dropdown-toggle {\n      background: #6610f2;\n}\n.sidebar .nav-link.nav-link-indigo i, .sidebar .navbar .nav-link-indigo.dropdown-toggle i, .navbar .sidebar .nav-link-indigo.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-indigo:hover, .sidebar .navbar .nav-link-indigo.dropdown-toggle:hover, .navbar .sidebar .nav-link-indigo.dropdown-toggle:hover {\n        background: #5b0cdd !important;\n}\n.sidebar .nav-link.nav-link-indigo:hover i, .sidebar .navbar .nav-link-indigo.dropdown-toggle:hover i, .navbar .sidebar .nav-link-indigo.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-purple, .sidebar .navbar .nav-link-purple.dropdown-toggle, .navbar .sidebar .nav-link-purple.dropdown-toggle {\n      background: #6f42c1;\n}\n.sidebar .nav-link.nav-link-purple i, .sidebar .navbar .nav-link-purple.dropdown-toggle i, .navbar .sidebar .nav-link-purple.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-purple:hover, .sidebar .navbar .nav-link-purple.dropdown-toggle:hover, .navbar .sidebar .nav-link-purple.dropdown-toggle:hover {\n        background: #643ab0 !important;\n}\n.sidebar .nav-link.nav-link-purple:hover i, .sidebar .navbar .nav-link-purple.dropdown-toggle:hover i, .navbar .sidebar .nav-link-purple.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-pink, .sidebar .navbar .nav-link-pink.dropdown-toggle, .navbar .sidebar .nav-link-pink.dropdown-toggle {\n      background: #e83e8c;\n}\n.sidebar .nav-link.nav-link-pink i, .sidebar .navbar .nav-link-pink.dropdown-toggle i, .navbar .sidebar .nav-link-pink.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-pink:hover, .sidebar .navbar .nav-link-pink.dropdown-toggle:hover, .navbar .sidebar .nav-link-pink.dropdown-toggle:hover {\n        background: #e5277e !important;\n}\n.sidebar .nav-link.nav-link-pink:hover i, .sidebar .navbar .nav-link-pink.dropdown-toggle:hover i, .navbar .sidebar .nav-link-pink.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-red, .sidebar .navbar .nav-link-red.dropdown-toggle, .navbar .sidebar .nav-link-red.dropdown-toggle {\n      background: #f86c6b;\n}\n.sidebar .nav-link.nav-link-red i, .sidebar .navbar .nav-link-red.dropdown-toggle i, .navbar .sidebar .nav-link-red.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-red:hover, .sidebar .navbar .nav-link-red.dropdown-toggle:hover, .navbar .sidebar .nav-link-red.dropdown-toggle:hover {\n        background: #f75453 !important;\n}\n.sidebar .nav-link.nav-link-red:hover i, .sidebar .navbar .nav-link-red.dropdown-toggle:hover i, .navbar .sidebar .nav-link-red.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-orange, .sidebar .navbar .nav-link-orange.dropdown-toggle, .navbar .sidebar .nav-link-orange.dropdown-toggle {\n      background: #f8cb00;\n}\n.sidebar .nav-link.nav-link-orange i, .sidebar .navbar .nav-link-orange.dropdown-toggle i, .navbar .sidebar .nav-link-orange.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-orange:hover, .sidebar .navbar .nav-link-orange.dropdown-toggle:hover, .navbar .sidebar .nav-link-orange.dropdown-toggle:hover {\n        background: #dfb600 !important;\n}\n.sidebar .nav-link.nav-link-orange:hover i, .sidebar .navbar .nav-link-orange.dropdown-toggle:hover i, .navbar .sidebar .nav-link-orange.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-yellow, .sidebar .navbar .nav-link-yellow.dropdown-toggle, .navbar .sidebar .nav-link-yellow.dropdown-toggle {\n      background: #ffc107;\n}\n.sidebar .nav-link.nav-link-yellow i, .sidebar .navbar .nav-link-yellow.dropdown-toggle i, .navbar .sidebar .nav-link-yellow.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-yellow:hover, .sidebar .navbar .nav-link-yellow.dropdown-toggle:hover, .navbar .sidebar .nav-link-yellow.dropdown-toggle:hover {\n        background: #edb100 !important;\n}\n.sidebar .nav-link.nav-link-yellow:hover i, .sidebar .navbar .nav-link-yellow.dropdown-toggle:hover i, .navbar .sidebar .nav-link-yellow.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-green, .sidebar .navbar .nav-link-green.dropdown-toggle, .navbar .sidebar .nav-link-green.dropdown-toggle {\n      background: #4dbd74;\n}\n.sidebar .nav-link.nav-link-green i, .sidebar .navbar .nav-link-green.dropdown-toggle i, .navbar .sidebar .nav-link-green.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-green:hover, .sidebar .navbar .nav-link-green.dropdown-toggle:hover, .navbar .sidebar .nav-link-green.dropdown-toggle:hover {\n        background: #41af67 !important;\n}\n.sidebar .nav-link.nav-link-green:hover i, .sidebar .navbar .nav-link-green.dropdown-toggle:hover i, .navbar .sidebar .nav-link-green.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-teal, .sidebar .navbar .nav-link-teal.dropdown-toggle, .navbar .sidebar .nav-link-teal.dropdown-toggle {\n      background: #20c997;\n}\n.sidebar .nav-link.nav-link-teal i, .sidebar .navbar .nav-link-teal.dropdown-toggle i, .navbar .sidebar .nav-link-teal.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-teal:hover, .sidebar .navbar .nav-link-teal.dropdown-toggle:hover, .navbar .sidebar .nav-link-teal.dropdown-toggle:hover {\n        background: #1cb386 !important;\n}\n.sidebar .nav-link.nav-link-teal:hover i, .sidebar .navbar .nav-link-teal.dropdown-toggle:hover i, .navbar .sidebar .nav-link-teal.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-cyan, .sidebar .navbar .nav-link-cyan.dropdown-toggle, .navbar .sidebar .nav-link-cyan.dropdown-toggle {\n      background: #63c2de;\n}\n.sidebar .nav-link.nav-link-cyan i, .sidebar .navbar .nav-link-cyan.dropdown-toggle i, .navbar .sidebar .nav-link-cyan.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-cyan:hover, .sidebar .navbar .nav-link-cyan.dropdown-toggle:hover, .navbar .sidebar .nav-link-cyan.dropdown-toggle:hover {\n        background: #4ebada !important;\n}\n.sidebar .nav-link.nav-link-cyan:hover i, .sidebar .navbar .nav-link-cyan.dropdown-toggle:hover i, .navbar .sidebar .nav-link-cyan.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-100, .sidebar .navbar .nav-link-gray-100.dropdown-toggle, .navbar .sidebar .nav-link-gray-100.dropdown-toggle {\n      background: #f0f3f5;\n}\n.sidebar .nav-link.nav-link-gray-100 i, .sidebar .navbar .nav-link-gray-100.dropdown-toggle i, .navbar .sidebar .nav-link-gray-100.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-100:hover, .sidebar .navbar .nav-link-gray-100.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-100.dropdown-toggle:hover {\n        background: #e1e7eb !important;\n}\n.sidebar .nav-link.nav-link-gray-100:hover i, .sidebar .navbar .nav-link-gray-100.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-100.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-200, .sidebar .navbar .nav-link-gray-200.dropdown-toggle, .navbar .sidebar .nav-link-gray-200.dropdown-toggle {\n      background: #c2cfd6;\n}\n.sidebar .nav-link.nav-link-gray-200 i, .sidebar .navbar .nav-link-gray-200.dropdown-toggle i, .navbar .sidebar .nav-link-gray-200.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-200:hover, .sidebar .navbar .nav-link-gray-200.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-200.dropdown-toggle:hover {\n        background: #b3c3cc !important;\n}\n.sidebar .nav-link.nav-link-gray-200:hover i, .sidebar .navbar .nav-link-gray-200.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-200.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-300, .sidebar .navbar .nav-link-gray-300.dropdown-toggle, .navbar .sidebar .nav-link-gray-300.dropdown-toggle {\n      background: #a4b7c1;\n}\n.sidebar .nav-link.nav-link-gray-300 i, .sidebar .navbar .nav-link-gray-300.dropdown-toggle i, .navbar .sidebar .nav-link-gray-300.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-300:hover, .sidebar .navbar .nav-link-gray-300.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-300.dropdown-toggle:hover {\n        background: #95abb7 !important;\n}\n.sidebar .nav-link.nav-link-gray-300:hover i, .sidebar .navbar .nav-link-gray-300.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-300.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-400, .sidebar .navbar .nav-link-gray-400.dropdown-toggle, .navbar .sidebar .nav-link-gray-400.dropdown-toggle {\n      background: #869fac;\n}\n.sidebar .nav-link.nav-link-gray-400 i, .sidebar .navbar .nav-link-gray-400.dropdown-toggle i, .navbar .sidebar .nav-link-gray-400.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-400:hover, .sidebar .navbar .nav-link-gray-400.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-400.dropdown-toggle:hover {\n        background: #7793a2 !important;\n}\n.sidebar .nav-link.nav-link-gray-400:hover i, .sidebar .navbar .nav-link-gray-400.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-400.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-500, .sidebar .navbar .nav-link-gray-500.dropdown-toggle, .navbar .sidebar .nav-link-gray-500.dropdown-toggle {\n      background: #678898;\n}\n.sidebar .nav-link.nav-link-gray-500 i, .sidebar .navbar .nav-link-gray-500.dropdown-toggle i, .navbar .sidebar .nav-link-gray-500.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-500:hover, .sidebar .navbar .nav-link-gray-500.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-500.dropdown-toggle:hover {\n        background: #5d7a89 !important;\n}\n.sidebar .nav-link.nav-link-gray-500:hover i, .sidebar .navbar .nav-link-gray-500.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-500.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-600, .sidebar .navbar .nav-link-gray-600.dropdown-toggle, .navbar .sidebar .nav-link-gray-600.dropdown-toggle {\n      background: #536c79;\n}\n.sidebar .nav-link.nav-link-gray-600 i, .sidebar .navbar .nav-link-gray-600.dropdown-toggle i, .navbar .sidebar .nav-link-gray-600.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-600:hover, .sidebar .navbar .nav-link-gray-600.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-600.dropdown-toggle:hover {\n        background: #495f6a !important;\n}\n.sidebar .nav-link.nav-link-gray-600:hover i, .sidebar .navbar .nav-link-gray-600.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-600.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-700, .sidebar .navbar .nav-link-gray-700.dropdown-toggle, .navbar .sidebar .nav-link-gray-700.dropdown-toggle {\n      background: #3e515b;\n}\n.sidebar .nav-link.nav-link-gray-700 i, .sidebar .navbar .nav-link-gray-700.dropdown-toggle i, .navbar .sidebar .nav-link-gray-700.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-700:hover, .sidebar .navbar .nav-link-gray-700.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-700.dropdown-toggle:hover {\n        background: #34444c !important;\n}\n.sidebar .nav-link.nav-link-gray-700:hover i, .sidebar .navbar .nav-link-gray-700.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-700.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-800, .sidebar .navbar .nav-link-gray-800.dropdown-toggle, .navbar .sidebar .nav-link-gray-800.dropdown-toggle {\n      background: #29363d;\n}\n.sidebar .nav-link.nav-link-gray-800 i, .sidebar .navbar .nav-link-gray-800.dropdown-toggle i, .navbar .sidebar .nav-link-gray-800.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-800:hover, .sidebar .navbar .nav-link-gray-800.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-800.dropdown-toggle:hover {\n        background: #1f292e !important;\n}\n.sidebar .nav-link.nav-link-gray-800:hover i, .sidebar .navbar .nav-link-gray-800.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-800.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-link.nav-link-gray-900, .sidebar .navbar .nav-link-gray-900.dropdown-toggle, .navbar .sidebar .nav-link-gray-900.dropdown-toggle {\n      background: #151b1e;\n}\n.sidebar .nav-link.nav-link-gray-900 i, .sidebar .navbar .nav-link-gray-900.dropdown-toggle i, .navbar .sidebar .nav-link-gray-900.dropdown-toggle i {\n        color: rgba(255, 255, 255, 0.7);\n}\n.sidebar .nav-link.nav-link-gray-900:hover, .sidebar .navbar .nav-link-gray-900.dropdown-toggle:hover, .navbar .sidebar .nav-link-gray-900.dropdown-toggle:hover {\n        background: #0b0e0f !important;\n}\n.sidebar .nav-link.nav-link-gray-900:hover i, .sidebar .navbar .nav-link-gray-900.dropdown-toggle:hover i, .navbar .sidebar .nav-link-gray-900.dropdown-toggle:hover i {\n          color: #fff;\n}\n.sidebar .nav-dropdown-toggle {\n    position: relative;\n}\n.sidebar .nav-dropdown-toggle::before {\n      position: absolute;\n      top: 50%;\n      right: 1rem;\n      display: block;\n      width: 8px;\n      height: 8px;\n      padding: 0;\n      margin-top: -4px;\n      content: \"\";\n      background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23536c79' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: center;\n      -webkit-transition: -webkit-transform .3s;\n      transition: -webkit-transform .3s;\n      transition: transform .3s;\n      transition: transform .3s, -webkit-transform .3s;\n}\n.sidebar .nav-dropdown.open {\n    background: rgba(0, 0, 0, 0.2);\n}\n.sidebar .nav-dropdown.open > .nav-dropdown-items {\n      max-height: 1500px;\n}\n.sidebar .nav-dropdown.open .nav-link, .sidebar .nav-dropdown.open .navbar .dropdown-toggle, .navbar .sidebar .nav-dropdown.open .dropdown-toggle {\n      color: #fff;\n      border-left: 0 !important;\n}\n.sidebar .nav-dropdown.open > .nav-link.nav-dropdown-toggle::before, .sidebar .navbar .nav-dropdown.open > .nav-dropdown-toggle.dropdown-toggle::before, .navbar .sidebar .nav-dropdown.open > .nav-dropdown-toggle.dropdown-toggle::before {\n      -webkit-transform: rotate(-90deg);\n              transform: rotate(-90deg);\n}\n.sidebar .nav-dropdown.open .nav-dropdown.open {\n      border-left: 0;\n}\n.sidebar .nav-label {\n    display: block;\n    padding: 0.09375rem 1rem;\n    color: #c2cfd6;\n}\n.sidebar .nav-label:hover {\n      color: #fff;\n      text-decoration: none;\n}\n.sidebar .nav-label i {\n      width: 20px;\n      margin: -3px 0.5rem 0 0;\n      font-size: 10px;\n      color: #536c79;\n      text-align: center;\n      vertical-align: middle;\n}\n.sidebar .progress {\n    background-color: #485f6b !important;\n}\n.sidebar .sidebar-footer {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n            flex: 0 0 auto;\n    padding: 0.75rem 1rem;\n    background: rgba(0, 0, 0, 0.2);\n}\n.sidebar .sidebar-minimizer {\n    position: relative;\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50px;\n            flex: 0 0 50px;\n    background-color: rgba(0, 0, 0, 0.2);\n    border: 0;\n}\n.sidebar .sidebar-minimizer::before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 50px;\n      height: 50px;\n      content: \"\";\n      background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23536c79' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\");\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: 12.5px;\n      -webkit-transition: .3s;\n      transition: .3s;\n}\n.sidebar .sidebar-minimizer:focus, .sidebar .sidebar-minimizer.focus {\n      outline: 0;\n}\n.sidebar .sidebar-minimizer:hover {\n      background-color: rgba(0, 0, 0, 0.3);\n}\n.sidebar .sidebar-minimizer:hover::before {\n        background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23fff' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\");\n}\n@media (min-width: 992px) {\n.sidebar-compact .sidebar .sidebar-nav {\n    width: 150px;\n}\n.sidebar-compact .sidebar .nav {\n    width: 150px;\n}\n.sidebar-compact .sidebar .nav .nav-title {\n      text-align: center;\n}\n.sidebar-compact .sidebar .nav .nav-item {\n      width: 150px;\n      border-left: 0 !important;\n}\n.sidebar-compact .sidebar .nav .nav-item .nav-link, .sidebar-compact .sidebar .nav .nav-item .navbar .dropdown-toggle, .navbar .sidebar-compact .sidebar .nav .nav-item .dropdown-toggle {\n        text-align: center;\n}\n.sidebar-compact .sidebar .nav .nav-item .nav-link i, .sidebar-compact .sidebar .nav .nav-item .navbar .dropdown-toggle i, .navbar .sidebar-compact .sidebar .nav .nav-item .dropdown-toggle i {\n          display: block;\n          width: 100%;\n          margin: 0.25rem 0;\n          font-size: 24px;\n}\n.sidebar-compact .sidebar .nav .nav-item .nav-link .badge, .sidebar-compact .sidebar .nav .nav-item .navbar .dropdown-toggle .badge, .navbar .sidebar-compact .sidebar .nav .nav-item .dropdown-toggle .badge {\n          position: absolute;\n          top: 18px;\n          right: 10px;\n}\n.sidebar-compact .sidebar .nav .nav-item .nav-link.nav-dropdown-toggle::before, .sidebar-compact .sidebar .nav .nav-item .navbar .nav-dropdown-toggle.dropdown-toggle::before, .navbar .sidebar-compact .sidebar .nav .nav-item .nav-dropdown-toggle.dropdown-toggle::before {\n          top: 30px;\n}\n.sidebar-minimized .hidden-cn {\n    display: none;\n}\n.sidebar-minimized .sidebar {\n    z-index: 1019;\n}\n.sidebar-minimized .sidebar .sidebar-nav {\n      overflow: visible;\n      width: 50px;\n}\n.sidebar-minimized .sidebar .nav {\n      width: 50px;\n}\n.sidebar-minimized .sidebar .nav-divider, .sidebar-minimized .sidebar .divider,\n    .sidebar-minimized .sidebar .nav-title,\n    .sidebar-minimized .sidebar .sidebar-footer,\n    .sidebar-minimized .sidebar .sidebar-form,\n    .sidebar-minimized .sidebar .sidebar-header {\n      display: none;\n}\n.sidebar-minimized .sidebar .sidebar-minimizer::before {\n      width: 100%;\n      -webkit-transform: rotate(-180deg);\n              transform: rotate(-180deg);\n}\n.sidebar-minimized .sidebar .nav-item {\n      width: 50px;\n      overflow: hidden;\n      border-left: 0 !important;\n}\n.sidebar-minimized .sidebar .nav-item:hover {\n        width: 250px;\n        overflow: visible;\n}\n.sidebar-minimized .sidebar .nav-item:hover > .nav-link, .sidebar-minimized .sidebar .navbar .nav-item:hover > .dropdown-toggle, .navbar .sidebar-minimized .sidebar .nav-item:hover > .dropdown-toggle {\n          background: #20a8d8;\n}\n.sidebar-minimized .sidebar .nav-item:hover > .nav-link i, .sidebar-minimized .sidebar .navbar .nav-item:hover > .dropdown-toggle i, .navbar .sidebar-minimized .sidebar .nav-item:hover > .dropdown-toggle i {\n            color: #fff;\n}\n.sidebar-minimized .sidebar .nav-link, .sidebar-minimized .sidebar .navbar .dropdown-toggle, .navbar .sidebar-minimized .sidebar .dropdown-toggle {\n      position: relative;\n      padding-left: 0;\n      margin: 0;\n      white-space: nowrap;\n      border-left: 0 !important;\n}\n.sidebar-minimized .sidebar .nav-link i, .sidebar-minimized .sidebar .navbar .dropdown-toggle i, .navbar .sidebar-minimized .sidebar .dropdown-toggle i {\n        display: block;\n        float: left;\n        width: 50px;\n        font-size: 18px;\n}\n.sidebar-minimized .sidebar .nav-link .badge, .sidebar-minimized .sidebar .navbar .dropdown-toggle .badge, .navbar .sidebar-minimized .sidebar .dropdown-toggle .badge {\n        position: absolute;\n        right: 15px;\n        display: none;\n}\n.sidebar-minimized .sidebar .nav-link:hover, .sidebar-minimized .sidebar .navbar .dropdown-toggle:hover, .navbar .sidebar-minimized .sidebar .dropdown-toggle:hover {\n        width: 250px;\n        background: #20a8d8;\n}\n.sidebar-minimized .sidebar .nav-link:hover .badge, .sidebar-minimized .sidebar .navbar .dropdown-toggle:hover .badge, .navbar .sidebar-minimized .sidebar .dropdown-toggle:hover .badge {\n          display: inline;\n}\n.sidebar-minimized .sidebar .nav-link.nav-dropdown-toggle::before, .sidebar-minimized .sidebar .navbar .nav-dropdown-toggle.dropdown-toggle::before, .navbar .sidebar-minimized .sidebar .nav-dropdown-toggle.dropdown-toggle::before {\n        display: none;\n}\n.sidebar-minimized .sidebar .nav-dropdown-items .nav-item {\n      width: 200px;\n}\n.sidebar-minimized .sidebar .nav-dropdown-items .nav-item .nav-link, .sidebar-minimized .sidebar .nav-dropdown-items .nav-item .navbar .dropdown-toggle, .navbar .sidebar-minimized .sidebar .nav-dropdown-items .nav-item .dropdown-toggle {\n        width: 200px;\n}\n.sidebar-minimized .sidebar .nav > .nav-dropdown > .nav-dropdown-items {\n      display: none;\n      max-height: 1000px;\n      background: #29363d;\n}\n.sidebar-minimized .sidebar .nav > .nav-dropdown:hover {\n      background: #20a8d8;\n}\n.sidebar-minimized .sidebar .nav > .nav-dropdown:hover > .nav-dropdown-items {\n        position: absolute;\n        left: 50px;\n        display: inline;\n}\n}\n.switch.switch-default {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 40px;\n  height: 24px;\n  background-color: transparent;\n  cursor: pointer;\n}\n.switch.switch-default .switch-input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n.switch.switch-default .switch-label {\n    position: relative;\n    display: block;\n    height: inherit;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background-color: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 2px;\n    -webkit-transition: opacity background .15s ease-out;\n    transition: opacity background .15s ease-out;\n}\n.switch.switch-default .switch-input:checked ~ .switch-label::before {\n    opacity: 0;\n}\n.switch.switch-default .switch-input:checked ~ .switch-label::after {\n    opacity: 1;\n}\n.switch.switch-default .switch-handle {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 1px;\n    -webkit-transition: left .15s ease-out;\n    transition: left .15s ease-out;\n}\n.switch.switch-default .switch-input:checked ~ .switch-handle {\n    left: 18px;\n}\n.switch.switch-default.switch-lg {\n    width: 48px;\n    height: 28px;\n}\n.switch.switch-default.switch-lg .switch-label {\n      font-size: 12px;\n}\n.switch.switch-default.switch-lg .switch-handle {\n      width: 24px;\n      height: 24px;\n}\n.switch.switch-default.switch-lg .switch-input:checked ~ .switch-handle {\n      left: 22px;\n}\n.switch.switch-default.switch-sm {\n    width: 32px;\n    height: 20px;\n}\n.switch.switch-default.switch-sm .switch-label {\n      font-size: 8px;\n}\n.switch.switch-default.switch-sm .switch-handle {\n      width: 16px;\n      height: 16px;\n}\n.switch.switch-default.switch-sm .switch-input:checked ~ .switch-handle {\n      left: 14px;\n}\n.switch.switch-default.switch-xs {\n    width: 24px;\n    height: 16px;\n}\n.switch.switch-default.switch-xs .switch-label {\n      font-size: 7px;\n}\n.switch.switch-default.switch-xs .switch-handle {\n      width: 12px;\n      height: 12px;\n}\n.switch.switch-default.switch-xs .switch-input:checked ~ .switch-handle {\n      left: 10px;\n}\n.switch.switch-text {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 48px;\n  height: 24px;\n  background-color: transparent;\n  cursor: pointer;\n}\n.switch.switch-text .switch-input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n.switch.switch-text .switch-label {\n    position: relative;\n    display: block;\n    height: inherit;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background-color: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 2px;\n    -webkit-transition: opacity background .15s ease-out;\n    transition: opacity background .15s ease-out;\n}\n.switch.switch-text .switch-label::before,\n  .switch.switch-text .switch-label::after {\n    position: absolute;\n    top: 50%;\n    width: 50%;\n    margin-top: -.5em;\n    line-height: 1;\n    text-align: center;\n    -webkit-transition: inherit;\n    transition: inherit;\n}\n.switch.switch-text .switch-label::before {\n    right: 1px;\n    color: #c2cfd6;\n    content: attr(data-off);\n}\n.switch.switch-text .switch-label::after {\n    left: 1px;\n    color: #fff;\n    content: attr(data-on);\n    opacity: 0;\n}\n.switch.switch-text .switch-input:checked ~ .switch-label::before {\n    opacity: 0;\n}\n.switch.switch-text .switch-input:checked ~ .switch-label::after {\n    opacity: 1;\n}\n.switch.switch-text .switch-handle {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 1px;\n    -webkit-transition: left .15s ease-out;\n    transition: left .15s ease-out;\n}\n.switch.switch-text .switch-input:checked ~ .switch-handle {\n    left: 26px;\n}\n.switch.switch-text.switch-lg {\n    width: 56px;\n    height: 28px;\n}\n.switch.switch-text.switch-lg .switch-label {\n      font-size: 12px;\n}\n.switch.switch-text.switch-lg .switch-handle {\n      width: 24px;\n      height: 24px;\n}\n.switch.switch-text.switch-lg .switch-input:checked ~ .switch-handle {\n      left: 30px;\n}\n.switch.switch-text.switch-sm {\n    width: 40px;\n    height: 20px;\n}\n.switch.switch-text.switch-sm .switch-label {\n      font-size: 8px;\n}\n.switch.switch-text.switch-sm .switch-handle {\n      width: 16px;\n      height: 16px;\n}\n.switch.switch-text.switch-sm .switch-input:checked ~ .switch-handle {\n      left: 22px;\n}\n.switch.switch-text.switch-xs {\n    width: 32px;\n    height: 16px;\n}\n.switch.switch-text.switch-xs .switch-label {\n      font-size: 7px;\n}\n.switch.switch-text.switch-xs .switch-handle {\n      width: 12px;\n      height: 12px;\n}\n.switch.switch-text.switch-xs .switch-input:checked ~ .switch-handle {\n      left: 18px;\n}\n.switch.switch-icon {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 48px;\n  height: 24px;\n  background-color: transparent;\n  cursor: pointer;\n}\n.switch.switch-icon .switch-input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n.switch.switch-icon .switch-label {\n    position: relative;\n    display: block;\n    height: inherit;\n    font-family: FontAwesome;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background-color: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 2px;\n    -webkit-transition: opacity background .15s ease-out;\n    transition: opacity background .15s ease-out;\n}\n.switch.switch-icon .switch-label::before,\n  .switch.switch-icon .switch-label::after {\n    position: absolute;\n    top: 50%;\n    width: 50%;\n    margin-top: -.5em;\n    line-height: 1;\n    text-align: center;\n    -webkit-transition: inherit;\n    transition: inherit;\n}\n.switch.switch-icon .switch-label::before {\n    right: 1px;\n    color: #c2cfd6;\n    content: attr(data-off);\n}\n.switch.switch-icon .switch-label::after {\n    left: 1px;\n    color: #fff;\n    content: attr(data-on);\n    opacity: 0;\n}\n.switch.switch-icon .switch-input:checked ~ .switch-label::before {\n    opacity: 0;\n}\n.switch.switch-icon .switch-input:checked ~ .switch-label::after {\n    opacity: 1;\n}\n.switch.switch-icon .switch-handle {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 1px;\n    -webkit-transition: left .15s ease-out;\n    transition: left .15s ease-out;\n}\n.switch.switch-icon .switch-input:checked ~ .switch-handle {\n    left: 26px;\n}\n.switch.switch-icon.switch-lg {\n    width: 56px;\n    height: 28px;\n}\n.switch.switch-icon.switch-lg .switch-label {\n      font-size: 12px;\n}\n.switch.switch-icon.switch-lg .switch-handle {\n      width: 24px;\n      height: 24px;\n}\n.switch.switch-icon.switch-lg .switch-input:checked ~ .switch-handle {\n      left: 30px;\n}\n.switch.switch-icon.switch-sm {\n    width: 40px;\n    height: 20px;\n}\n.switch.switch-icon.switch-sm .switch-label {\n      font-size: 8px;\n}\n.switch.switch-icon.switch-sm .switch-handle {\n      width: 16px;\n      height: 16px;\n}\n.switch.switch-icon.switch-sm .switch-input:checked ~ .switch-handle {\n      left: 22px;\n}\n.switch.switch-icon.switch-xs {\n    width: 32px;\n    height: 16px;\n}\n.switch.switch-icon.switch-xs .switch-label {\n      font-size: 7px;\n}\n.switch.switch-icon.switch-xs .switch-handle {\n      width: 12px;\n      height: 12px;\n}\n.switch.switch-icon.switch-xs .switch-input:checked ~ .switch-handle {\n      left: 18px;\n}\n.switch.switch-3d {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 40px;\n  height: 24px;\n  background-color: transparent;\n  cursor: pointer;\n}\n.switch.switch-3d .switch-input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n}\n.switch.switch-3d .switch-label {\n    position: relative;\n    display: block;\n    height: inherit;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background-color: #f0f3f5;\n    border: 1px solid #c2cfd6;\n    border-radius: 2px;\n    -webkit-transition: opacity background .15s ease-out;\n    transition: opacity background .15s ease-out;\n}\n.switch.switch-3d .switch-input:checked ~ .switch-label::before {\n    opacity: 0;\n}\n.switch.switch-3d .switch-input:checked ~ .switch-label::after {\n    opacity: 1;\n}\n.switch.switch-3d .switch-handle {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 24px;\n    height: 24px;\n    background: #fff;\n    border: 1px solid #c2cfd6;\n    border-radius: 1px;\n    -webkit-transition: left .15s ease-out;\n    transition: left .15s ease-out;\n    border: 0;\n    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n}\n.switch.switch-3d .switch-input:checked ~ .switch-handle {\n    left: 16px;\n}\n.switch.switch-3d.switch-lg {\n    width: 48px;\n    height: 28px;\n}\n.switch.switch-3d.switch-lg .switch-label {\n      font-size: 12px;\n}\n.switch.switch-3d.switch-lg .switch-handle {\n      width: 28px;\n      height: 28px;\n}\n.switch.switch-3d.switch-lg .switch-input:checked ~ .switch-handle {\n      left: 20px;\n}\n.switch.switch-3d.switch-sm {\n    width: 32px;\n    height: 20px;\n}\n.switch.switch-3d.switch-sm .switch-label {\n      font-size: 8px;\n}\n.switch.switch-3d.switch-sm .switch-handle {\n      width: 20px;\n      height: 20px;\n}\n.switch.switch-3d.switch-sm .switch-input:checked ~ .switch-handle {\n      left: 12px;\n}\n.switch.switch-3d.switch-xs {\n    width: 24px;\n    height: 16px;\n}\n.switch.switch-3d.switch-xs .switch-label {\n      font-size: 7px;\n}\n.switch.switch-3d.switch-xs .switch-handle {\n      width: 16px;\n      height: 16px;\n}\n.switch.switch-3d.switch-xs .switch-input:checked ~ .switch-handle {\n      left: 8px;\n}\n.switch-pill .switch-label, .switch.switch-3d .switch-label,\n.switch-pill .switch-handle,\n.switch.switch-3d .switch-handle {\n  border-radius: 50em !important;\n}\n.switch-pill .switch-label::before, .switch.switch-3d .switch-label::before {\n  right: 2px !important;\n}\n.switch-pill .switch-label::after, .switch.switch-3d .switch-label::after {\n  left: 2px !important;\n}\n.switch-primary > .switch-input:checked ~ .switch-label {\n  background: #20a8d8 !important;\n  border-color: #1985ac;\n}\n.switch-primary > .switch-input:checked ~ .switch-handle {\n  border-color: #1985ac;\n}\n.switch-primary-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #20a8d8;\n}\n.switch-primary-outline > .switch-input:checked ~ .switch-label::after {\n    color: #20a8d8;\n}\n.switch-primary-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #20a8d8;\n}\n.switch-primary-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #20a8d8;\n}\n.switch-primary-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #20a8d8;\n}\n.switch-primary-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #20a8d8 !important;\n  border-color: #20a8d8;\n}\n.switch-secondary > .switch-input:checked ~ .switch-label {\n  background: #a4b7c1 !important;\n  border-color: #869fac;\n}\n.switch-secondary > .switch-input:checked ~ .switch-handle {\n  border-color: #869fac;\n}\n.switch-secondary-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #a4b7c1;\n}\n.switch-secondary-outline > .switch-input:checked ~ .switch-label::after {\n    color: #a4b7c1;\n}\n.switch-secondary-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #a4b7c1;\n}\n.switch-secondary-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #a4b7c1;\n}\n.switch-secondary-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #a4b7c1;\n}\n.switch-secondary-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #a4b7c1 !important;\n  border-color: #a4b7c1;\n}\n.switch-success > .switch-input:checked ~ .switch-label {\n  background: #4dbd74 !important;\n  border-color: #3a9d5d;\n}\n.switch-success > .switch-input:checked ~ .switch-handle {\n  border-color: #3a9d5d;\n}\n.switch-success-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #4dbd74;\n}\n.switch-success-outline > .switch-input:checked ~ .switch-label::after {\n    color: #4dbd74;\n}\n.switch-success-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #4dbd74;\n}\n.switch-success-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #4dbd74;\n}\n.switch-success-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #4dbd74;\n}\n.switch-success-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #4dbd74 !important;\n  border-color: #4dbd74;\n}\n.switch-info > .switch-input:checked ~ .switch-label {\n  background: #63c2de !important;\n  border-color: #39b2d5;\n}\n.switch-info > .switch-input:checked ~ .switch-handle {\n  border-color: #39b2d5;\n}\n.switch-info-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #63c2de;\n}\n.switch-info-outline > .switch-input:checked ~ .switch-label::after {\n    color: #63c2de;\n}\n.switch-info-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #63c2de;\n}\n.switch-info-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #63c2de;\n}\n.switch-info-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #63c2de;\n}\n.switch-info-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #63c2de !important;\n  border-color: #63c2de;\n}\n.switch-warning > .switch-input:checked ~ .switch-label {\n  background: #ffc107 !important;\n  border-color: #d39e00;\n}\n.switch-warning > .switch-input:checked ~ .switch-handle {\n  border-color: #d39e00;\n}\n.switch-warning-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #ffc107;\n}\n.switch-warning-outline > .switch-input:checked ~ .switch-label::after {\n    color: #ffc107;\n}\n.switch-warning-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #ffc107;\n}\n.switch-warning-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #ffc107;\n}\n.switch-warning-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #ffc107;\n}\n.switch-warning-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #ffc107 !important;\n  border-color: #ffc107;\n}\n.switch-danger > .switch-input:checked ~ .switch-label {\n  background: #f86c6b !important;\n  border-color: #f63c3a;\n}\n.switch-danger > .switch-input:checked ~ .switch-handle {\n  border-color: #f63c3a;\n}\n.switch-danger-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f86c6b;\n}\n.switch-danger-outline > .switch-input:checked ~ .switch-label::after {\n    color: #f86c6b;\n}\n.switch-danger-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #f86c6b;\n}\n.switch-danger-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f86c6b;\n}\n.switch-danger-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #f86c6b;\n}\n.switch-danger-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #f86c6b !important;\n  border-color: #f86c6b;\n}\n.switch-light > .switch-input:checked ~ .switch-label {\n  background: #f0f3f5 !important;\n  border-color: #d1dbe1;\n}\n.switch-light > .switch-input:checked ~ .switch-handle {\n  border-color: #d1dbe1;\n}\n.switch-light-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f0f3f5;\n}\n.switch-light-outline > .switch-input:checked ~ .switch-label::after {\n    color: #f0f3f5;\n}\n.switch-light-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #f0f3f5;\n}\n.switch-light-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f0f3f5;\n}\n.switch-light-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #f0f3f5;\n}\n.switch-light-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #f0f3f5 !important;\n  border-color: #f0f3f5;\n}\n.switch-dark > .switch-input:checked ~ .switch-label {\n  background: #29363d !important;\n  border-color: #151b1f;\n}\n.switch-dark > .switch-input:checked ~ .switch-handle {\n  border-color: #151b1f;\n}\n.switch-dark-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #29363d;\n}\n.switch-dark-outline > .switch-input:checked ~ .switch-label::after {\n    color: #29363d;\n}\n.switch-dark-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #29363d;\n}\n.switch-dark-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #29363d;\n}\n.switch-dark-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #29363d;\n}\n.switch-dark-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #29363d !important;\n  border-color: #29363d;\n}\n.switch-blue > .switch-input:checked ~ .switch-label {\n  background: #20a8d8 !important;\n  border-color: #1985ac;\n}\n.switch-blue > .switch-input:checked ~ .switch-handle {\n  border-color: #1985ac;\n}\n.switch-blue-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #20a8d8;\n}\n.switch-blue-outline > .switch-input:checked ~ .switch-label::after {\n    color: #20a8d8;\n}\n.switch-blue-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #20a8d8;\n}\n.switch-blue-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #20a8d8;\n}\n.switch-blue-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #20a8d8;\n}\n.switch-blue-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #20a8d8 !important;\n  border-color: #20a8d8;\n}\n.switch-indigo > .switch-input:checked ~ .switch-label {\n  background: #6610f2 !important;\n  border-color: #510bc4;\n}\n.switch-indigo > .switch-input:checked ~ .switch-handle {\n  border-color: #510bc4;\n}\n.switch-indigo-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #6610f2;\n}\n.switch-indigo-outline > .switch-input:checked ~ .switch-label::after {\n    color: #6610f2;\n}\n.switch-indigo-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #6610f2;\n}\n.switch-indigo-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #6610f2;\n}\n.switch-indigo-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #6610f2;\n}\n.switch-indigo-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #6610f2 !important;\n  border-color: #6610f2;\n}\n.switch-purple > .switch-input:checked ~ .switch-label {\n  background: #6f42c1 !important;\n  border-color: #59339d;\n}\n.switch-purple > .switch-input:checked ~ .switch-handle {\n  border-color: #59339d;\n}\n.switch-purple-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #6f42c1;\n}\n.switch-purple-outline > .switch-input:checked ~ .switch-label::after {\n    color: #6f42c1;\n}\n.switch-purple-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #6f42c1;\n}\n.switch-purple-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #6f42c1;\n}\n.switch-purple-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #6f42c1;\n}\n.switch-purple-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #6f42c1 !important;\n  border-color: #6f42c1;\n}\n.switch-pink > .switch-input:checked ~ .switch-label {\n  background: #e83e8c !important;\n  border-color: #d91a72;\n}\n.switch-pink > .switch-input:checked ~ .switch-handle {\n  border-color: #d91a72;\n}\n.switch-pink-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #e83e8c;\n}\n.switch-pink-outline > .switch-input:checked ~ .switch-label::after {\n    color: #e83e8c;\n}\n.switch-pink-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #e83e8c;\n}\n.switch-pink-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #e83e8c;\n}\n.switch-pink-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #e83e8c;\n}\n.switch-pink-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #e83e8c !important;\n  border-color: #e83e8c;\n}\n.switch-red > .switch-input:checked ~ .switch-label {\n  background: #f86c6b !important;\n  border-color: #f63c3a;\n}\n.switch-red > .switch-input:checked ~ .switch-handle {\n  border-color: #f63c3a;\n}\n.switch-red-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f86c6b;\n}\n.switch-red-outline > .switch-input:checked ~ .switch-label::after {\n    color: #f86c6b;\n}\n.switch-red-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #f86c6b;\n}\n.switch-red-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f86c6b;\n}\n.switch-red-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #f86c6b;\n}\n.switch-red-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #f86c6b !important;\n  border-color: #f86c6b;\n}\n.switch-orange > .switch-input:checked ~ .switch-label {\n  background: #f8cb00 !important;\n  border-color: #c5a100;\n}\n.switch-orange > .switch-input:checked ~ .switch-handle {\n  border-color: #c5a100;\n}\n.switch-orange-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f8cb00;\n}\n.switch-orange-outline > .switch-input:checked ~ .switch-label::after {\n    color: #f8cb00;\n}\n.switch-orange-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #f8cb00;\n}\n.switch-orange-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f8cb00;\n}\n.switch-orange-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #f8cb00;\n}\n.switch-orange-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #f8cb00 !important;\n  border-color: #f8cb00;\n}\n.switch-yellow > .switch-input:checked ~ .switch-label {\n  background: #ffc107 !important;\n  border-color: #d39e00;\n}\n.switch-yellow > .switch-input:checked ~ .switch-handle {\n  border-color: #d39e00;\n}\n.switch-yellow-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #ffc107;\n}\n.switch-yellow-outline > .switch-input:checked ~ .switch-label::after {\n    color: #ffc107;\n}\n.switch-yellow-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #ffc107;\n}\n.switch-yellow-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #ffc107;\n}\n.switch-yellow-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #ffc107;\n}\n.switch-yellow-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #ffc107 !important;\n  border-color: #ffc107;\n}\n.switch-green > .switch-input:checked ~ .switch-label {\n  background: #4dbd74 !important;\n  border-color: #3a9d5d;\n}\n.switch-green > .switch-input:checked ~ .switch-handle {\n  border-color: #3a9d5d;\n}\n.switch-green-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #4dbd74;\n}\n.switch-green-outline > .switch-input:checked ~ .switch-label::after {\n    color: #4dbd74;\n}\n.switch-green-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #4dbd74;\n}\n.switch-green-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #4dbd74;\n}\n.switch-green-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #4dbd74;\n}\n.switch-green-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #4dbd74 !important;\n  border-color: #4dbd74;\n}\n.switch-teal > .switch-input:checked ~ .switch-label {\n  background: #20c997 !important;\n  border-color: #199d76;\n}\n.switch-teal > .switch-input:checked ~ .switch-handle {\n  border-color: #199d76;\n}\n.switch-teal-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #20c997;\n}\n.switch-teal-outline > .switch-input:checked ~ .switch-label::after {\n    color: #20c997;\n}\n.switch-teal-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #20c997;\n}\n.switch-teal-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #20c997;\n}\n.switch-teal-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #20c997;\n}\n.switch-teal-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #20c997 !important;\n  border-color: #20c997;\n}\n.switch-cyan > .switch-input:checked ~ .switch-label {\n  background: #63c2de !important;\n  border-color: #39b2d5;\n}\n.switch-cyan > .switch-input:checked ~ .switch-handle {\n  border-color: #39b2d5;\n}\n.switch-cyan-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #63c2de;\n}\n.switch-cyan-outline > .switch-input:checked ~ .switch-label::after {\n    color: #63c2de;\n}\n.switch-cyan-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #63c2de;\n}\n.switch-cyan-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #63c2de;\n}\n.switch-cyan-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #63c2de;\n}\n.switch-cyan-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #63c2de !important;\n  border-color: #63c2de;\n}\n.switch-gray-100 > .switch-input:checked ~ .switch-label {\n  background: #f0f3f5 !important;\n  border-color: #d1dbe1;\n}\n.switch-gray-100 > .switch-input:checked ~ .switch-handle {\n  border-color: #d1dbe1;\n}\n.switch-gray-100-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f0f3f5;\n}\n.switch-gray-100-outline > .switch-input:checked ~ .switch-label::after {\n    color: #f0f3f5;\n}\n.switch-gray-100-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #f0f3f5;\n}\n.switch-gray-100-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #f0f3f5;\n}\n.switch-gray-100-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #f0f3f5;\n}\n.switch-gray-100-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #f0f3f5 !important;\n  border-color: #f0f3f5;\n}\n.switch-gray-200 > .switch-input:checked ~ .switch-label {\n  background: #c2cfd6 !important;\n  border-color: #a4b7c2;\n}\n.switch-gray-200 > .switch-input:checked ~ .switch-handle {\n  border-color: #a4b7c2;\n}\n.switch-gray-200-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #c2cfd6;\n}\n.switch-gray-200-outline > .switch-input:checked ~ .switch-label::after {\n    color: #c2cfd6;\n}\n.switch-gray-200-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #c2cfd6;\n}\n.switch-gray-200-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #c2cfd6;\n}\n.switch-gray-200-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #c2cfd6;\n}\n.switch-gray-200-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #c2cfd6 !important;\n  border-color: #c2cfd6;\n}\n.switch-gray-300 > .switch-input:checked ~ .switch-label {\n  background: #a4b7c1 !important;\n  border-color: #869fac;\n}\n.switch-gray-300 > .switch-input:checked ~ .switch-handle {\n  border-color: #869fac;\n}\n.switch-gray-300-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #a4b7c1;\n}\n.switch-gray-300-outline > .switch-input:checked ~ .switch-label::after {\n    color: #a4b7c1;\n}\n.switch-gray-300-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #a4b7c1;\n}\n.switch-gray-300-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #a4b7c1;\n}\n.switch-gray-300-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #a4b7c1;\n}\n.switch-gray-300-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #a4b7c1 !important;\n  border-color: #a4b7c1;\n}\n.switch-gray-400 > .switch-input:checked ~ .switch-label {\n  background: #869fac !important;\n  border-color: #688797;\n}\n.switch-gray-400 > .switch-input:checked ~ .switch-handle {\n  border-color: #688797;\n}\n.switch-gray-400-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #869fac;\n}\n.switch-gray-400-outline > .switch-input:checked ~ .switch-label::after {\n    color: #869fac;\n}\n.switch-gray-400-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #869fac;\n}\n.switch-gray-400-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #869fac;\n}\n.switch-gray-400-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #869fac;\n}\n.switch-gray-400-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #869fac !important;\n  border-color: #869fac;\n}\n.switch-gray-500 > .switch-input:checked ~ .switch-label {\n  background: #678898 !important;\n  border-color: #526d7a;\n}\n.switch-gray-500 > .switch-input:checked ~ .switch-handle {\n  border-color: #526d7a;\n}\n.switch-gray-500-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #678898;\n}\n.switch-gray-500-outline > .switch-input:checked ~ .switch-label::after {\n    color: #678898;\n}\n.switch-gray-500-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #678898;\n}\n.switch-gray-500-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #678898;\n}\n.switch-gray-500-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #678898;\n}\n.switch-gray-500-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #678898 !important;\n  border-color: #678898;\n}\n.switch-gray-600 > .switch-input:checked ~ .switch-label {\n  background: #536c79 !important;\n  border-color: #3e515b;\n}\n.switch-gray-600 > .switch-input:checked ~ .switch-handle {\n  border-color: #3e515b;\n}\n.switch-gray-600-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #536c79;\n}\n.switch-gray-600-outline > .switch-input:checked ~ .switch-label::after {\n    color: #536c79;\n}\n.switch-gray-600-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #536c79;\n}\n.switch-gray-600-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #536c79;\n}\n.switch-gray-600-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #536c79;\n}\n.switch-gray-600-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #536c79 !important;\n  border-color: #536c79;\n}\n.switch-gray-700 > .switch-input:checked ~ .switch-label {\n  background: #3e515b !important;\n  border-color: #29363d;\n}\n.switch-gray-700 > .switch-input:checked ~ .switch-handle {\n  border-color: #29363d;\n}\n.switch-gray-700-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #3e515b;\n}\n.switch-gray-700-outline > .switch-input:checked ~ .switch-label::after {\n    color: #3e515b;\n}\n.switch-gray-700-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #3e515b;\n}\n.switch-gray-700-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #3e515b;\n}\n.switch-gray-700-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #3e515b;\n}\n.switch-gray-700-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #3e515b !important;\n  border-color: #3e515b;\n}\n.switch-gray-800 > .switch-input:checked ~ .switch-label {\n  background: #29363d !important;\n  border-color: #151b1f;\n}\n.switch-gray-800 > .switch-input:checked ~ .switch-handle {\n  border-color: #151b1f;\n}\n.switch-gray-800-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #29363d;\n}\n.switch-gray-800-outline > .switch-input:checked ~ .switch-label::after {\n    color: #29363d;\n}\n.switch-gray-800-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #29363d;\n}\n.switch-gray-800-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #29363d;\n}\n.switch-gray-800-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #29363d;\n}\n.switch-gray-800-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #29363d !important;\n  border-color: #29363d;\n}\n.switch-gray-900 > .switch-input:checked ~ .switch-label {\n  background: #151b1e !important;\n  border-color: black;\n}\n.switch-gray-900 > .switch-input:checked ~ .switch-handle {\n  border-color: black;\n}\n.switch-gray-900-outline > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #151b1e;\n}\n.switch-gray-900-outline > .switch-input:checked ~ .switch-label::after {\n    color: #151b1e;\n}\n.switch-gray-900-outline > .switch-input:checked ~ .switch-handle {\n  border-color: #151b1e;\n}\n.switch-gray-900-outline-alt > .switch-input:checked ~ .switch-label {\n  background: #fff !important;\n  border-color: #151b1e;\n}\n.switch-gray-900-outline-alt > .switch-input:checked ~ .switch-label::after {\n    color: #151b1e;\n}\n.switch-gray-900-outline-alt > .switch-input:checked ~ .switch-handle {\n  background: #151b1e !important;\n  border-color: #151b1e;\n}\n.table-outline {\n  border: 1px solid #a4b7c1;\n}\n.table-outline td {\n    vertical-align: middle;\n}\n.table-align-middle td {\n  vertical-align: middle;\n}\n.table-clear td {\n  border: 0;\n}\n.social-box {\n  min-height: 160px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  background: #fff;\n  border: 1px solid #c2cfd6;\n}\n.social-box i {\n    display: block;\n    margin: -1px -1px 0;\n    font-size: 40px;\n    line-height: 90px;\n    background: #c2cfd6;\n}\n.social-box .chart-wrapper {\n    height: 90px;\n    margin: -90px 0 0;\n}\n.social-box .chart-wrapper canvas {\n      width: 100% !important;\n      height: 90px !important;\n}\n.social-box ul {\n    padding: 10px 0;\n    list-style: none;\n}\n.social-box ul li {\n      display: block;\n      float: left;\n      width: 50%;\n}\n.social-box ul li:first-child {\n        border-right: 1px solid #c2cfd6;\n}\n.social-box ul li strong {\n        display: block;\n        font-size: 20px;\n}\n.social-box ul li span {\n        font-size: 10px;\n        font-weight: 500;\n        color: #c2cfd6;\n        text-transform: uppercase;\n}\n.social-box.facebook i {\n    color: #fff;\n    background: #3b5998;\n}\n.social-box.twitter i {\n    color: #fff;\n    background: #00aced;\n}\n.social-box.linkedin i {\n    color: #fff;\n    background: #4875b4;\n}\n.social-box.google-plus i {\n    color: #fff;\n    background: #d34836;\n}\n.horizontal-bars {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.horizontal-bars li {\n    position: relative;\n    height: 40px;\n    line-height: 40px;\n    vertical-align: middle;\n}\n.horizontal-bars li .title {\n      width: 100px;\n      font-size: 12px;\n      font-weight: 600;\n      color: #536c79;\n      vertical-align: middle;\n}\n.horizontal-bars li .bars {\n      position: absolute;\n      top: 15px;\n      width: 100%;\n      padding-left: 100px;\n}\n.horizontal-bars li .bars .progress:first-child {\n        margin-bottom: 2px;\n}\n.horizontal-bars li.legend {\n      text-align: center;\n}\n.horizontal-bars li.legend .badge {\n        display: inline-block;\n        width: 8px;\n        height: 8px;\n        padding: 0;\n}\n.horizontal-bars li.divider {\n      height: 40px;\n}\n.horizontal-bars li.divider i {\n        margin: 0 !important;\n}\n.horizontal-bars.type-2 li {\n    overflow: hidden;\n}\n.horizontal-bars.type-2 li i {\n      display: inline-block;\n      margin-right: 1rem;\n      margin-left: 5px;\n      font-size: 18px;\n      line-height: 40px;\n}\n.horizontal-bars.type-2 li .title {\n      display: inline-block;\n      width: auto;\n      margin-top: -9px;\n      font-size: 0.875rem;\n      font-weight: normal;\n      line-height: 40px;\n      color: #151b1e;\n}\n.horizontal-bars.type-2 li .value {\n      float: right;\n      font-weight: 600;\n}\n.horizontal-bars.type-2 li .bars {\n      position: absolute;\n      top: auto;\n      bottom: 0;\n      padding: 0;\n}\n.icons-list {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.icons-list li {\n    position: relative;\n    height: 40px;\n    vertical-align: middle;\n}\n.icons-list li i {\n      display: block;\n      float: left;\n      width: 35px !important;\n      height: 35px !important;\n      margin: 2px;\n      line-height: 35px !important;\n      text-align: center;\n}\n.icons-list li .desc {\n      height: 40px;\n      margin-left: 50px;\n      border-bottom: 1px solid #c2cfd6;\n}\n.icons-list li .desc .title {\n        padding: 2px 0 0;\n        margin: 0;\n}\n.icons-list li .desc small {\n        display: block;\n        margin-top: -4px;\n        color: #536c79;\n}\n.icons-list li .value {\n      position: absolute;\n      top: 2px;\n      right: 45px;\n      text-align: right;\n}\n.icons-list li .value strong {\n        display: block;\n        margin-top: -3px;\n}\n.icons-list li .actions {\n      position: absolute;\n      top: -4px;\n      right: 10px;\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n      text-align: center;\n}\n.icons-list li .actions i {\n        float: none;\n        width: auto;\n        height: auto;\n        padding: 0;\n        margin: 0;\n        line-height: normal;\n}\n.icons-list li.divider {\n      height: 40px;\n}\n.icons-list li.divider i {\n        width: auto;\n        height: auto;\n        margin: 2px 0 0;\n        font-size: 18px;\n}\n@media all and (-ms-high-contrast: none) {\nhtml {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n.app,\napp-dashboard,\napp-root {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-height: 100vh;\n}\n.app-header {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 55px;\n          flex: 0 0 55px;\n}\n.app-footer {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 50px;\n          flex: 0 0 50px;\n}\n.app-body {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow-x: hidden;\n}\n.app-body .main {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n}\n.app-body .sidebar {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 200px;\n            flex: 0 0 200px;\n    -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n            order: -1;\n}\n.app-body .aside-menu {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 250px;\n            flex: 0 0 250px;\n}\n.header-fixed .app-header {\n  position: fixed;\n  z-index: 1020;\n  width: 100%;\n}\n.header-fixed .app-body {\n  margin-top: 55px;\n}\n.sidebar-hidden .sidebar {\n  margin-left: -200px;\n}\n.sidebar-fixed .sidebar {\n  position: fixed;\n  z-index: 1019;\n  width: 200px;\n  height: calc(100vh - 55px);\n}\n.sidebar-fixed .main, .sidebar-fixed .app-footer {\n  margin-left: 200px;\n}\n.sidebar-fixed.sidebar-hidden .main, .sidebar-fixed.sidebar-hidden .app-footer {\n  margin-left: 0;\n}\n.sidebar-off-canvas .sidebar {\n  position: fixed;\n  z-index: 1019;\n  height: calc(100vh - 55px);\n}\n@media (min-width: 992px) {\n.sidebar-compact .sidebar {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 150px;\n            flex: 0 0 150px;\n}\n.sidebar-compact.sidebar-hidden .sidebar {\n    margin-left: -150px;\n}\n.sidebar-compact.sidebar-fixed .main, .sidebar-compact.sidebar-fixed .app-footer {\n    margin-left: 150px;\n}\n.sidebar-compact.sidebar-fixed .sidebar {\n    width: 150px;\n}\n.sidebar-compact.sidebar-fixed.sidebar-hidden .main, .sidebar-compact.sidebar-fixed.sidebar-hidden .app-footer {\n    margin-left: 0;\n}\n.sidebar-compact .sidebar-minimizer {\n    display: none;\n}\n.sidebar-minimized .sidebar {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50px;\n            flex: 0 0 50px;\n}\n.sidebar-minimized.sidebar-hidden .sidebar {\n    margin-left: -50px;\n}\n.sidebar-minimized.sidebar-fixed .main, .sidebar-minimized.sidebar-fixed .app-footer {\n    margin-left: 50px;\n}\n.sidebar-minimized.sidebar-fixed .sidebar {\n    width: 50px;\n}\n.sidebar-minimized.sidebar-fixed.sidebar-hidden .main, .sidebar-minimized.sidebar-fixed.sidebar-hidden .app-footer {\n    margin-left: 0;\n}\n}\n.aside-menu-hidden .aside-menu {\n  margin-right: -250px;\n}\n.aside-menu-fixed .aside-menu {\n  position: fixed;\n  right: 0;\n  height: 100%;\n}\n.aside-menu-fixed .aside-menu .tab-content {\n    height: calc(100vh - 2.375rem - 55px);\n}\n.aside-menu-fixed .main, .aside-menu-fixed .app-footer {\n  margin-right: 250px;\n}\n.aside-menu-fixed.aside-menu-hidden .main, .aside-menu-fixed.aside-menu-hidden .app-footer {\n  margin-right: 0;\n}\n.aside-menu-off-canvas .aside-menu {\n  position: fixed;\n  right: 0;\n  z-index: 1019;\n  height: 100%;\n}\n.aside-menu-off-canvas .aside-menu .tab-content {\n    height: calc(100vh - 2.375rem - 55px);\n}\n.breadcrumb-fixed .main {\n  padding-top: 3.875rem;\n}\n.breadcrumb-fixed .breadcrumb {\n  position: fixed;\n  top: 55px;\n  right: 0;\n  left: 0;\n  z-index: 1018;\n}\n.breadcrumb-fixed .main:nth-child(2) .breadcrumb {\n  right: 250px;\n  left: 200px;\n}\n.breadcrumb-fixed .main:first-child .breadcrumb {\n  right: 250px;\n  left: 0;\n}\n.breadcrumb-fixed .main:last-child .breadcrumb {\n  right: 0;\n}\n.breadcrumb-fixed.sidebar-minimized .main .breadcrumb {\n  left: 50px;\n}\n.breadcrumb-fixed.sidebar-hidden .main .breadcrumb, .breadcrumb-fixed.sidebar-off-canvas .main .breadcrumb {\n  left: 0;\n}\n.breadcrumb-fixed.aside-menu-hidden .main .breadcrumb, .breadcrumb-fixed.aside-menu-off-canvas .main .breadcrumb {\n  right: 0;\n}\n.footer-fixed .app-footer {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1020;\n  height: 50px;\n}\n.footer-fixed .app-body {\n  margin-bottom: 50px;\n}\n.app-header,\n.app-footer,\n.sidebar,\n.main,\n.aside-menu {\n  -webkit-transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, -webkit-box-flex 0.25s;\n  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, -webkit-box-flex 0.25s;\n  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, flex 0.25s;\n  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, flex 0.25s, -webkit-box-flex 0.25s, -ms-flex 0.25s;\n}\n.sidebar-nav {\n  -webkit-transition: width 0.25s;\n  transition: width 0.25s;\n}\n.breadcrumb {\n  -webkit-transition: left 0.25s, right 0.25s, width 0.25s;\n  transition: left 0.25s, right 0.25s, width 0.25s;\n}\n@media (max-width: 991.99px) {\n.app-header.navbar {\n    position: fixed !important;\n    z-index: 1020;\n    width: 100%;\n    text-align: center;\n    background-color: #fff;\n    border-bottom: 1px solid #c2cfd6;\n}\n.app-header.navbar .navbar-toggler {\n      color: #536c79;\n}\n.app-header.navbar .navbar-brand {\n      position: absolute;\n      left: 50%;\n      margin-left: -77.5px;\n}\n.app-body {\n    margin-top: 55px;\n}\n.breadcrumb-fixed .main:nth-child(2) .breadcrumb {\n    right: auto;\n    left: auto;\n    width: 100%;\n}\n.sidebar {\n    position: fixed;\n    z-index: 1019;\n    width: 220px;\n    height: calc(100vh - 55px);\n    margin-left: -220px;\n}\n.sidebar .sidebar-nav,\n    .sidebar .nav {\n      width: 220px;\n      min-height: calc(100vh - 55px);\n}\n.sidebar .sidebar-minimizer {\n      display: none;\n}\n.main, .app-footer {\n    margin-left: 0 !important;\n}\n.sidebar-hidden .sidebar {\n    margin-left: -220px;\n}\n.sidebar-mobile-show .sidebar {\n    width: 220px;\n    margin-left: 0;\n}\n.sidebar-mobile-show .main {\n    margin-right: -220px !important;\n    margin-left: 220px !important;\n}\n}\nhr.transparent {\n  border-top: 1px solid transparent;\n}\n.bg-primary,\n.bg-success,\n.bg-info,\n.bg-warning,\n.bg-danger,\n.bg-inverse {\n  color: #fff;\n}\n.b-a-0 {\n  border: 0 !important;\n}\n.b-t-0 {\n  border-top: 0 !important;\n}\n.b-r-0 {\n  border-right: 0 !important;\n}\n.b-b-0 {\n  border-bottom: 0 !important;\n}\n.b-l-0 {\n  border-left: 0 !important;\n}\n.b-a-1 {\n  border: 1px solid #c2cfd6 !important;\n}\n.b-t-1 {\n  border-top: 1px solid #c2cfd6 !important;\n}\n.b-r-1 {\n  border-right: 1px solid #c2cfd6 !important;\n}\n.b-b-1 {\n  border-bottom: 1px solid #c2cfd6 !important;\n}\n.b-l-1 {\n  border-left: 1px solid #c2cfd6 !important;\n}\n.b-a-2 {\n  border: 2px solid #c2cfd6 !important;\n}\n.b-t-2 {\n  border-top: 2px solid #c2cfd6 !important;\n}\n.b-r-2 {\n  border-right: 2px solid #c2cfd6 !important;\n}\n.b-b-2 {\n  border-bottom: 2px solid #c2cfd6 !important;\n}\n.b-l-2 {\n  border-left: 2px solid #c2cfd6 !important;\n}\n@media (max-width: 575.99px) {\n.d-down-none {\n    display: none !important;\n}\n}\n@media (max-width: 767.99px) {\n.d-sm-down-none {\n    display: none !important;\n}\n}\n@media (max-width: 991.99px) {\n.d-md-down-none {\n    display: none !important;\n}\n}\n@media (max-width: 1199.99px) {\n.d-lg-down-none {\n    display: none !important;\n}\n}\n.d-xl-down-none {\n  display: none !important;\n}\n.label-pill {\n  border-radius: 1rem !important;\n}\n.open > a, .show > a {\n  outline: 0;\n}\n.navbar .dropdown-toggle .img-avatar {\n  height: 35px;\n  margin: 0 10px;\n}\n*[dir=\"rtl\"] {\n  direction: rtl;\n  unicode-bidi: embed;\n}\n*[dir=\"rtl\"] ul {\n    -webkit-padding-start: 0;\n}\n*[dir=\"rtl\"] table tr th {\n    text-align: right;\n}\n*[dir=\"rtl\"] .breadcrumb-item {\n    float: right;\n}\n*[dir=\"rtl\"] .breadcrumb-menu {\n    right: auto;\n    left: 1rem;\n}\n*[dir=\"rtl\"] .dropdown-item {\n    text-align: right;\n}\n*[dir=\"rtl\"] .dropdown-item i {\n      margin-right: -10px;\n      margin-left: 10px;\n}\n*[dir=\"rtl\"] .dropdown-item .badge {\n      right: auto;\n      left: 10px;\n}\n*[dir=\"rtl\"] .sidebar-hidden .sidebar {\n    margin-right: -200px;\n}\n*[dir=\"rtl\"] .sidebar-fixed .main, *[dir=\"rtl\"] .sidebar-fixed .app-footer {\n    margin-right: 200px;\n}\n*[dir=\"rtl\"] .sidebar-fixed.sidebar-hidden .main, *[dir=\"rtl\"] .sidebar-fixed.sidebar-hidden .app-footer {\n    margin-right: 0;\n}\n*[dir=\"rtl\"] .sidebar-minimized .sidebar {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 50px;\n            flex: 0 0 50px;\n}\n*[dir=\"rtl\"] .sidebar-minimized.sidebar-hidden .sidebar {\n    margin-right: -50px;\n    margin-left: 0;\n}\n*[dir=\"rtl\"] .sidebar-minimized.sidebar-fixed .main, *[dir=\"rtl\"] .sidebar-minimized.sidebar-fixed .app-footer {\n    margin-right: 50px;\n}\n*[dir=\"rtl\"] .sidebar-minimized.sidebar-fixed.sidebar-hidden .main, *[dir=\"rtl\"] .sidebar-minimized.sidebar-fixed.sidebar-hidden .app-footer {\n    margin-left: 0;\n}\n*[dir=\"rtl\"] .aside-menu-hidden .aside-menu {\n    margin-right: 0;\n    margin-left: -250px;\n}\n*[dir=\"rtl\"] .aside-menu-fixed .aside-menu {\n    right: auto;\n    left: 0;\n}\n*[dir=\"rtl\"] .aside-menu-fixed .main, *[dir=\"rtl\"] .aside-menu-fixed .app-footer {\n    margin-left: 250px;\n}\n*[dir=\"rtl\"] .aside-menu-fixed.aside-menu-hidden .main, *[dir=\"rtl\"] .aside-menu-fixed.aside-menu-hidden .app-footer {\n    margin-left: 0;\n}\n*[dir=\"rtl\"] .aside-menu-off-canvas .aside-menu {\n    position: fixed;\n    right: 0;\n    z-index: 1019;\n    height: 100%;\n}\n*[dir=\"rtl\"] .aside-menu-off-canvas .aside-menu .tab-content {\n      height: calc(100vh - 2.375rem - 55px);\n}\n*[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .nav-link, *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .navbar .dropdown-toggle, .navbar *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .dropdown-toggle {\n    direction: rtl;\n}\n*[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .nav-link i, *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .navbar .dropdown-toggle i, .navbar *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .dropdown-toggle i {\n      margin: 0 0 0 0.5rem;\n}\n*[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .nav-link .badge, *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .navbar .dropdown-toggle .badge, .navbar *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .dropdown-toggle .badge {\n      float: left;\n      margin-top: 2px;\n}\n*[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .nav-link.nav-dropdown-toggle::before, *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .navbar .nav-dropdown-toggle.dropdown-toggle::before, .navbar *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item .nav-dropdown-toggle.dropdown-toggle::before {\n      position: absolute;\n      right: auto !important;\n      left: 1rem;\n      -webkit-transform: rotate(180deg);\n              transform: rotate(180deg);\n}\n*[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item.nav-dropdown.open > .nav-link.nav-dropdown-toggle::before, *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .navbar .nav-item.nav-dropdown.open > .nav-dropdown-toggle.dropdown-toggle::before, .navbar *[dir=\"rtl\"] .sidebar .sidebar-nav .nav .nav-item.nav-dropdown.open > .nav-dropdown-toggle.dropdown-toggle::before {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n}\n*[dir=\"rtl\"] .sidebar-minimized .sidebar .nav-link, *[dir=\"rtl\"] .sidebar-minimized .sidebar .navbar .dropdown-toggle, .navbar *[dir=\"rtl\"] .sidebar-minimized .sidebar .dropdown-toggle {\n    padding-right: 0;\n}\n*[dir=\"rtl\"] .sidebar-minimized .sidebar .nav-link i, *[dir=\"rtl\"] .sidebar-minimized .sidebar .navbar .dropdown-toggle i, .navbar *[dir=\"rtl\"] .sidebar-minimized .sidebar .dropdown-toggle i {\n      float: right;\n      padding: 0;\n      margin: 0;\n}\n*[dir=\"rtl\"] .sidebar-minimized .sidebar .nav-link .badge, *[dir=\"rtl\"] .sidebar-minimized .sidebar .navbar .dropdown-toggle .badge, .navbar *[dir=\"rtl\"] .sidebar-minimized .sidebar .dropdown-toggle .badge {\n      right: auto;\n      left: 15px;\n}\n*[dir=\"rtl\"] .sidebar-minimized .sidebar .nav > .nav-dropdown:hover > .nav-dropdown-items {\n    right: 50px;\n    left: 0;\n}\n*[dir=\"rtl\"] .horizontal-bars li .bars {\n    padding-right: 100px;\n    padding-left: 0;\n}\n*[dir=\"rtl\"] .horizontal-bars li .bars .progress:first-child {\n      margin-bottom: 2px;\n}\n*[dir=\"rtl\"] .horizontal-bars.type-2 li i {\n    margin-right: 5px;\n    margin-left: 1rem;\n}\n*[dir=\"rtl\"] .horizontal-bars.type-2 li .value {\n    float: left;\n    font-weight: 600;\n}\n*[dir=\"rtl\"] .horizontal-bars.type-2 li .bars {\n    padding: 0;\n}\n*[dir=\"rtl\"] .icons-list li {\n    position: relative;\n    height: 40px;\n    vertical-align: middle;\n}\n*[dir=\"rtl\"] .icons-list li i {\n      float: right;\n}\n*[dir=\"rtl\"] .icons-list li .desc {\n      margin-right: 50px;\n      margin-left: 0;\n}\n*[dir=\"rtl\"] .icons-list li .value {\n      right: auto;\n      left: 45px;\n      text-align: left;\n}\n*[dir=\"rtl\"] .icons-list li .value strong {\n        display: block;\n        margin-top: -3px;\n}\n*[dir=\"rtl\"] .icons-list li .actions {\n      right: auto;\n      left: 10px;\n}\n*[dir=\"rtl\"] .callout {\n    border: 0 solid #c2cfd6;\n    border-right-width: .25rem;\n}\n*[dir=\"rtl\"] .callout.callout-primary {\n      border-right-color: #20a8d8;\n}\n*[dir=\"rtl\"] .callout.callout-secondary {\n      border-right-color: #a4b7c1;\n}\n*[dir=\"rtl\"] .callout.callout-success {\n      border-right-color: #4dbd74;\n}\n*[dir=\"rtl\"] .callout.callout-info {\n      border-right-color: #63c2de;\n}\n*[dir=\"rtl\"] .callout.callout-warning {\n      border-right-color: #ffc107;\n}\n*[dir=\"rtl\"] .callout.callout-danger {\n      border-right-color: #f86c6b;\n}\n*[dir=\"rtl\"] .callout.callout-light {\n      border-right-color: #f0f3f5;\n}\n*[dir=\"rtl\"] .callout.callout-dark {\n      border-right-color: #29363d;\n}\n*[dir=\"rtl\"] .callout.callout-blue {\n      border-right-color: #20a8d8;\n}\n*[dir=\"rtl\"] .callout.callout-indigo {\n      border-right-color: #6610f2;\n}\n*[dir=\"rtl\"] .callout.callout-purple {\n      border-right-color: #6f42c1;\n}\n*[dir=\"rtl\"] .callout.callout-pink {\n      border-right-color: #e83e8c;\n}\n*[dir=\"rtl\"] .callout.callout-red {\n      border-right-color: #f86c6b;\n}\n*[dir=\"rtl\"] .callout.callout-orange {\n      border-right-color: #f8cb00;\n}\n*[dir=\"rtl\"] .callout.callout-yellow {\n      border-right-color: #ffc107;\n}\n*[dir=\"rtl\"] .callout.callout-green {\n      border-right-color: #4dbd74;\n}\n*[dir=\"rtl\"] .callout.callout-teal {\n      border-right-color: #20c997;\n}\n*[dir=\"rtl\"] .callout.callout-cyan {\n      border-right-color: #63c2de;\n}\n*[dir=\"rtl\"] .callout.callout-gray-100 {\n      border-right-color: #f0f3f5;\n}\n*[dir=\"rtl\"] .callout.callout-gray-200 {\n      border-right-color: #c2cfd6;\n}\n*[dir=\"rtl\"] .callout.callout-gray-300 {\n      border-right-color: #a4b7c1;\n}\n*[dir=\"rtl\"] .callout.callout-gray-400 {\n      border-right-color: #869fac;\n}\n*[dir=\"rtl\"] .callout.callout-gray-500 {\n      border-right-color: #678898;\n}\n*[dir=\"rtl\"] .callout.callout-gray-600 {\n      border-right-color: #536c79;\n}\n*[dir=\"rtl\"] .callout.callout-gray-700 {\n      border-right-color: #3e515b;\n}\n*[dir=\"rtl\"] .callout.callout-gray-800 {\n      border-right-color: #29363d;\n}\n*[dir=\"rtl\"] .callout.callout-gray-900 {\n      border-right-color: #151b1e;\n}\n*[dir=\"rtl\"] .callout .chart-wrapper {\n      left: 0;\n      float: left;\n}\n*[dir=\"rtl\"] .callout-default {\n    border-right-color: #536c79;\n}\n.email-app {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  background: #fff;\n  border: 1px solid #c2cfd6;\n}\n.email-app nav {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 200px;\n            flex: 0 0 200px;\n    padding: 1rem;\n    border-right: 1px solid #c2cfd6;\n}\n.email-app nav .btn-block {\n      margin-bottom: 15px;\n}\n.email-app nav .nav {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.email-app nav .nav .nav-item {\n        position: relative;\n}\n.email-app nav .nav .nav-item .nav-link, .email-app nav .nav .nav-item .navbar .dropdown-toggle, .navbar .email-app nav .nav .nav-item .dropdown-toggle {\n          color: #151b1e;\n          border-bottom: 1px solid #c2cfd6;\n}\n.email-app nav .nav .nav-item .nav-link i, .email-app nav .nav .nav-item .navbar .dropdown-toggle i, .navbar .email-app nav .nav .nav-item .dropdown-toggle i {\n            width: 20px;\n            margin: 0 10px 0 0;\n            font-size: 14px;\n            text-align: center;\n}\n.email-app nav .nav .nav-item .nav-link .badge, .email-app nav .nav .nav-item .navbar .dropdown-toggle .badge, .navbar .email-app nav .nav .nav-item .dropdown-toggle .badge {\n            float: right;\n            margin-top: 4px;\n            margin-left: 10px;\n}\n.email-app main {\n    min-width: 0;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    padding: 1rem;\n}\n.email-app .inbox .toolbar {\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #c2cfd6;\n}\n.email-app .inbox .messages {\n    padding: 0;\n    list-style: none;\n}\n.email-app .inbox .message {\n    position: relative;\n    padding: 1rem 1rem 1rem 2rem;\n    cursor: pointer;\n    border-bottom: 1px solid #c2cfd6;\n}\n.email-app .inbox .message:hover {\n      background: #f0f3f5;\n}\n.email-app .inbox .message .actions {\n      position: absolute;\n      left: 0;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n}\n.email-app .inbox .message .actions .action {\n        width: 2rem;\n        margin-bottom: 0.5rem;\n        color: #a4b7c1;\n        text-align: center;\n}\n.email-app .inbox .message a {\n      color: #000;\n}\n.email-app .inbox .message a:hover {\n        text-decoration: none;\n}\n.email-app .inbox .message.unread .header, .email-app .inbox .message.unread .title {\n      font-weight: bold;\n}\n.email-app .inbox .message .header {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: row;\n              flex-direction: row;\n      margin-bottom: 0.5rem;\n}\n.email-app .inbox .message .header .date {\n        margin-left: auto;\n}\n.email-app .inbox .message .title {\n      margin-bottom: 0.5rem;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.email-app .inbox .message .description {\n      font-size: 12px;\n}\n.email-app .message .toolbar {\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #c2cfd6;\n}\n.email-app .message .details .title {\n    padding: 1rem 0;\n    font-weight: bold;\n}\n.email-app .message .details .header {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 1rem 0;\n    margin: 1rem 0;\n    border-top: 1px solid #c2cfd6;\n    border-bottom: 1px solid #c2cfd6;\n}\n.email-app .message .details .header .avatar {\n      width: 40px;\n      height: 40px;\n      margin-right: 1rem;\n}\n.email-app .message .details .header .from {\n      font-size: 12px;\n      color: #536c79;\n      -ms-flex-item-align: center;\n          align-self: center;\n}\n.email-app .message .details .header .from span {\n        display: block;\n        font-weight: bold;\n}\n.email-app .message .details .header .date {\n      margin-left: auto;\n}\n.email-app .message .details .attachments {\n    padding: 1rem 0;\n    margin-bottom: 1rem;\n    border-top: 3px solid #f0f3f5;\n    border-bottom: 3px solid #f0f3f5;\n}\n.email-app .message .details .attachments .attachment {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      margin: 0.5rem 0;\n      font-size: 12px;\n      -ms-flex-item-align: center;\n          align-self: center;\n}\n.email-app .message .details .attachments .attachment .badge {\n        margin: 0 0.5rem;\n        line-height: inherit;\n}\n.email-app .message .details .attachments .attachment .menu {\n        margin-left: auto;\n}\n.email-app .message .details .attachments .attachment .menu a {\n          padding: 0 0.5rem;\n          font-size: 14px;\n          color: #c2cfd6;\n}\n@media (max-width: 767.99px) {\n.email-app {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.email-app nav {\n      -webkit-box-flex: 0;\n          -ms-flex: 0 0 100%;\n              flex: 0 0 100%;\n}\n}\n@media (max-width: 575.99px) {\n.email-app .message .header {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row wrap;\n            flex-flow: row wrap;\n}\n.email-app .message .header .date {\n      -webkit-box-flex: 0;\n          -ms-flex: 0 0 100%;\n              flex: 0 0 100%;\n}\n}\n", ""]);

// exports


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".daterangepicker {\n  position: absolute;\n  color: inherit;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  width: 278px;\n  max-width: none;\n  padding: 0;\n  margin-top: 7px;\n  top: 100px;\n  left: 20px;\n  z-index: 3001;\n  display: none;\n  font-family: arial;\n  font-size: 15px;\n  line-height: 1em;\n}\n\n.daterangepicker:before, .daterangepicker:after {\n  position: absolute;\n  display: inline-block;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  content: '';\n}\n\n.daterangepicker:before {\n  top: -7px;\n  border-right: 7px solid transparent;\n  border-left: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n}\n\n.daterangepicker:after {\n  top: -6px;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #fff;\n  border-left: 6px solid transparent;\n}\n\n.daterangepicker.opensleft:before {\n  right: 9px;\n}\n\n.daterangepicker.opensleft:after {\n  right: 10px;\n}\n\n.daterangepicker.openscenter:before {\n  left: 0;\n  right: 0;\n  width: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.daterangepicker.openscenter:after {\n  left: 0;\n  right: 0;\n  width: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.daterangepicker.opensright:before {\n  left: 9px;\n}\n\n.daterangepicker.opensright:after {\n  left: 10px;\n}\n\n.daterangepicker.drop-up {\n  margin-top: -7px;\n}\n\n.daterangepicker.drop-up:before {\n  top: initial;\n  bottom: -7px;\n  border-bottom: initial;\n  border-top: 7px solid #ccc;\n}\n\n.daterangepicker.drop-up:after {\n  top: initial;\n  bottom: -6px;\n  border-bottom: initial;\n  border-top: 6px solid #fff;\n}\n\n.daterangepicker.single .daterangepicker .ranges, .daterangepicker.single .drp-calendar {\n  float: none;\n}\n\n.daterangepicker.single .drp-selected {\n  display: none;\n}\n\n.daterangepicker.show-calendar .drp-calendar {\n  display: block;\n}\n\n.daterangepicker.show-calendar .drp-buttons {\n  display: block;\n}\n\n.daterangepicker.auto-apply .drp-buttons {\n  display: none;\n}\n\n.daterangepicker .drp-calendar {\n  display: none;\n  max-width: 270px;\n}\n\n.daterangepicker .drp-calendar.left {\n  padding: 8px 0 8px 8px;\n}\n\n.daterangepicker .drp-calendar.right {\n  padding: 8px;\n}\n\n.daterangepicker .drp-calendar.single .calendar-table {\n  border: none;\n}\n\n.daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span {\n  color: #fff;\n  border: solid black;\n  border-width: 0 2px 2px 0;\n  border-radius: 0;\n  display: inline-block;\n  padding: 3px;\n}\n\n.daterangepicker .calendar-table .next span {\n  transform: rotate(-45deg);\n  -webkit-transform: rotate(-45deg);\n}\n\n.daterangepicker .calendar-table .prev span {\n  transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n}\n\n.daterangepicker .calendar-table th, .daterangepicker .calendar-table td {\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n  min-width: 32px;\n  width: 32px;\n  height: 24px;\n  line-height: 24px;\n  font-size: 12px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.daterangepicker .calendar-table {\n  border: 1px solid #fff;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.daterangepicker .calendar-table table {\n  width: 100%;\n  margin: 0;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n\n.daterangepicker td.available:hover, .daterangepicker th.available:hover {\n  background-color: #eee;\n  border-color: transparent;\n  color: inherit;\n}\n\n.daterangepicker td.week, .daterangepicker th.week {\n  font-size: 80%;\n  color: #ccc;\n}\n\n.daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {\n  background-color: #fff;\n  border-color: transparent;\n  color: #999;\n}\n\n.daterangepicker td.in-range {\n  background-color: #ebf4f8;\n  border-color: transparent;\n  color: #000;\n  border-radius: 0;\n}\n\n.daterangepicker td.start-date {\n  border-radius: 4px 0 0 4px;\n}\n\n.daterangepicker td.end-date {\n  border-radius: 0 4px 4px 0;\n}\n\n.daterangepicker td.start-date.end-date {\n  border-radius: 4px;\n}\n\n.daterangepicker td.active, .daterangepicker td.active:hover {\n  background-color: #357ebd;\n  border-color: transparent;\n  color: #fff;\n}\n\n.daterangepicker th.month {\n  width: auto;\n}\n\n.daterangepicker td.disabled, .daterangepicker option.disabled {\n  color: #999;\n  cursor: not-allowed;\n  text-decoration: line-through;\n}\n\n.daterangepicker select.monthselect, .daterangepicker select.yearselect {\n  font-size: 12px;\n  padding: 1px;\n  height: auto;\n  margin: 0;\n  cursor: default;\n}\n\n.daterangepicker select.monthselect {\n  margin-right: 2%;\n  width: 56%;\n}\n\n.daterangepicker select.yearselect {\n  width: 40%;\n}\n\n.daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {\n  width: 50px;\n  margin: 0 auto;\n  background: #eee;\n  border: 1px solid #eee;\n  padding: 2px;\n  outline: 0;\n  font-size: 12px;\n}\n\n.daterangepicker .calendar-time {\n  text-align: center;\n  margin: 4px auto 0 auto;\n  line-height: 30px;\n  position: relative;\n}\n\n.daterangepicker .calendar-time select.disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n\n.daterangepicker .drp-buttons {\n  clear: both;\n  text-align: right;\n  padding: 8px;\n  border-top: 1px solid #ddd;\n  display: none;\n  line-height: 12px;\n  vertical-align: middle;\n}\n\n.daterangepicker .drp-selected {\n  display: inline-block;\n  font-size: 12px;\n  padding-right: 8px;\n}\n\n.daterangepicker .drp-buttons .btn {\n  margin-left: 8px;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 8px;\n}\n\n.daterangepicker.show-ranges .drp-calendar.left {\n  border-left: 1px solid #ddd;\n}\n\n.daterangepicker .ranges {\n  float: none;\n  text-align: left;\n  margin: 0;\n}\n\n.daterangepicker.show-calendar .ranges {\n  margin-top: 8px;\n}\n\n.daterangepicker .ranges ul {\n  list-style: none;\n  margin: 0 auto;\n  padding: 0;\n  width: 100%;\n}\n\n.daterangepicker .ranges li {\n  font-size: 12px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.daterangepicker .ranges li:hover {\n  background-color: #eee;\n}\n\n.daterangepicker .ranges li.active {\n  background-color: #08c;\n  color: #fff;\n}\n\n/*  Larger Screen Styling */\n@media (min-width: 564px) {\n  .daterangepicker {\n    width: auto;\n  }\n\n  .daterangepicker .ranges ul {\n    width: 140px;\n  }\n\n  .daterangepicker.single .ranges ul {\n    width: 100%;\n  }\n\n  .daterangepicker.single .drp-calendar.left {\n    clear: none;\n  }\n\n  .daterangepicker.single.ltr .ranges, .daterangepicker.single.ltr .drp-calendar {\n    float: left;\n  }\n\n  .daterangepicker.single.rtl .ranges, .daterangepicker.single.rtl .drp-calendar {\n    float: right;\n  }\n\n  .daterangepicker.ltr {\n    direction: ltr;\n    text-align: left;\n  }\n\n  .daterangepicker.ltr .drp-calendar.left {\n    clear: left;\n    margin-right: 0;\n  }\n\n  .daterangepicker.ltr .drp-calendar.left .calendar-table {\n    border-right: none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .daterangepicker.ltr .drp-calendar.right {\n    margin-left: 0;\n  }\n\n  .daterangepicker.ltr .drp-calendar.right .calendar-table {\n    border-left: none;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .daterangepicker.ltr .drp-calendar.left .calendar-table {\n    padding-right: 8px;\n  }\n\n  .daterangepicker.ltr .ranges, .daterangepicker.ltr .drp-calendar {\n    float: left;\n  }\n\n  .daterangepicker.rtl {\n    direction: rtl;\n    text-align: right;\n  }\n\n  .daterangepicker.rtl .drp-calendar.left {\n    clear: right;\n    margin-left: 0;\n  }\n\n  .daterangepicker.rtl .drp-calendar.left .calendar-table {\n    border-left: none;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .daterangepicker.rtl .drp-calendar.right {\n    margin-right: 0;\n  }\n\n  .daterangepicker.rtl .drp-calendar.right .calendar-table {\n    border-right: none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .daterangepicker.rtl .drp-calendar.left .calendar-table {\n    padding-left: 12px;\n  }\n\n  .daterangepicker.rtl .ranges, .daterangepicker.rtl .drp-calendar {\n    text-align: right;\n    float: right;\n  }\n}\n\n@media (min-width: 730px) {\n  .daterangepicker .ranges {\n    width: auto;\n  }\n\n  .daterangepicker.ltr .ranges {\n    float: left;\n  }\n\n  .daterangepicker.rtl .ranges {\n    float: right;\n  }\n\n  .daterangepicker .drp-calendar.left {\n    clear: none !important;\n  }\n}\n\n.reportrange-text {\n  background: #fff;\n  cursor: pointer;\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  width: 100%;\n}\n\n.daterangepicker {\n  flex-direction: column;\n  display: flex !important;\n  width: auto;\n}\n\n.calendars {\n  display: flex !important;\n}\n\ndiv.daterangepicker.opensleft {\n  top: 35px;\n  right: 10px;\n  left: auto;\n}\n\ndiv.daterangepicker.openscenter {\n  top: 35px;\n  right: auto;\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n\ndiv.daterangepicker.opensright {\n  top: 35px;\n  left: 10px;\n  right: auto;\n}\n\n/* Enter and leave animations can use different */\n/* durations and timing functions.              */\n.slide-fade-enter-active {\n  transition: all .2s ease;\n}\n\n.slide-fade-leave-active {\n  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);\n}\n\n.slide-fade-enter, .slide-fade-leave-to\n  /* .slide-fade-leave-active for <2.1.8 */\n{\n  transform: translateX(10px);\n  opacity: 0;\n}\n", ""]);

// exports


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "/* cyrillic-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OX-hpOqc.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n\n/* cyrillic */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OVuhpOqc.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n\n/* greek-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OXuhpOqc.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n\n/* greek */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OUehpOqc.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n\n/* vietnamese */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OXehpOqc.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n\n/* latin-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OXOhpOqc.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\n/* latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: local('Open Sans Light'), local('OpenSans-Light'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OUuhp.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFWJ0bbck.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n\n/* cyrillic */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n\n/* greek-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFWZ0bbck.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n\n/* greek */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFVp0bbck.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n\n/* vietnamese */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFWp0bbck.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n\n/* latin-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFW50bbck.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\n/* latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Open Sans Regular'), local('OpenSans-Regular'), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFVZ0b.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOX-hpOqc.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n\n/* cyrillic */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOVuhpOqc.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n\n/* greek-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOXuhpOqc.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n\n/* greek */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOUehpOqc.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n\n/* vietnamese */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOXehpOqc.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n\n/* latin-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOXOhpOqc.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\n/* latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: local('Open Sans SemiBold'), local('OpenSans-SemiBold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UNirkOUuhp.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOX-hpOqc.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n\n/* cyrillic */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOVuhpOqc.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n\n/* greek-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOXuhpOqc.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n\n/* greek */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOUehpOqc.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n\n/* vietnamese */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOXehpOqc.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\n}\n\n/* latin-ext */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOXOhpOqc.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n\n/* latin */\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: local('Open Sans Bold'), local('OpenSans-Bold'), url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOUuhp.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n:root, html {\n  font: 100%/1.75 Open Sans, Helvetica, sans-serif !important;\n  font-family: Open Sans, Helvetica, sans-serif;\n  font-size: 100%;\n  font-feature-settings: normal;\n  color: #000;\n}\n.badge {\n  border-radius: .25rem;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = "../../static/img/logo.08e947b.png";

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = "../../static/img/logo-symbol.950bc15.png";

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("router-view")
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Main__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_user_List__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_user_Form__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_role_List__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_admin_role_Form__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_admin_permission_List__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_admin_permission_Form__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_admin_client_List__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_admin_client_Form__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_admin_inventory_master_group_List__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_admin_inventory_master_group_Form__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_admin_inventory_master_type_List__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_admin_inventory_master_type_Form__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_admin_inventory_master_account_List__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_admin_inventory_master_account_Form__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_admin_inventory_master_material_List__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_admin_inventory_master_material_Form__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_admin_inventory_master_material_detail_List__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_admin_inventory_master_material_detail_Form__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_admin_inventory_master_supplier_List__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_admin_inventory_master_supplier_Form__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_admin_inventory_master_uom_Form__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_admin_inventory_master_uom_List__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_admin_inventory_master_uom_detail_Form__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_admin_inventory_master_uom_detail_List__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_admin_inventory_master_genstore_Form__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_admin_inventory_master_genstore_List__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_admin_inventory_master_recipe_Form__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_admin_inventory_master_recipe_List__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_admin_inventory_master_material_detail_supplier_Form__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_admin_inventory_master_material_detail_supplier_List__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_admin_inventory_master_material_recipe_mapping_Form__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_admin_inventory_master_material_recipe_mapping_List__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_admin_inventory_sync_master_Form__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_admin_inventory_sync_master_List__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_admin_inventory_sync_master_detail_List__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_Dashboard__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_Report__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_SalesHistory__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_ProductMix__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_OrderProcessingTime__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_pages_Page404__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_pages_Page500__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_admin_Login__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_admin_Logout__ = __webpack_require__(1334);























































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_47__views_admin_Login__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_48__views_admin_Logout__["a" /* default */]
  }, {
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__containers_Main__["a" /* default */],
    meta: {
      label: 'home'
    },
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_40__views_Dashboard__["a" /* default */],
      meta: {
        auth: true,
        label: 'dashboard'
      }
    }, {
      path: 'sales-history',
      name: 'sales_history',
      component: __WEBPACK_IMPORTED_MODULE_42__views_SalesHistory__["a" /* default */],
      meta: {
        auth: true,
        label: 'sales_history'
      }
    }, {
      path: 'product-mix',
      name: 'product_mix',
      component: __WEBPACK_IMPORTED_MODULE_43__views_ProductMix__["a" /* default */],
      meta: {
        auth: true,
        label: 'product_mix'
      }
    }, {
      path: 'order-processing-time',
      name: 'order_processing_time',
      component: __WEBPACK_IMPORTED_MODULE_44__views_OrderProcessingTime__["a" /* default */],
      meta: {
        auth: true,
        label: 'order_processing_time'
      }
    }, {
      path: 'report',
      name: 'report',
      component: __WEBPACK_IMPORTED_MODULE_41__views_Report__["a" /* default */],
      meta: {
        auth: { roles: ['report'] },
        label: 'report'
      }
    }, {
      path: 'user',
      redirect: '/user',
      name: 'user',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'user'
      },
      children: [{
        path: '/',
        name: 'user_list',
        component: __WEBPACK_IMPORTED_MODULE_5__views_admin_user_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'user_edit',
        component: __WEBPACK_IMPORTED_MODULE_6__views_admin_user_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'user_create',
        component: __WEBPACK_IMPORTED_MODULE_6__views_admin_user_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'role',
      redirect: '/role',
      name: 'role',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'role'
      },
      children: [{
        path: '/',
        name: 'role_list',
        component: __WEBPACK_IMPORTED_MODULE_7__views_admin_role_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'role_edit',
        component: __WEBPACK_IMPORTED_MODULE_8__views_admin_role_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'role_create',
        component: __WEBPACK_IMPORTED_MODULE_8__views_admin_role_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'permission',
      redirect: '/permission',
      name: 'permission',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'permission'
      },
      children: [{
        path: '/',
        name: 'permission_list',
        component: __WEBPACK_IMPORTED_MODULE_9__views_admin_permission_List__["a" /* default */],
        meta: {
          auth: { roles: ['permission.list'] },
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'permission_edit',
        component: __WEBPACK_IMPORTED_MODULE_10__views_admin_permission_Form__["a" /* default */],
        meta: {
          auth: { roles: ['permission.update', 'permission.detail'] },
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'permission_create',
        component: __WEBPACK_IMPORTED_MODULE_10__views_admin_permission_Form__["a" /* default */],
        meta: {
          auth: { roles: ['permission.create'] },
          label: 'create'
        }
      }]
    }, {
      path: 'client',
      redirect: '/client',
      name: 'client',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'client'
      },
      children: [{
        path: '/',
        name: 'client_list',
        component: __WEBPACK_IMPORTED_MODULE_11__views_admin_client_List__["a" /* default */],
        meta: {
          auth: { roles: ['client.list'] },
          label: 'list'
        }
      }, {
        path: 'edit/:uuid',
        props: true,
        name: 'client_edit',
        component: __WEBPACK_IMPORTED_MODULE_12__views_admin_client_Form__["a" /* default */],
        meta: {
          auth: { roles: ['client.update', 'client.detail'] },
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'client_create',
        component: __WEBPACK_IMPORTED_MODULE_12__views_admin_client_Form__["a" /* default */],
        meta: {
          auth: { roles: ['client.create'] },
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-group',
      redirect: '/inventory/master-group',
      name: 'master_group',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_group'
      },
      children: [{
        path: '/',
        name: 'master_group_list',
        component: __WEBPACK_IMPORTED_MODULE_13__views_admin_inventory_master_group_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_group_edit',
        component: __WEBPACK_IMPORTED_MODULE_14__views_admin_inventory_master_group_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_group_create',
        component: __WEBPACK_IMPORTED_MODULE_14__views_admin_inventory_master_group_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-type',
      redirect: '/inventory/master-type',
      name: 'master_type',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_type'
      },
      children: [{
        path: '/',
        name: 'master_type_list',
        component: __WEBPACK_IMPORTED_MODULE_15__views_admin_inventory_master_type_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_type_edit',
        component: __WEBPACK_IMPORTED_MODULE_16__views_admin_inventory_master_type_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_type_create',
        component: __WEBPACK_IMPORTED_MODULE_16__views_admin_inventory_master_type_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-uom',
      redirect: '/inventory/master-uom',
      name: 'master_uom',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_uom'
      },
      children: [{
        path: '/',
        name: 'master_uom_list',
        component: __WEBPACK_IMPORTED_MODULE_26__views_admin_inventory_master_uom_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_uom_edit',
        component: __WEBPACK_IMPORTED_MODULE_25__views_admin_inventory_master_uom_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_uom_create',
        component: __WEBPACK_IMPORTED_MODULE_25__views_admin_inventory_master_uom_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-uom-detail',
      redirect: '/inventory/master-uom-detail',
      name: 'master_uom_detail',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_uom_detail'
      },
      children: [{
        path: '/',
        name: 'master_uom_detail_list',
        component: __WEBPACK_IMPORTED_MODULE_28__views_admin_inventory_master_uom_detail_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_uom_detail_edit',
        component: __WEBPACK_IMPORTED_MODULE_27__views_admin_inventory_master_uom_detail_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_uom_detail_create',
        component: __WEBPACK_IMPORTED_MODULE_27__views_admin_inventory_master_uom_detail_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-account',
      redirect: '/inventory/master-account',
      name: 'master_account',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_account'
      },
      children: [{
        path: '/',
        name: 'master_account_list',
        component: __WEBPACK_IMPORTED_MODULE_17__views_admin_inventory_master_account_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_account_edit',
        component: __WEBPACK_IMPORTED_MODULE_18__views_admin_inventory_master_account_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_account_create',
        component: __WEBPACK_IMPORTED_MODULE_18__views_admin_inventory_master_account_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material',
      redirect: '/inventory/master-material',
      name: 'master_material',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material'
      },
      children: [{
        path: '/',
        name: 'master_material_list',
        component: __WEBPACK_IMPORTED_MODULE_19__views_admin_inventory_master_material_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_material_edit',
        component: __WEBPACK_IMPORTED_MODULE_20__views_admin_inventory_master_material_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_create',
        component: __WEBPACK_IMPORTED_MODULE_20__views_admin_inventory_master_material_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material-detail',
      redirect: '/inventory/master-material-detail',
      name: 'master_material_detail',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material_detail'
      },
      children: [{
        path: '/',
        name: 'master_material_detail_list',
        component: __WEBPACK_IMPORTED_MODULE_21__views_admin_inventory_master_material_detail_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_material_detail_edit',
        component: __WEBPACK_IMPORTED_MODULE_22__views_admin_inventory_master_material_detail_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_detail_create',
        component: __WEBPACK_IMPORTED_MODULE_22__views_admin_inventory_master_material_detail_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-supplier',
      redirect: '/inventory/master-supplier',
      name: 'master_supplier',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_supplier'
      },
      children: [{
        path: '/',
        name: 'master_supplier_list',
        component: __WEBPACK_IMPORTED_MODULE_23__views_admin_inventory_master_supplier_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_supplier_edit',
        component: __WEBPACK_IMPORTED_MODULE_24__views_admin_inventory_master_supplier_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_supplier_create',
        component: __WEBPACK_IMPORTED_MODULE_24__views_admin_inventory_master_supplier_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-genstore',
      redirect: '/inventory/master-genstore',
      name: 'master_genstore',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_genstore'
      },
      children: [{
        path: '/',
        name: 'list',
        component: __WEBPACK_IMPORTED_MODULE_30__views_admin_inventory_master_genstore_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_genstore_edit',
        component: __WEBPACK_IMPORTED_MODULE_29__views_admin_inventory_master_genstore_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_genstore_create',
        component: __WEBPACK_IMPORTED_MODULE_29__views_admin_inventory_master_genstore_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-recipe',
      redirect: '/inventory/master-recipe',
      name: 'master_recipe',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_recipe'
      },
      children: [{
        path: '/',
        name: 'list',
        component: __WEBPACK_IMPORTED_MODULE_32__views_admin_inventory_master_recipe_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'master_recipe_edit',
        component: __WEBPACK_IMPORTED_MODULE_31__views_admin_inventory_master_recipe_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_recipe_create',
        component: __WEBPACK_IMPORTED_MODULE_31__views_admin_inventory_master_recipe_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material-detail-supplier',
      redirect: '/inventory/master-material-detail-supplier',
      name: 'master_material_detail_supplier',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material_detail_supplier'
      },
      children: [{
        path: '/',
        name: 'master_material_detail_supplier_list',
        component: __WEBPACK_IMPORTED_MODULE_34__views_admin_inventory_master_material_detail_supplier_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:material_detail_id',
        props: true,
        name: 'master_material_detail_supplier_edit',
        component: __WEBPACK_IMPORTED_MODULE_33__views_admin_inventory_master_material_detail_supplier_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_detail_supplier_create',
        component: __WEBPACK_IMPORTED_MODULE_33__views_admin_inventory_master_material_detail_supplier_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/master-material-recipe-mapping',
      redirect: '/inventory/master-material-recipe-mapping',
      name: 'master_material_recipe_mapping',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'master_material_recipe_mapping'
      },
      children: [{
        path: '/',
        name: 'master_material_recipe_mapping_list',
        component: __WEBPACK_IMPORTED_MODULE_36__views_admin_inventory_master_material_recipe_mapping_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:material_recipe_mapping_id',
        props: true,
        name: 'master_material_recipe_mapping_edit',
        component: __WEBPACK_IMPORTED_MODULE_35__views_admin_inventory_master_material_recipe_mapping_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'master_material_recipe_mapping_create',
        component: __WEBPACK_IMPORTED_MODULE_35__views_admin_inventory_master_material_recipe_mapping_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/sync-master',
      redirect: '/inventory/sync-master',
      name: 'sync_master',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'sync_master'
      },
      children: [{
        path: '/',
        name: 'sync_master_list',
        component: __WEBPACK_IMPORTED_MODULE_38__views_admin_inventory_sync_master_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }, {
        path: 'edit/:id',
        props: true,
        name: 'sync_master_edit',
        component: __WEBPACK_IMPORTED_MODULE_37__views_admin_inventory_sync_master_Form__["a" /* default */],
        meta: {
          label: 'edit'
        }
      }, {
        path: 'create',
        name: 'sync_master_create',
        component: __WEBPACK_IMPORTED_MODULE_37__views_admin_inventory_sync_master_Form__["a" /* default */],
        meta: {
          label: 'create'
        }
      }]
    }, {
      path: 'inventory/sync-master-detail',
      redirect: '/inventory/sync-master-detail',
      name: 'sync_master_detail',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        label: 'sync_master_detail'
      },
      children: [{
        path: '/',
        name: 'sync_master_detail_list',
        component: __WEBPACK_IMPORTED_MODULE_39__views_admin_inventory_sync_master_detail_List__["a" /* default */],
        meta: {
          label: 'list'
        }
      }]
    }]
  }, {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_45__views_pages_Page404__["a" /* default */]
    }, {
      path: '403',
      name: 'Page403',
      component: __WEBPACK_IMPORTED_MODULE_45__views_pages_Page404__["a" /* default */]
    }, {
      path: '500',
      name: 'Page500',
      component: __WEBPACK_IMPORTED_MODULE_46__views_pages_Page500__["a" /* default */]
    }]
  }]
}));

/***/ }),
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cc5c7ed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1140);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1105)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cc5c7ed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/containers/Main.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4cc5c7ed", Component.options)
  } else {
    hotAPI.reload("data-v-4cc5c7ed", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("bb2d78ca", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4cc5c7ed\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Main.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4cc5c7ed\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Main.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.custom-template {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  text-align: left;\n  font-size: 13px;\n  margin: 5px;\n  margin-bottom: 0;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: #E8F9F0;\n  border: 2px solid #D0F2E1;\n}\n.custom-template, .custom-template > div {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n}\n.custom-template .custom-template-icon {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 auto;\n            flex: 0 1 auto;\n    color: #15C371;\n    font-size: 32px;\n    padding: 0 10px;\n}\n.custom-template .custom-template-close {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 auto;\n            flex: 0 1 auto;\n    padding: 0 20px;\n    font-size: 16px;\n    opacity: 0.2;\n    cursor: pointer;\n}\n.custom-template .custom-template-close:hover {\n      opacity: 0.8;\n}\n.custom-template .custom-template-content {\n    padding: 10px;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 0 auto;\n            flex: 1 0 auto;\n}\n.custom-template .custom-template-content .custom-template-title {\n      letter-spacing: 1px;\n      text-transform: uppercase;\n      font-size: 10px;\n      font-weight: 600;\n}\n.nav-dropdown-items .nav-link {\n  padding-left: 2rem;\n}\n", ""]);

// exports


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(14);
/* unused harmony reexport Aside */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(184);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a55538_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(1111);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29a55538_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Aside.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29a55538", Component.options)
  } else {
    hotAPI.reload("data-v-29a55538", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classList }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ff56ba0", esExports)
  }
}

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.classList },
    [
      _c("input", {
        staticClass: "switch-input",
        attrs: { type: "checkbox" },
        domProps: { value: _vm.value, checked: _vm.isChecked },
        on: { change: _vm.handleChange }
      }),
      _vm._v(" "),
      _vm.isOn
        ? [
            _c("span", {
              staticClass: "switch-label",
              attrs: { "data-on": _vm.on, "data-off": _vm.off }
            })
          ]
        : [_c("span", { staticClass: "switch-label" })],
      _vm._v(" "),
      _c("span", { staticClass: "switch-handle" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5168b938", esExports)
  }
}

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "aside-menu" },
    [
      _c(
        "b-tabs",
        [
          _c(
            "b-tab",
            { attrs: { title: "<i class='icon-list'></i>" } },
            [
              _c(
                "Callout",
                {
                  staticClass:
                    "m-0 py-2 text-muted text-center bg-light text-uppercase"
                },
                [_c("small", [_c("b", [_vm._v("Today")])])]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "transparent mx-3 my-0" }),
              _vm._v(" "),
              _c(
                "Callout",
                { staticClass: "m-0 py-3", attrs: { variant: "warning" } },
                [
                  _c("div", { staticClass: "avatar float-right" }, [
                    _c("img", {
                      staticClass: "img-avatar",
                      attrs: {
                        src: "static/img/avatars/7.jpg",
                        alt: "admin@bootstrapmaster.com"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("Meeting with "),
                    _c("strong", [_vm._v("Lucas")])
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted mr-3" }, [
                    _c("i", { staticClass: "icon-calendar" }),
                    _vm._v("  1 - 3pm")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _c("i", { staticClass: "icon-location-pin" }),
                    _vm._v("  Palo Alto, CA ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-3 my-0" }),
              _vm._v(" "),
              _c(
                "Callout",
                { staticClass: "m-0 py-3", attrs: { variant: "info" } },
                [
                  _c("div", { staticClass: "avatar float-right" }, [
                    _c("img", {
                      staticClass: "img-avatar",
                      attrs: {
                        src: "static/img/avatars/4.jpg",
                        alt: "admin@bootstrapmaster.com"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v("Skype with "),
                    _c("strong", [_vm._v("Megan")])
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted mr-3" }, [
                    _c("i", { staticClass: "icon-calendar" }),
                    _vm._v("  4 - 5pm")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _c("i", { staticClass: "icon-social-skype" }),
                    _vm._v("  On-line ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "transparent mx-3 my-0" }),
              _vm._v(" "),
              _c(
                "Callout",
                {
                  staticClass:
                    "m-0 py-2 text-muted text-center bg-light text-uppercase"
                },
                [_c("small", [_c("b", [_vm._v("Tomorrow")])])]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "transparent mx-3 my-0" }),
              _vm._v(" "),
              _c(
                "Callout",
                { staticClass: "m-0 py-3", attrs: { variant: "danger" } },
                [
                  _c("div", [
                    _vm._v("New UI Project - "),
                    _c("strong", [_vm._v("deadline")])
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted mr-3" }, [
                    _c("i", { staticClass: "icon-calendar" }),
                    _vm._v("  10 - 11pm")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _c("i", { staticClass: "icon-home" }),
                    _vm._v("  creativeLabs HQ ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "avatars-stack mt-2" }, [
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/2.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/3.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/4.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/5.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/6.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-3 my-0" }),
              _vm._v(" "),
              _c(
                "Callout",
                { staticClass: "m-0 py-3", attrs: { variant: "success" } },
                [
                  _c("div", [
                    _c("strong", [_vm._v("#10 Startups.Garden")]),
                    _vm._v(" Meetup")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted mr-3" }, [
                    _c("i", { staticClass: "icon-calendar" }),
                    _vm._v("  1 - 3pm")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _c("i", { staticClass: "icon-location-pin" }),
                    _vm._v("  Palo Alto, CA ")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-3 my-0" }),
              _vm._v(" "),
              _c(
                "Callout",
                { staticClass: "m-0 py-3", attrs: { variant: "primary" } },
                [
                  _c("div", [_c("strong", [_vm._v("Team meeting")])]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted mr-3" }, [
                    _c("i", { staticClass: "icon-calendar" }),
                    _vm._v("  4 - 6pm")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted" }, [
                    _c("i", { staticClass: "icon-home" }),
                    _vm._v("  creativeLabs HQ ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "avatars-stack mt-2" }, [
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/2.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/3.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/4.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/5.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/6.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/7.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "avatar avatar-xs" }, [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/8.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-3 my-0" })
            ],
            1
          ),
          _vm._v(" "),
          _c("b-tab", { attrs: { title: "<i class='icon-speech'></i>" } }, [
            _c("div", { staticClass: "p-3" }, [
              _c("div", { staticClass: "message" }, [
                _c("div", { staticClass: "py-3 pb-5 mr-3 float-left" }, [
                  _c(
                    "div",
                    { staticClass: "avatar" },
                    [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/7.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-badge", {
                        staticClass: "avatar-status",
                        attrs: { variant: "success" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Lukasz Holeczek")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted float-right mt-1" }, [
                    _vm._v("1:52 PM")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-truncate font-weight-bold" }, [
                  _vm._v("Lorem ipsum dolor sit amet")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt..."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "message" }, [
                _c("div", { staticClass: "py-3 pb-5 mr-3 float-left" }, [
                  _c(
                    "div",
                    { staticClass: "avatar" },
                    [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/7.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-badge", {
                        staticClass: "avatar-status",
                        attrs: { variant: "success" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Lukasz Holeczek")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted float-right mt-1" }, [
                    _vm._v("1:52 PM")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-truncate font-weight-bold" }, [
                  _vm._v("Lorem ipsum dolor sit amet")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt..."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "message" }, [
                _c("div", { staticClass: "py-3 pb-5 mr-3 float-left" }, [
                  _c(
                    "div",
                    { staticClass: "avatar" },
                    [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/7.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-badge", {
                        staticClass: "avatar-status",
                        attrs: { variant: "success" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Lukasz Holeczek")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted float-right mt-1" }, [
                    _vm._v("1:52 PM")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-truncate font-weight-bold" }, [
                  _vm._v("Lorem ipsum dolor sit amet")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt..."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "message" }, [
                _c("div", { staticClass: "py-3 pb-5 mr-3 float-left" }, [
                  _c(
                    "div",
                    { staticClass: "avatar" },
                    [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/7.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-badge", {
                        staticClass: "avatar-status",
                        attrs: { variant: "success" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Lukasz Holeczek")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted float-right mt-1" }, [
                    _vm._v("1:52 PM")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-truncate font-weight-bold" }, [
                  _vm._v("Lorem ipsum dolor sit amet")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt..."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "message" }, [
                _c("div", { staticClass: "py-3 pb-5 mr-3 float-left" }, [
                  _c(
                    "div",
                    { staticClass: "avatar" },
                    [
                      _c("img", {
                        staticClass: "img-avatar",
                        attrs: {
                          src: "static/img/avatars/7.jpg",
                          alt: "admin@bootstrapmaster.com"
                        }
                      }),
                      _vm._v(" "),
                      _c("b-badge", {
                        staticClass: "avatar-status",
                        attrs: { variant: "success" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Lukasz Holeczek")
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-muted float-right mt-1" }, [
                    _vm._v("1:52 PM")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-truncate font-weight-bold" }, [
                  _vm._v("Lorem ipsum dolor sit amet")
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt..."
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("b-tab", { attrs: { title: "<i class='icon-settings'></i>" } }, [
            _c(
              "div",
              { staticClass: "p-3" },
              [
                _c("h6", [_vm._v("Settings")]),
                _vm._v(" "),
                _c("div", { staticClass: "aside-options" }, [
                  _c(
                    "div",
                    { staticClass: "clearfix mt-4" },
                    [
                      _c("small", [_c("b", [_vm._v("Option 1")])]),
                      _vm._v(" "),
                      _c("c-switch", {
                        staticClass: "float-right",
                        attrs: {
                          type: "text",
                          variant: "success",
                          on: "on",
                          off: "off",
                          pill: true,
                          size: "sm",
                          checked: true
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "aside-options" }, [
                  _c(
                    "div",
                    { staticClass: "clearfix mt-3" },
                    [
                      _c("small", [_c("b", [_vm._v("Option 2")])]),
                      _vm._v(" "),
                      _c("c-switch", {
                        staticClass: "float-right",
                        attrs: {
                          type: "text",
                          variant: "success",
                          on: "on",
                          off: "off",
                          pill: true,
                          size: "sm"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(
                        "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "aside-options" }, [
                  _c(
                    "div",
                    { staticClass: "clearfix mt-3" },
                    [
                      _c("small", [_c("b", [_vm._v("Option 3")])]),
                      _vm._v(" "),
                      _c("c-switch", {
                        staticClass: "float-right",
                        attrs: {
                          type: "text",
                          variant: "success",
                          on: "on",
                          off: "off",
                          pill: true,
                          size: "sm"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "aside-options" }, [
                  _c(
                    "div",
                    { staticClass: "clearfix mt-3" },
                    [
                      _c("small", [_c("b", [_vm._v("Option 4")])]),
                      _vm._v(" "),
                      _c("c-switch", {
                        staticClass: "float-right",
                        attrs: {
                          type: "text",
                          variant: "success",
                          on: "on",
                          off: "off",
                          pill: true,
                          size: "sm",
                          checked: true
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h6", [_vm._v("System Utilization")]),
                _vm._v(" "),
                _c("div", { staticClass: "text-uppercase mb-1 mt-4" }, [
                  _c("small", [_c("b", [_vm._v("CPU Usage")])])
                ]),
                _vm._v(" "),
                _c("b-progress", {
                  staticClass: "progress-xs",
                  attrs: { height: "{}", variant: "info", value: 25 }
                }),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v("348 Processes. 1/4 Cores.")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-uppercase mb-1 mt-2" }, [
                  _c("small", [_c("b", [_vm._v("Memory Usage")])])
                ]),
                _vm._v(" "),
                _c("b-progress", {
                  staticClass: "progress-xs",
                  attrs: { height: "{}", variant: "warning", value: 70 }
                }),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v("11444GB/16384MB")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-uppercase mb-1 mt-2" }, [
                  _c("small", [_c("b", [_vm._v("SSD 1 Usage")])])
                ]),
                _vm._v(" "),
                _c("b-progress", {
                  staticClass: "progress-xs",
                  attrs: { height: "{}", variant: "danger", value: 95 }
                }),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v("243GB/256GB")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-uppercase mb-1 mt-2" }, [
                  _c("small", [_c("b", [_vm._v("SSD 2 Usage")])])
                ]),
                _vm._v(" "),
                _c("b-progress", {
                  staticClass: "progress-xs",
                  attrs: { height: "{}", variant: "success", value: 10 }
                }),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v("25GB/256GB")
                ])
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29a55538", esExports)
  }
}

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f46de9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(1113);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f46de9a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Breadcrumb.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6f46de9a", Component.options)
  } else {
    hotAPI.reload("data-v-6f46de9a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "breadcrumb" },
    _vm._l(_vm.list, function(item, index) {
      return _c(
        "li",
        { staticClass: "breadcrumb-item" },
        [
          _vm.isLast(index)
            ? _c("span", { staticClass: "active" }, [
                _vm._v(_vm._s(_vm.showName(item)))
              ])
            : _c("router-link", { attrs: { to: item } }, [
                _vm._v(_vm._s(_vm.showName(item)))
              ])
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f46de9a", esExports)
  }
}

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ab164b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(1115);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ab164b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Footer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40ab164b", Component.options)
  } else {
    hotAPI.reload("data-v-40ab164b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "app-footer" }, [
      _c("span", { staticClass: "ml-auto" }, [
        _vm._v("copyright © 2018 by "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("Diqit")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741978ef_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1122);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1117)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741978ef_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Header/Header.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-741978ef", Component.options)
  } else {
    hotAPI.reload("data-v-741978ef", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("aa4767a6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-741978ef\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-741978ef\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.header-language {\n  margin-top: 16px;\n}\n.header-language select {\n  height: 35px !important;\n  width: 100px;\n}\n.header-search {\n  width: 400px;\n}\n", ""]);

// exports


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8c5ef7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(1120);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8c5ef7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Header/HeaderDropdownAccnt.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a8c5ef7", Component.options)
  } else {
    hotAPI.reload("data-v-4a8c5ef7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    { attrs: { right: "", "no-caret": "" } },
    [
      _c("template", { slot: "button-content" }, [
        _c("img", {
          staticClass: "img-avatar",
          attrs: {
            src: _vm.$auth.user()["info"]["avatar"],
            alt: _vm.$auth.user()["info"]["name"]
          }
        })
      ]),
      _vm._v(" "),
      _c("b-dropdown-header", [
        _vm._v(
          _vm._s(_vm.$t("hello")) +
            " " +
            _vm._s(_vm.$auth.user()["info"]["name"])
        )
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("i", { staticClass: "fa fa-user" }),
        _vm._v(" " + _vm._s(_vm.$t("profile")))
      ]),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function($event) {
              _vm.logout()
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-lock" }),
          _vm._v(" " + _vm._s(_vm.$t("logout")))
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a8c5ef7", esExports)
  }
}

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "lang" } }, [
    _c("p", { staticStyle: { display: "none" } }, [
      _c(
        "a",
        {
          staticClass: " typo-l6",
          staticStyle: { color: "white" },
          attrs: { href: "javascript:void(0)" },
          on: {
            click: function($event) {
              _vm.setLang("vi")
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("vietnamese")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: " typo-l6",
          staticStyle: { color: "white" },
          attrs: { href: "javascript:void(0)" },
          on: {
            click: function($event) {
              _vm.setLang("en")
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("english")) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "p",
      [
        _c("b-form-select", {
          attrs: {
            id: "basicSelect",
            value: _vm.current_lang,
            size: "sm",
            plain: true,
            options: [
              {
                text: _vm.$t("vietnamese"),
                value: "vi"
              },
              {
                text: _vm.$t("english"),
                value: "en"
              }
            ]
          },
          model: {
            value: _vm.current_lang,
            callback: function($$v) {
              _vm.current_lang = $$v
            },
            expression: "current_lang"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f737190", esExports)
  }
}

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "app-header navbar" },
    [
      _c(
        "button",
        {
          staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
          attrs: { type: "button" },
          on: { click: _vm.mobileSidebarToggle }
        },
        [_c("span", { staticClass: "navbar-toggler-icon" })]
      ),
      _vm._v(" "),
      _c("b-link", { staticClass: "navbar-brand", attrs: { to: "#" } }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "navbar-toggler sidebar-toggler d-md-down-none",
          attrs: { type: "button" },
          on: { click: _vm.sidebarToggle }
        },
        [_c("span", { staticClass: "navbar-toggler-icon" })]
      ),
      _vm._v(" "),
      _c(
        "b-navbar-nav",
        { staticClass: "ml-auto" },
        [_c("HeaderDropdownAccnt")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-741978ef", esExports)
  }
}

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ef2d09_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1139);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1124)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ef2d09_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/Sidebar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60ef2d09", Component.options)
  } else {
    hotAPI.reload("data-v-60ef2d09", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1b22e8a6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60ef2d09\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60ef2d09\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Sidebar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.nav-link {\n  cursor:pointer;\n}\n", ""]);

// exports


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5d98a8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(1127);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5d98a8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/SidebarMinimizer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c5d98a8a", Component.options)
  } else {
    hotAPI.reload("data-v-c5d98a8a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", {
    staticClass: "sidebar-minimizer",
    attrs: { type: "button" },
    on: {
      click: function($event) {
        _vm.sidebarMinimize()
        _vm.brandMinimize()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5d98a8a", esExports)
  }
}

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96fd8d42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(1130);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96fd8d42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/SidebarNavDivider.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-96fd8d42", Component.options)
  } else {
    hotAPI.reload("data-v-96fd8d42", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1129 */,
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { class: _vm.classList })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96fd8d42", esExports)
  }
}

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70e388a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(1132);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70e388a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/SidebarNavDropdown.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d70e388a", Component.options)
  } else {
    hotAPI.reload("data-v-d70e388a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "nav-item nav-dropdown",
      attrs: { tag: "li", to: _vm.url, disabled: "" }
    },
    [
      _c(
        "div",
        {
          staticClass: "nav-link nav-dropdown-toggle",
          on: { click: _vm.handleClick }
        },
        [_c("i", { class: _vm.icon }), _vm._v(" " + _vm._s(_vm.name))]
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "nav-dropdown-items" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d70e388a", esExports)
  }
}

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f3cc24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(1134);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f3cc24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/SidebarNavLink.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35f3cc24", Component.options)
  } else {
    hotAPI.reload("data-v-35f3cc24", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isExternalLink
    ? _c("div", [
        _c(
          "a",
          { class: _vm.classList, attrs: { href: _vm.url } },
          [
            _c("i", { class: _vm.icon }),
            _vm._v(" " + _vm._s(_vm.name) + "\n    "),
            _vm.badge && _vm.badge.text
              ? _c("b-badge", { attrs: { variant: _vm.badge.variant } }, [
                  _vm._v(_vm._s(_vm.badge.text))
                ])
              : _vm._e()
          ],
          1
        )
      ])
    : _c(
        "div",
        [
          _c(
            "router-link",
            { class: _vm.classList, attrs: { to: _vm.url } },
            [
              _c("i", { class: _vm.icon }),
              _vm._v(" " + _vm._s(_vm.name) + "\n    "),
              _vm.badge && _vm.badge.text
                ? _c("b-badge", { attrs: { variant: _vm.badge.variant } }, [
                    _vm._v(_vm._s(_vm.badge.text))
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35f3cc24", esExports)
  }
}

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca9c49e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(1136);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ca9c49e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/SidebarNavTitle.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6ca9c49e", Component.options)
  } else {
    hotAPI.reload("data-v-6ca9c49e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { class: _vm.classList },
    [
      _vm.wrapper && _vm.wrapper.element
        ? [
            _c(
              _vm.wrapper.element,
              _vm._b(
                { tag: "component" },
                "component",
                _vm.wrapper.attributes,
                false
              ),
              [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]
            )
          ]
        : [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ca9c49e", esExports)
  }
}

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f562bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(1138);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34f562bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Sidebar/SidebarNavItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34f562bd", Component.options)
  } else {
    hotAPI.reload("data-v-34f562bd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { class: _vm.classList, on: { click: _vm.hideMobile } },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34f562bd", esExports)
  }
}

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c(
        "nav",
        { staticClass: "sidebar-nav" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav" },
            [
              _vm._l(_vm.navItems, function(item, index) {
                return _vm.$auth.check(item.role)
                  ? [
                      item.title
                        ? [
                            _c("SidebarNavTitle", {
                              attrs: {
                                name: _vm.$t(item.name),
                                classes: item.class,
                                wrapper: item.wrapper
                              }
                            })
                          ]
                        : item.divider
                        ? [
                            _c("SidebarNavDivider", {
                              attrs: { classes: item.class }
                            })
                          ]
                        : [
                            item.children
                              ? [
                                  _vm.$auth.check(item.role)
                                    ? _c(
                                        "SidebarNavDropdown",
                                        {
                                          attrs: {
                                            name: _vm.$t(item.name),
                                            url: item.url,
                                            icon: item.icon
                                          }
                                        },
                                        [
                                          _vm._l(item.children, function(
                                            childL1,
                                            index
                                          ) {
                                            return [
                                              childL1.children
                                                ? [
                                                    _c(
                                                      "SidebarNavDropdown",
                                                      {
                                                        attrs: {
                                                          name: _vm.$t(
                                                            childL1.name
                                                          ),
                                                          url: childL1.url,
                                                          icon: childL1.icon
                                                        }
                                                      },
                                                      _vm._l(
                                                        childL1.children,
                                                        function(
                                                          childL2,
                                                          index
                                                        ) {
                                                          return _c(
                                                            "li",
                                                            {
                                                              staticClass:
                                                                "nav-item"
                                                            },
                                                            [
                                                              _c(
                                                                "SidebarNavLink",
                                                                {
                                                                  attrs: {
                                                                    name: _vm.$t(
                                                                      childL2.name
                                                                    ),
                                                                    url:
                                                                      childL2.url,
                                                                    icon:
                                                                      childL2.icon,
                                                                    badge:
                                                                      childL2.badge,
                                                                    variant:
                                                                      item.variant
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "SidebarNavItem",
                                                      {
                                                        attrs: {
                                                          classes: item.class
                                                        }
                                                      },
                                                      [
                                                        _c("SidebarNavLink", {
                                                          attrs: {
                                                            name: _vm.$t(
                                                              childL1.name
                                                            ),
                                                            url: childL1.url,
                                                            icon: childL1.icon,
                                                            badge:
                                                              childL1.badge,
                                                            variant:
                                                              item.variant
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c(
                                    "SidebarNavItem",
                                    { attrs: { classes: item.class } },
                                    [
                                      _vm.$auth.check(item.role)
                                        ? _c("SidebarNavLink", {
                                            attrs: {
                                              name: _vm.$t(item.name),
                                              url: item.url,
                                              icon: item.icon,
                                              badge: item.badge,
                                              variant: item.variant
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                          ]
                    ]
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c("SidebarMinimizer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ef2d09", esExports)
  }
}

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("notifications"),
      _vm._v(" "),
      _c("AppHeader"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-body" },
        [
          _c("Sidebar", { attrs: { navItems: _vm.nav } }),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "main" },
            [
              _c("breadcrumb", { attrs: { list: _vm.list } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("AppFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cc5c7ed", esExports)
  }
}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7457cd0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1161);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7457cd0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/user/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c7457cd0", Component.options)
  } else {
    hotAPI.reload("data-v-c7457cd0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "select-dropdown" } },
    [
      _c(
        "b-dropdown",
        {
          attrs: {
            slot: this.position,
            text: _vm.$t(_vm.value),
            variant: _vm.theme
          },
          slot: this.position
        },
        _vm._l(_vm.values, function(item) {
          return _c(
            "b-dropdown-item",
            {
              key: item.id,
              on: {
                click: function($event) {
                  _vm.setSelected(item)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t(item)))]
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ffe1eea", esExports)
  }
}

/***/ }),
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: function getToken() {
    return localStorage.getItem('default_auth_token');
  },
  deleteToken: function deleteToken() {
    return localStorage.removeItem('default_auth_token');
  }
});

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.$auth.check(_vm.model + ".create")
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: _vm.model + "_create" }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          { attrs: { variant: "primary" } },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("create")) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _vm.$auth.check(
                                            _vm.model + ".update"
                                          ) ||
                                          _vm.$auth.check(_vm.model + ".detail")
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: _vm.model + "_edit",
                                                      params: {
                                                        uuid: item.uuid
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "primary"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.active != 1 &&
                                          _vm.$auth.check(
                                            _vm.model + ".update.status"
                                          )
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.uuid,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.active == 1 &&
                                          _vm.$auth.check(
                                            _vm.model + ".update.status"
                                          )
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.uuid,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7457cd0", esExports)
  }
}

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68641abe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1168);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1163)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68641abe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68641abe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/user/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-68641abe", Component.options)
  } else {
    hotAPI.reload("data-v-68641abe", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3f3fcf2e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-68641abe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-68641abe\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.preview-image[data-v-68641abe] {\n  width: 100%;\n}\n.switch[data-v-68641abe] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n.role-permissions[data-v-68641abe] {\n  width: calc(70% - 30px);\n  margin-left: calc(30% + 15px);\n}\n.role-permission[data-v-68641abe] {\n  width: 50%;\n  float: left;\n}\n", ""]);

// exports


/***/ }),
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { label: _vm.$t("avatar") } },
                                  [
                                    _c("b-form-file", {
                                      ref: "avatar",
                                      attrs: {
                                        id: "avatarData",
                                        accept: "image/*"
                                      },
                                      on: { change: _vm.previewImage }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "image-desktop-preview" },
                                  [
                                    _c("img", {
                                      staticClass: "preview-image",
                                      attrs: {
                                        src:
                                          _vm.avatarData != ""
                                            ? _vm.avatarData
                                            : _vm.item.avatar
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "9" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("username"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "usernameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.username,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "username", $$v)
                                        },
                                        expression: "item.username"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("email"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "emailFeedback"
                                      },
                                      model: {
                                        value: _vm.item.email,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "email", $$v)
                                        },
                                        expression: "item.email"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("password"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "password",
                                        "aria-describedby": "passwordFeedback"
                                      },
                                      model: {
                                        value: _vm.item.password,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "password", $$v)
                                        },
                                        expression: "item.password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("confirm_password"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "password",
                                        "aria-describedby":
                                          "passwordConfirmationFeedback"
                                      },
                                      model: {
                                        value: _vm.item.password_confirmation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "password_confirmation",
                                            $$v
                                          )
                                        },
                                        expression: "item.password_confirmation"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("store"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options:
                                          _vm.outlets[_vm.$session.get("lang")]
                                      },
                                      model: {
                                        value: _vm.item.store_code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "store_code", $$v)
                                        },
                                        expression: "item.store_code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.active,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "active", $$v)
                                            },
                                            expression: "item.active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _vm._l(_vm.roles, function(role) {
                              return _c(
                                "b-col",
                                { key: role.code, attrs: { cols: "3" } },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "switch switch-icon switch-primary"
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "switch-input",
                                        attrs: {
                                          type: "checkbox",
                                          name: "roles[]"
                                        },
                                        domProps: {
                                          value: role.id,
                                          checked:
                                            _vm._.indexOf(
                                              _vm.item.roleIds,
                                              role.id
                                            ) >= 0
                                              ? true
                                              : false
                                        },
                                        on: { change: _vm.updatePermission }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-label",
                                        attrs: {
                                          "data-on": "",
                                          "data-off": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-handle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "legend",
                                    { staticClass: "col-form-label" },
                                    [
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(role.name))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "role-permissions" },
                                    _vm._l(role.permissions, function(
                                      permission
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: permission.id,
                                          staticClass: "role-permission"
                                        },
                                        [
                                          _c("input", {
                                            attrs: { type: "hidden" },
                                            domProps: { value: permission.id }
                                          })
                                        ]
                                      )
                                    })
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _vm._l(_vm.permissions, function(permission) {
                              return _c(
                                "div",
                                { key: permission.code, staticClass: "col-3" },
                                [
                                  _c(
                                    "label",
                                    {
                                      class:
                                        "switch switch-icon switch-" +
                                        (_vm.checkPermissionInRole(
                                          permission.id
                                        )
                                          ? "secondary"
                                          : "primary")
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "switch-input",
                                        attrs: {
                                          type: "checkbox",
                                          name: "roles[]"
                                        },
                                        domProps: {
                                          value: permission.id,
                                          checked: _vm.checkPermission(
                                            permission.id
                                          )
                                        },
                                        on: { change: _vm.updateRole }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-label",
                                        attrs: {
                                          "data-on": "",
                                          "data-off": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-handle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "legend",
                                    { staticClass: "col-form-label" },
                                    [
                                      _vm._v(
                                        _vm._s(permission.name) +
                                          "\n                "
                                      ),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(permission.description))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68641abe", esExports)
  }
}

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c93bd4d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1170);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c93bd4d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/role/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c93bd4d", Component.options)
  } else {
    hotAPI.reload("data-v-5c93bd4d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "role-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.$auth.check(_vm.model + ".create")
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: _vm.model + "_create" }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          { attrs: { variant: "primary" } },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("create")) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _vm.$auth.check(
                                            _vm.model + ".update"
                                          ) ||
                                          _vm.$auth.check(_vm.model + ".detail")
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: _vm.model + "_edit",
                                                      params: {
                                                        uuid: item.uuid
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "primary"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.active != 1 &&
                                          _vm.$auth.check(
                                            _vm.model + ".update.status"
                                          )
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.uuid,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.active == 1 &&
                                          _vm.$auth.check(
                                            _vm.model + ".update.status"
                                          )
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.uuid,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c93bd4d", esExports)
  }
}

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289a9673_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1174);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1172)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-289a9673"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289a9673_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/role/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-289a9673", Component.options)
  } else {
    hotAPI.reload("data-v-289a9673", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("28d2bd0c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-289a9673\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-289a9673\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-289a9673] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "role-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: { readonly: "" },
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.active,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "active", $$v)
                                            },
                                            expression: "item.active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "switch switch-icon switch-primary"
                                },
                                [
                                  _c("input", {
                                    staticClass: "switch-input",
                                    attrs: { type: "checkbox" },
                                    on: { change: _vm.checkAll }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "switch-label",
                                    attrs: { "data-on": "", "data-off": "" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "switch-handle" })
                                ]
                              ),
                              _vm._v(" "),
                              _c("legend", { staticClass: "col-form-label" }, [
                                _c("b", [_vm._v("All")])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.permissionsData, function(permission) {
                              return _c(
                                "div",
                                { key: permission.code, staticClass: "col-3" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "switch switch-icon switch-primary"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.permissionIds,
                                            expression: "item.permissionIds"
                                          }
                                        ],
                                        staticClass: "switch-input",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: permission.id,
                                          checked: Array.isArray(
                                            _vm.item.permissionIds
                                          )
                                            ? _vm._i(
                                                _vm.item.permissionIds,
                                                permission.id
                                              ) > -1
                                            : _vm.item.permissionIds
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.item.permissionIds,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = permission.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.item.permissionIds = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.item.permissionIds = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.item,
                                                "permissionIds",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-label",
                                        attrs: {
                                          "data-on": "",
                                          "data-off": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-handle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "legend",
                                    { staticClass: "col-form-label" },
                                    [
                                      _vm._v(
                                        _vm._s(permission.name) +
                                          "\n                "
                                      ),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(permission.description))]
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-289a9673", esExports)
  }
}

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88a954d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1176);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88a954d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/permission/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88a954d8", Component.options)
  } else {
    hotAPI.reload("data-v-88a954d8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.$auth.check(_vm.model + ".create")
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: _vm.model + "_create" }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          { attrs: { variant: "primary" } },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("create")) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _vm.$auth.check(
                                            _vm.model + ".update"
                                          ) ||
                                          _vm.$auth.check(_vm.model + ".detail")
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: _vm.model + "_edit",
                                                      params: {
                                                        uuid: item.uuid
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "primary"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.active != 1 &&
                                          _vm.$auth.check(
                                            _vm.model + ".update.status"
                                          )
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.uuid,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.active == 1 &&
                                          _vm.$auth.check(
                                            _vm.model + ".update.status"
                                          )
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.uuid,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88a954d8", esExports)
  }
}

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f09ba28c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1180);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1178)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f09ba28c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f09ba28c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/permission/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f09ba28c", Component.options)
  } else {
    hotAPI.reload("data-v-f09ba28c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1179);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("efbdf8dc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f09ba28c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f09ba28c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-f09ba28c] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: { readonly: "" },
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.active,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "active", $$v)
                                            },
                                            expression: "item.active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f09ba28c", esExports)
  }
}

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662c5218_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1182);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662c5218_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/client/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-662c5218", Component.options)
  } else {
    hotAPI.reload("data-v-662c5218", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "client-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("role")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "7" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.$auth.check(_vm.model + ".create")
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: _vm.model + "_create" }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          { attrs: { variant: "primary" } },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("create")) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _vm.$auth.check(
                                            _vm.model + ".update"
                                          ) ||
                                          _vm.$auth.check(_vm.model + ".detail")
                                            ? _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: _vm.model + "_edit",
                                                      params: {
                                                        uuid: item.uuid
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "primary"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-edit"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-662c5218", esExports)
  }
}

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32332b3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1187);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1184)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32332b3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32332b3e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/client/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32332b3e", Component.options)
  } else {
    hotAPI.reload("data-v-32332b3e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1185);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("9fdab400", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32332b3e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32332b3e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-32332b3e] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1186 */,
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-card",
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("config")) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "label",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.config_content",
                                                modifiers: {
                                                  config_content: true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "switch switch-sm switch-text switch-info float-right mb-0",
                                            on: {
                                              click: _vm.updateConfigStatus
                                            }
                                          },
                                          [
                                            _vm.configStatus == 1
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.configStatus == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      { attrs: { id: "config_content" } },
                                      [
                                        _vm._l(_vm.item.configs, function(
                                          config,
                                          c
                                        ) {
                                          return _c(
                                            "b-row",
                                            { key: config.id },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("group"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control",
                                                        model: {
                                                          value: config.group,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              config,
                                                              "group",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "config.group"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("key"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control",
                                                        model: {
                                                          value: config.key,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              config,
                                                              "key",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "config.key"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("value"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control",
                                                        model: {
                                                          value: config.value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              config,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "config.value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "1" } },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "danger"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeConfig(c)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash-o"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: { click: _vm.addConfig }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-plus"
                                                    }),
                                                    _vm._v(
                                                      "  " +
                                                        _vm._s(_vm.$t("config"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-card",
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("customizes")) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "label",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.customize_content",
                                                modifiers: {
                                                  customize_content: true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "switch switch-sm switch-text switch-info float-right mb-0",
                                            on: {
                                              click: _vm.updateCustomizeStatus
                                            }
                                          },
                                          [
                                            _vm.customizeStatus == 1
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.customizeStatus == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      { attrs: { id: "customize_content" } },
                                      [
                                        _vm._l(_vm.item.customizes, function(
                                          customize,
                                          c
                                        ) {
                                          return _c(
                                            "b-row",
                                            { key: customize.id },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("group"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        attrs: {
                                                          options: _vm.groups
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.item.customizes[
                                                              c
                                                            ].group,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.item
                                                                .customizes[c],
                                                              "group",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.customizes[c].group"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "danger"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeGroup(c)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-minus"
                                                      }),
                                                      _vm._v(
                                                        "  " +
                                                          _vm._s(
                                                            _vm.$t("group")
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "9" } },
                                                [
                                                  _vm._l(
                                                    _vm.item.customizes[c]
                                                      .fields,
                                                    function(field, f) {
                                                      return _c(
                                                        "b-row",
                                                        { key: field.id },
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "name"
                                                                    ),
                                                                    "label-cols": 3,
                                                                    horizontal: true
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-input",
                                                                    {
                                                                      staticClass:
                                                                        "form-control",
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .item
                                                                            .customizes[
                                                                            c
                                                                          ]
                                                                            .fields[
                                                                            f
                                                                          ]
                                                                            .name,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customizes[
                                                                              c
                                                                            ]
                                                                              .fields[
                                                                              f
                                                                            ],
                                                                            "name",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.customizes[c].fields[f].name"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "tag"
                                                                    ),
                                                                    "label-cols": 3,
                                                                    horizontal: true
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-select",
                                                                    {
                                                                      attrs: {
                                                                        options:
                                                                          _vm.tags
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.updateTag(
                                                                            c,
                                                                            f
                                                                          )
                                                                        }
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .item
                                                                            .customizes[
                                                                            c
                                                                          ]
                                                                            .fields[
                                                                            f
                                                                          ].tag,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customizes[
                                                                              c
                                                                            ]
                                                                              .fields[
                                                                              f
                                                                            ],
                                                                            "tag",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.customizes[c].fields[f].tag"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "text_box"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "type"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs: {
                                                                            options:
                                                                              _vm.types
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .type,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "type",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.type"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "class"
                                                                    ),
                                                                    "label-cols": 3,
                                                                    horizontal: true
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-input",
                                                                    {
                                                                      staticClass:
                                                                        "form-control",
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .item
                                                                            .customizes[
                                                                            c
                                                                          ]
                                                                            .fields[
                                                                            f
                                                                          ]
                                                                            .attribute
                                                                            .class,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customizes[
                                                                              c
                                                                            ]
                                                                              .fields[
                                                                              f
                                                                            ]
                                                                              .attribute,
                                                                            "class",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.customizes[c].fields[f].attribute.class"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "date_box"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "default"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "masked-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            name:
                                                                              "date",
                                                                            mask: [
                                                                              /\d/,
                                                                              /\d/,
                                                                              "/",
                                                                              /\d/,
                                                                              /\d/,
                                                                              "/",
                                                                              /\d/,
                                                                              /\d/,
                                                                              /\d/,
                                                                              /\d/
                                                                            ],
                                                                            guide: true,
                                                                            placeholderChar:
                                                                              "_",
                                                                            showMask: true,
                                                                            keepCharPositions: true
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .default,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "default",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.default"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "text_box"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "default"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .default,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "default",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.default"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "text_box" ||
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "text_area"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "place_holder"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .place_holder,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "place_holder",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.place_holder"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "switch"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "check_value"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .check_value,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "check_value",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.check_value"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "switch"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "uncheck_value"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .uncheck_value,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "uncheck_value",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.uncheck_value"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "text_area"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "rows"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .rows,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "rows",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.rows"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "select"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "multiple"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "c-switch",
                                                                        _vm._b(
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "icon",
                                                                              variant:
                                                                                "primary",
                                                                              checked:
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute
                                                                                  .multiple,
                                                                              value: 1,
                                                                              uncheckedValue: 0
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute
                                                                                  .multiple,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .item
                                                                                    .customizes[
                                                                                    c
                                                                                  ]
                                                                                    .fields[
                                                                                    f
                                                                                  ]
                                                                                    .attribute,
                                                                                  "multiple",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.customizes[c].fields[f].attribute.multiple"
                                                                            }
                                                                          },
                                                                          "c-switch",
                                                                          {
                                                                            on:
                                                                              "\uf00c",
                                                                            off:
                                                                              "\uf00d"
                                                                          },
                                                                          false
                                                                        )
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "select" ||
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "check_box" ||
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "radio_group"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "options"
                                                                        ),
                                                                        "label-cols": 2,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "table",
                                                                        {
                                                                          staticClass:
                                                                            "table"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "thead",
                                                                            [
                                                                              _c(
                                                                                "tr",
                                                                                [
                                                                                  _c(
                                                                                    "th",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "text"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "th",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "value"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "th"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "tbody",
                                                                            [
                                                                              _vm._l(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute
                                                                                  .options,
                                                                                function(
                                                                                  option,
                                                                                  o
                                                                                ) {
                                                                                  return _c(
                                                                                    "tr",
                                                                                    {
                                                                                      key:
                                                                                        option.id
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _c(
                                                                                            "b-form-input",
                                                                                            {
                                                                                              staticClass:
                                                                                                "form-control",
                                                                                              model: {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .item
                                                                                                    .customizes[
                                                                                                    c
                                                                                                  ]
                                                                                                    .fields[
                                                                                                    f
                                                                                                  ]
                                                                                                    .attribute
                                                                                                    .options[
                                                                                                    o
                                                                                                  ]
                                                                                                    .text,
                                                                                                callback: function(
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .item
                                                                                                      .customizes[
                                                                                                      c
                                                                                                    ]
                                                                                                      .fields[
                                                                                                      f
                                                                                                    ]
                                                                                                      .attribute
                                                                                                      .options[
                                                                                                      o
                                                                                                    ],
                                                                                                    "text",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                                expression:
                                                                                                  "item.customizes[c].fields[f].attribute.options[o].text"
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _c(
                                                                                            "b-form-input",
                                                                                            {
                                                                                              staticClass:
                                                                                                "form-control",
                                                                                              model: {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .item
                                                                                                    .customizes[
                                                                                                    c
                                                                                                  ]
                                                                                                    .fields[
                                                                                                    f
                                                                                                  ]
                                                                                                    .attribute
                                                                                                    .options[
                                                                                                    o
                                                                                                  ]
                                                                                                    .value,
                                                                                                callback: function(
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .item
                                                                                                      .customizes[
                                                                                                      c
                                                                                                    ]
                                                                                                      .fields[
                                                                                                      f
                                                                                                    ]
                                                                                                      .attribute
                                                                                                      .options[
                                                                                                      o
                                                                                                    ],
                                                                                                    "value",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                                expression:
                                                                                                  "item.customizes[c].fields[f].attribute.options[o].value"
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _c(
                                                                                            "b-button",
                                                                                            {
                                                                                              attrs: {
                                                                                                size:
                                                                                                  "sm",
                                                                                                variant:
                                                                                                  "danger"
                                                                                              },
                                                                                              on: {
                                                                                                click: function(
                                                                                                  $event
                                                                                                ) {
                                                                                                  _vm.removeOption(
                                                                                                    c,
                                                                                                    f,
                                                                                                    o
                                                                                                  )
                                                                                                }
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "i",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "fa fa-minus"
                                                                                                }
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "tr",
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      attrs: {
                                                                                        colspan:
                                                                                          "2"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "b-button",
                                                                                        {
                                                                                          attrs: {
                                                                                            size:
                                                                                              "sm",
                                                                                            variant:
                                                                                              "success"
                                                                                          },
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.addOption(
                                                                                                c,
                                                                                                f
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-plus"
                                                                                            }
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            2
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "danger"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.removeField(
                                                                        c,
                                                                        f
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-minus"
                                                                  }),
                                                                  _vm._v(
                                                                    "  " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "field"
                                                                        )
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "clearfix"
                                                                },
                                                                [_c("hr")]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: { cols: "12" }
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              attrs: {
                                                                variant:
                                                                  "success"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.addField(
                                                                    c
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-plus"
                                                              }),
                                                              _vm._v(
                                                                "  " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "field"
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "clearfix" },
                                                    [_c("hr")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: { click: _vm.addGroup }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-plus"
                                                    }),
                                                    _vm._v(
                                                      "  " +
                                                        _vm._s(_vm.$t("group"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(" " + _vm._s(_vm.$t("update")))
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(" " + _vm._s(_vm.$t("save")))
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32332b3e", esExports)
  }
}

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b5fe24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1189);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b5fe24_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_group/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-68b5fe24", Component.options)
  } else {
    hotAPI.reload("data-v-68b5fe24", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-group-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68b5fe24", esExports)
  }
}

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a84bd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1191);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0a84bd8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_group/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0a84bd8", Component.options)
  } else {
    hotAPI.reload("data-v-d0a84bd8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-group-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("group_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("group_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0a84bd8", esExports)
  }
}

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21eb2b83_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1193);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21eb2b83_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_type/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21eb2b83", Component.options)
  } else {
    hotAPI.reload("data-v-21eb2b83", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-type-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21eb2b83", esExports)
  }
}

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241bf6ae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1197);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1195)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-241bf6ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241bf6ae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_type/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-241bf6ae", Component.options)
  } else {
    hotAPI.reload("data-v-241bf6ae", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1196);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("fb028912", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-241bf6ae\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-241bf6ae\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-241bf6ae] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-type-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("type_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("type_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("type_description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(" " + _vm._s(_vm.$t("update")) + "\n")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-241bf6ae", esExports)
  }
}

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b30f00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1199);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b30f00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_account/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76b30f00", Component.options)
  } else {
    hotAPI.reload("data-v-76b30f00", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-account-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76b30f00", esExports)
  }
}

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b9e826_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1201);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b9e826_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_account/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42b9e826", Component.options)
  } else {
    hotAPI.reload("data-v-42b9e826", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-account-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("account_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("account_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42b9e826", esExports)
  }
}

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b2f436_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1203);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b2f436_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20b2f436", Component.options)
  } else {
    hotAPI.reload("data-v-20b2f436", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20b2f436", esExports)
  }
}

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268c6548_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1205);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268c6548_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-268c6548", Component.options)
  } else {
    hotAPI.reload("data-v-268c6548", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("group_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.groups,
                                        disabled: _vm.id
                                      },
                                      model: {
                                        value: _vm.item.group_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "group_id", $$v)
                                        },
                                        expression: "item.group_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("type"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.types,
                                        disabled: _vm.id
                                      },
                                      model: {
                                        value: _vm.item.type_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "type_id", $$v)
                                        },
                                        expression: "item.type_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("account_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.accounts },
                                      model: {
                                        value: _vm.item.account_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "account_id", $$v)
                                        },
                                        expression: "item.account_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("genstore_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.genstores },
                                      model: {
                                        value: _vm.item.genstore_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "genstore_id", $$v)
                                        },
                                        expression: "item.genstore_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("material_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("material_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("net_weight"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: { type: "number" },
                                      model: {
                                        value: _vm.item.recipe_rate,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "recipe_rate", $$v)
                                        },
                                        expression: "item.recipe_rate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("material_uom"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.recipe_rate_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "recipe_rate_uom_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.recipe_rate_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-268c6548", esExports)
  }
}

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_893ba378_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1207);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_893ba378_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material_detail/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-893ba378", Component.options)
  } else {
    hotAPI.reload("data-v-893ba378", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-detail-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-893ba378", esExports)
  }
}

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f12df12c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1211);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1209)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f12df12c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f12df12c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material_detail/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f12df12c", Component.options)
  } else {
    hotAPI.reload("data-v-f12df12c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1210);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("52c765ae", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f12df12c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f12df12c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-f12df12c] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-detail-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("material_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.materials },
                                      model: {
                                        value: _vm.item.material_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "material_id", $$v)
                                        },
                                        expression: "item.material_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_uom_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.supplier_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "supplier_uom_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.supplier_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("smaller_uom_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.smaller_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "smaller_uom_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.smaller_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("smaller_uom_detail_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.smaller_uom_details
                                      },
                                      model: {
                                        value: _vm.item.smaller_uom_detail_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "smaller_uom_detail_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.smaller_uom_detail_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("outlet_uom_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.outlet_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "outlet_uom_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.outlet_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("outlet_uom_detail_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.outlet_uom_details
                                      },
                                      model: {
                                        value: _vm.item.outlet_uom_detail_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "outlet_uom_detail_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.outlet_uom_detail_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("recipe_uom_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.recipe_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "recipe_uom_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.recipe_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("recipe_uom_detail_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.recipe_uom_details
                                      },
                                      model: {
                                        value: _vm.item.recipe_uom_detail_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "recipe_uom_detail_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.recipe_uom_detail_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("report_uom_id"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.report_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "report_uom_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.report_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("material_detail_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("material_detail_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("fixed_unit"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.fixed_unit_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "fixed_unit_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.fixed_unit_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f12df12c", esExports)
  }
}

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6766c931_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1213);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6766c931_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_supplier/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6766c931", Component.options)
  } else {
    hotAPI.reload("data-v-6766c931", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-supplier-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("supplier_import_do"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0,
                                                        ""
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1,
                                                        ""
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_import_do == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        "",
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_import_do != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        "",
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6766c931", esExports)
  }
}

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_336da257_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1215);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_336da257_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_supplier/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-336da257", Component.options)
  } else {
    hotAPI.reload("data-v-336da257", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-supplier-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_address"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.address,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "address", $$v)
                                        },
                                        expression: "item.address"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_phone"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.phone,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "phone", $$v)
                                        },
                                        expression: "item.phone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_fax"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.fax,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "fax", $$v)
                                        },
                                        expression: "item.fax"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "supplier_terms_of_payment"
                                      ),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.terms_of_payment,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "terms_of_payment",
                                            $$v
                                          )
                                        },
                                        expression: "item.terms_of_payment"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("supplier_import_do"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_import_do,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_import_do,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_import_do",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_import_do"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("tax"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_tax,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_tax,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "is_tax", $$v)
                                            },
                                            expression: "item.is_tax"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-336da257", esExports)
  }
}

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8af5800_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1219);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1217)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8af5800"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8af5800_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_uom/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b8af5800", Component.options)
  } else {
    hotAPI.reload("data-v-b8af5800", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1218);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("02b4d464", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b8af5800\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b8af5800\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-uom-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _vm._v(" "),
                      _vm.item.id == ""
                        ? _c("strong", [_vm._v(_vm._s(_vm.$t("create")))])
                        : _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "6", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("uom_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8af5800", esExports)
  }
}

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50bd0a4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1221);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50bd0a4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_uom/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-50bd0a4c", Component.options)
  } else {
    hotAPI.reload("data-v-50bd0a4c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-uom-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50bd0a4c", esExports)
  }
}

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32788046_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1225);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1223)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32788046"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32788046_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_uom_detail/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32788046", Component.options)
  } else {
    hotAPI.reload("data-v-32788046", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1224);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("693363aa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32788046\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-32788046\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.qty_uom[data-v-32788046] {\n  margin-top: -190px;\n}\n", ""]);

// exports


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-uom-detail-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _vm._v(" "),
                      _vm.item.id == ""
                        ? _c("strong", [_vm._v(_vm._s(_vm.$t("create")))])
                        : _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "6", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("from_uom_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.from_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "from_uom_id", $$v)
                                        },
                                        expression: "item.from_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("from_uom_qty"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.from_uom_qty,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "from_uom_qty",
                                            $$v
                                          )
                                        },
                                        expression: "item.from_uom_qty"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("to_uom_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: { options: _vm.uoms },
                                      model: {
                                        value: _vm.item.to_uom_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "to_uom_id", $$v)
                                        },
                                        expression: "item.to_uom_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("to_uom_qty"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.to_uom_qty,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "to_uom_qty", $$v)
                                        },
                                        expression: "item.to_uom_qty"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("conversion_rate"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.conversion_rate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "conversion_rate",
                                            $$v
                                          )
                                        },
                                        expression: "item.conversion_rate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32788046", esExports)
  }
}

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6671a720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1227);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6671a720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_uom_detail/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6671a720", Component.options)
  } else {
    hotAPI.reload("data-v-6671a720", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-uom-detail-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6671a720", esExports)
  }
}

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e604e32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1229);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e604e32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_genstore/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e604e32", Component.options)
  } else {
    hotAPI.reload("data-v-0e604e32", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-genstore-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("genstore_code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("genstore_name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("genstore_description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("active"),
                                      "label-cols": "3",
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c(
                                      "c-switch",
                                      _vm._b(
                                        {
                                          attrs: {
                                            type: "icon",
                                            variant: "primary",
                                            checked: _vm.item.is_active,
                                            value: 1,
                                            uncheckedValue: 0
                                          },
                                          model: {
                                            value: _vm.item.is_active,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "is_active",
                                                $$v
                                              )
                                            },
                                            expression: "item.is_active"
                                          }
                                        },
                                        "c-switch",
                                        { on: "\uf00c", off: "\uf00d" },
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e604e32", esExports)
  }
}

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4259750c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1231);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4259750c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_genstore/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4259750c", Component.options)
  } else {
    hotAPI.reload("data-v-4259750c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-genstore-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4259750c", esExports)
  }
}

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f5fed5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1237);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1233)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36f5fed5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f5fed5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_recipe/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-36f5fed5", Component.options)
  } else {
    hotAPI.reload("data-v-36f5fed5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1234);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("afe1fd9c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-36f5fed5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-36f5fed5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-36f5fed5] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchAll */
/* unused harmony export changeStatusItem */
/* unused harmony export changeStatusDefaultItem */
/* unused harmony export get */
/* unused harmony export create */
/* unused harmony export update */
/* harmony export (immutable) */ __webpack_exports__["a"] = getMasterRecipeDetailByRecipe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe-detail/list',
    method: 'get',
    params: data
  });
}

function changeStatusItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe-detail/update-status',
    method: 'put',
    data: data
  });
}

function changeStatusDefaultItem(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe-detail/update-status-default',
    method: 'put',
    data: data
  });
}

function get(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe-detail/detail',
    method: 'get',
    params: data
  });
}

function create(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: procss.env.BASE_URL_INVENTORY + '/master-recipe-detail/create',
    method: 'post',
    data: data
  });
}

function update(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe-detail/update',
    method: 'put',
    data: data
  });
}

function getMasterRecipeDetailByRecipe(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/master-recipe-detail/get-by-recipe',
    method: 'get',
    params: data
  });
}

/***/ }),
/* 1236 */,
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { staticClass: "fa fa-align-justify" }),
                      _vm._v(" "),
                      _vm.item.id == ""
                        ? _c("strong", [_vm._v(_vm._s(_vm.$t("create")))])
                        : _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { "align-self": "center" } },
                              [
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("code"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.code,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "code",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.code"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("name"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.name"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("uom_name"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("v-select", {
                                              attrs: { options: _vm.uoms },
                                              model: {
                                                value: _vm.item.uom_id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "uom_id",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.uom_id"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("plucode"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.plucode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "plucode",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.plucode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("sku"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              attrs: {
                                                placeholder:
                                                  "Ie. 224300006,213830015,213830014"
                                              },
                                              model: {
                                                value: _vm.item.sku,
                                                callback: function($$v) {
                                                  _vm.$set(_vm.item, "sku", $$v)
                                                },
                                                expression: "item.sku"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("usage"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.usage,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "usage",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.usage"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("expired_in"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              model: {
                                                value: _vm.item.expired_in,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "expired_in",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.expired_in"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("price"),
                                              "label-cols": 2,
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "form-control",
                                              attrs: { disabled: "" },
                                              model: {
                                                value: _vm.item.price,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "price",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.price"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("active"),
                                              "label-cols": "2",
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c(
                                              "c-switch",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    type: "icon",
                                                    variant: "primary",
                                                    checked: _vm.item.is_active,
                                                    value: 1,
                                                    uncheckedValue: 0
                                                  },
                                                  model: {
                                                    value: _vm.item.is_active,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "is_active",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.is_active"
                                                  }
                                                },
                                                "c-switch",
                                                { on: "\uf00c", off: "\uf00d" },
                                                false
                                              )
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("daily_batch"),
                                              "label-cols": "2",
                                              horizontal: true
                                            }
                                          },
                                          [
                                            _c(
                                              "c-switch",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    type: "icon",
                                                    variant: "primary",
                                                    checked:
                                                      _vm.item.is_daily_batch,
                                                    value: 1,
                                                    uncheckedValue: 0
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.item.is_daily_batch,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "is_daily_batch",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.is_daily_batch"
                                                  }
                                                },
                                                "c-switch",
                                                { on: "\uf00c", off: "\uf00d" },
                                                false
                                              )
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.item.code || this.recipes.length === 0
                              },
                              on: { click: _vm.addNew }
                            },
                            [
                              _vm._v(
                                "\n                  Add new\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-modal",
                            {
                              ref: "my-modal",
                              attrs: {
                                id: "modalPrevent",
                                title: "Add recipe detail"
                              },
                              on: { ok: _vm.handleAdd }
                            },
                            [
                              _c(
                                "form",
                                {
                                  attrs: { id: "add-recipe-detail" },
                                  on: {
                                    submit: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      _vm.hideModal($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-form-radio-group",
                                        {
                                          attrs: {
                                            id: "choose-method",
                                            name: "radioSubComponent"
                                          },
                                          model: {
                                            value: _vm.selected,
                                            callback: function($$v) {
                                              _vm.selected = $$v
                                            },
                                            expression: "selected"
                                          }
                                        },
                                        [
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: { value: "true" },
                                              on: {
                                                change: function($event) {
                                                  _vm.switchTab(true)
                                                }
                                              }
                                            },
                                            [_vm._v("Using material")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-radio",
                                            {
                                              attrs: { value: "false" },
                                              on: {
                                                change: function($event) {
                                                  _vm.switchTab(false)
                                                }
                                              }
                                            },
                                            [_vm._v("Using others recipe")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isHidden
                                    ? _c(
                                        "b-form",
                                        { attrs: { id: "using-material" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t("material"),
                                                "label-cols": 3,
                                                horizontal: true
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  options: _vm.materials
                                                },
                                                model: {
                                                  value: _vm.popup.material,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.popup,
                                                      "material",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "popup.material"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isHidden
                                    ? _c(
                                        "b-form",
                                        {
                                          attrs: { id: "using-others-recipe" }
                                        },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: _vm.$t("recipe"),
                                                "label-cols": 3,
                                                horizontal: true
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                attrs: { options: _vm.recipes },
                                                model: {
                                                  value: _vm.popup.recipe,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.popup,
                                                      "recipe",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "popup.recipe"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("recipe_detail_usage"),
                                        "label-cols": 3,
                                        horizontal: true
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        model: {
                                          value: _vm.popup.recipe_detail_usage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.popup,
                                              "recipe_detail_usage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "popup.recipe_detail_usage"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t("recipe_detail_status"),
                                        "label-cols": "3",
                                        horizontal: true
                                      }
                                    },
                                    [
                                      _c(
                                        "c-switch",
                                        _vm._b(
                                          {
                                            attrs: {
                                              type: "icon",
                                              variant: "primary",
                                              value: 1,
                                              uncheckedValue: 0
                                            },
                                            model: {
                                              value:
                                                _vm.popup.recipe_detail_status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.popup,
                                                  "recipe_detail_status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "popup.recipe_detail_status"
                                            }
                                          },
                                          "c-switch",
                                          { on: "\uf00c", off: "\uf00d" },
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        [
                          _c("b-table", {
                            ref: "table",
                            attrs: {
                              items: _vm.data_table,
                              fields: _vm.columns_table
                            },
                            scopedSlots: _vm._u([
                              _vm._l(_vm.formatted, function(field, fieldKey) {
                                return {
                                  key: field,
                                  fn: function(row) {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          key: fieldKey + "-Edit",
                                          staticClass: "btn btn-sm btn-primary",
                                          on: {
                                            click: function($event) {
                                              _vm.editRecipeDeTail(
                                                row.index,
                                                row.item
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Edit")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          key: fieldKey + "-Remove",
                                          staticClass: "btn btn-sm btn-danger",
                                          on: {
                                            click: function($event) {
                                              _vm.removeRecipeDeTail(row.index)
                                            }
                                          }
                                        },
                                        [_vm._v("Remove")]
                                      )
                                    ]
                                  }
                                }
                              })
                            ])
                          })
                        ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("back")) +
                                  "\n                "
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36f5fed5", esExports)
  }
}

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aef25af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1239);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aef25af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_recipe/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6aef25af", Component.options)
  } else {
    hotAPI.reload("data-v-6aef25af", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-recipe-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("daily_batch")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0,
                                                        "active"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1,
                                                        "active"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_daily_batch == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        0,
                                                        "daily_batch"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_daily_batch != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.id,
                                                        1,
                                                        "daily_batch"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: { id: item.id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6aef25af", esExports)
  }
}

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0511cbfe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1241);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0511cbfe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material_detail_supplier/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0511cbfe", Component.options)
  } else {
    hotAPI.reload("data-v-0511cbfe", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-supplier-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _vm._v(" "),
                      _vm.item.new
                        ? _c("strong", [_vm._v(_vm._s(_vm.$t("create")))])
                        : _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "9", "align-self": "center" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("material_detail"),
                                  "label-cols": 3,
                                  horizontal: true
                                }
                              },
                              [
                                _vm.item.new
                                  ? _c("v-select", {
                                      attrs: { options: _vm.material_details },
                                      model: {
                                        value: _vm.item.material_detail_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "material_detail_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.material_detail_id"
                                      }
                                    })
                                  : _c("v-select", {
                                      attrs: {
                                        options: _vm.material_details,
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.item.material_detail_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.item,
                                            "material_detail_id",
                                            $$v
                                          )
                                        },
                                        expression: "item.material_detail_id"
                                      }
                                    })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("supplier"),
                                  "label-cols": 3,
                                  horizontal: true
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    multiple: "multiple",
                                    options: _vm.suppliers
                                  },
                                  model: {
                                    value: _vm.item.supplier_ids,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item, "supplier_ids", $$v)
                                    },
                                    expression: "item.supplier_ids"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("active"),
                                  "label-cols": "3",
                                  horizontal: true
                                }
                              },
                              [
                                _c(
                                  "c-switch",
                                  _vm._b(
                                    {
                                      attrs: {
                                        type: "icon",
                                        variant: "primary",
                                        checked: _vm.item.is_active,
                                        value: 1,
                                        uncheckedValue: 0
                                      },
                                      model: {
                                        value: _vm.item.is_active,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "is_active", $$v)
                                        },
                                        expression: "item.is_active"
                                      }
                                    },
                                    "c-switch",
                                    { on: "\uf00c", off: "\uf00d" },
                                    false
                                  )
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.material_detail_id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.material_detail_id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0511cbfe", esExports)
  }
}

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317040db_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1243);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_317040db_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material_detail_supplier/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-317040db", Component.options)
  } else {
    hotAPI.reload("data-v-317040db", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-detail-supplier-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _vm._l(_vm.dataTable.header, function(
                                      item
                                    ) {
                                      return _c(
                                        "th",
                                        {
                                          key: item.id,
                                          staticClass: "text-left",
                                          class: item.sort
                                            ? "cursor-pointer"
                                            : "",
                                          attrs: { scope: "col" },
                                          on: {
                                            click: function($event) {
                                              _vm.updateSort(item.name)
                                            }
                                          }
                                        },
                                        [
                                          _vm.dataTable.sort.type == "asc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-asc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.dataTable.sort.type == "desc" &&
                                          _vm.dataTable.sort.field == item.name
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-sort-amount-desc text-muted"
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item.name)))
                                          ])
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("active")))
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { scope: "col" } }, [
                                      _vm._v(_vm._s(_vm.$t("action")))
                                    ])
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            staticClass: "text-left",
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { scope: "row" } },
                                        [
                                          item.is_active == 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.material_detail_id,
                                                        0
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.is_active != 1
                                            ? _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "danger"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.updateStatusItem(
                                                        item.material_detail_id,
                                                        1
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-times"
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: {
                                                    material_detail_id:
                                                      item.material_detail_id
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-317040db", esExports)
  }
}

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e4d6e1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1245);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e4d6e1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material_recipe_mapping/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e4d6e1e", Component.options)
  } else {
    hotAPI.reload("data-v-3e4d6e1e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-supplier-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _vm._v(" "),
                      _vm.item.new
                        ? _c("strong", [_vm._v(_vm._s(_vm.$t("create")))])
                        : _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "9", "align-self": "center" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("source_type"),
                                  "label-cols": 3,
                                  horizontal: true
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: { options: _vm.source_type },
                                  model: {
                                    value: _vm.item.source_type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item, "source_type", $$v)
                                    },
                                    expression: "item.source_type"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("source_code"),
                                  "label-cols": 3,
                                  horizontal: true
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: { options: _vm.source_codes },
                                  model: {
                                    value: _vm.item.source_code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item, "source_code", $$v)
                                    },
                                    expression: "item.source_code"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("destination_type"),
                                  "label-cols": 3,
                                  horizontal: true
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: { options: _vm.source_type },
                                  model: {
                                    value: _vm.item.destination_type,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item,
                                        "destination_type",
                                        $$v
                                      )
                                    },
                                    expression: "item.destination_type"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("destination_code"),
                                  "label-cols": 3,
                                  horizontal: true
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: { options: _vm.destination_codes },
                                  model: {
                                    value: _vm.item.destination_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item,
                                        "destination_code",
                                        $$v
                                      )
                                    },
                                    expression: "item.destination_code"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.material_recipe_mapping_id != null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.material_recipe_mapping_id == null
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("save")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4d6e1e", esExports)
  }
}

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_724694f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1247);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_724694f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/master_material_recipe_mapping/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-724694f8", Component.options)
  } else {
    hotAPI.reload("data-v-724694f8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-material-detail-supplier-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      { text: _vm.$t("active"), value: 1 },
                                      { text: _vm.$t("inactive"), value: 0 }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.actived,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "actived", $$v)
                                    },
                                    expression: "filter.actived"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "1" } },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: { name: _vm.model + "_create" }
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      { attrs: { variant: "primary" } },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create")) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(_vm._s(_vm.$t("source_type")))
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(_vm._s(_vm.$t("source_code")))
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(_vm._s(_vm.$t("destination_type")))
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(_vm._s(_vm.$t("destination_code")))
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(_vm._s(_vm.$t("action")))
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        field
                                      ) {
                                        return _c(
                                          "td",
                                          {
                                            key: field.id,
                                            staticClass: "text-left",
                                            attrs: { scope: "row" }
                                          },
                                          [
                                            field.render != null
                                              ? _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      field.render(
                                                        item[field.name]
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            field.render == null
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item[field.name]) +
                                                      "\n                      "
                                                  )
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: { scope: "row", width: "130" }
                                        },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: _vm.model + "_edit",
                                                  params: {
                                                    material_recipe_mapping_id:
                                                      item.id
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    variant: "primary"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-edit"
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-724694f8", esExports)
  }
}

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_178827fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(1252);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-178827fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_178827fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/sync_master/Form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-178827fa", Component.options)
  } else {
    hotAPI.reload("data-v-178827fa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1250);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("47631b16", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-178827fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-178827fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-178827fa] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTableSyncList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function getTableSyncList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/table-sync/common-list',
    method: 'get'
  });
}

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "master-group-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.id != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "6", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("version"),
                                      "label-cols": 3
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.version,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "version", $$v)
                                        },
                                        expression: "item.version"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "switch switch-icon switch-primary"
                                },
                                [
                                  _c("input", {
                                    staticClass: "switch-input",
                                    attrs: { type: "checkbox" },
                                    on: { change: _vm.checkAll }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "switch-label",
                                    attrs: { "data-on": "", "data-off": "" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "switch-handle" })
                                ]
                              ),
                              _vm._v(" "),
                              _c("legend", { staticClass: "col-form-label" }, [
                                _c("b", [_vm._v("All")])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.tableSyncData, function(table) {
                              return _c(
                                "b-col",
                                { key: table.id, attrs: { cols: "3" } },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "switch switch-icon switch-primary"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.item.tableSyncIds,
                                            expression: "item.tableSyncIds"
                                          }
                                        ],
                                        staticClass: "switch-input",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: table.id,
                                          checked: Array.isArray(
                                            _vm.item.tableSyncIds
                                          )
                                            ? _vm._i(
                                                _vm.item.tableSyncIds,
                                                table.id
                                              ) > -1
                                            : _vm.item.tableSyncIds
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.item.tableSyncIds,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = table.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.item.tableSyncIds = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.item.tableSyncIds = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.item,
                                                "tableSyncIds",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-label",
                                        attrs: {
                                          "data-on": "",
                                          "data-off": ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "switch-handle"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "legend",
                                    { staticClass: "col-form-label" },
                                    [_vm._v(_vm._s(table.table_name))]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.id != null && _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("update")) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "success" },
                            on: { click: _vm.createItem }
                          },
                          [
                            _c("i", { staticClass: "fa fa-save" }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("save")) + "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-178827fa", esExports)
  }
}

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b814ed4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1256);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1254)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b814ed4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b814ed4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/sync_master/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b814ed4", Component.options)
  } else {
    hotAPI.reload("data-v-4b814ed4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1255);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("4549c97e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b814ed4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b814ed4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./List.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.switch[data-v-4b814ed4] {\n  margin-bottom: 0px;\n  margin-top: 7px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sync-master-list" },
    [
      _c(
        "div",
        { staticClass: "animated fadeIn" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: { "header-tag": "header", "footer-tag": "footer" }
                    },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("i", {
                          attrs: { className: "fa fa-align-justify" }
                        }),
                        _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-actions" })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { cols: "5" } }),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("select-dropdown", {
                                        attrs: {
                                          options: _vm.filter.options,
                                          selected: _vm.filter.selected,
                                          position: "prepend",
                                          all: true
                                        },
                                        model: {
                                          value: _vm.field,
                                          callback: function($$v) {
                                            _vm.field = $$v
                                          },
                                          expression: "field"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        model: {
                                          value: _vm.key,
                                          callback: function($$v) {
                                            _vm.key = $$v
                                          },
                                          expression: "key"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.refreshData()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-search"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.$t("search"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "1" } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: _vm.model + "_create" }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        { attrs: { variant: "primary" } },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-plus"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("create")) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "table-responsive" }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-striped table-hover table-sm header-pointer"
                              },
                              [
                                _c("thead", [
                                  _c(
                                    "tr",
                                    [
                                      _vm._l(_vm.dataTable.header, function(
                                        item
                                      ) {
                                        return _c(
                                          "th",
                                          {
                                            key: item.id,
                                            class: item.sort
                                              ? "cursor-pointer"
                                              : "",
                                            attrs: { scope: "col" },
                                            on: {
                                              click: function($event) {
                                                _vm.updateSort(item.name)
                                              }
                                            }
                                          },
                                          [
                                            _vm.dataTable.sort.type == "asc" &&
                                            _vm.dataTable.sort.field ==
                                              item.name
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-sort-amount-asc text-muted"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.dataTable.sort.type == "desc" &&
                                            _vm.dataTable.sort.field ==
                                              item.name
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-sort-amount-desc text-muted"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.$t(item.name)))
                                            ])
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(_vm._s(_vm.$t("action")))
                                      ])
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.dataTable.body, function(item) {
                                    return _c(
                                      "tr",
                                      { key: item.id },
                                      [
                                        _vm._l(_vm.dataTable.header, function(
                                          field
                                        ) {
                                          return _c(
                                            "td",
                                            {
                                              key: field.id,
                                              attrs: { scope: "row" }
                                            },
                                            [
                                              field.render != null
                                                ? _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        field.render(
                                                          item[field.name]
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              field.render == null
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item[field.name]
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              scope: "row",
                                              width: "130"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  size: "sm",
                                                  variant: "success"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.showStores(item.id)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Confirm\n                      "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  })
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-pagination", {
                                    attrs: {
                                      "total-rows": _vm.dataTable.total,
                                      "per-page": _vm.dataTable.paginate
                                    },
                                    model: {
                                      value: _vm.dataTable.offset,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dataTable, "offset", $$v)
                                      },
                                      expression: "dataTable.offset"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { col: "", lg: "1" } },
                                [
                                  _c("b-form-select", {
                                    staticClass: "mb-3",
                                    attrs: { options: [10, 20, 50, 100] },
                                    model: {
                                      value: _vm.dataTable.paginate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dataTable, "paginate", $$v)
                                      },
                                      expression: "dataTable.paginate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "switch-input",
        attrs: { type: "checkbox" },
        on: { change: _vm.checkAll }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "store-modal",
          attrs: { size: "lg", title: "Sync master inventory into Store" },
          on: { ok: _vm.confirm }
        },
        [
          _c(
            "form",
            { staticClass: "row", attrs: { id: "list-store" } },
            [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "label",
                  { staticClass: "switch switch-icon switch-primary" },
                  [
                    _c("input", {
                      staticClass: "switch-input",
                      attrs: { type: "checkbox" },
                      on: { change: _vm.checkAll }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "switch-label",
                      attrs: { "data-on": "", "data-off": "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "switch-handle" })
                  ]
                ),
                _vm._v(" "),
                _c("legend", { staticClass: "col-form-label" }, [
                  _c("b", [_vm._v("All")])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.popup.storeData, function(store) {
                return _c(
                  "b-col",
                  { key: store.store_code, attrs: { cols: "6" } },
                  [
                    _c(
                      "label",
                      { staticClass: "switch switch-icon switch-primary" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.storeIds,
                              expression: "item.storeIds"
                            }
                          ],
                          staticClass: "switch-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: store.store_code,
                            checked: Array.isArray(_vm.item.storeIds)
                              ? _vm._i(_vm.item.storeIds, store.store_code) > -1
                              : _vm.item.storeIds
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.item.storeIds,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = store.store_code,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.item.storeIds = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.item.storeIds = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.$set(_vm.item, "storeIds", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "switch-label",
                          attrs: { "data-on": "", "data-off": "" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "switch-handle" })
                      ]
                    ),
                    _vm._v(" "),
                    _c("legend", { staticClass: "col-form-label" }, [
                      _vm._v(_vm._s(store.name))
                    ])
                  ]
                )
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b814ed4", esExports)
  }
}

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98d77434_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1259);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98d77434_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/inventory/sync_master_detail/List.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-98d77434", Component.options)
  } else {
    hotAPI.reload("data-v-98d77434", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_request__ = __webpack_require__(13);


function fetchAll(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__services_request__["a" /* default */])({
    url: "https://betapich.phsmk.id/inventory/v1/inventory" + '/sync-master-detail/list',
    method: 'get',
    params: data
  });
}

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sync-master-detail-list" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { staticClass: "text-center", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "5" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "2" } },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: [
                                      { text: _vm.$t("all"), value: null },
                                      {
                                        text: _vm.$t("already_sync_to_pos"),
                                        value: 1
                                      },
                                      {
                                        text: _vm.$t("not_sync_to_pos"),
                                        value: 0
                                      }
                                    ]
                                  },
                                  model: {
                                    value: _vm.filter.is_sync,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "is_sync", $$v)
                                    },
                                    expression: "filter.is_sync"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "4" } },
                              [
                                _c(
                                  "b-input-group",
                                  [
                                    _c("select-dropdown", {
                                      attrs: {
                                        options: _vm.filter.options,
                                        selected: _vm.filter.selected,
                                        position: "prepend",
                                        all: true
                                      },
                                      model: {
                                        value: _vm.field,
                                        callback: function($$v) {
                                          _vm.field = $$v
                                        },
                                        expression: "field"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      model: {
                                        value: _vm.key,
                                        callback: function($$v) {
                                          _vm.key = $$v
                                        },
                                        expression: "key"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    _vm.refreshData()
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-search"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(_vm.$t("search"))
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.$auth.check(_vm.model + ".create")
                              ? _c(
                                  "b-col",
                                  { attrs: { cols: "1" } },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: { name: _vm.model + "_create" }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          { attrs: { variant: "primary" } },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-plus"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("create")) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-responsive" }, [
                          _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-hover table-sm header-pointer"
                            },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(_vm.dataTable.header, function(item) {
                                    return _c(
                                      "th",
                                      {
                                        key: item.id,
                                        class: item.sort
                                          ? "cursor-pointer"
                                          : "",
                                        attrs: { scope: "col" },
                                        on: {
                                          click: function($event) {
                                            _vm.updateSort(item.name)
                                          }
                                        }
                                      },
                                      [
                                        _vm.dataTable.sort.type == "asc" &&
                                        _vm.dataTable.sort.field == item.name
                                          ? _c("i", {
                                              staticClass:
                                                "fa fa-sort-amount-asc text-muted"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.dataTable.sort.type == "desc" &&
                                        _vm.dataTable.sort.field == item.name
                                          ? _c("i", {
                                              staticClass:
                                                "fa fa-sort-amount-desc text-muted"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t(item.name)))
                                        ])
                                      ]
                                    )
                                  })
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.dataTable.body, function(item) {
                                  return _c(
                                    "tr",
                                    { key: item.id },
                                    _vm._l(_vm.dataTable.header, function(
                                      field
                                    ) {
                                      return _c(
                                        "td",
                                        {
                                          key: field.id,
                                          attrs: { scope: "row" }
                                        },
                                        [
                                          field.render != null
                                            ? _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    field.render(
                                                      item[field.name]
                                                    )
                                                  )
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          field.render == null
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item[field.name]) +
                                                    "\n                    "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    })
                                  )
                                })
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.dataTable.total,
                                    "per-page": _vm.dataTable.paginate
                                  },
                                  model: {
                                    value: _vm.dataTable.offset,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "offset", $$v)
                                    },
                                    expression: "dataTable.offset"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { col: "", lg: "1" } },
                              [
                                _c("b-form-select", {
                                  staticClass: "mb-3",
                                  attrs: { options: [10, 20, 50, 100] },
                                  model: {
                                    value: _vm.dataTable.paginate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.dataTable, "paginate", $$v)
                                    },
                                    expression: "dataTable.paginate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98d77434", esExports)
  }
}

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ba47ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(1280);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1261)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22ba47ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ba47ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Dashboard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-22ba47ca", Component.options)
  } else {
    hotAPI.reload("data-v-22ba47ca", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1262);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("ce3bf08a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-22ba47ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-22ba47ca\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.process-container[data-v-22ba47ca] {\n  width: 100%;\n  height: 35px;\n}\n.process-container .current[data-v-22ba47ca] {\n  height: 35px;\n  -webkit-transition: width 1s; /* Safari */\n  transition:width 1s;\n}\n.process-container .target[data-v-22ba47ca] {\n  width: 2px;\n  height: 35px;\n  margin-top: -35px;\n  -webkit-transition: margin-left 1s; /* Safari */\n  transition: margin-left 1s;\n}\n.chart-title[data-v-22ba47ca] {\n  color: #6c6c6c;\n  padding: 5px;\n}\n.loading[data-v-22ba47ca] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 99999;\n  padding-top: 300px;\n}\n", ""]);

// exports


/***/ }),
/* 1263 */,
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 249,
	"./af.js": 249,
	"./ar": 250,
	"./ar-dz": 251,
	"./ar-dz.js": 251,
	"./ar-kw": 252,
	"./ar-kw.js": 252,
	"./ar-ly": 253,
	"./ar-ly.js": 253,
	"./ar-ma": 254,
	"./ar-ma.js": 254,
	"./ar-sa": 255,
	"./ar-sa.js": 255,
	"./ar-tn": 256,
	"./ar-tn.js": 256,
	"./ar.js": 250,
	"./az": 257,
	"./az.js": 257,
	"./be": 258,
	"./be.js": 258,
	"./bg": 259,
	"./bg.js": 259,
	"./bm": 260,
	"./bm.js": 260,
	"./bn": 261,
	"./bn.js": 261,
	"./bo": 262,
	"./bo.js": 262,
	"./br": 263,
	"./br.js": 263,
	"./bs": 264,
	"./bs.js": 264,
	"./ca": 265,
	"./ca.js": 265,
	"./cs": 266,
	"./cs.js": 266,
	"./cv": 267,
	"./cv.js": 267,
	"./cy": 268,
	"./cy.js": 268,
	"./da": 269,
	"./da.js": 269,
	"./de": 270,
	"./de-at": 271,
	"./de-at.js": 271,
	"./de-ch": 272,
	"./de-ch.js": 272,
	"./de.js": 270,
	"./dv": 273,
	"./dv.js": 273,
	"./el": 274,
	"./el.js": 274,
	"./en-SG": 275,
	"./en-SG.js": 275,
	"./en-au": 276,
	"./en-au.js": 276,
	"./en-ca": 277,
	"./en-ca.js": 277,
	"./en-gb": 278,
	"./en-gb.js": 278,
	"./en-ie": 279,
	"./en-ie.js": 279,
	"./en-il": 280,
	"./en-il.js": 280,
	"./en-nz": 281,
	"./en-nz.js": 281,
	"./eo": 282,
	"./eo.js": 282,
	"./es": 283,
	"./es-do": 284,
	"./es-do.js": 284,
	"./es-us": 285,
	"./es-us.js": 285,
	"./es.js": 283,
	"./et": 286,
	"./et.js": 286,
	"./eu": 287,
	"./eu.js": 287,
	"./fa": 288,
	"./fa.js": 288,
	"./fi": 289,
	"./fi.js": 289,
	"./fo": 290,
	"./fo.js": 290,
	"./fr": 291,
	"./fr-ca": 292,
	"./fr-ca.js": 292,
	"./fr-ch": 293,
	"./fr-ch.js": 293,
	"./fr.js": 291,
	"./fy": 294,
	"./fy.js": 294,
	"./ga": 295,
	"./ga.js": 295,
	"./gd": 296,
	"./gd.js": 296,
	"./gl": 297,
	"./gl.js": 297,
	"./gom-latn": 298,
	"./gom-latn.js": 298,
	"./gu": 299,
	"./gu.js": 299,
	"./he": 300,
	"./he.js": 300,
	"./hi": 301,
	"./hi.js": 301,
	"./hr": 302,
	"./hr.js": 302,
	"./hu": 303,
	"./hu.js": 303,
	"./hy-am": 304,
	"./hy-am.js": 304,
	"./id": 305,
	"./id.js": 305,
	"./is": 306,
	"./is.js": 306,
	"./it": 307,
	"./it-ch": 308,
	"./it-ch.js": 308,
	"./it.js": 307,
	"./ja": 309,
	"./ja.js": 309,
	"./jv": 310,
	"./jv.js": 310,
	"./ka": 311,
	"./ka.js": 311,
	"./kk": 312,
	"./kk.js": 312,
	"./km": 313,
	"./km.js": 313,
	"./kn": 314,
	"./kn.js": 314,
	"./ko": 315,
	"./ko.js": 315,
	"./ku": 316,
	"./ku.js": 316,
	"./ky": 317,
	"./ky.js": 317,
	"./lb": 318,
	"./lb.js": 318,
	"./lo": 319,
	"./lo.js": 319,
	"./lt": 320,
	"./lt.js": 320,
	"./lv": 321,
	"./lv.js": 321,
	"./me": 322,
	"./me.js": 322,
	"./mi": 323,
	"./mi.js": 323,
	"./mk": 324,
	"./mk.js": 324,
	"./ml": 325,
	"./ml.js": 325,
	"./mn": 326,
	"./mn.js": 326,
	"./mr": 327,
	"./mr.js": 327,
	"./ms": 328,
	"./ms-my": 329,
	"./ms-my.js": 329,
	"./ms.js": 328,
	"./mt": 330,
	"./mt.js": 330,
	"./my": 331,
	"./my.js": 331,
	"./nb": 332,
	"./nb.js": 332,
	"./ne": 333,
	"./ne.js": 333,
	"./nl": 334,
	"./nl-be": 335,
	"./nl-be.js": 335,
	"./nl.js": 334,
	"./nn": 336,
	"./nn.js": 336,
	"./pa-in": 337,
	"./pa-in.js": 337,
	"./pl": 338,
	"./pl.js": 338,
	"./pt": 339,
	"./pt-br": 340,
	"./pt-br.js": 340,
	"./pt.js": 339,
	"./ro": 341,
	"./ro.js": 341,
	"./ru": 342,
	"./ru.js": 342,
	"./sd": 343,
	"./sd.js": 343,
	"./se": 344,
	"./se.js": 344,
	"./si": 345,
	"./si.js": 345,
	"./sk": 346,
	"./sk.js": 346,
	"./sl": 347,
	"./sl.js": 347,
	"./sq": 348,
	"./sq.js": 348,
	"./sr": 349,
	"./sr-cyrl": 350,
	"./sr-cyrl.js": 350,
	"./sr.js": 349,
	"./ss": 351,
	"./ss.js": 351,
	"./sv": 352,
	"./sv.js": 352,
	"./sw": 353,
	"./sw.js": 353,
	"./ta": 354,
	"./ta.js": 354,
	"./te": 355,
	"./te.js": 355,
	"./tet": 356,
	"./tet.js": 356,
	"./tg": 357,
	"./tg.js": 357,
	"./th": 358,
	"./th.js": 358,
	"./tl-ph": 359,
	"./tl-ph.js": 359,
	"./tlh": 360,
	"./tlh.js": 360,
	"./tr": 361,
	"./tr.js": 361,
	"./tzl": 362,
	"./tzl.js": 362,
	"./tzm": 363,
	"./tzm-latn": 364,
	"./tzm-latn.js": 364,
	"./tzm.js": 363,
	"./ug-cn": 365,
	"./ug-cn.js": 365,
	"./uk": 366,
	"./uk.js": 366,
	"./ur": 367,
	"./ur.js": 367,
	"./uz": 368,
	"./uz-latn": 369,
	"./uz-latn.js": 369,
	"./uz.js": 368,
	"./vi": 370,
	"./vi.js": 370,
	"./x-pseudo": 371,
	"./x-pseudo.js": 371,
	"./yo": 372,
	"./yo.js": 372,
	"./zh-cn": 373,
	"./zh-cn.js": 373,
	"./zh-hk": 374,
	"./zh-hk.js": 374,
	"./zh-tw": 375,
	"./zh-tw.js": 375
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1264;

/***/ }),
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"3.1.0","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","prepublishOnly":"yarn run lint && yarn run test && yarn run build"},"dependencies":{},"peerDependencies":{"chart.js":"2.7.x"},"devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1278);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1e3a2d2f", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2aa05b1f\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./SquareLoader.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2aa05b1f\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./SquareLoader.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.v-spinner\n{\n    text-align: center;\n}\n.v-spinner .v-square\n{\n    -webkit-animation: v-squareDelay 3s 0s infinite cubic-bezier(.09,.57,.49,.9);\n            animation: v-squareDelay 3s 0s infinite cubic-bezier(.09,.57,.49,.9);\n    -webkit-animation-fill-mode: both;\n\t          animation-fill-mode: both;\n    -webkit-perspective: 100px;\n            perspective: 100px;\n    display: inline-block;\n}\n@-webkit-keyframes v-squareDelay\n{\n25%\n    {\n        -webkit-transform: rotateX(180deg) rotateY(0);\n                transform: rotateX(180deg) rotateY(0);\n}\n50%\n    {\n        -webkit-transform: rotateX(180deg) rotateY(180deg);\n                transform: rotateX(180deg) rotateY(180deg);\n}\n75%\n    {\n        -webkit-transform: rotateX(0) rotateY(180deg);\n                transform: rotateX(0) rotateY(180deg);\n}\n100%\n    {\n        -webkit-transform: rotateX(0) rotateY(0);\n                transform: rotateX(0) rotateY(0);\n}\n}\n@keyframes v-squareDelay\n{\n25%\n    {\n        -webkit-transform: rotateX(180deg) rotateY(0);\n                transform: rotateX(180deg) rotateY(0);\n}\n50%\n    {\n        -webkit-transform: rotateX(180deg) rotateY(180deg);\n                transform: rotateX(180deg) rotateY(180deg);\n}\n75%\n    {\n        -webkit-transform: rotateX(0) rotateY(180deg);\n                transform: rotateX(0) rotateY(180deg);\n}\n100%\n    {\n        -webkit-transform: rotateX(0) rotateY(0);\n                transform: rotateX(0) rotateY(0);\n}\n}\n", ""]);

// exports


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "v-spinner"
    },
    [_c("div", { staticClass: "v-square", style: _vm.spinnerStyle })]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aa05b1f", esExports)
  }
}

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c("square-loader", {
                attrs: { loading: true, color: "#26A65B", size: "50px" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.outlets[_vm.$session.get("lang")]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "12" } }, [
                _c(
                  "div",
                  { staticClass: "process-container bg-secondary" },
                  [
                    _c("div", {
                      staticClass: "current bg-primary",
                      style: "width: " + _vm.current + "%"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "target bg-danger",
                      style: "margin-left: " + _vm.target + "%",
                      attrs: { id: "target" }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          show: _vm.show_target,
                          target: "target",
                          placement: "bottom"
                        },
                        on: {
                          "update:show": function($event) {
                            _vm.show_target = $event
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("numeral")(_vm.target_sales, "0,0")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-money" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_sale")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-shopping-basket" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-bar-chart" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("numeral")(
                            _vm.total_sales / _vm.total_cheque,
                            "0,0.00"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("average_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-bullhorn" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.sos, "0,0.00")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("sos")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_channel_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_by_channel_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_type_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_by_type_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_type")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels:
                    _vm.cheque_by_channel_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_by_channel_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.cheque_by_type_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_by_type_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_by_type")))])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22ba47ca", esExports)
  }
}

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df2ea424_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__(1284);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1282)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df2ea424"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df2ea424_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/Report.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-df2ea424", Component.options)
  } else {
    hotAPI.reload("data-v-df2ea424", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1283);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2c3bc8a7", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-df2ea424\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Report.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-df2ea424\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Report.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.process-container[data-v-df2ea424] {\n  width: 100%;\n  height: 35px;\n}\n.process-container .current[data-v-df2ea424] {\n  height: 35px;\n  -webkit-transition: width 1s; /* Safari */\n  transition:width 1s;\n}\n.process-container .target[data-v-df2ea424] {\n  width: 2px;\n  height: 35px;\n  margin-top: -35px;\n  -webkit-transition: margin-left 1s; /* Safari */\n  transition: margin-left 1s;\n}\n.chart-title[data-v-df2ea424] {\n  color: #6c6c6c;\n  padding: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("date_range"),
                        "label-cols": 3,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          startDate: _vm.startDate,
                          endDate: _vm.endDate,
                          opens: "right",
                          localeData: { format: "DD/MM/YYYY" }
                        },
                        on: { update: _vm.updateDateRange }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 3,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: [
                            { text: _vm.$t("all"), value: null },
                            { text: "Outlet 1", value: 1 },
                            { text: "Outlet 2", value: 2 }
                          ]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("type"),
                        "label-cols": 3,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: [
                            { text: _vm.$t("daily"), value: "daily" },
                            { text: _vm.$t("weekly"), value: "weekly" },
                            { text: _vm.$t("monthly"), value: "monthly" }
                          ]
                        },
                        model: {
                          value: _vm.type,
                          callback: function($$v) {
                            _vm.type = $$v
                          },
                          expression: "type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "12" } }, [
                _c(
                  "div",
                  { staticClass: "process-container bg-secondary" },
                  [
                    _c("div", {
                      staticClass: "current bg-primary",
                      style: "width: " + _vm.current + "%"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "target bg-danger",
                      style: "margin-left: " + _vm.target + "%",
                      attrs: { id: "target" }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          show: _vm.show_target,
                          target: "target",
                          placement: "bottom"
                        },
                        on: {
                          "update:show": function($event) {
                            _vm.show_target = $event
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("numeral")(_vm.target_sales, "0,0")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fa fa-money" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_sale")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fa fa-shopping-basket" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fa fa-bar-chart" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("numeral")(
                            _vm.total_sales / _vm.total_cheque,
                            "0,0.00"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("average_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "3" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right" }, [
                      _c("i", { staticClass: "fa fa-bullhorn" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.sos, "0,0.00")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("sos")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("bar", {
                attrs: {
                  labels: _vm.sale_trend_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_trend_datasets[_vm.$session.get("lang")]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_trend")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("bar", {
                attrs: {
                  labels: _vm.cheque_trend_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_trend_datasets[_vm.$session.get("lang")]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_trend")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_channel_labels[_vm.$session.get("lang")],
                  datasets:
                    _vm.sale_by_channel_datasets[_vm.$session.get("lang")]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df2ea424", esExports)
  }
}

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesHistory_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af4eb22_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesHistory_vue__ = __webpack_require__(1288);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1286)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7af4eb22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af4eb22_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/SalesHistory.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7af4eb22", Component.options)
  } else {
    hotAPI.reload("data-v-7af4eb22", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1287);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3a279488", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7af4eb22\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SalesHistory.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7af4eb22\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SalesHistory.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.process-container[data-v-7af4eb22] {\n  width: 100%;\n  height: 35px;\n}\n.process-container .current[data-v-7af4eb22] {\n  height: 35px;\n  -webkit-transition: width 1s; /* Safari */\n  transition:width 1s;\n}\n.process-container .target[data-v-7af4eb22] {\n  width: 2px;\n  height: 35px;\n  margin-top: -35px;\n  -webkit-transition: margin-left 1s; /* Safari */\n  transition: margin-left 1s;\n}\n.chart-title[data-v-7af4eb22] {\n  color: #6c6c6c;\n  padding: 5px;\n}\n.loading[data-v-7af4eb22] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 99999;\n  padding-top: 300px;\n}\n", ""]);

// exports


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c("square-loader", {
                attrs: { loading: true, color: "#26A65B", size: "50px" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "7" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.outlets[_vm.$session.get("lang")]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("date"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          startDate: _vm.start_date,
                          endDate: _vm.end_date,
                          "locale-data": _vm.locale
                        },
                        on: { update: _vm.updateDate }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.refresh }
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" " + _vm._s(_vm.$t("search")))
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "12" } }, [
                _c(
                  "div",
                  { staticClass: "process-container bg-secondary" },
                  [
                    _c("div", {
                      staticClass: "current bg-primary",
                      style: "width: " + _vm.current + "%"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "target bg-danger",
                      style: "margin-left: " + _vm.target + "%",
                      attrs: { id: "target" }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          show: _vm.show_target,
                          target: "target",
                          placement: "bottom"
                        },
                        on: {
                          "update:show": function($event) {
                            _vm.show_target = $event
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("numeral")(_vm.target_sales, "0,0")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-money" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_sale")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-shopping-basket" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-bar-chart" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("numeral")(
                            _vm.total_sales / _vm.total_cheque,
                            "0,0.00"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("average_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-bullhorn" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.sos, "0,0.00")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("sos")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_channel_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_by_channel_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_type_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_by_type_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_type")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels:
                    _vm.cheque_by_channel_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_by_channel_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.cheque_by_type_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_by_type_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_by_type")))])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7af4eb22", esExports)
  }
}

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductMix_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a767a27_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductMix_vue__ = __webpack_require__(1295);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1290)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a767a27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductMix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a767a27_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductMix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/ProductMix.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a767a27", Component.options)
  } else {
    hotAPI.reload("data-v-7a767a27", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1291);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("3ebf6b80", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a767a27\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProductMix.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a767a27\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ProductMix.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.chart-title[data-v-7a767a27] {\n  color: #6c6c6c;\n  padding: 5px;\n}\n.loading[data-v-7a767a27] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 99999;\n  padding-top: 300px;\n}\n", ""]);

// exports


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Doughnut_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Doughnut_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/charts/Doughnut.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e0e3372", Component.options)
  } else {
    hotAPI.reload("data-v-6e0e3372", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1293 */,
/* 1294 */,
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c("square-loader", {
                attrs: { loading: true, color: "#26A65B", size: "50px" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "7" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.outlets[_vm.$session.get("lang")]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("date"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          startDate: _vm.start_date,
                          endDate: _vm.end_date,
                          "locale-data": _vm.locale
                        },
                        on: { update: _vm.updateDate }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.refresh }
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" " + _vm._s(_vm.$t("search")))
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "6", lg: "6" } }, [
            _vm.best_sale_data != null
              ? _c(
                  "table",
                  { staticClass: "table" },
                  _vm._l(_vm.best_sale_data, function(item, index) {
                    return _c("tr", [
                      _c("td", [
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            style: "background-color: " + item.color
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { style: "font-weight: 600; color: " + item.color },
                        [_vm._v(_vm._s(item.total))]
                      )
                    ])
                  })
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c("doughnut", {
                attrs: {
                  labels: _vm.best_sale_labels,
                  datasets: _vm.best_sale_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("top_10")))])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a767a27", esExports)
  }
}

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderProcessingTime_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1114bb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderProcessingTime_vue__ = __webpack_require__(1299);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1297)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1114bb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderProcessingTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1114bb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderProcessingTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/OrderProcessingTime.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b1114bb8", Component.options)
  } else {
    hotAPI.reload("data-v-b1114bb8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1298);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1640f634", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b1114bb8\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderProcessingTime.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b1114bb8\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OrderProcessingTime.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.process-container[data-v-b1114bb8] {\n  width: 100%;\n  height: 35px;\n}\n.process-container .current[data-v-b1114bb8] {\n  height: 35px;\n  -webkit-transition: width 1s; /* Safari */\n  transition:width 1s;\n}\n.process-container .target[data-v-b1114bb8] {\n  width: 2px;\n  height: 35px;\n  margin-top: -35px;\n  -webkit-transition: margin-left 1s; /* Safari */\n  transition: margin-left 1s;\n}\n.loading[data-v-b1114bb8] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 99999;\n  padding-top: 300px;\n}\n", ""]);

// exports


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c("square-loader", {
                attrs: { loading: true, color: "#26A65B", size: "50px" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.outlets[_vm.$session.get("lang")]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("date"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          startDate: _vm.start_date,
                          endDate: _vm.end_date,
                          "locale-data": _vm.locale
                        },
                        on: { update: _vm.updateDate }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.refresh }
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" " + _vm._s(_vm.$t("search")))
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("list")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }, [_c("hr")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-responsive" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-striped table-hover table-sm header-pointer"
                          },
                          [
                            _c("thead", [
                              _c(
                                "tr",
                                _vm._l(_vm.dataTable.header, function(item) {
                                  return _c(
                                    "th",
                                    {
                                      key: item.id,
                                      class: item.sort ? "cursor-pointer" : "",
                                      attrs: { scope: "col" },
                                      on: {
                                        click: function($event) {
                                          _vm.updateSort(item.name)
                                        }
                                      }
                                    },
                                    [
                                      _vm.dataTable.sort.type == "asc" &&
                                      _vm.dataTable.sort.field == item.name
                                        ? _c("i", {
                                            staticClass:
                                              "fa fa-sort-amount-asc text-muted"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.dataTable.sort.type == "desc" &&
                                      _vm.dataTable.sort.field == item.name
                                        ? _c("i", {
                                            staticClass:
                                              "fa fa-sort-amount-desc text-muted"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t(item.name)))
                                      ])
                                    ]
                                  )
                                })
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.dataTable.body, function(item) {
                                return _c(
                                  "tr",
                                  { key: item.id },
                                  _vm._l(_vm.dataTable.header, function(field) {
                                    return _c(
                                      "td",
                                      {
                                        key: field.id,
                                        attrs: { scope: "row" }
                                      },
                                      [
                                        field.render != null
                                          ? _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  field.render(item[field.name])
                                                )
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        field.render == null
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(item[field.name]) +
                                                  "\n                    "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  })
                                )
                              })
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-pagination", {
                                attrs: {
                                  "total-rows": _vm.dataTable.total,
                                  "per-page": _vm.dataTable.paginate
                                },
                                model: {
                                  value: _vm.dataTable.offset,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataTable, "offset", $$v)
                                  },
                                  expression: "dataTable.offset"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { col: "", lg: "1" } },
                            [
                              _c("b-form-select", {
                                staticClass: "mb-3",
                                attrs: { options: [10, 20, 50, 100] },
                                model: {
                                  value: _vm.dataTable.paginate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataTable, "paginate", $$v)
                                  },
                                  expression: "dataTable.paginate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [_c("div", { staticClass: "clearfix" }, [_c("hr")])]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1114bb8", esExports)
  }
}

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29415b98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(1301);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29415b98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/pages/Page404.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29415b98", Component.options)
  } else {
    hotAPI.reload("data-v-29415b98", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "b-row",
          { staticClass: "justify-content-center" },
          [
            _c(
              "b-col",
              { attrs: { md: "6" } },
              [
                _c("div", { staticClass: "clearfix" }, [
                  _c("h1", { staticClass: "float-left display-3 mr-4" }, [
                    _vm._v("404")
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-3" }, [
                    _vm._v("Oops! You're lost.")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v("The page you are looking for was not found.")
                  ])
                ]),
                _vm._v(" "),
                _c("b-input-group", [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _c("i", { staticClass: "fa fa-search" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      id: "prependedInput",
                      size: "16",
                      type: "text",
                      placeholder: "What are you looking for?"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group-append" },
                    [
                      _c("b-button", { attrs: { variant: "info" } }, [
                        _vm._v("Search")
                      ])
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29415b98", esExports)
  }
}

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200d2f71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(1303);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200d2f71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/pages/Page500.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-200d2f71", Component.options)
  } else {
    hotAPI.reload("data-v-200d2f71", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "b-row",
          { staticClass: "justify-content-center" },
          [
            _c(
              "b-col",
              { attrs: { md: "6" } },
              [
                _c("div", { staticClass: "clearfix" }, [
                  _c("h1", { staticClass: "float-left display-3 mr-4" }, [
                    _vm._v("500")
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "pt-3" }, [
                    _vm._v("Houston, we have a problem!")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      "The page you are looking for is temporarily unavailable."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("b-input-group", [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _c("i", { staticClass: "fa fa-search" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: {
                      id: "prependedInput",
                      size: "16",
                      type: "text",
                      placeholder: "What are you looking for?"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group-append" },
                    [
                      _c("b-button", { attrs: { variant: "info" } }, [
                        _vm._v("Search")
                      ])
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-200d2f71", esExports)
  }
}

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b46c3df_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1333);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(1305)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b46c3df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b46c3df_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/Login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b46c3df", Component.options)
  } else {
    hotAPI.reload("data-v-2b46c3df", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1306);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("ab772dda", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b46c3df\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false,\"alias\":{\"../img\":\"../static/img\"}}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b46c3df\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "\n.login-language[data-v-2b46c3df] {\n  width: 100px;\n  float: right;\n  margin-top: -10px;\n}\n.login-card-body[data-v-2b46c3df] {\n  padding-top: 0px !important;\n  margin-top: -20px !important;\n}\n.login-logo[data-v-2b46c3df] {\n  width: 85%;\n  margin-bottom: 20px;\n}\n.login-copyright[data-v-2b46c3df] {\n  margin-top: 40px;\n  margin-bottom: -30px;\n}\n", ""]);

// exports


/***/ }),
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app flex-row align-items-center" },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-card-group",
                    [
                      _c(
                        "b-card",
                        { staticClass: "p-4", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c("h1", [_vm._v(_vm._s(_vm.$t("login_title")))]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.$t("login_description")))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.error != null,
                                      expression: "error != null"
                                    }
                                  ],
                                  staticClass: "text-danger"
                                },
                                [_vm._v(_vm._s(_vm.error))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }, [
                                _c("br")
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.login($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    { staticClass: "mb-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _c("i", {
                                                staticClass: "icon-user"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$t("username"),
                                          "aria-describedby":
                                            "username-feedback"
                                        },
                                        model: {
                                          value: _vm.body.username,
                                          callback: function($$v) {
                                            _vm.$set(_vm.body, "username", $$v)
                                          },
                                          expression: "body.username"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group",
                                    { staticClass: "mb-4" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _c("i", {
                                                staticClass: "icon-lock"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "password",
                                          placeholder: _vm.$t("password"),
                                          "aria-describedby":
                                            "password-feedback"
                                        },
                                        model: {
                                          value: _vm.body.password,
                                          callback: function($$v) {
                                            _vm.$set(_vm.body, "password", $$v)
                                          },
                                          expression: "body.password"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "5" } },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "px-4",
                                              attrs: { variant: "primary" },
                                              on: { click: _vm.login }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("login_title"))
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-right",
                                          attrs: { cols: "7" }
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "px-0",
                                              attrs: { variant: "link" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("forgot_password")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card",
                        {
                          staticClass:
                            "text-white bg-primary py-5 d-md-down-none",
                          staticStyle: { width: "44%" },
                          attrs: { "no-body": "" }
                        },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "text-center login-card-body" },
                            [
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "login-language" },
                                  [_c("change-language")],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "login-logo",
                                  attrs: {
                                    src: "static/img/logo.png",
                                    alt: "Central Hub"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", { staticStyle: { display: "none" } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("slogan")) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("div", { staticClass: "login-copyright" }, [
                                  _vm._v("copyright © 2018")
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b46c3df", esExports)
  }
}

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaba7ef8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(1335);
var disposed = false
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaba7ef8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/views/admin/Logout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eaba7ef8", Component.options)
  } else {
    hotAPI.reload("data-v-eaba7ef8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app flex-row align-items-center" })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eaba7ef8", esExports)
  }
}

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1338);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* actions */]
}));

/***/ }),
/* 1337 */,
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export statelang */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(1343);




var statelang = {
  lang: 'en'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LANG */], function (state, payload) {
  if (__WEBPACK_IMPORTED_MODULE_1__main__["default"] != null) {
    __WEBPACK_IMPORTED_MODULE_1__main__["default"].$i18n.locale = payload;
  }
});

var actions = {
  setLang: function setLang(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LANG */], payload);
  }
};

/***/ }),
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LANG; });
var SET_LANG = 'SET_LANG';

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_session__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_session__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_session___default.a, {
  persist: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = { en: __WEBPACK_IMPORTED_MODULE_2__assets_lang_en_json___default.a, vi: __WEBPACK_IMPORTED_MODULE_3__assets_lang_vi_json___default.a };
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: messages,
  fallbackLocale: 'en'
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 1345 */,
/* 1346 */
/***/ (function(module, exports) {

module.exports = {"english":"English","vietnamese":"Vietnamese","login_title":"Login","login_description":"Sign In to your account","username":"Username","password":"Password","forgot_password":"Forgot password?","slogan":"Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.","field_required":"This is a required field","field_email":"This is a Email field","field_confirm":"This is not match","field_number":"Must be number","are.you.looking.for.something":"Can we help you to find for something?","logout":"Logout","hello":"Hello","error":"Error","success":"Success","save_successful":"Save Successful","all":"All","name":"Name","description":"Description","address":"Address","phone":"Phone","fax":"Fax","terms_of_payment":"Terms Of Payment","active":"Active","inactive":"InActive","action":"Action","search":"Search","email":"Email","avatar":"Avatar","confirm_password":"Confirm Password","store":"Store","is_active":"Active","daily_batch":"Daily Batch","tax":"Tax","home":"Home","dashboard":"Dashboard","report":"Report","system":"System","users":"Users","roles":"Roles","permissions":"Permissions","code":"Code","super.admin":"Super Admin","guest":"Guest","user":"User","role":"Role","permission":"Permission","client":"Client","profile":"Profile","edit":"Edit","save":"Save","update":"Update","create":"Create","delete":"Delete","list":"List","back":"Back","update_status":"Update Status","detail":"Detail","config":"Config","group":"Group","key":"Key","value":"Value","customizes":"Customizes","field":"Field","tag":"Tag","type":"Type","class":"Class","default":"Default","undefault":"Undefault","place_holder":"Place Holder","options":"Options","text":"Text","multiple":"Multiple","check_value":"Checked value","uncheck_value":"Unchecked value","rows":"Rows","date_range":"Date Range","outlet":"Outlet","total_sale":"Total Sales","total_cheque":"Total Bill","average_cheque":"Average Bill","sos":"SOS %","daily":"Daily","weekly":"Weekly","monthly":"Monthly","target":"Target","sales_amount":"Sales Amount","sales_trend":"Sales Trend","cheque_trend":"Bill Trend","sales_by_channel":"Sales By Channel","sales_history":"Sales History","takeaway":"Takeaway","delivery":"Delivery","eat_in":"Eat In","sales_by_type":"Sales By Type","cheque_by_channel":"Bill By Channel","cheque_by_type":"Bill By Type","date":"Date","1st":"1st","2nd":"2nd","3rd":"3rd","4th":"4th","5th":"5th","6th":"6th","7th":"7th","8th":"8th","9th":"9th","10th":"10th","11th":"11th","12th":"12th","13th":"13th","14th":"14th","15th":"15th","16th":"16th","17th":"17th","18th":"18th","19th":"19th","20th":"20th","21st":"21st","22nd":"22nd","23rd":"23rd","24th":"24th","25th":"25th","26th":"26th","27th":"27th","28th":"28th","29th":"29th","30th":"30th","31st":"31st","32nd":"32nd","33rd":"33rd","34th":"34th","35th":"35th","36th":"36th","37th":"37th","38th":"38th","39th":"39th","40th":"40th","41st":"41st","42nd":"42nd","43rd":"43rd","44th":"44th","45th":"45th","46th":"46th","47th":"47th","48th":"48th","49th":"49th","50th":"50th","51st":"51st","52nd":"52nd","january":"January","february":"February","march":"March","april":"April","may":"May","june":"June","july":"July","august":"August","september":"September","october":"October","november":"November","december":"December","online":"Online","call_center":"Call Center","offline":"Offline","aggregator":"Aggregator","offline_go_jek":"Go-Jek","grab":"Grab","account":"Account","genstore":"Genstore","uom":"Uom","uom_detail":"Uom Detail","material":"Material","material_detail":"Material Detail","supplier":"Supplier","recipe":"Recipe","recipe_detail":"Recipe Detail","recipe_detail_usage":"Recipe Detail Usage","recipe_detail_usage_unit":"Recipe Detail Usage Unit","recipe_detail_status":"Recipe Detail Status","recipe_default":"Recipe Default","master_data":"Master data","sync":"Sync","master_group":"Master Group","group_id":"Group","group_code":"Group Code","group_name":"Group Name","master_type":"Master Type","type_id":"Type","type_code":"Type Code","type_name":"Type Name","type_description":"Type Description","master_account":"Master Account","account_id":"Account id","account_code":"Account Code","account_name":"Account Name","master_genstore":"Master Genstore","genstore_code":"Genstore Code","genstore_name":"Genstore Name","genstore_description":"Genstore Description","master_uom":"Master Uom","uom_name":"Uom Name","master_uom_detail":"Master Uom Detail","from_uom_name":"From Uom","to_uom_name":"To Uom","from_uom_qty":"Qty From Uom","to_uom_qty":"Qty To Uom","conversion_rate":"Conversion Rate","is_actived":"Active","master_material":"Master Material","material_id":"Material id","material_code":"Material Code","material_name":"Material Name","net_weight":"Weight","material_uom":"Uom","recipe_rate":"Net Weight","master_material_detail":"Material Detail","material_detail_id":"Material Detail id","material_detail_code":"Material Detail Code","material_detail_name":"Material Detail Name","supplier_unit_name":"Supplier unit","supplier_uom_id":"Supplier Unit","outlet_uom_id":"Outlet Unit","outlet_uom_detail_id":"Outlet Uom","smaller_uom_id":"Smaller unit","smaller_uom_detail_id":"Smaller uom","outlet_uom_name":"Outlet unit","outlet_uom_detail_name":"Outlet uom","recipe_uom_id":"Recipe unit","recipe_uom_name":"Recipe unit","recipe_uom_detail_name":"Recipe uom","recipe_uom_detail_id":"Recipe uom","smaller_uom_name":"Smaller unit","smaller_uom_detail_name":"Smaller uom","report_uom_id":"Report unit","report_uom_name":"Report uom","fixed_unit":"Fixed unit","supplier_master":"Supplier Master","supplier_id":"Supplier Id","supplier_code":"Supplier Code","supplier_name":"Supplier Name","supplier_address":"Supplier Address","supplier_phone":"Supplier Phone","supplier_fax":"Supplier Fax","supplier_terms_of_payment":"Supplier Terms Of Payment","supplier_import_do":"Import DO Online","master_recipe":"Master Recipe","plucode":"Plucode","sku":"Sku","recipe_code":"Recipe Code","master_recipe_detail":"Master Recipe Detail","recipe_detail_name":"Recipe Detail Name","recipe_detail_code":"Recipe Detail Code","uom_detail_name":"Uom Detail Name","recipe_name":"Recipe Name","is_default":"Default","expired_in":"Expired In","usage":"Usage","price":"Price","master":"Master","short_code":"Short Code","long_name":"Long Name","current_price":"Current Price","current_qty":"Current Qty","short_name":"Short Name","uom_id":"UOM Id","r_uom_id":"R UOM Id","product_mix":"Product Mix","top_10":"TOP 10","order_processing_time":"Order time","order_number":"Order number","channel":"Channel","order_type":"Order type","order_date":"Order date","sent_to_kds":"Kds time","cooked":"Cooked time","delivery_start_time":"Delivered time","customer_recieved":"Customer received","encashment_time":"Encashment time","sos_achived":"SOS","master_material_detail_supplier":"Master Material Detail Supplier","material_detail_supplier":"Material Detail Supplier","master_material_recipe_mapping":"Master Material Recipe Mapping","source_type":"Source Type","source_code":"Source Code","destination_type":"Destination Type","destination_code":"Destination Code","supplier_names":"List Supplier","sync_data":"Sync Data","sync_master":"Sync Master","is_sync":"Sync to POS","version":"Version","sync_master_detail":"Sync Master Detail","file_name":"File Name","store_code":"Store Code","already_sync_to_pos":"Already Sync To Pos","not_sync_to_pos":"Not Sync To Pos","inventory":"Inventory"}

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports = {"english":"Tiếng Anh","vietnamese":"Tiếng Việt","login_title":"Đăng nhập","login_description":"Đăng nhập với tài khoản của bạn","username":"Tài khoản","password":"Mật khẩu","forgot_password":"Quên mật khẩu?","slogan":"Một con vịt xòe ra hai cái cánh, nó kêu rằng cáp cáp cáp, cạp cạp cạp. Gặp hồ nước nó bì bà bì bõm, lúc lên bờ vẫy cái cánh cho khô.","field_required":"Trường này không được bỏ trống.","field_email":"Trường này phải là Email","field_confirm":"Trường này không chính xác","field_number":"Phải là số","are.you.looking.for.something":"Chúng tôi có thể giúp bạn tìm kiếm?","logout":"Đăng xuất","hello":"Xin chào","error":"Lỗi!","success":"Thành công!","save_successful":"Lưu thành công.","all":"Tất cả","name":"Tên","description":"Mô tả","address":"Địa chỉ","active":"Kích hoạt","inactive":"Ngưng hoạt động","action":"","search":"Tìm kiếm","email":"Email","avatar":"Ảnh đại diện","confirm_password":"Xác nhận mật khẩu","store":"Cửa hàng","is_actived":"Active","home":"Trang chủ","dashboard":"Bảng điều khiển","report":"Thống kê","system":"Hệ thống","users":"Nhân viên","roles":"Chức vụ","permissions":"Chức năng","code":"Mã","super.admin":"Toàn quyền tối cao","guest":"Khách vãng lai","user":"Nhân viên","role":"Chức vụ","permission":"Quyền","client":"Thị trường","profile":"Cá nhân","save":"Thêm mới","edit":"Cập nhật","update":"Cập nhật","create":"Tạo mới","delete":"Xóa","list":"Danh sách","back":"Trở lại","update_status":"Cập nhật trạng thái","detail":"Chi tiết","config":"Cài đặt","group":"Nhóm","key":"Tên","value":"Giá trị","customizes":"Tùy chỉnh","field":"Trường","tag":"Tag","type":"Type","class":"Class","default":"Default","place_holder":"Place Holder","options":"Options","text":"Text","multiple":"Multiple","check_value":"Checked value","uncheck_value":"Unchecked value","rows":"Rows","date_range":"Thời gian","outlet":"Cửa hàng","total_sale":"Tổng doanh thu","total_cheque":"Tổng đơn hàng","average_cheque":"Trung bình đơn hàng","sos":"SOS %","daily":"Ngày","weekly":"Tuần","monthly":"Tháng","target":"Mục tiêu","sales_amount":"Tổng đơn hàng","sales_trend":"Xu hướng mua hàng","cheque_trend":"Cheque Trend","sales_by_channel":"Kênh bán hàng","sales_history":"Lịch sử bán hàng","takeaway":"Mang về","delivery":"Giao hàng","sales_by_type":"Loại bán hàng","cheque_by_channel":"Kênh bán hàng","cheque_by_type":"Loại bán hàng","date":"Ngày","1st":"Tuần 1","2nd":"Tuần 2","3rd":"Tuần 3","4th":"Tuần 4","5th":"Tuần 5","6th":"Tuần 6","7th":"Tuần 7","8th":"Tuần 8","9th":"Tuần 9","10th":"Tuần 10","11th":"Tuần 11","12th":"Tuần 12","13th":"Tuần 13","14th":"Tuần 14","15th":"Tuần 15","16th":"Tuần 16","17th":"Tuần 17","18th":"Tuần 18","19th":"Tuần 19","20th":"Tuần 20","21st":"Tuần 21","22nd":"Tuần 22","23rd":"Tuần 23","24th":"Tuần 24","25th":"Tuần 25","26th":"Tuần 26","27th":"Tuần 27","28th":"Tuần 28","29th":"Tuần 29","30th":"Tuần 30","31st":"Tuần 31","32nd":"Tuần 32","33rd":"Tuần 33","34th":"Tuần 34","35th":"Tuần 35","36th":"Tuần 36","37th":"Tuần 37","38th":"Tuần 38","39th":"Tuần 39","40th":"Tuần 40","41st":"Tuần 41","42nd":"Tuần 42","43rd":"Tuần 43","44th":"Tuần 44","45th":"Tuần 45","46th":"Tuần 46","47th":"Tuần 47","48th":"Tuần 48","49th":"Tuần 49","50th":"Tuần 50","51st":"Tuần 51","52nd":"Tuần 52","january":"Tháng 1","february":"Tháng 2","march":"Tháng 3","april":"Tháng 4","may":"Tháng 5","june":"Tháng 6","july":"Tháng 7","august":"Tháng 8","september":"Tháng 9","october":"Tháng 10","november":"Tháng 11","december":"Tháng 12","online":"Online","call_center":"Tổng đại","offline":"Cửa hàng","aggregator":"Đối tác","offline_go_jek":"Go-Jek","grab":"Grab","master_group":"Master Group","group_id":"Group ID","group_name":"Group Name","master_type":"Master Type","type_id":"Type ID","type_name":"Type Name","master_account":"Master Account","account_id":"Account","account_code":"Account Code","account_name":"Account Name","master_material":"Master Material","material_id":"Material id","material_code":"Material Code","material_name":"Material Name","master_material_detail":"Master Material Detail","material_detail_id":"Material Detail id","material_detail_code":"Material Detail Code","material_detail_name":"Material Detail Name","master_supplier":"Master Supplier","supplier_id":"Supplier id","supplier_code":"Supplier Code","supplier_name":"Supplier Name","supplier_address":"Supplier Address","master":"Master","short_code":"Short Code","long_name":"Long Name","current_price":"Current Price","current_qty":"Current Qty","short_name":"Short Name","uom_id":"UOM Id","r_uom_id":"R UOM Id","unit":"Đơn vị","unit_conversion":"Unit Conversion","first_unit":"First Unit","first_num":"First Number","second_unit":"Second Unit","second_num":"Second Number","supplier_unit":"Supplier Unit","recipe_unit":"Recipe Unit","opname_unit":"Operation Unit","bom":"Bom","bom_code":"Code","quantity":"Quantity","price":"Price","sku":"Sku","master_quantity":"Master Quantity","master_unit":"Master Unit","master_price":"Master Price","product_mix":"Product Mix","top_10":"TOP 10","order_processing_time":"Thời gian xử lý","order_number":"Order number","channel":"Channel","order_type":"Order type","order_date":"Order date","sent_to_kds":"Kds time","cooked":"Cooked time","delivery_start_time":"Delivered time","customer_recieved":"Customer received","encashment_time":"Encashment time","sos_achived":"SOS","inventory":"Inventory"}

/***/ }),
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */
/***/ (function(module, exports) {

module.exports = {"version":"2019b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ })
],[109]);


// WEBPACK FOOTER //
// static/js/app.56629e9ff69a9132fde7.js